// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ----- CSS reset ----- */
*,
*::before,
*::after {
  box-sizing: border-box;
}

input,
button,
textarea,
select {
  font: inherit;
}

button,
select {
  text-transform: none;
}

/* ----- Global styles ----- */
body {
  margin: 0;
  font-family: var(--mantine-font-family);
  font-size: var(--mantine-font-size-md);
  line-height: var(--mantine-line-height);
  background-color: var(--mantine-color-body);
  color: var(--mantine-color-text);

  -webkit-font-smoothing: var(--mantine-webkit-font-smoothing);
  -moz-osx-font-smoothing: var(--mantine-moz-font-smoothing);
}
@media screen and (max-device-width: 31.25em) {
body {
    -webkit-text-size-adjust: 100%
}
  }

@media (prefers-reduced-motion: reduce) {
    [data-respect-reduced-motion] [data-reduce-motion] {
      transition: none;
      animation: none;
    }
  }

[data-mantine-color-scheme='light'] .mantine-light-hidden {
    display: none;
}

[data-mantine-color-scheme='dark'] .mantine-dark-hidden {
    display: none;
}

.mantine-focus-auto:focus-visible {
    outline: 2px solid var(--mantine-primary-color-filled);
    outline-offset: calc(0.125rem * var(--mantine-scale));
  }

.mantine-focus-always:focus {
    outline: 2px solid var(--mantine-primary-color-filled);
    outline-offset: calc(0.125rem * var(--mantine-scale));
  }

.mantine-focus-never:focus {
    outline: none;
  }

.mantine-active:active {
    transform: translateY(calc(0.0625rem * var(--mantine-scale)));
  }

:where([dir="rtl"]) .mantine-rotate-rtl {
    transform: rotate(180deg);
}

/* ----- Default CSS variables ----- */

:root {
  color-scheme: var(--mantine-color-scheme);

  --mantine-z-index-app: 100;
  --mantine-z-index-modal: 200;
  --mantine-z-index-popover: 300;
  --mantine-z-index-overlay: 400;
  --mantine-z-index-max: 9999;

  --mantine-scale: 1;
  --mantine-cursor-type: default;
  --mantine-webkit-font-smoothing: antialiased;
  --mantine-color-scheme: light dark;
  --mantine-moz-font-smoothing: grayscale;
  --mantine-color-white: #fff;
  --mantine-color-black: #000;
  --mantine-line-height: 1.55;
  --mantine-font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial,
    sans-serif, Apple Color Emoji, Segoe UI Emoji;
  --mantine-font-family-monospace: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas,
    Liberation Mono, Courier New, monospace;
  --mantine-font-family-headings: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica,
    Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji;
  --mantine-heading-font-weight: 700;
  --mantine-radius-default: calc(0.25rem * var(--mantine-scale));
  --mantine-primary-color-0: var(--mantine-color-blue-0);
  --mantine-primary-color-1: var(--mantine-color-blue-1);
  --mantine-primary-color-2: var(--mantine-color-blue-2);
  --mantine-primary-color-3: var(--mantine-color-blue-3);
  --mantine-primary-color-4: var(--mantine-color-blue-4);
  --mantine-primary-color-5: var(--mantine-color-blue-5);
  --mantine-primary-color-6: var(--mantine-color-blue-6);
  --mantine-primary-color-7: var(--mantine-color-blue-7);
  --mantine-primary-color-8: var(--mantine-color-blue-8);
  --mantine-primary-color-9: var(--mantine-color-blue-9);
  --mantine-primary-color-filled: var(--mantine-color-blue-filled);
  --mantine-primary-color-filled-hover: var(--mantine-color-blue-filled-hover);
  --mantine-primary-color-light: var(--mantine-color-blue-light);
  --mantine-primary-color-light-hover: var(--mantine-color-blue-light-hover);
  --mantine-primary-color-light-color: var(--mantine-color-blue-light-color);
  --mantine-breakpoint-xs: 36em;
  --mantine-breakpoint-sm: 48em;
  --mantine-breakpoint-md: 62em;
  --mantine-breakpoint-lg: 75em;
  --mantine-breakpoint-xl: 88em;
  --mantine-spacing-xs: calc(0.625rem * var(--mantine-scale));
  --mantine-spacing-sm: calc(0.75rem * var(--mantine-scale));
  --mantine-spacing-md: calc(1rem * var(--mantine-scale));
  --mantine-spacing-lg: calc(1.25rem * var(--mantine-scale));
  --mantine-spacing-xl: calc(2rem * var(--mantine-scale));
  --mantine-font-size-xs: calc(0.75rem * var(--mantine-scale));
  --mantine-font-size-sm: calc(0.875rem * var(--mantine-scale));
  --mantine-font-size-md: calc(1rem * var(--mantine-scale));
  --mantine-font-size-lg: calc(1.125rem * var(--mantine-scale));
  --mantine-font-size-xl: calc(1.25rem * var(--mantine-scale));
  --mantine-line-height-xs: 1.4;
  --mantine-line-height-sm: 1.45;
  --mantine-line-height-md: 1.55;
  --mantine-line-height-lg: 1.6;
  --mantine-line-height-xl: 1.65;
  --mantine-shadow-xs: 0 calc(0.0625rem * var(--mantine-scale))
      calc(0.1875rem * var(--mantine-scale)) rgba(0, 0, 0, 0.05),
    0 calc(0.0625rem * var(--mantine-scale)) calc(0.125rem * var(--mantine-scale))
      rgba(0, 0, 0, 0.1);
  --mantine-shadow-sm: 0 calc(0.0625rem * var(--mantine-scale))
      calc(0.1875rem * var(--mantine-scale)) rgba(0, 0, 0, 0.05),
    rgba(0, 0, 0, 0.05) 0 calc(0.625rem * var(--mantine-scale))
      calc(0.9375rem * var(--mantine-scale)) calc(-0.3125rem * var(--mantine-scale)),
    rgba(0, 0, 0, 0.04) 0 calc(0.4375rem * var(--mantine-scale))
      calc(0.4375rem * var(--mantine-scale)) calc(-0.3125rem * var(--mantine-scale));
  --mantine-shadow-md: 0 calc(0.0625rem * var(--mantine-scale))
      calc(0.1875rem * var(--mantine-scale)) rgba(0, 0, 0, 0.05),
    rgba(0, 0, 0, 0.05) 0 calc(1.25rem * var(--mantine-scale))
      calc(1.5625rem * var(--mantine-scale)) calc(-0.3125rem * var(--mantine-scale)),
    rgba(0, 0, 0, 0.04) 0 calc(0.625rem * var(--mantine-scale))
      calc(0.625rem * var(--mantine-scale)) calc(-0.3125rem * var(--mantine-scale));
  --mantine-shadow-lg: 0 calc(0.0625rem * var(--mantine-scale))
      calc(0.1875rem * var(--mantine-scale)) rgba(0, 0, 0, 0.05),
    rgba(0, 0, 0, 0.05) 0 calc(1.75rem * var(--mantine-scale))
      calc(1.4375rem * var(--mantine-scale)) calc(-0.4375rem * var(--mantine-scale)),
    rgba(0, 0, 0, 0.04) 0 calc(0.75rem * var(--mantine-scale)) calc(0.75rem * var(--mantine-scale))
      calc(-0.4375rem * var(--mantine-scale));
  --mantine-shadow-xl: 0 calc(0.0625rem * var(--mantine-scale))
      calc(0.1875rem * var(--mantine-scale)) rgba(0, 0, 0, 0.05),
    rgba(0, 0, 0, 0.05) 0 calc(2.25rem * var(--mantine-scale)) calc(1.75rem * var(--mantine-scale))
      calc(-0.4375rem * var(--mantine-scale)),
    rgba(0, 0, 0, 0.04) 0 calc(1.0625rem * var(--mantine-scale))
      calc(1.0625rem * var(--mantine-scale)) calc(-0.4375rem * var(--mantine-scale));
  --mantine-radius-xs: calc(0.125rem * var(--mantine-scale));
  --mantine-radius-sm: calc(0.25rem * var(--mantine-scale));
  --mantine-radius-md: calc(0.5rem * var(--mantine-scale));
  --mantine-radius-lg: calc(1rem * var(--mantine-scale));
  --mantine-radius-xl: calc(2rem * var(--mantine-scale));
  --mantine-color-dark-0: #c9c9c9;
  --mantine-color-dark-1: #b8b8b8;
  --mantine-color-dark-2: #828282;
  --mantine-color-dark-3: #696969;
  --mantine-color-dark-4: #424242;
  --mantine-color-dark-5: #3b3b3b;
  --mantine-color-dark-6: #2e2e2e;
  --mantine-color-dark-7: #242424;
  --mantine-color-dark-8: #1f1f1f;
  --mantine-color-dark-9: #141414;
  --mantine-color-gray-0: #f8f9fa;
  --mantine-color-gray-1: #f1f3f5;
  --mantine-color-gray-2: #e9ecef;
  --mantine-color-gray-3: #dee2e6;
  --mantine-color-gray-4: #ced4da;
  --mantine-color-gray-5: #adb5bd;
  --mantine-color-gray-6: #868e96;
  --mantine-color-gray-7: #495057;
  --mantine-color-gray-8: #343a40;
  --mantine-color-gray-9: #212529;
  --mantine-color-red-0: #fff5f5;
  --mantine-color-red-1: #ffe3e3;
  --mantine-color-red-2: #ffc9c9;
  --mantine-color-red-3: #ffa8a8;
  --mantine-color-red-4: #ff8787;
  --mantine-color-red-5: #ff6b6b;
  --mantine-color-red-6: #fa5252;
  --mantine-color-red-7: #f03e3e;
  --mantine-color-red-8: #e03131;
  --mantine-color-red-9: #c92a2a;
  --mantine-color-pink-0: #fff0f6;
  --mantine-color-pink-1: #ffdeeb;
  --mantine-color-pink-2: #fcc2d7;
  --mantine-color-pink-3: #faa2c1;
  --mantine-color-pink-4: #f783ac;
  --mantine-color-pink-5: #f06595;
  --mantine-color-pink-6: #e64980;
  --mantine-color-pink-7: #d6336c;
  --mantine-color-pink-8: #c2255c;
  --mantine-color-pink-9: #a61e4d;
  --mantine-color-grape-0: #f8f0fc;
  --mantine-color-grape-1: #f3d9fa;
  --mantine-color-grape-2: #eebefa;
  --mantine-color-grape-3: #e599f7;
  --mantine-color-grape-4: #da77f2;
  --mantine-color-grape-5: #cc5de8;
  --mantine-color-grape-6: #be4bdb;
  --mantine-color-grape-7: #ae3ec9;
  --mantine-color-grape-8: #9c36b5;
  --mantine-color-grape-9: #862e9c;
  --mantine-color-violet-0: #f3f0ff;
  --mantine-color-violet-1: #e5dbff;
  --mantine-color-violet-2: #d0bfff;
  --mantine-color-violet-3: #b197fc;
  --mantine-color-violet-4: #9775fa;
  --mantine-color-violet-5: #845ef7;
  --mantine-color-violet-6: #7950f2;
  --mantine-color-violet-7: #7048e8;
  --mantine-color-violet-8: #6741d9;
  --mantine-color-violet-9: #5f3dc4;
  --mantine-color-indigo-0: #edf2ff;
  --mantine-color-indigo-1: #dbe4ff;
  --mantine-color-indigo-2: #bac8ff;
  --mantine-color-indigo-3: #91a7ff;
  --mantine-color-indigo-4: #748ffc;
  --mantine-color-indigo-5: #5c7cfa;
  --mantine-color-indigo-6: #4c6ef5;
  --mantine-color-indigo-7: #4263eb;
  --mantine-color-indigo-8: #3b5bdb;
  --mantine-color-indigo-9: #364fc7;
  --mantine-color-blue-0: #e7f5ff;
  --mantine-color-blue-1: #d0ebff;
  --mantine-color-blue-2: #a5d8ff;
  --mantine-color-blue-3: #74c0fc;
  --mantine-color-blue-4: #4dabf7;
  --mantine-color-blue-5: #339af0;
  --mantine-color-blue-6: #228be6;
  --mantine-color-blue-7: #1c7ed6;
  --mantine-color-blue-8: #1971c2;
  --mantine-color-blue-9: #1864ab;
  --mantine-color-cyan-0: #e3fafc;
  --mantine-color-cyan-1: #c5f6fa;
  --mantine-color-cyan-2: #99e9f2;
  --mantine-color-cyan-3: #66d9e8;
  --mantine-color-cyan-4: #3bc9db;
  --mantine-color-cyan-5: #22b8cf;
  --mantine-color-cyan-6: #15aabf;
  --mantine-color-cyan-7: #1098ad;
  --mantine-color-cyan-8: #0c8599;
  --mantine-color-cyan-9: #0b7285;
  --mantine-color-teal-0: #e6fcf5;
  --mantine-color-teal-1: #c3fae8;
  --mantine-color-teal-2: #96f2d7;
  --mantine-color-teal-3: #63e6be;
  --mantine-color-teal-4: #38d9a9;
  --mantine-color-teal-5: #20c997;
  --mantine-color-teal-6: #12b886;
  --mantine-color-teal-7: #0ca678;
  --mantine-color-teal-8: #099268;
  --mantine-color-teal-9: #087f5b;
  --mantine-color-green-0: #ebfbee;
  --mantine-color-green-1: #d3f9d8;
  --mantine-color-green-2: #b2f2bb;
  --mantine-color-green-3: #8ce99a;
  --mantine-color-green-4: #69db7c;
  --mantine-color-green-5: #51cf66;
  --mantine-color-green-6: #40c057;
  --mantine-color-green-7: #37b24d;
  --mantine-color-green-8: #2f9e44;
  --mantine-color-green-9: #2b8a3e;
  --mantine-color-lime-0: #f4fce3;
  --mantine-color-lime-1: #e9fac8;
  --mantine-color-lime-2: #d8f5a2;
  --mantine-color-lime-3: #c0eb75;
  --mantine-color-lime-4: #a9e34b;
  --mantine-color-lime-5: #94d82d;
  --mantine-color-lime-6: #82c91e;
  --mantine-color-lime-7: #74b816;
  --mantine-color-lime-8: #66a80f;
  --mantine-color-lime-9: #5c940d;
  --mantine-color-yellow-0: #fff9db;
  --mantine-color-yellow-1: #fff3bf;
  --mantine-color-yellow-2: #ffec99;
  --mantine-color-yellow-3: #ffe066;
  --mantine-color-yellow-4: #ffd43b;
  --mantine-color-yellow-5: #fcc419;
  --mantine-color-yellow-6: #fab005;
  --mantine-color-yellow-7: #f59f00;
  --mantine-color-yellow-8: #f08c00;
  --mantine-color-yellow-9: #e67700;
  --mantine-color-orange-0: #fff4e6;
  --mantine-color-orange-1: #ffe8cc;
  --mantine-color-orange-2: #ffd8a8;
  --mantine-color-orange-3: #ffc078;
  --mantine-color-orange-4: #ffa94d;
  --mantine-color-orange-5: #ff922b;
  --mantine-color-orange-6: #fd7e14;
  --mantine-color-orange-7: #f76707;
  --mantine-color-orange-8: #e8590c;
  --mantine-color-orange-9: #d9480f;
  --mantine-h1-font-size: calc(2.125rem * var(--mantine-scale));
  --mantine-h1-line-height: 1.3;
  --mantine-h1-font-weight: 700;
  --mantine-h2-font-size: calc(1.625rem * var(--mantine-scale));
  --mantine-h2-line-height: 1.35;
  --mantine-h2-font-weight: 700;
  --mantine-h3-font-size: calc(1.375rem * var(--mantine-scale));
  --mantine-h3-line-height: 1.4;
  --mantine-h3-font-weight: 700;
  --mantine-h4-font-size: calc(1.125rem * var(--mantine-scale));
  --mantine-h4-line-height: 1.45;
  --mantine-h4-font-weight: 700;
  --mantine-h5-font-size: calc(1rem * var(--mantine-scale));
  --mantine-h5-line-height: 1.5;
  --mantine-h5-font-weight: 700;
  --mantine-h6-font-size: calc(0.875rem * var(--mantine-scale));
  --mantine-h6-line-height: 1.5;
  --mantine-h6-font-weight: 700;
}

:root[data-mantine-color-scheme='dark'] {
  --mantine-color-scheme: dark;
  --mantine-primary-color-contrast: var(--mantine-color-white);
  --mantine-color-bright: var(--mantine-color-white);
  --mantine-color-text: var(--mantine-color-dark-0);
  --mantine-color-body: var(--mantine-color-dark-7);
  --mantine-color-error: var(--mantine-color-red-8);
  --mantine-color-placeholder: var(--mantine-color-dark-3);
  --mantine-color-anchor: var(--mantine-color-blue-4);
  --mantine-color-default: var(--mantine-color-dark-6);
  --mantine-color-default-hover: var(--mantine-color-dark-5);
  --mantine-color-default-color: var(--mantine-color-white);
  --mantine-color-default-border: var(--mantine-color-dark-4);
  --mantine-color-dimmed: var(--mantine-color-dark-2);
  --mantine-color-dark-text: var(--mantine-color-dark-4);
  --mantine-color-dark-filled: var(--mantine-color-dark-8);
  --mantine-color-dark-filled-hover: var(--mantine-color-dark-7);
  --mantine-color-dark-light: rgba(36, 36, 36, 0.15);
  --mantine-color-dark-light-hover: rgba(36, 36, 36, 0.2);
  --mantine-color-dark-light-color: var(--mantine-color-dark-3);
  --mantine-color-dark-outline: var(--mantine-color-dark-4);
  --mantine-color-dark-outline-hover: rgba(36, 36, 36, 0.05);
  --mantine-color-gray-text: var(--mantine-color-gray-4);
  --mantine-color-gray-filled: var(--mantine-color-gray-8);
  --mantine-color-gray-filled-hover: var(--mantine-color-gray-9);
  --mantine-color-gray-light: rgba(134, 142, 150, 0.15);
  --mantine-color-gray-light-hover: rgba(134, 142, 150, 0.2);
  --mantine-color-gray-light-color: var(--mantine-color-gray-3);
  --mantine-color-gray-outline: var(--mantine-color-gray-4);
  --mantine-color-gray-outline-hover: rgba(206, 212, 218, 0.05);
  --mantine-color-red-text: var(--mantine-color-red-4);
  --mantine-color-red-filled: var(--mantine-color-red-8);
  --mantine-color-red-filled-hover: var(--mantine-color-red-9);
  --mantine-color-red-light: rgba(250, 82, 82, 0.15);
  --mantine-color-red-light-hover: rgba(250, 82, 82, 0.2);
  --mantine-color-red-light-color: var(--mantine-color-red-3);
  --mantine-color-red-outline: var(--mantine-color-red-4);
  --mantine-color-red-outline-hover: rgba(255, 135, 135, 0.05);
  --mantine-color-pink-text: var(--mantine-color-pink-4);
  --mantine-color-pink-filled: var(--mantine-color-pink-8);
  --mantine-color-pink-filled-hover: var(--mantine-color-pink-9);
  --mantine-color-pink-light: rgba(230, 73, 128, 0.15);
  --mantine-color-pink-light-hover: rgba(230, 73, 128, 0.2);
  --mantine-color-pink-light-color: var(--mantine-color-pink-3);
  --mantine-color-pink-outline: var(--mantine-color-pink-4);
  --mantine-color-pink-outline-hover: rgba(247, 131, 172, 0.05);
  --mantine-color-grape-text: var(--mantine-color-grape-4);
  --mantine-color-grape-filled: var(--mantine-color-grape-8);
  --mantine-color-grape-filled-hover: var(--mantine-color-grape-9);
  --mantine-color-grape-light: rgba(190, 75, 219, 0.15);
  --mantine-color-grape-light-hover: rgba(190, 75, 219, 0.2);
  --mantine-color-grape-light-color: var(--mantine-color-grape-3);
  --mantine-color-grape-outline: var(--mantine-color-grape-4);
  --mantine-color-grape-outline-hover: rgba(218, 119, 242, 0.05);
  --mantine-color-violet-text: var(--mantine-color-violet-4);
  --mantine-color-violet-filled: var(--mantine-color-violet-8);
  --mantine-color-violet-filled-hover: var(--mantine-color-violet-9);
  --mantine-color-violet-light: rgba(121, 80, 242, 0.15);
  --mantine-color-violet-light-hover: rgba(121, 80, 242, 0.2);
  --mantine-color-violet-light-color: var(--mantine-color-violet-3);
  --mantine-color-violet-outline: var(--mantine-color-violet-4);
  --mantine-color-violet-outline-hover: rgba(151, 117, 250, 0.05);
  --mantine-color-indigo-text: var(--mantine-color-indigo-4);
  --mantine-color-indigo-filled: var(--mantine-color-indigo-8);
  --mantine-color-indigo-filled-hover: var(--mantine-color-indigo-9);
  --mantine-color-indigo-light: rgba(76, 110, 245, 0.15);
  --mantine-color-indigo-light-hover: rgba(76, 110, 245, 0.2);
  --mantine-color-indigo-light-color: var(--mantine-color-indigo-3);
  --mantine-color-indigo-outline: var(--mantine-color-indigo-4);
  --mantine-color-indigo-outline-hover: rgba(116, 143, 252, 0.05);
  --mantine-color-blue-text: var(--mantine-color-blue-4);
  --mantine-color-blue-filled: var(--mantine-color-blue-8);
  --mantine-color-blue-filled-hover: var(--mantine-color-blue-9);
  --mantine-color-blue-light: rgba(34, 139, 230, 0.15);
  --mantine-color-blue-light-hover: rgba(34, 139, 230, 0.2);
  --mantine-color-blue-light-color: var(--mantine-color-blue-3);
  --mantine-color-blue-outline: var(--mantine-color-blue-4);
  --mantine-color-blue-outline-hover: rgba(77, 171, 247, 0.05);
  --mantine-color-cyan-text: var(--mantine-color-cyan-4);
  --mantine-color-cyan-filled: var(--mantine-color-cyan-8);
  --mantine-color-cyan-filled-hover: var(--mantine-color-cyan-9);
  --mantine-color-cyan-light: rgba(21, 170, 191, 0.15);
  --mantine-color-cyan-light-hover: rgba(21, 170, 191, 0.2);
  --mantine-color-cyan-light-color: var(--mantine-color-cyan-3);
  --mantine-color-cyan-outline: var(--mantine-color-cyan-4);
  --mantine-color-cyan-outline-hover: rgba(59, 201, 219, 0.05);
  --mantine-color-teal-text: var(--mantine-color-teal-4);
  --mantine-color-teal-filled: var(--mantine-color-teal-8);
  --mantine-color-teal-filled-hover: var(--mantine-color-teal-9);
  --mantine-color-teal-light: rgba(18, 184, 134, 0.15);
  --mantine-color-teal-light-hover: rgba(18, 184, 134, 0.2);
  --mantine-color-teal-light-color: var(--mantine-color-teal-3);
  --mantine-color-teal-outline: var(--mantine-color-teal-4);
  --mantine-color-teal-outline-hover: rgba(56, 217, 169, 0.05);
  --mantine-color-green-text: var(--mantine-color-green-4);
  --mantine-color-green-filled: var(--mantine-color-green-8);
  --mantine-color-green-filled-hover: var(--mantine-color-green-9);
  --mantine-color-green-light: rgba(64, 192, 87, 0.15);
  --mantine-color-green-light-hover: rgba(64, 192, 87, 0.2);
  --mantine-color-green-light-color: var(--mantine-color-green-3);
  --mantine-color-green-outline: var(--mantine-color-green-4);
  --mantine-color-green-outline-hover: rgba(105, 219, 124, 0.05);
  --mantine-color-lime-text: var(--mantine-color-lime-4);
  --mantine-color-lime-filled: var(--mantine-color-lime-8);
  --mantine-color-lime-filled-hover: var(--mantine-color-lime-9);
  --mantine-color-lime-light: rgba(130, 201, 30, 0.15);
  --mantine-color-lime-light-hover: rgba(130, 201, 30, 0.2);
  --mantine-color-lime-light-color: var(--mantine-color-lime-3);
  --mantine-color-lime-outline: var(--mantine-color-lime-4);
  --mantine-color-lime-outline-hover: rgba(169, 227, 75, 0.05);
  --mantine-color-yellow-text: var(--mantine-color-yellow-4);
  --mantine-color-yellow-filled: var(--mantine-color-yellow-8);
  --mantine-color-yellow-filled-hover: var(--mantine-color-yellow-9);
  --mantine-color-yellow-light: rgba(250, 176, 5, 0.15);
  --mantine-color-yellow-light-hover: rgba(250, 176, 5, 0.2);
  --mantine-color-yellow-light-color: var(--mantine-color-yellow-3);
  --mantine-color-yellow-outline: var(--mantine-color-yellow-4);
  --mantine-color-yellow-outline-hover: rgba(255, 212, 59, 0.05);
  --mantine-color-orange-text: var(--mantine-color-orange-4);
  --mantine-color-orange-filled: var(--mantine-color-orange-8);
  --mantine-color-orange-filled-hover: var(--mantine-color-orange-9);
  --mantine-color-orange-light: rgba(253, 126, 20, 0.15);
  --mantine-color-orange-light-hover: rgba(253, 126, 20, 0.2);
  --mantine-color-orange-light-color: var(--mantine-color-orange-3);
  --mantine-color-orange-outline: var(--mantine-color-orange-4);
  --mantine-color-orange-outline-hover: rgba(255, 169, 77, 0.05);
}

:root[data-mantine-color-scheme='light'] {
  --mantine-color-scheme: light;
  --mantine-color-bright: var(--mantine-color-black);
  --mantine-color-text: var(--mantine-color-black);
  --mantine-color-body: var(--mantine-color-white);
  --mantine-primary-color-contrast: var(--mantine-color-white);
  --mantine-color-error: var(--mantine-color-red-6);
  --mantine-color-placeholder: var(--mantine-color-gray-5);
  --mantine-color-anchor: var(--mantine-primary-color-filled);
  --mantine-color-default: var(--mantine-color-white);
  --mantine-color-default-hover: var(--mantine-color-gray-0);
  --mantine-color-default-color: var(--mantine-color-gray-9);
  --mantine-color-default-border: var(--mantine-color-gray-4);
  --mantine-color-dimmed: var(--mantine-color-gray-6);
  --mantine-color-dark-text: var(--mantine-color-dark-filled);
  --mantine-color-dark-filled: var(--mantine-color-dark-6);
  --mantine-color-dark-filled-hover: var(--mantine-color-dark-7);
  --mantine-color-dark-light: rgba(56, 56, 56, 0.1);
  --mantine-color-dark-light-hover: rgba(56, 56, 56, 0.12);
  --mantine-color-dark-light-color: var(--mantine-color-dark-6);
  --mantine-color-dark-outline: var(--mantine-color-dark-6);
  --mantine-color-dark-outline-hover: rgba(56, 56, 56, 0.05);
  --mantine-color-gray-text: var(--mantine-color-gray-filled);
  --mantine-color-gray-filled: var(--mantine-color-gray-6);
  --mantine-color-gray-filled-hover: var(--mantine-color-gray-7);
  --mantine-color-gray-light: rgba(134, 142, 150, 0.1);
  --mantine-color-gray-light-hover: rgba(134, 142, 150, 0.12);
  --mantine-color-gray-light-color: var(--mantine-color-gray-6);
  --mantine-color-gray-outline: var(--mantine-color-gray-6);
  --mantine-color-gray-outline-hover: rgba(134, 142, 150, 0.05);
  --mantine-color-red-text: var(--mantine-color-red-filled);
  --mantine-color-red-filled: var(--mantine-color-red-6);
  --mantine-color-red-filled-hover: var(--mantine-color-red-7);
  --mantine-color-red-light: rgba(250, 82, 82, 0.1);
  --mantine-color-red-light-hover: rgba(250, 82, 82, 0.12);
  --mantine-color-red-light-color: var(--mantine-color-red-6);
  --mantine-color-red-outline: var(--mantine-color-red-6);
  --mantine-color-red-outline-hover: rgba(250, 82, 82, 0.05);
  --mantine-color-pink-text: var(--mantine-color-pink-filled);
  --mantine-color-pink-filled: var(--mantine-color-pink-6);
  --mantine-color-pink-filled-hover: var(--mantine-color-pink-7);
  --mantine-color-pink-light: rgba(230, 73, 128, 0.1);
  --mantine-color-pink-light-hover: rgba(230, 73, 128, 0.12);
  --mantine-color-pink-light-color: var(--mantine-color-pink-6);
  --mantine-color-pink-outline: var(--mantine-color-pink-6);
  --mantine-color-pink-outline-hover: rgba(230, 73, 128, 0.05);
  --mantine-color-grape-text: var(--mantine-color-grape-filled);
  --mantine-color-grape-filled: var(--mantine-color-grape-6);
  --mantine-color-grape-filled-hover: var(--mantine-color-grape-7);
  --mantine-color-grape-light: rgba(190, 75, 219, 0.1);
  --mantine-color-grape-light-hover: rgba(190, 75, 219, 0.12);
  --mantine-color-grape-light-color: var(--mantine-color-grape-6);
  --mantine-color-grape-outline: var(--mantine-color-grape-6);
  --mantine-color-grape-outline-hover: rgba(190, 75, 219, 0.05);
  --mantine-color-violet-text: var(--mantine-color-violet-filled);
  --mantine-color-violet-filled: var(--mantine-color-violet-6);
  --mantine-color-violet-filled-hover: var(--mantine-color-violet-7);
  --mantine-color-violet-light: rgba(121, 80, 242, 0.1);
  --mantine-color-violet-light-hover: rgba(121, 80, 242, 0.12);
  --mantine-color-violet-light-color: var(--mantine-color-violet-6);
  --mantine-color-violet-outline: var(--mantine-color-violet-6);
  --mantine-color-violet-outline-hover: rgba(121, 80, 242, 0.05);
  --mantine-color-indigo-text: var(--mantine-color-indigo-filled);
  --mantine-color-indigo-filled: var(--mantine-color-indigo-6);
  --mantine-color-indigo-filled-hover: var(--mantine-color-indigo-7);
  --mantine-color-indigo-light: rgba(76, 110, 245, 0.1);
  --mantine-color-indigo-light-hover: rgba(76, 110, 245, 0.12);
  --mantine-color-indigo-light-color: var(--mantine-color-indigo-6);
  --mantine-color-indigo-outline: var(--mantine-color-indigo-6);
  --mantine-color-indigo-outline-hover: rgba(76, 110, 245, 0.05);
  --mantine-color-blue-text: var(--mantine-color-blue-filled);
  --mantine-color-blue-filled: var(--mantine-color-blue-6);
  --mantine-color-blue-filled-hover: var(--mantine-color-blue-7);
  --mantine-color-blue-light: rgba(34, 139, 230, 0.1);
  --mantine-color-blue-light-hover: rgba(34, 139, 230, 0.12);
  --mantine-color-blue-light-color: var(--mantine-color-blue-6);
  --mantine-color-blue-outline: var(--mantine-color-blue-6);
  --mantine-color-blue-outline-hover: rgba(34, 139, 230, 0.05);
  --mantine-color-cyan-text: var(--mantine-color-cyan-filled);
  --mantine-color-cyan-filled: var(--mantine-color-cyan-6);
  --mantine-color-cyan-filled-hover: var(--mantine-color-cyan-7);
  --mantine-color-cyan-light: rgba(21, 170, 191, 0.1);
  --mantine-color-cyan-light-hover: rgba(21, 170, 191, 0.12);
  --mantine-color-cyan-light-color: var(--mantine-color-cyan-6);
  --mantine-color-cyan-outline: var(--mantine-color-cyan-6);
  --mantine-color-cyan-outline-hover: rgba(21, 170, 191, 0.05);
  --mantine-color-teal-text: var(--mantine-color-teal-filled);
  --mantine-color-teal-filled: var(--mantine-color-teal-6);
  --mantine-color-teal-filled-hover: var(--mantine-color-teal-7);
  --mantine-color-teal-light: rgba(18, 184, 134, 0.1);
  --mantine-color-teal-light-hover: rgba(18, 184, 134, 0.12);
  --mantine-color-teal-light-color: var(--mantine-color-teal-6);
  --mantine-color-teal-outline: var(--mantine-color-teal-6);
  --mantine-color-teal-outline-hover: rgba(18, 184, 134, 0.05);
  --mantine-color-green-text: var(--mantine-color-green-filled);
  --mantine-color-green-filled: var(--mantine-color-green-6);
  --mantine-color-green-filled-hover: var(--mantine-color-green-7);
  --mantine-color-green-light: rgba(64, 192, 87, 0.1);
  --mantine-color-green-light-hover: rgba(64, 192, 87, 0.12);
  --mantine-color-green-light-color: var(--mantine-color-green-6);
  --mantine-color-green-outline: var(--mantine-color-green-6);
  --mantine-color-green-outline-hover: rgba(64, 192, 87, 0.05);
  --mantine-color-lime-text: var(--mantine-color-lime-filled);
  --mantine-color-lime-filled: var(--mantine-color-lime-6);
  --mantine-color-lime-filled-hover: var(--mantine-color-lime-7);
  --mantine-color-lime-light: rgba(130, 201, 30, 0.1);
  --mantine-color-lime-light-hover: rgba(130, 201, 30, 0.12);
  --mantine-color-lime-light-color: var(--mantine-color-lime-6);
  --mantine-color-lime-outline: var(--mantine-color-lime-6);
  --mantine-color-lime-outline-hover: rgba(130, 201, 30, 0.05);
  --mantine-color-yellow-text: var(--mantine-color-yellow-filled);
  --mantine-color-yellow-filled: var(--mantine-color-yellow-6);
  --mantine-color-yellow-filled-hover: var(--mantine-color-yellow-7);
  --mantine-color-yellow-light: rgba(250, 176, 5, 0.1);
  --mantine-color-yellow-light-hover: rgba(250, 176, 5, 0.12);
  --mantine-color-yellow-light-color: var(--mantine-color-yellow-6);
  --mantine-color-yellow-outline: var(--mantine-color-yellow-6);
  --mantine-color-yellow-outline-hover: rgba(250, 176, 5, 0.05);
  --mantine-color-orange-text: var(--mantine-color-orange-filled);
  --mantine-color-orange-filled: var(--mantine-color-orange-6);
  --mantine-color-orange-filled-hover: var(--mantine-color-orange-7);
  --mantine-color-orange-light: rgba(253, 126, 20, 0.1);
  --mantine-color-orange-light-hover: rgba(253, 126, 20, 0.12);
  --mantine-color-orange-light-color: var(--mantine-color-orange-6);
  --mantine-color-orange-outline: var(--mantine-color-orange-6);
  --mantine-color-orange-outline-hover: rgba(253, 126, 20, 0.05);
}

.m_d57069b5 {
  --scrollarea-scrollbar-size: calc(0.75rem * var(--mantine-scale));

  position: relative;
  overflow: hidden;
}

.m_c0783ff9 {
  scrollbar-width: none;
  -ms-overflow-style: none;
  -webkit-overflow-scrolling: touch;
  width: 100%;
  height: 100%;
}

.m_c0783ff9::-webkit-scrollbar {
    display: none;
  }

.m_c0783ff9:where([data-scrollbars='xy'], [data-scrollbars='y']):where([data-offset-scrollbars='xy'], [data-offset-scrollbars='y']) {
      padding-inline-end: var(--scrollarea-scrollbar-size);
      padding-inline-start: unset;
    }

.m_c0783ff9:where([data-scrollbars='xy'], [data-scrollbars='x']):where([data-offset-scrollbars='xy'], [data-offset-scrollbars='x']) {
      padding-bottom: var(--scrollarea-scrollbar-size);
    }

.m_f8f631dd {
  min-width: 100%;
  display: table;
}

.m_c44ba933 {
  user-select: none;
  touch-action: none;
  box-sizing: border-box;
  transition:
    background-color 150ms ease,
    opacity 150ms ease;

  padding: calc(var(--scrollarea-scrollbar-size) / 5);
  display: flex;
  background-color: transparent;
  flex-direction: row;
}

@media (hover: hover) {
    :where([data-mantine-color-scheme='light']) .m_c44ba933:hover {
      background-color: var(--mantine-color-gray-0);
  }

      :where([data-mantine-color-scheme='light']) .m_c44ba933:hover > .m_d8b5e363 {
        background-color: rgba(0, 0, 0, 0.5);
      }

    :where([data-mantine-color-scheme='dark']) .m_c44ba933:hover {
      background-color: var(--mantine-color-dark-8);
  }

      :where([data-mantine-color-scheme='dark']) .m_c44ba933:hover > .m_d8b5e363 {
        background-color: rgba(255, 255, 255, 0.5);
      }
}

@media (hover: none) {
    :where([data-mantine-color-scheme='light']) .m_c44ba933:active {
      background-color: var(--mantine-color-gray-0);
  }

      :where([data-mantine-color-scheme='light']) .m_c44ba933:active > .m_d8b5e363 {
        background-color: rgba(0, 0, 0, 0.5);
      }

    :where([data-mantine-color-scheme='dark']) .m_c44ba933:active {
      background-color: var(--mantine-color-dark-8);
  }

      :where([data-mantine-color-scheme='dark']) .m_c44ba933:active > .m_d8b5e363 {
        background-color: rgba(255, 255, 255, 0.5);
      }
}

.m_c44ba933:where([data-hidden], [data-state='hidden']) {
    display: none;
  }

.m_c44ba933:where([data-orientation='vertical']) {
    width: var(--scrollarea-scrollbar-size);
    top: 0;
    bottom: var(--sa-corner-width);
    inset-inline-end: 0;
  }

.m_c44ba933:where([data-orientation='horizontal']) {
    height: var(--scrollarea-scrollbar-size);
    flex-direction: column;
    bottom: 0;
    inset-inline-start: 0;
    inset-inline-end: var(--sa-corner-width);
  }

.m_d8b5e363 {
  flex: 1;
  border-radius: var(--scrollarea-scrollbar-size);
  position: relative;
  transition: background-color 150ms ease;
  overflow: hidden;
}

.m_d8b5e363::before {
    content: '""';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    min-width: calc(2.75rem * var(--mantine-scale));
    min-height: calc(2.75rem * var(--mantine-scale));
  }

:where([data-mantine-color-scheme='light']) .m_d8b5e363 {
    background-color: rgba(0, 0, 0, 0.4);
}

:where([data-mantine-color-scheme='dark']) .m_d8b5e363 {
    background-color: rgba(255, 255, 255, 0.4);
}

.m_21657268 {
  position: absolute;
  opacity: 0;
  transition: opacity 150ms ease;
  display: block;
  inset-inline-end: 0;
  bottom: 0;
}

:where([data-mantine-color-scheme='light']) .m_21657268 {
    background-color: var(--mantine-color-gray-0);
}

:where([data-mantine-color-scheme='dark']) .m_21657268 {
    background-color: var(--mantine-color-dark-8);
}

.m_21657268:where([data-hovered]) {
    opacity: 1;
  }

.m_21657268:where([data-hidden]) {
    display: none;
  }

.m_87cf2631 {
  background-color: transparent;
  cursor: pointer;
  border: 0;
  padding: 0;
  appearance: none;
  font-size: var(--mantine-font-size-md);
  text-align: left;
  text-decoration: none;
  color: inherit;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
}

  :where([dir="rtl"]) .m_87cf2631 {
    text-align: right;
}

.m_515a97f8 {
  border: 0;
  clip: rect(0 0 0 0);
  height: calc(0.0625rem * var(--mantine-scale));
  width: calc(0.0625rem * var(--mantine-scale));
  margin: calc(-0.0625rem * var(--mantine-scale));
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
}

.m_1b7284a3 {
  --paper-radius: var(--mantine-radius-default);

  outline: 0;
  -webkit-tap-highlight-color: transparent;
  display: block;
  touch-action: manipulation;
  text-decoration: none;
  border-radius: var(--paper-radius);
  box-shadow: var(--paper-shadow);
  background-color: var(--mantine-color-body);
}

  :where([data-mantine-color-scheme='light']) .m_1b7284a3:where([data-with-border]) {
      border: calc(0.0625rem * var(--mantine-scale)) solid var(--mantine-color-gray-3);
}

  :where([data-mantine-color-scheme='dark']) .m_1b7284a3:where([data-with-border]) {
      border: calc(0.0625rem * var(--mantine-scale)) solid var(--mantine-color-dark-4);
}

.m_38a85659 {
  position: absolute;
  border: 1px solid var(--popover-border-color);
  padding: var(--mantine-spacing-sm) var(--mantine-spacing-md);
  box-shadow: var(--popover-shadow, none);
  border-radius: var(--popover-radius, var(--mantine-radius-default));
}

  .m_38a85659:where([data-fixed]) {
    position: fixed;
  }

  .m_38a85659:focus {
    outline: none;
  }

  :where([data-mantine-color-scheme='light']) .m_38a85659 {
    --popover-border-color: var(--mantine-color-gray-2);
    background-color: var(--mantine-color-white);
}

  :where([data-mantine-color-scheme='dark']) .m_38a85659 {
    --popover-border-color: var(--mantine-color-dark-4);
    background-color: var(--mantine-color-dark-6);
}

.m_a31dc6c1 {
  background-color: inherit;
  border: 1px solid var(--popover-border-color);
  z-index: 1;
}

.m_5ae2e3c {
  --loader-size-xs: calc(1.125rem * var(--mantine-scale));
  --loader-size-sm: calc(1.375rem * var(--mantine-scale));
  --loader-size-md: calc(2.25rem * var(--mantine-scale));
  --loader-size-lg: calc(2.75rem * var(--mantine-scale));
  --loader-size-xl: calc(3.625rem * var(--mantine-scale));
  --loader-size: var(--loader-size-md);
  --loader-color: var(--mantine-primary-color-filled);
}

/* ----- Bars loader ----- */
@keyframes m_5d2b3b9d {
  0% {
    transform: scale(0.6);
    opacity: 0;
  }

  50%,
  100% {
    transform: scale(1);
  }
}

.m_7a2bd4cd {
  position: relative;
  width: var(--loader-size);
  height: var(--loader-size);
  display: flex;
  gap: calc(var(--loader-size) / 5);
}

.m_870bb79 {
  flex: 1;
  background: var(--loader-color);
  animation: m_5d2b3b9d 1.2s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  border-radius: calc(0.125rem * var(--mantine-scale));
}

.m_870bb79:nth-of-type(1) {
    animation-delay: -240ms;
  }

.m_870bb79:nth-of-type(2) {
    animation-delay: -120ms;
  }

.m_870bb79:nth-of-type(3) {
    animation-delay: 0;
  }

/* ----- Dots loader ----- */
@keyframes m_aac34a1 {
  0%,
  100% {
    transform: scale(1);
    opacity: 1;
  }

  50% {
    transform: scale(0.6);
    opacity: 0.5;
  }
}

.m_4e3f22d7 {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: calc(var(--loader-size) / 10);
  position: relative;
  width: var(--loader-size);
  height: var(--loader-size);
}

.m_870c4af {
  width: calc(var(--loader-size) / 3 - var(--loader-size) / 15);
  height: calc(var(--loader-size) / 3 - var(--loader-size) / 15);
  border-radius: 50%;
  background: var(--loader-color);
  animation: m_aac34a1 0.8s infinite linear;
}

.m_870c4af:nth-child(2) {
    animation-delay: 0.4s;
  }

/* ----- Oval loader ----- */
@keyframes m_f8e89c4b {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.m_b34414df {
  display: inline-block;
  width: var(--loader-size);
  height: var(--loader-size);
}

.m_b34414df::after {
    content: '';
    display: block;
    width: var(--loader-size);
    height: var(--loader-size);
    border-radius: calc(625rem * var(--mantine-scale));
    border-width: calc(var(--loader-size) / 8);
    border-style: solid;
    border-color: var(--loader-color) var(--loader-color) var(--loader-color) transparent;
    animation: m_f8e89c4b 1.2s linear infinite;
  }

.m_8d3f4000 {
  --ai-size-xs: calc(1.125rem * var(--mantine-scale));
  --ai-size-sm: calc(1.375rem * var(--mantine-scale));
  --ai-size-md: calc(1.75rem * var(--mantine-scale));
  --ai-size-lg: calc(2.125rem * var(--mantine-scale));
  --ai-size-xl: calc(2.75rem * var(--mantine-scale));

  --ai-size-input-xs: calc(1.875rem * var(--mantine-scale));
  --ai-size-input-sm: calc(2.25rem * var(--mantine-scale));
  --ai-size-input-md: calc(2.625rem * var(--mantine-scale));
  --ai-size-input-lg: calc(3.125rem * var(--mantine-scale));
  --ai-size-input-xl: calc(3.75rem * var(--mantine-scale));

  --ai-size: var(--ai-size-md);
  --ai-color: var(--mantine-color-white);

  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  user-select: none;
  overflow: hidden;

  width: var(--ai-size);
  height: var(--ai-size);
  min-width: var(--ai-size);
  min-height: var(--ai-size);
  border-radius: var(--ai-radius, var(--mantine-radius-default));
  background: var(--ai-bg, var(--mantine-primary-color-filled));
  color: var(--ai-color, var(--mantine-color-white));
  border: var(--ai-bd, calc(0.0625rem * var(--mantine-scale)) solid transparent);
  cursor: pointer;
}

  @media (hover: hover) {
    .m_8d3f4000:hover:where(:not([data-loading], :disabled, [data-disabled])) {
      background-color: var(--ai-hover, var(--mantine-primary-color-filled-hover));
      color: var(--ai-hover-color, var(--ai-color));
    }
}

  @media (hover: none) {
    .m_8d3f4000:active:where(:not([data-loading], :disabled, [data-disabled])) {
      background-color: var(--ai-hover, var(--mantine-primary-color-filled-hover));
      color: var(--ai-hover-color, var(--ai-color));
    }
}

  .m_8d3f4000[data-loading] {
    cursor: not-allowed;
  }

  .m_8d3f4000[data-loading] .m_8d3afb97 {
      opacity: 0;
      transform: translateY(100%);
    }

  .m_8d3f4000:where(:disabled:not([data-loading]), [data-disabled]:not([data-loading])) {
    cursor: not-allowed;
    border: calc(0.0625rem * var(--mantine-scale)) solid transparent;
  }

  :where([data-mantine-color-scheme='light']) .m_8d3f4000:where(:disabled:not([data-loading]), [data-disabled]:not([data-loading])) {
      background-color: var(--mantine-color-gray-1);
      color: var(--mantine-color-gray-5);
}

  :where([data-mantine-color-scheme='dark']) .m_8d3f4000:where(:disabled:not([data-loading]), [data-disabled]:not([data-loading])) {
      background-color: var(--mantine-color-dark-6);
      color: var(--mantine-color-dark-3);
}

  .m_8d3f4000:where(:disabled:not([data-loading]), [data-disabled]:not([data-loading])):active {
      transform: none;
    }

.m_302b9fb1 {
  inset: calc(-0.0625rem * var(--mantine-scale));
  position: absolute;
  border-radius: var(--ai-radius, var(--mantine-radius-default));
  display: flex;
  align-items: center;
  justify-content: center;
}

:where([data-mantine-color-scheme='light']) .m_302b9fb1 {
    background-color: rgba(255, 255, 255, 0.15);
}

:where([data-mantine-color-scheme='dark']) .m_302b9fb1 {
    background-color: rgba(0, 0, 0, 0.15);
}

.m_1a0f1b21 {
  --ai-border-width: calc(0.0625rem * var(--mantine-scale));
  display: flex;
}

.m_1a0f1b21 :where(*):focus {
      position: relative;
      z-index: 1;
    }

.m_1a0f1b21[data-orientation='horizontal'] {
    flex-direction: row;
  }

.m_1a0f1b21[data-orientation='horizontal'] .m_8d3f4000:not(:only-child):first-child {
        border-end-end-radius: 0;
        border-start-end-radius: 0;
        border-inline-end-width: calc(var(--ai-border-width) / 2);
      }

.m_1a0f1b21[data-orientation='horizontal'] .m_8d3f4000:not(:only-child):last-child {
        border-end-start-radius: 0;
        border-start-start-radius: 0;
        border-inline-start-width: calc(var(--ai-border-width) / 2);
      }

.m_1a0f1b21[data-orientation='horizontal'] .m_8d3f4000:not(:only-child):not(:first-child):not(:last-child) {
        border-radius: 0;
        border-inline-width: calc(var(--ai-border-width) / 2);
      }

.m_1a0f1b21[data-orientation='vertical'] {
    flex-direction: column;
  }

.m_1a0f1b21[data-orientation='vertical'] .m_8d3f4000:not(:only-child):first-child {
        border-end-start-radius: 0;
        border-end-end-radius: 0;
        border-bottom-width: calc(var(--ai-border-width) / 2);
      }

.m_1a0f1b21[data-orientation='vertical'] .m_8d3f4000:not(:only-child):last-child {
        border-start-start-radius: 0;
        border-start-end-radius: 0;
        border-top-width: calc(var(--ai-border-width) / 2);
      }

.m_1a0f1b21[data-orientation='vertical'] .m_8d3f4000:not(:only-child):not(:first-child):not(:last-child) {
        border-radius: 0;
        border-bottom-width: calc(var(--ai-border-width) / 2);
        border-top-width: calc(var(--ai-border-width) / 2);
      }

.m_8d3afb97 {
  display: flex;
  align-items: center;
  justify-content: center;
  transition:
    transform 150ms ease,
    opacity 100ms ease;
  width: 100%;
  height: 100%;
}

.m_86a44da5 {
  --cb-size-xs: calc(1.125rem * var(--mantine-scale));
  --cb-size-sm: calc(1.375rem * var(--mantine-scale));
  --cb-size-md: calc(1.75rem * var(--mantine-scale));
  --cb-size-lg: calc(2.125rem * var(--mantine-scale));
  --cb-size-xl: calc(2.75rem * var(--mantine-scale));

  --cb-size: var(--cb-size-md);
  --cb-icon-size: 70%;
  --cb-radius: var(--mantine-radius-default);

  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  user-select: none;

  width: var(--cb-size);
  height: var(--cb-size);
  min-width: var(--cb-size);
  min-height: var(--cb-size);
  border-radius: var(--cb-radius);
}

  :where([data-mantine-color-scheme='light']) .m_86a44da5 {
    color: var(--mantine-color-gray-7);
}

  :where([data-mantine-color-scheme='dark']) .m_86a44da5 {
    color: var(--mantine-color-dark-1);
}

  .m_86a44da5[data-disabled],
  .m_86a44da5:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }

@media (hover: hover) {
    :where([data-mantine-color-scheme='light']) .m_220c80f2:where(:not([data-disabled], :disabled)):hover {
      background-color: var(--mantine-color-gray-0);
  }

    :where([data-mantine-color-scheme='dark']) .m_220c80f2:where(:not([data-disabled], :disabled)):hover {
      background-color: var(--mantine-color-dark-6);
  }
}

@media (hover: none) {
    :where([data-mantine-color-scheme='light']) .m_220c80f2:where(:not([data-disabled], :disabled)):active {
      background-color: var(--mantine-color-gray-0);
  }

    :where([data-mantine-color-scheme='dark']) .m_220c80f2:where(:not([data-disabled], :disabled)):active {
      background-color: var(--mantine-color-dark-6);
  }
}

.m_4081bf90 {
  display: flex;
  flex-direction: row;
  flex-wrap: var(--group-wrap, wrap);
  justify-content: var(--group-justify, flex-start);
  align-items: var(--group-align, center);
  gap: var(--group-gap, var(--mantine-spacing-md));
}

  .m_4081bf90:where([data-grow]) > * {
      flex-grow: 1;
      max-width: var(--group-child-width);
    }

.m_9814e45f {
  inset: 0;
  position: absolute;
  background: var(--overlay-bg, rgba(0, 0, 0, 0.6));
  backdrop-filter: var(--overlay-filter);
  -webkit-backdrop-filter: var(--overlay-filter);
  border-radius: var(--overlay-radius, 0);
  z-index: var(--overlay-z-index);
}

  .m_9814e45f:where([data-fixed]) {
    position: fixed;
  }

  .m_9814e45f:where([data-center]) {
    display: flex;
    align-items: center;
    justify-content: center;
  }

.m_615af6c9 {
  line-height: 1;
  padding: 0;
  margin: 0;
  font-weight: 400;
  font-size: var(--mantine-font-size-md);
}

.m_b5489c3c {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--mb-padding, var(--mantine-spacing-md));
  padding-inline-end: calc(var(--mb-padding, var(--mantine-spacing-md)) - calc(0.3125rem * var(--mantine-scale)));
  position: sticky;
  top: 0;
  background-color: var(--mantine-color-body);
  z-index: 1000;
  min-height: calc(3.75rem * var(--mantine-scale));
  transition: padding-inline-end 100ms;
}

.m_60c222c7 {
  position: fixed;
  width: 100%;
  top: 0;
  bottom: 0;
  z-index: var(--mb-z-index);
  pointer-events: none;
}

.m_fd1ab0aa {
  pointer-events: all;
  box-shadow: var(--mb-shadow, var(--mantine-shadow-xl));
}

.m_fd1ab0aa [data-mantine-scrollbar] {
    z-index: 1001;
  }

.m_fd1ab0aa:has([data-mantine-scrollbar][data-state='visible']) .m_b5489c3c {
    padding-inline-end: calc(var(--mb-padding, var(--mantine-spacing-md)) + calc(0.3125rem * var(--mantine-scale)));
  }

.m_606cb269 {
  margin-inline-start: auto;
}

.m_5df29311 {
  padding: var(--mb-padding, var(--mantine-spacing-md));
  padding-top: var(--mb-padding, var(--mantine-spacing-md));
}

.m_5df29311:where(:not(:only-child)) {
    padding-top: 0;
  }

.m_6c018570 {
  position: relative;
  margin-top: var(--input-margin-top, 0rem);
  margin-bottom: var(--input-margin-bottom, 0rem);

  --input-height-xs: calc(1.875rem * var(--mantine-scale));
  --input-height-sm: calc(2.25rem * var(--mantine-scale));
  --input-height-md: calc(2.625rem * var(--mantine-scale));
  --input-height-lg: calc(3.125rem * var(--mantine-scale));
  --input-height-xl: calc(3.75rem * var(--mantine-scale));

  --input-padding-y-xs: calc(0.3125rem * var(--mantine-scale));
  --input-padding-y-sm: calc(0.375rem * var(--mantine-scale));
  --input-padding-y-md: calc(0.5rem * var(--mantine-scale));
  --input-padding-y-lg: calc(0.625rem * var(--mantine-scale));
  --input-padding-y-xl: calc(0.8125rem * var(--mantine-scale));

  --input-height: var(--input-height-sm);
  --input-radius: var(--mantine-radius-default);

  --input-cursor: text;
  --input-text-align: left;
  --input-line-height: calc(var(--input-height) - calc(0.125rem * var(--mantine-scale)));
  --input-padding: calc(var(--input-height) / 3);
  --input-padding-inline-start: var(--input-padding);
  --input-padding-inline-end: var(--input-padding);
  --input-placeholder-color: var(--mantine-color-placeholder);
  --input-color: var(--mantine-color-text);

  --input-left-section-size: var(--input-left-section-width, calc(var(--input-height) - calc(0.125rem * var(--mantine-scale))));

  --input-right-section-size: var(
    --input-right-section-width,
    calc(var(--input-height) - calc(0.125rem * var(--mantine-scale)))
  );

  --input-size: var(--input-height);

  --section-y: calc(0.0625rem * var(--mantine-scale));
  --left-section-start: calc(0.0625rem * var(--mantine-scale));
  --left-section-border-radius: var(--input-radius) 0 0 var(--input-radius);

  --right-section-end: calc(0.0625rem * var(--mantine-scale));
  --right-section-border-radius: 0 var(--input-radius) var(--input-radius) 0;
}

  .m_6c018570[data-variant='unstyled'] {
    --input-padding: 0;
    --input-padding-y: 0;
    --input-padding-inline-start: 0;
    --input-padding-inline-end: 0;
  }

  .m_6c018570[data-pointer] {
    --input-cursor: pointer;
  }

  .m_6c018570[data-multiline] {
    --input-padding-y-xs: calc(0.28125rem * var(--mantine-scale));
    --input-padding-y-sm: calc(0.34375rem * var(--mantine-scale));
    --input-padding-y-md: calc(0.4375rem * var(--mantine-scale));
    --input-padding-y-lg: calc(0.59375rem * var(--mantine-scale));
    --input-padding-y-xl: calc(0.8125rem * var(--mantine-scale));

    --input-size: auto;
    --input-line-height: var(--mantine-line-height);
    --input-padding-y: var(--input-padding-y-sm);
  }

  .m_6c018570[data-with-left-section] {
    --input-padding-inline-start: var(--input-left-section-size);
  }

  .m_6c018570[data-with-right-section] {
    --input-padding-inline-end: var(--input-right-section-size);
  }

  [data-mantine-color-scheme='light'] .m_6c018570 {
    --input-disabled-bg: var(--mantine-color-gray-1);
    --input-disabled-color: var(--mantine-color-gray-6);
}

  [data-mantine-color-scheme='light'] .m_6c018570[data-variant='default'] {
      --input-bd: var(--mantine-color-gray-4);
      --input-bg: var(--mantine-color-white);
      --input-bd-focus: var(--mantine-primary-color-filled);
    }

  [data-mantine-color-scheme='light'] .m_6c018570[data-variant='filled'] {
      --input-bd: transparent;
      --input-bg: var(--mantine-color-gray-1);
      --input-bd-focus: var(--mantine-primary-color-filled);
    }

  [data-mantine-color-scheme='light'] .m_6c018570[data-variant='unstyled'] {
      --input-bd: transparent;
      --input-bg: transparent;
      --input-bd-focus: transparent;
    }

  [data-mantine-color-scheme='dark'] .m_6c018570 {
    --input-disabled-bg: var(--mantine-color-dark-6);
    --input-disabled-color: var(--mantine-color-dark-2);
}

  [data-mantine-color-scheme='dark'] .m_6c018570[data-variant='default'] {
      --input-bd: var(--mantine-color-dark-4);
      --input-bg: var(--mantine-color-dark-6);
      --input-bd-focus: var(--mantine-primary-color-filled);
    }

  [data-mantine-color-scheme='dark'] .m_6c018570[data-variant='filled'] {
      --input-bd: transparent;
      --input-bg: var(--mantine-color-dark-5);
      --input-bd-focus: var(--mantine-primary-color-filled);
    }

  [data-mantine-color-scheme='dark'] .m_6c018570[data-variant='unstyled'] {
      --input-bd: transparent;
      --input-bg: transparent;
      --input-bd-focus: transparent;
    }

  [data-mantine-color-scheme] .m_6c018570[data-error]:not([data-variant='unstyled']) {
      --input-bd: var(--mantine-color-error);
    }

  [data-mantine-color-scheme] .m_6c018570[data-error] {

    --input-color: var(--mantine-color-error);
    --input-placeholder-color: var(--mantine-color-error);
    --input-section-color: var(--mantine-color-error);
}

  :where([dir="rtl"]) .m_6c018570 {
    --input-text-align: right;
    --left-section-border-radius: 0 var(--input-radius) var(--input-radius) 0;
    --right-section-border-radius: var(--input-radius) 0 0 var(--input-radius);
}

.m_8fb7ebe7 {
  -webkit-tap-highlight-color: transparent;
  appearance: none;
  resize: var(--input-resize, none);
  display: block;
  width: 100%;
  transition: border-color 100ms ease;

  text-align: var(--input-text-align);
  color: var(--input-color);
  border: calc(0.0625rem * var(--mantine-scale)) solid var(--input-bd);
  background-color: var(--input-bg);
  font-family: var(--input-font-family, var(--mantine-font-family));
  height: var(--input-size);
  min-height: var(--input-height);
  line-height: var(--input-line-height);
  font-size: var(--input-fz, var(--input-fz, var(--mantine-font-size-sm)));
  border-radius: var(--input-radius);
  padding-inline-start: var(--input-padding-inline-start);
  padding-inline-end: var(--input-padding-inline-end);
  padding-top: var(--input-padding-y, 0rem);
  padding-bottom: var(--input-padding-y, 0rem);
  cursor: var(--input-cursor);
  overflow: var(--input-overflow);
}

/* Used as data attribute in Textarea component, does not have associated prop on the Input component */

.m_8fb7ebe7[data-no-overflow] {
    --input-overflow: hidden;
  }

/* Used as data attribute in JsonInput component, does not have associated prop on the Input component */

.m_8fb7ebe7[data-monospace] {
    --input-font-family: var(--mantine-font-family-monospace);
    --input-fz: calc(var(--input-fz, var(--mantine-font-size-sm)) - calc(0.125rem * var(--mantine-scale)));
  }

.m_8fb7ebe7:focus,
  .m_8fb7ebe7:focus-within {
    outline: none;
    --input-bd: var(--input-bd-focus);
  }

[data-error] .m_8fb7ebe7:focus, [data-error] .m_8fb7ebe7:focus-within {
      --input-bd: var(--mantine-color-error);
    }

.m_8fb7ebe7::placeholder {
    color: var(--input-placeholder-color);
    opacity: 1;
  }

.m_8fb7ebe7::-webkit-inner-spin-button,
  .m_8fb7ebe7::-webkit-outer-spin-button,
  .m_8fb7ebe7::-webkit-search-decoration,
  .m_8fb7ebe7::-webkit-search-cancel-button,
  .m_8fb7ebe7::-webkit-search-results-button,
  .m_8fb7ebe7::-webkit-search-results-decoration {
    appearance: none;
  }

.m_8fb7ebe7[type='number'] {
    -moz-appearance: textfield;
  }

.m_8fb7ebe7:disabled,
  .m_8fb7ebe7[data-disabled] {
    cursor: not-allowed;
    opacity: 0.6;
    background-color: var(--input-disabled-bg);
    color: var(--input-disabled-color);
  }

/* Required to be a separate selector to work in Firefox, can be merged with &:disabled once :has is supported */

.m_8fb7ebe7:has(input:disabled) {
    cursor: not-allowed;
    opacity: 0.6;
    background-color: var(--input-disabled-bg);
    color: var(--input-disabled-color);
  }

.m_82577fc2 {
  pointer-events: var(--section-pointer-events);
  position: absolute;
  z-index: 1;
  inset-inline-start: var(--section-start);
  inset-inline-end: var(--section-end);
  bottom: var(--section-y);
  top: var(--section-y);
  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--section-size);
  border-radius: var(--section-border-radius);
  color: var(--input-section-color, var(--mantine-color-dimmed));
}

.m_82577fc2[data-position='right'] {
    --section-pointer-events: var(--input-right-section-pointer-events);
    --section-end: var(--right-section-end);
    --section-size: var(--input-right-section-size);
    --section-border-radius: var(--right-section-border-radius);
  }

.m_82577fc2[data-position='left'] {
    --section-pointer-events: var(--input-left-section-pointer-events);
    --section-start: var(--left-section-start);
    --section-size: var(--input-left-section-size);
    --section-border-radius: var(--left-section-border-radius);
  }

/* ----- Input.Placeholder ----- */
.m_88bacfd0 {
  color: var(--input-placeholder-color, var(--mantine-color-placeholder));
}
[data-error] .m_88bacfd0 {
    --input-placeholder-color: var(--input-color, var(--mantine-color-placeholder));
  }

/* ----- Input.Wrapper ----- */
.m_46b77525 {
  line-height: var(--mantine-line-height);
}

.m_8fdc1311 {
  display: inline-block;
  font-weight: 500;
  word-break: break-word;
  cursor: default;
  -webkit-tap-highlight-color: transparent;
  font-size: var(--input-label-size, var(--mantine-font-size-sm));
}

.m_78a94662 {
  color: var(--input-asterisk-color, var(--mantine-color-error));
}

.m_8f816625,
.m_fe47ce59 {
  word-wrap: break-word;
  line-height: 1.2;
  display: block;
  margin: 0;
  padding: 0;
}

.m_8f816625 {
  color: var(--mantine-color-error);
  font-size: var(--input-error-size, calc(var(--mantine-font-size-sm) - calc(0.125rem * var(--mantine-scale))));
}

.m_fe47ce59 {
  color: var(--mantine-color-dimmed);
  font-size: var(--input-description-size, calc(var(--mantine-font-size-sm) - calc(0.125rem * var(--mantine-scale))));
}

.m_8bffd616 {
  display: flex;
}

.m_96b553a6 {
  --transition-duration: 150ms;

  top: 0;
  left: 0;
  position: absolute;
  z-index: 0;
  transition-property: transform, width, height;
  transition-timing-function: ease;
  transition-duration: 0ms;
}

  .m_96b553a6:where([data-initialized]) {
    transition-duration: var(--transition-duration);
  }

  .m_96b553a6:where([data-hidden]) {
    background-color: red;
    display: none;
  }

.m_9bdbb667 {
  --accordion-radius: var(--mantine-radius-default);
}

.m_df78851f {
  word-break: break-word;
}

.m_4ba554d4 {
  padding: var(--mantine-spacing-md);
  padding-top: calc(var(--mantine-spacing-xs) / 2);
}

.m_8fa820a0 {
  margin: 0;
  padding: 0;
}

.m_4ba585b8 {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  padding-inline: var(--mantine-spacing-md);
  opacity: 1;
  cursor: pointer;
  background-color: transparent;
}

.m_4ba585b8:where([data-chevron-position='left']) {
    flex-direction: row;
    padding-inline-start: 0;
  }

:where([data-mantine-color-scheme='light']) .m_4ba585b8 {
    color: var(--mantine-color-black);
}

:where([data-mantine-color-scheme='dark']) .m_4ba585b8 {
    color: var(--mantine-color-dark-0);
}

.m_4ba585b8:where(:disabled, [data-disabled]) {
    opacity: 0.4;
    cursor: not-allowed;
  }

@media (hover: hover) {
      :where([data-mantine-color-scheme='light']) .m_6939a5e9:where(:not(:disabled, [data-disabled])):hover, :where([data-mantine-color-scheme='light']) .m_4271d21b:where(:not(:disabled, [data-disabled])):hover {
        background-color: var(--mantine-color-gray-0);
  }

      :where([data-mantine-color-scheme='dark']) .m_6939a5e9:where(:not(:disabled, [data-disabled])):hover, :where([data-mantine-color-scheme='dark']) .m_4271d21b:where(:not(:disabled, [data-disabled])):hover {
        background-color: var(--mantine-color-dark-6);
  }
}

@media (hover: none) {
      :where([data-mantine-color-scheme='light']) .m_6939a5e9:where(:not(:disabled, [data-disabled])):active, :where([data-mantine-color-scheme='light']) .m_4271d21b:where(:not(:disabled, [data-disabled])):active {
        background-color: var(--mantine-color-gray-0);
  }

      :where([data-mantine-color-scheme='dark']) .m_6939a5e9:where(:not(:disabled, [data-disabled])):active, :where([data-mantine-color-scheme='dark']) .m_4271d21b:where(:not(:disabled, [data-disabled])):active {
        background-color: var(--mantine-color-dark-6);
  }
}

.m_df3ffa0f {
  color: inherit;
  font-weight: 400;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-top: var(--mantine-spacing-sm);
  padding-bottom: var(--mantine-spacing-sm);
}

.m_3f35ae96 {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  transition: transform var(--accordion-transition-duration, 200ms) ease;
  width: var(--accordion-chevron-size, calc(0.9375rem * var(--mantine-scale)));
  min-width: var(--accordion-chevron-size, calc(0.9375rem * var(--mantine-scale)));
  transform: rotate(0deg);
}

.m_3f35ae96:where([data-rotate]) {
    transform: rotate(180deg);
  }

.m_3f35ae96:where([data-position='left']) {
    margin-inline-end: var(--mantine-spacing-md);
    margin-inline-start: var(--mantine-spacing-md);
  }

.m_9bd771fe {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-inline-end: var(--mantine-spacing-sm);
}

.m_9bd771fe:where([data-chevron-position='left']) {
    margin-inline-end: 0;
    margin-inline-start: var(--mantine-spacing-lg);
  }

:where([data-mantine-color-scheme='light']) .m_9bd7b098 {
    --item-border-color: var(--mantine-color-gray-3);
    --item-filled-color: var(--mantine-color-gray-0);
}

:where([data-mantine-color-scheme='dark']) .m_9bd7b098 {
    --item-border-color: var(--mantine-color-dark-4);
    --item-filled-color: var(--mantine-color-dark-6);
}

.m_fe19b709 {
  border-bottom: 1px solid var(--item-border-color);
}

.m_1f921b3b {
  border: 1px solid var(--item-border-color);
  transition: background-color 150ms ease;
}

.m_1f921b3b:where([data-active]) {
    background-color: var(--item-filled-color);
  }

.m_1f921b3b:first-of-type {
    border-start-start-radius: var(--accordion-radius);
    border-start-end-radius: var(--accordion-radius);
  }

.m_1f921b3b:first-of-type > [data-accordion-control] {
      border-start-start-radius: var(--accordion-radius);
      border-start-end-radius: var(--accordion-radius);
    }

.m_1f921b3b:last-of-type {
    border-end-start-radius: var(--accordion-radius);
    border-end-end-radius: var(--accordion-radius);
  }

.m_1f921b3b:last-of-type > [data-accordion-control] {
      border-end-start-radius: var(--accordion-radius);
      border-end-end-radius: var(--accordion-radius);
    }

.m_1f921b3b + .m_1f921b3b {
    border-top: 0;
  }

.m_2cdf939a {
  border-radius: var(--accordion-radius);
}

.m_2cdf939a:where([data-active]) {
    background-color: var(--item-filled-color);
  }

.m_9f59b069 {
  background-color: var(--item-filled-color);
  border-radius: var(--accordion-radius);
  border: calc(0.0625rem * var(--mantine-scale)) solid transparent;
  transition: background-color 150ms ease;
}

.m_9f59b069[data-active] {
    border-color: var(--item-border-color);
  }

:where([data-mantine-color-scheme='light']) .m_9f59b069[data-active] {
      background-color: var(--mantine-color-white);
}

:where([data-mantine-color-scheme='dark']) .m_9f59b069[data-active] {
      background-color: var(--mantine-color-dark-7);
}

.m_9f59b069 + .m_9f59b069 {
    margin-top: var(--mantine-spacing-md);
  }

.m_7f854edf {
  position: fixed;
  z-index: var(--affix-z-index);
  inset-inline-start: var(--affix-left);
  inset-inline-end: var(--affix-right);
  top: var(--affix-top);
  bottom: var(--affix-bottom);
}

.m_66836ed3 {
  --alert-radius: var(--mantine-radius-default);
  --alert-bg: var(--mantine-primary-color-light);
  --alert-bd: calc(0.0625rem * var(--mantine-scale)) solid transparent;
  --alert-color: var(--mantine-primary-color-light-color);

  padding: var(--mantine-spacing-md) var(--mantine-spacing-md);
  border-radius: var(--alert-radius);
  position: relative;
  overflow: hidden;
  background-color: var(--alert-bg);
  border: var(--alert-bd);
  color: var(--alert-color);
}

.m_a5d60502 {
  display: flex;
}

.m_667c2793 {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: var(--mantine-spacing-xs);
}

.m_6a03f287 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: var(--mantine-font-size-sm);
  font-weight: 700;
}

.m_6a03f287:where([data-with-close-button]) {
    padding-inline-end: var(--mantine-spacing-md);
  }

.m_698f4f23 {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
}

.m_667f2a6a {
  line-height: 1;
  width: calc(1.25rem * var(--mantine-scale));
  height: calc(1.25rem * var(--mantine-scale));
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-inline-end: var(--mantine-spacing-md);
  margin-top: calc(0.0625rem * var(--mantine-scale));
}

.m_7fa78076 {
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: var(--mantine-font-size-sm);
}

:where([data-mantine-color-scheme='light']) .m_7fa78076 {
    color: var(--mantine-color-black);
}

:where([data-mantine-color-scheme='dark']) .m_7fa78076 {
    color: var(--mantine-color-white);
}

.m_7fa78076:where([data-variant='filled']) {
    color: var(--alert-color);
  }

.m_7fa78076:where([data-variant='white']) {
    color: var(--mantine-color-black);
  }

.m_87f54839 {
  width: calc(1.25rem * var(--mantine-scale));
  height: calc(1.25rem * var(--mantine-scale));
  color: var(--alert-color);
}

.m_b6d8b162 {
  -webkit-tap-highlight-color: transparent;
  text-decoration: none;
  font-size: var(--text-fz, var(--mantine-font-size-md));
  line-height: var(--text-lh, var(--mantine-line-height-md));
  font-weight: normal;
  margin: 0;
  padding: 0;
  color: var(--text-color);
}

  .m_b6d8b162:where([data-truncate]) {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .m_b6d8b162:where([data-truncate='start']) {
    direction: rtl;
    text-align: right;
  }

  :where([dir="rtl"]) .m_b6d8b162:where([data-truncate='start']) {
      direction: ltr;
      text-align: left;
}

  .m_b6d8b162:where([data-variant='gradient']) {
    background-image: var(--text-gradient);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .m_b6d8b162:where([data-line-clamp]) {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: var(--text-line-clamp);
    -webkit-box-orient: vertical;
  }

  .m_b6d8b162:where([data-inherit]) {
    line-height: inherit;
    font-weight: inherit;
    font-size: inherit;
  }

  .m_b6d8b162:where([data-inline]) {
    line-height: 1;
  }

.m_849cf0da {
  color: var(--mantine-color-anchor);
  text-decoration: none;
  appearance: none;
  border: none;
  display: inline;
  padding: 0;
  margin: 0;
  background-color: transparent;
  cursor: pointer;
}

  @media (hover: hover) {

  .m_849cf0da:where([data-underline='hover']):hover {
      text-decoration: underline;
  }
}

  @media (hover: none) {

  .m_849cf0da:where([data-underline='hover']):active {
      text-decoration: underline;
  }
}

  .m_849cf0da:where([data-underline='always']) {
    text-decoration: underline;
  }

  .m_849cf0da:where([data-variant='gradient']),
    .m_849cf0da:where([data-variant='gradient']):hover {
      text-decoration: none;
    }

  .m_849cf0da:where([data-line-clamp]) {
    display: -webkit-box;
  }

.m_89ab340[data-resizing] {
    --app-shell-transition-duration: 0ms !important;
  }
  .m_89ab340[data-disabled] {
    --app-shell-header-offset: 0rem !important;
    --app-shell-navbar-offset: 0rem !important;
  }
  [data-mantine-color-scheme='light'] .m_89ab340 {
    --app-shell-border-color: var(--mantine-color-gray-3);
}
  [data-mantine-color-scheme='dark'] .m_89ab340 {
    --app-shell-border-color: var(--mantine-color-dark-4);
}

.m_45252eee,
.m_9cdde9a,
.m_3b16f56b,
.m_8983817,
.m_3840c879 {
  transition-duration: var(--app-shell-transition-duration);
  transition-timing-function: var(--app-shell-transition-timing-function);
}

.m_45252eee,
.m_9cdde9a {
  position: fixed;
  display: flex;
  flex-direction: column;
  top: var(--app-shell-header-offset, 0rem);
  height: calc(
    100dvh - var(--app-shell-header-offset, 0rem) - var(--app-shell-footer-offset, 0rem)
  );
  background-color: var(--mantine-color-body);
  transition-property: transform, top, height;
}

:where([data-layout='alt']) .m_45252eee, :where([data-layout='alt']) .m_9cdde9a {
    top: 0rem;
    height: 100dvh;
  }

.m_45252eee {
  inset-inline-start: 0;
  width: var(--app-shell-navbar-width);
  transition-property: transform, top, height;
  transform: var(--app-shell-navbar-transform);
  z-index: var(--app-shell-navbar-z-index);
}

:where([dir="rtl"]) .m_45252eee {
    transform: var(--app-shell-navbar-transform-rtl);
}

.m_45252eee:where([data-with-border]) {
    border-inline-end: 1px solid var(--app-shell-border-color);
  }

.m_9cdde9a {
  inset-inline-end: 0;
  width: var(--app-shell-aside-width);
  transform: var(--app-shell-aside-transform);
  z-index: var(--app-shell-aside-z-index);
}

:where([dir="rtl"]) .m_9cdde9a {
    transform: var(--app-shell-aside-transform-rtl);
}

.m_9cdde9a:where([data-with-border]) {
    border-inline-start: 1px solid var(--app-shell-border-color);
  }

.m_8983817 {
  padding-inline-start: calc(var(--app-shell-navbar-offset, 0rem) + var(--app-shell-padding));
  padding-inline-end: calc(var(--app-shell-aside-offset, 0rem) + var(--app-shell-padding));
  padding-top: calc(var(--app-shell-header-offset, 0rem) + var(--app-shell-padding));
  padding-bottom: calc(var(--app-shell-footer-offset, 0rem) + var(--app-shell-padding));
  min-height: 100dvh;
  transition-property: padding;
}

.m_3b16f56b,
.m_3840c879 {
  position: fixed;
  inset-inline: 0;
  transition-property: transform, left, right;
  background-color: var(--mantine-color-body);
}

:where([data-layout='alt']) .m_3b16f56b, :where([data-layout='alt']) .m_3840c879 {
    inset-inline-start: var(--app-shell-navbar-offset, 0rem);
    inset-inline-end: var(--app-shell-aside-offset, 0rem);
  }

.m_3b16f56b {
  top: 0;
  height: var(--app-shell-header-height);
  background-color: var(--mantine-color-body);
  transform: var(--app-shell-header-transform);
  z-index: var(--app-shell-header-z-index);
}

.m_3b16f56b:where([data-with-border]) {
    border-bottom: 1px solid var(--app-shell-border-color);
  }

.m_3840c879 {
  bottom: 0;
  height: calc(var(--app-shell-footer-height) + env(safe-area-inset-bottom));
  padding-bottom: env(safe-area-inset-bottom);
  transform: var(--app-shell-footer-transform);
  z-index: var(--app-shell-footer-z-index);
}

.m_3840c879:where([data-with-border]) {
    border-top: 1px solid var(--app-shell-border-color);
  }

.m_6dcfc7c7 {
  flex-grow: 0;
}

.m_6dcfc7c7:where([data-grow]) {
    flex-grow: 1;
  }

.m_71ac47fc {
  --ar-ratio: 1;
  max-width: 100%;
}

  .m_71ac47fc > :where(*:not(style)) {
    aspect-ratio: var(--ar-ratio);
    width: 100%;
  }

  .m_71ac47fc > :where(img, video) {
    object-fit: cover;
  }

.m_88b62a41 {
  --combobox-padding: calc(0.25rem * var(--mantine-scale));
  padding: var(--combobox-padding);
}

  .m_88b62a41:has([data-mantine-scrollbar]) {
    padding-inline-end: 0;
  }

  .m_88b62a41[data-hidden] {
    display: none;
  }

/* Variables must be both on dropdown and options to support usage of Combobox.Options without Combobox.Dropdown */
.m_88b62a41,
.m_b2821a6e {
  --combobox-option-padding-xs: calc(0.25rem * var(--mantine-scale)) calc(0.5rem * var(--mantine-scale));
  --combobox-option-padding-sm: calc(0.375rem * var(--mantine-scale)) calc(0.625rem * var(--mantine-scale));
  --combobox-option-padding-md: calc(0.5rem * var(--mantine-scale)) calc(0.75rem * var(--mantine-scale));
  --combobox-option-padding-lg: calc(0.625rem * var(--mantine-scale)) calc(1rem * var(--mantine-scale));
  --combobox-option-padding-xl: calc(0.875rem * var(--mantine-scale)) calc(1.25rem * var(--mantine-scale));
  --combobox-option-padding: var(--combobox-option-padding-sm);
}

.m_92253aa5 {
  padding: var(--combobox-option-padding);
  font-size: var(--combobox-option-fz, var(--mantine-font-size-sm));
  border-radius: var(--mantine-radius-default);
  background-color: transparent;
  color: inherit;
  cursor: pointer;
  word-break: break-word;
}

.m_92253aa5:where([data-combobox-selected]) {
    background-color: var(--mantine-primary-color-filled);
    color: var(--mantine-color-white);
  }

.m_92253aa5:where([data-combobox-disabled]) {
    cursor: not-allowed;
    opacity: 0.35;
  }

@media (hover: hover) {
      :where([data-mantine-color-scheme='light']) .m_92253aa5:hover:where(:not([data-combobox-selected], [data-combobox-disabled])) {
        background-color: var(--mantine-color-gray-0);
  }

      :where([data-mantine-color-scheme='dark']) .m_92253aa5:hover:where(:not([data-combobox-selected], [data-combobox-disabled])) {
        background-color: var(--mantine-color-dark-7);
  }
}

@media (hover: none) {
      :where([data-mantine-color-scheme='light']) .m_92253aa5:active:where(:not([data-combobox-selected], [data-combobox-disabled])) {
        background-color: var(--mantine-color-gray-0);
  }

      :where([data-mantine-color-scheme='dark']) .m_92253aa5:active:where(:not([data-combobox-selected], [data-combobox-disabled])) {
        background-color: var(--mantine-color-dark-7);
  }
}

.m_985517d8 {
  margin-inline: calc(var(--combobox-padding) * -1);
  margin-top: calc(var(--combobox-padding) * -1);
  width: calc(100% + var(--combobox-padding) * 2);
  border-top-width: 0;
  border-inline-width: 0;
  border-end-start-radius: 0;
  border-end-end-radius: 0;
  margin-bottom: var(--combobox-padding);
  position: relative;
}

:where([data-mantine-color-scheme='light']) .m_985517d8, :where([data-mantine-color-scheme='light']) .m_985517d8:focus {
      border-color: var(--mantine-color-gray-2);
}

:where([data-mantine-color-scheme='dark']) .m_985517d8, :where([data-mantine-color-scheme='dark']) .m_985517d8:focus {
      border-color: var(--mantine-color-dark-4);
}

:where([data-mantine-color-scheme='light']) .m_985517d8 {
    background-color: var(--mantine-color-white);
}

:where([data-mantine-color-scheme='dark']) .m_985517d8 {
    background-color: var(--mantine-color-dark-7);
}

.m_2530cd1d {
  font-size: var(--combobox-option-fz, var(--mantine-font-size-sm));
  text-align: center;
  padding: var(--combobox-option-padding);
  color: var(--mantine-color-dimmed);
}

.m_858f94bd,
.m_82b967cb {
  font-size: var(--combobox-option-fz, var(--mantine-font-size-sm));
  border: 0 solid transparent;
  margin-inline: calc(var(--combobox-padding) * -1);
  padding: var(--combobox-option-padding);
}

:where([data-mantine-color-scheme='light']) .m_858f94bd, :where([data-mantine-color-scheme='light']) .m_82b967cb {
    border-color: var(--mantine-color-gray-2);
}

:where([data-mantine-color-scheme='dark']) .m_858f94bd, :where([data-mantine-color-scheme='dark']) .m_82b967cb {
    border-color: var(--mantine-color-dark-4);
}

.m_82b967cb {
  border-top-width: calc(0.0625rem * var(--mantine-scale));
  margin-top: var(--combobox-padding);
  margin-bottom: calc(var(--combobox-padding) * -1);
}

.m_858f94bd {
  border-bottom-width: calc(0.0625rem * var(--mantine-scale));
  margin-bottom: var(--combobox-padding);
  margin-top: calc(var(--combobox-padding) * -1);
}

.m_254f3e4f:has(.m_2bb2e9e5:only-child) {
    display: none;
  }

.m_2bb2e9e5 {
  color: var(--mantine-color-dimmed);
  font-size: calc(var(--combobox-option-fz, var(--mantine-font-size-sm)) * 0.85);
  padding: var(--combobox-option-padding);
  font-weight: 500;
  position: relative;
  display: flex;
  align-items: center;
}

.m_2bb2e9e5::after {
    content: '';
    flex: 1;
    inset-inline: 0;
    height: calc(0.0625rem * var(--mantine-scale));
    margin-inline-start: var(--mantine-spacing-xs);
  }

:where([data-mantine-color-scheme='light']) .m_2bb2e9e5::after {
      background-color: var(--mantine-color-gray-2);
}

:where([data-mantine-color-scheme='dark']) .m_2bb2e9e5::after {
      background-color: var(--mantine-color-dark-4);
}

.m_2bb2e9e5:only-child {
    display: none;
  }

/* ------- Combobox.Chevron ------- */
.m_2943220b {
  --combobox-chevron-size-xs: calc(0.875rem * var(--mantine-scale));
  --combobox-chevron-size-sm: calc(1.125rem * var(--mantine-scale));
  --combobox-chevron-size-md: calc(1.25rem * var(--mantine-scale));
  --combobox-chevron-size-lg: calc(1.5rem * var(--mantine-scale));
  --combobox-chevron-size-xl: calc(1.75rem * var(--mantine-scale));
  --combobox-chevron-size: var(--combobox-chevron-size-sm);

  width: var(--combobox-chevron-size);
  height: var(--combobox-chevron-size);
}
:where([data-mantine-color-scheme='light']) .m_2943220b {
    color: var(--mantine-color-gray-6);
}
:where([data-mantine-color-scheme='dark']) .m_2943220b {
    color: var(--mantine-color-dark-3);
}
.m_2943220b:where([data-error]) {
    color: var(--mantine-color-error);
  }

/* ------- OptionsDropdown ------- */
.m_390b5f4 {
  display: flex;
  align-items: center;
  gap: calc(0.5rem * var(--mantine-scale));
}
.m_390b5f4:where([data-reverse]) {
    justify-content: space-between;
  }

.m_8ee53fc2 {
  opacity: 0.4;
  width: 0.8em;
  min-width: 0.8em;
  height: 0.8em;
}

:where([data-combobox-selected]) .m_8ee53fc2 {
    opacity: 1;
  }

.m_5f75b09e {
  --label-lh-xs: calc(1rem * var(--mantine-scale));
  --label-lh-sm: calc(1.25rem * var(--mantine-scale));
  --label-lh-md: calc(1.5rem * var(--mantine-scale));
  --label-lh-lg: calc(1.875rem * var(--mantine-scale));
  --label-lh-xl: calc(2.25rem * var(--mantine-scale));
  --label-lh: var(--label-lh-sm);
}

  .m_5f75b09e[data-label-position='left'] {
    --label-order: 1;
    --label-offset-end: var(--mantine-spacing-sm);
    --label-offset-start: 0;
  }

  .m_5f75b09e[data-label-position='right'] {
    --label-order: 2;
    --label-offset-end: 0;
    --label-offset-start: var(--mantine-spacing-sm);
  }

.m_5f6e695e {
  display: flex;
}

.m_d3ea56bb {
  --label-cursor: var(--mantine-cursor-type);

  -webkit-tap-highlight-color: transparent;
  display: inline-flex;
  flex-direction: column;
  font-size: var(--label-fz, var(--mantine-font-size-sm));
  line-height: var(--label-lh);
  cursor: var(--label-cursor);
  order: var(--label-order);
}

fieldset:disabled .m_d3ea56bb,
  .m_d3ea56bb[data-disabled] {
    --label-cursor: not-allowed;
  }

.m_8ee546b8 {
  cursor: var(--label-cursor);
  color: inherit;
  padding-inline-start: var(--label-offset-start);
  padding-inline-end: var(--label-offset-end);
}

:where([data-mantine-color-scheme='light']) fieldset:disabled .m_8ee546b8, :where([data-mantine-color-scheme='light']) .m_8ee546b8:where([data-disabled]) {
      color: var(--mantine-color-gray-5);
}

:where([data-mantine-color-scheme='dark']) fieldset:disabled .m_8ee546b8, :where([data-mantine-color-scheme='dark']) .m_8ee546b8:where([data-disabled]) {
      color: var(--mantine-color-dark-3);
}

.m_328f68c0 {
  margin-top: calc(var(--mantine-spacing-xs) / 2);
  padding-inline-start: var(--label-offset-start);
  padding-inline-end: var(--label-offset-end);
}

.m_8e8a99cc {
  margin-top: calc(var(--mantine-spacing-xs) / 2);
  padding-inline-start: var(--label-offset-start);
  padding-inline-end: var(--label-offset-end);
}

.m_26775b0a {
  --card-radius: var(--mantine-radius-default);

  display: block;
  width: 100%;
  border-radius: var(--card-radius);
  cursor: pointer;
}

  .m_26775b0a :where(*) {
    cursor: inherit;
  }

  .m_26775b0a:where([data-with-border]) {
    border: calc(0.0625rem * var(--mantine-scale)) solid transparent;
  }

  :where([data-mantine-color-scheme='light']) .m_26775b0a:where([data-with-border]) {
      border-color: var(--mantine-color-gray-3);
}

  :where([data-mantine-color-scheme='dark']) .m_26775b0a:where([data-with-border]) {
      border-color: var(--mantine-color-dark-4);
}

.m_5e5256ee {
  --checkbox-size-xs: calc(1rem * var(--mantine-scale));
  --checkbox-size-sm: calc(1.25rem * var(--mantine-scale));
  --checkbox-size-md: calc(1.5rem * var(--mantine-scale));
  --checkbox-size-lg: calc(1.875rem * var(--mantine-scale));
  --checkbox-size-xl: calc(2.25rem * var(--mantine-scale));

  --checkbox-size: var(--checkbox-size-sm);
  --checkbox-color: var(--mantine-primary-color-filled);
  --checkbox-icon-color: var(--mantine-color-white);

  position: relative;
  border: calc(0.0625rem * var(--mantine-scale)) solid transparent;
  width: var(--checkbox-size);
  min-width: var(--checkbox-size);
  height: var(--checkbox-size);
  min-height: var(--checkbox-size);
  border-radius: var(--checkbox-radius, var(--mantine-radius-default));
  transition:
    border-color 100ms ease,
    background-color 100ms ease;
  cursor: var(--mantine-cursor-type);
  -webkit-tap-highlight-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
}

  :where([data-mantine-color-scheme='light']) .m_5e5256ee {
    background-color: var(--mantine-color-white);
    border-color: var(--mantine-color-gray-4);
}

  :where([data-mantine-color-scheme='dark']) .m_5e5256ee {
    background-color: var(--mantine-color-dark-6);
    border-color: var(--mantine-color-dark-4);
}

  .m_5e5256ee[data-indeterminate],
  .m_5e5256ee[data-checked] {
    background-color: var(--checkbox-color);
    border-color: var(--checkbox-color);
  }

  .m_5e5256ee[data-indeterminate] > .m_1b1c543a, .m_5e5256ee[data-checked] > .m_1b1c543a {
      opacity: 1;
      transform: none;
      color: var(--checkbox-icon-color);
    }

  .m_5e5256ee[data-disabled] {
    cursor: not-allowed;
  }

  :where([data-mantine-color-scheme='light']) .m_5e5256ee[data-disabled] {
      background-color: var(--mantine-color-gray-2);
      border-color: var(--mantine-color-gray-3);
}

  :where([data-mantine-color-scheme='dark']) .m_5e5256ee[data-disabled] {
      background-color: var(--mantine-color-dark-6);
      border-color: var(--mantine-color-dark-6);
}

  [data-mantine-color-scheme='light'] .m_5e5256ee[data-disabled][data-checked] > .m_1b1c543a {
        color: var(--mantine-color-gray-5);
}

  [data-mantine-color-scheme='dark'] .m_5e5256ee[data-disabled][data-checked] > .m_1b1c543a {
        color: var(--mantine-color-dark-3);
}

.m_76e20374[data-indeterminate]:not([data-disabled]),
  .m_76e20374[data-checked]:not([data-disabled]) {
    background-color: transparent;
    border-color: var(--checkbox-color);
  }

.m_76e20374[data-indeterminate]:not([data-disabled]) > .m_1b1c543a, .m_76e20374[data-checked]:not([data-disabled]) > .m_1b1c543a {
      color: var(--checkbox-color);
      opacity: 1;
      transform: none;
    }

.m_1b1c543a {
  display: block;
  width: 60%;
  color: transparent;
  pointer-events: none;
  transform: translateY(calc(0.3125rem * var(--mantine-scale))) scale(0.5);
  opacity: 1;
  transition:
    transform 100ms ease,
    opacity 100ms ease;
}

.m_bf2d988c {
  --checkbox-size-xs: calc(1rem * var(--mantine-scale));
  --checkbox-size-sm: calc(1.25rem * var(--mantine-scale));
  --checkbox-size-md: calc(1.5rem * var(--mantine-scale));
  --checkbox-size-lg: calc(1.875rem * var(--mantine-scale));
  --checkbox-size-xl: calc(2.25rem * var(--mantine-scale));

  --checkbox-size: var(--checkbox-size-sm);
  --checkbox-color: var(--mantine-primary-color-filled);
  --checkbox-icon-color: var(--mantine-color-white);
}

.m_26062bec {
  position: relative;
  width: var(--checkbox-size);
  height: var(--checkbox-size);
  order: 1;
}

.m_26062bec:where([data-label-position='left']) {
    order: 2;
  }

.m_26063560 {
  appearance: none;
  border: calc(0.0625rem * var(--mantine-scale)) solid transparent;
  width: var(--checkbox-size);
  height: var(--checkbox-size);
  border-radius: var(--checkbox-radius, var(--mantine-radius-default));
  padding: 0;
  display: block;
  margin: 0;
  transition:
    border-color 100ms ease,
    background-color 100ms ease;
  cursor: var(--mantine-cursor-type);
  -webkit-tap-highlight-color: transparent;
}

:where([data-mantine-color-scheme='light']) .m_26063560 {
    background-color: var(--mantine-color-white);
    border-color: var(--mantine-color-gray-4);
}

:where([data-mantine-color-scheme='dark']) .m_26063560 {
    background-color: var(--mantine-color-dark-6);
    border-color: var(--mantine-color-dark-4);
}

.m_26063560:where([data-error]) {
    border-color: var(--mantine-color-error);
  }

.m_26063560[data-indeterminate],
  .m_26063560:checked {
    background-color: var(--checkbox-color);
    border-color: var(--checkbox-color);
  }

.m_26063560[data-indeterminate] + .m_bf295423, .m_26063560:checked + .m_bf295423 {
      opacity: 1;
      transform: none;
    }

.m_26063560:disabled {
    cursor: not-allowed;
  }

:where([data-mantine-color-scheme='light']) .m_26063560:disabled {
      background-color: var(--mantine-color-gray-2);
      border-color: var(--mantine-color-gray-3);
}

:where([data-mantine-color-scheme='dark']) .m_26063560:disabled {
      background-color: var(--mantine-color-dark-6);
      border-color: var(--mantine-color-dark-6);
}

[data-mantine-color-scheme='light'] .m_26063560:disabled + .m_bf295423 {
        color: var(--mantine-color-gray-5);
}

[data-mantine-color-scheme='dark'] .m_26063560:disabled + .m_bf295423 {
        color: var(--mantine-color-dark-3);
}

.m_215c4542 + .m_bf295423 {
    color: var(--checkbox-color);
  }

.m_215c4542[data-indeterminate]:not(:disabled),
  .m_215c4542:checked:not(:disabled) {
    background-color: transparent;
    border-color: var(--checkbox-color);
  }

.m_215c4542[data-indeterminate]:not(:disabled) + .m_bf295423, .m_215c4542:checked:not(:disabled) + .m_bf295423 {
      color: var(--checkbox-color);
      opacity: 1;
      transform: none;
    }

.m_bf295423 {
  position: absolute;
  inset: 0;
  width: 60%;
  margin: auto;
  color: var(--checkbox-icon-color);
  pointer-events: none;
  transform: translateY(calc(0.3125rem * var(--mantine-scale))) scale(0.5);
  opacity: 0;
  transition:
    transform 100ms ease,
    opacity 100ms ease;
}

/* Avatar.Group root element */
.m_11def92b {
  --ag-spacing: var(--mantine-spacing-sm);
  --ag-offset: calc(var(--ag-spacing) * -1);

  display: flex;
  padding-inline-start: var(--ag-spacing);
}

/* Avatar root element */
.m_f85678b6 {
  --avatar-size-xs: calc(1rem * var(--mantine-scale));
  --avatar-size-sm: calc(1.625rem * var(--mantine-scale));
  --avatar-size-md: calc(2.375rem * var(--mantine-scale));
  --avatar-size-lg: calc(3.5rem * var(--mantine-scale));
  --avatar-size-xl: calc(5.25rem * var(--mantine-scale));

  --avatar-size: var(--avatar-size-md);
  --avatar-radius: calc(62.5rem * var(--mantine-scale));
  --avatar-bg: var(--mantine-color-gray-light);
  --avatar-bd: calc(0.0625rem * var(--mantine-scale)) solid transparent;
  --avatar-color: var(--mantine-color-gray-light-color);
  --avatar-placeholder-fz: calc(var(--avatar-size) / 2.5);

  -webkit-tap-highlight-color: transparent;
  position: relative;
  display: block;
  user-select: none;
  overflow: hidden;
  border-radius: var(--avatar-radius);
  text-decoration: none;
  padding: 0;
  width: var(--avatar-size);
  height: var(--avatar-size);
  min-width: var(--avatar-size);
}
.m_f85678b6:where([data-within-group]) {
    margin-inline-start: var(--ag-offset);
    border: 2px solid var(--mantine-color-body);
    background: var(--mantine-color-body);
  }

.m_11f8ac07 {
  object-fit: cover;
  width: 100%;
  height: 100%;
  display: block;
}

.m_104cd71f {
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  user-select: none;
  border-radius: var(--avatar-radius);
  font-size: var(--avatar-placeholder-fz);
  background: var(--avatar-bg);
  border: var(--avatar-bd);
  color: var(--avatar-color);
}

.m_104cd71f > [data-avatar-placeholder-icon] {
    width: 70%;
    height: 70%;
  }

.m_2ce0de02 {
  background-size: cover;
  background-position: center;
  display: block;
  width: 100%;
  border: 0;
  text-decoration: none;
  border-radius: var(--bi-radius, 0);
}

.m_347db0ec {
  --badge-height-xs: calc(1rem * var(--mantine-scale));
  --badge-height-sm: calc(1.125rem * var(--mantine-scale));
  --badge-height-md: calc(1.25rem * var(--mantine-scale));
  --badge-height-lg: calc(1.625rem * var(--mantine-scale));
  --badge-height-xl: calc(2rem * var(--mantine-scale));

  --badge-fz-xs: calc(0.5625rem * var(--mantine-scale));
  --badge-fz-sm: calc(0.625rem * var(--mantine-scale));
  --badge-fz-md: calc(0.6875rem * var(--mantine-scale));
  --badge-fz-lg: calc(0.8125rem * var(--mantine-scale));
  --badge-fz-xl: calc(1rem * var(--mantine-scale));

  --badge-padding-x-xs: calc(0.375rem * var(--mantine-scale));
  --badge-padding-x-sm: calc(0.5rem * var(--mantine-scale));
  --badge-padding-x-md: calc(0.625rem * var(--mantine-scale));
  --badge-padding-x-lg: calc(0.75rem * var(--mantine-scale));
  --badge-padding-x-xl: calc(1rem * var(--mantine-scale));

  --badge-height: var(--badge-height-md);
  --badge-fz: var(--badge-fz-md);
  --badge-padding-x: var(--badge-padding-x-md);
  --badge-radius: calc(62.5rem * var(--mantine-scale));
  --badge-lh: calc(var(--badge-height) - calc(0.125rem * var(--mantine-scale)));
  --badge-color: var(--mantine-color-white);
  --badge-bg: var(--mantine-primary-color-filled);
  --badge-bd: calc(0.0625rem * var(--mantine-scale)) solid transparent;

  -webkit-tap-highlight-color: transparent;
  font-size: var(--badge-fz);
  border-radius: var(--badge-radius);
  height: var(--badge-height);
  line-height: var(--badge-lh);
  text-decoration: none;
  padding: 0 var(--badge-padding-x);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  text-transform: uppercase;
  font-weight: 700;
  letter-spacing: calc(0.015625rem * var(--mantine-scale));
  cursor: inherit;
  text-overflow: ellipsis;
  overflow: hidden;
  color: var(--badge-color);
  background: var(--badge-bg);
  border: var(--badge-bd);
}

  .m_347db0ec:where([data-block]) {
    display: flex;
    width: 100%;
  }

  .m_347db0ec:where([data-circle]) {
    padding-inline: calc(0.125rem * var(--mantine-scale));
    width: var(--badge-height);
  }

.m_fbd81e3d {
  --badge-dot-size: calc(var(--badge-height) / 3.4);
}

:where([data-mantine-color-scheme='light']) .m_fbd81e3d {
    background-color: var(--mantine-color-white);
    border-color: var(--mantine-color-gray-4);
    color: var(--mantine-color-black);
}

:where([data-mantine-color-scheme='dark']) .m_fbd81e3d {
    background-color: var(--mantine-color-dark-5);
    border-color: var(--mantine-color-dark-5);
    color: var(--mantine-color-white);
}

.m_fbd81e3d::before {
    content: '';
    display: block;
    width: var(--badge-dot-size);
    height: var(--badge-dot-size);
    border-radius: var(--badge-dot-size);
    background-color: var(--badge-dot-color);
    margin-inline-end: var(--badge-dot-size);
  }

.m_5add502a {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.m_91fdda9b {
  --badge-section-margin: calc(var(--mantine-spacing-xs) / 2);

  display: inline-flex;
  justify-content: center;
  align-items: center;
}

.m_91fdda9b:where([data-position='left']) {
    margin-inline-end: var(--badge-section-margin);
  }

.m_91fdda9b:where([data-position='right']) {
    margin-inline-start: var(--badge-section-margin);
  }

.m_ddec01c0 {
  --blockquote-border: 3px solid var(--bq-bd);

  position: relative;
  margin: 0;
  border-inline-start: var(--blockquote-border);
  border-start-end-radius: var(--bq-radius);
  border-end-end-radius: var(--bq-radius);
  padding: var(--mantine-spacing-xl) calc(2.375rem * var(--mantine-scale));
}

  :where([data-mantine-color-scheme='light']) .m_ddec01c0 {
    background-color: var(--bq-bg-light);
}

  :where([data-mantine-color-scheme='dark']) .m_ddec01c0 {
    background-color: var(--bq-bg-dark);
}

.m_dde7bd57 {
  --blockquote-icon-offset: calc(var(--bq-icon-size) / -2);

  position: absolute;
  color: var(--bq-bd);
  background-color: var(--mantine-color-body);
  display: flex;
  align-items: center;
  justify-content: center;
  top: var(--blockquote-icon-offset);
  inset-inline-start: var(--blockquote-icon-offset);
  width: var(--bq-icon-size);
  height: var(--bq-icon-size);
  border-radius: var(--bq-icon-size);
}

.m_dde51a35 {
  display: block;
  margin-top: var(--mantine-spacing-md);
  opacity: 0.6;
  font-size: 85%;
}

.m_8b3717df {
  display: flex;
  align-items: center;
}

.m_f678d540 {
  line-height: 1;
  white-space: nowrap;
  -webkit-tap-highlight-color: transparent;
}

.m_3b8f2208 {
  margin-inline: var(--bc-separator-margin, var(--mantine-spacing-xs));
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

:where([data-mantine-color-scheme='light']) .m_3b8f2208 {
    color: var(--mantine-color-gray-7);
}

:where([data-mantine-color-scheme='dark']) .m_3b8f2208 {
    color: var(--mantine-color-dark-2);
}

.m_fea6bf1a {
  --burger-size-xs: calc(0.75rem * var(--mantine-scale));
  --burger-size-sm: calc(1.125rem * var(--mantine-scale));
  --burger-size-md: calc(1.5rem * var(--mantine-scale));
  --burger-size-lg: calc(2.125rem * var(--mantine-scale));
  --burger-size-xl: calc(2.625rem * var(--mantine-scale));

  --burger-size: var(--burger-size-md);
  --burger-line-size: calc(var(--burger-size) / 12);

  width: calc(var(--burger-size) + var(--mantine-spacing-xs));
  height: calc(var(--burger-size) + var(--mantine-spacing-xs));
  padding: calc(var(--mantine-spacing-xs) / 2);
  cursor: pointer;
}

  :where([data-mantine-color-scheme='light']) .m_fea6bf1a {
    --burger-color: var(--mantine-color-black);
}

  :where([data-mantine-color-scheme='dark']) .m_fea6bf1a {
    --burger-color: var(--mantine-color-white);
}

.m_d4fb9cad {
  position: relative;
  user-select: none;
}

.m_d4fb9cad,
  .m_d4fb9cad::before,
  .m_d4fb9cad::after {
    display: block;
    width: var(--burger-size);
    height: var(--burger-line-size);
    background-color: var(--burger-color);
    outline: calc(0.0625rem * var(--mantine-scale)) solid transparent;
    transition-property: background-color, transform;
    transition-duration: var(--burger-transition-duration, 300ms);
    transition-timing-function: var(--burger-transition-timing-function, ease);
  }

.m_d4fb9cad::before,
  .m_d4fb9cad::after {
    position: absolute;
    content: '';
    inset-inline-start: 0;
  }

.m_d4fb9cad::before {
    top: calc(var(--burger-size) / -3);
  }

.m_d4fb9cad::after {
    top: calc(var(--burger-size) / 3);
  }

.m_d4fb9cad[data-opened] {
    background-color: transparent;
  }

.m_d4fb9cad[data-opened]::before {
      transform: translateY(calc(var(--burger-size) / 3)) rotate(45deg);
    }

.m_d4fb9cad[data-opened]::after {
      transform: translateY(calc(var(--burger-size) / -3)) rotate(-45deg);
    }

.m_77c9d27d {
  --button-height-xs: calc(1.875rem * var(--mantine-scale));
  --button-height-sm: calc(2.25rem * var(--mantine-scale));
  --button-height-md: calc(2.625rem * var(--mantine-scale));
  --button-height-lg: calc(3.125rem * var(--mantine-scale));
  --button-height-xl: calc(3.75rem * var(--mantine-scale));

  --button-height-compact-xs: calc(1.375rem * var(--mantine-scale));
  --button-height-compact-sm: calc(1.625rem * var(--mantine-scale));
  --button-height-compact-md: calc(1.875rem * var(--mantine-scale));
  --button-height-compact-lg: calc(2.125rem * var(--mantine-scale));
  --button-height-compact-xl: calc(2.5rem * var(--mantine-scale));

  --button-padding-x-xs: calc(0.875rem * var(--mantine-scale));
  --button-padding-x-sm: calc(1.125rem * var(--mantine-scale));
  --button-padding-x-md: calc(1.375rem * var(--mantine-scale));
  --button-padding-x-lg: calc(1.625rem * var(--mantine-scale));
  --button-padding-x-xl: calc(2rem * var(--mantine-scale));

  --button-padding-x-compact-xs: calc(0.4375rem * var(--mantine-scale));
  --button-padding-x-compact-sm: calc(0.5rem * var(--mantine-scale));
  --button-padding-x-compact-md: calc(0.625rem * var(--mantine-scale));
  --button-padding-x-compact-lg: calc(0.75rem * var(--mantine-scale));
  --button-padding-x-compact-xl: calc(0.875rem * var(--mantine-scale));

  --button-height: var(--button-height-sm);
  --button-padding-x: var(--button-padding-x-sm);
  --button-color: var(--mantine-color-white);

  user-select: none;
  font-weight: 600;
  position: relative;
  line-height: 1;
  text-align: center;
  overflow: hidden;

  width: auto;
  cursor: pointer;
  display: inline-block;
  border-radius: var(--button-radius, var(--mantine-radius-default));
  font-size: var(--button-fz, var(--mantine-font-size-sm));
  background: var(--button-bg, var(--mantine-primary-color-filled));
  border: var(--button-bd, calc(0.0625rem * var(--mantine-scale)) solid transparent);
  color: var(--button-color, var(--mantine-color-white));
  height: var(--button-height, var(--button-height-sm));
  padding-inline: var(--button-padding-x, var(--button-padding-x-sm));
  vertical-align: middle;
}

  .m_77c9d27d:where([data-block]) {
    display: block;
    width: 100%;
  }

  .m_77c9d27d:where([data-with-left-section]) {
    padding-inline-start: calc(var(--button-padding-x) / 1.5);
  }

  .m_77c9d27d:where([data-with-right-section]) {
    padding-inline-end: calc(var(--button-padding-x) / 1.5);
  }

  .m_77c9d27d:where(:disabled:not([data-loading]), [data-disabled]:not([data-loading])) {
    cursor: not-allowed;
    border: calc(0.0625rem * var(--mantine-scale)) solid transparent;
    transform: none;
  }

  :where([data-mantine-color-scheme='light']) .m_77c9d27d:where(:disabled:not([data-loading]), [data-disabled]:not([data-loading])) {
      color: var(--mantine-color-gray-5);
      background: var(--mantine-color-gray-1);
}

  :where([data-mantine-color-scheme='dark']) .m_77c9d27d:where(:disabled:not([data-loading]), [data-disabled]:not([data-loading])) {
      color: var(--mantine-color-dark-3);
      background: var(--mantine-color-dark-6);
}

  .m_77c9d27d::before {
    content: '';
    pointer-events: none;
    position: absolute;
    inset: calc(-0.0625rem * var(--mantine-scale));
    border-radius: var(--button-radius, var(--mantine-radius-default));
    transform: translateY(-100%);
    opacity: 0;
    filter: blur(12px);
    transition:
      transform 150ms ease,
      opacity 100ms ease;
  }

  :where([data-mantine-color-scheme='light']) .m_77c9d27d::before {
      background-color: rgba(255, 255, 255, 0.15);
}

  :where([data-mantine-color-scheme='dark']) .m_77c9d27d::before {
      background-color: rgba(0, 0, 0, 0.15);
}

  .m_77c9d27d:where([data-loading]) {
    cursor: not-allowed;
    transform: none;
  }

  .m_77c9d27d:where([data-loading])::before {
      transform: translateY(0);
      opacity: 1;
    }

  .m_77c9d27d:where([data-loading]) .m_80f1301b {
      opacity: 0;
      transform: translateY(100%);
    }

  @media (hover: hover) {
    .m_77c9d27d:hover:where(:not([data-loading], :disabled, [data-disabled])) {
      background-color: var(--button-hover, var(--mantine-primary-color-filled-hover));
      color: var(--button-hover-color, var(--button-color));
    }
}

  @media (hover: none) {
    .m_77c9d27d:active:where(:not([data-loading], :disabled, [data-disabled])) {
      background-color: var(--button-hover, var(--mantine-primary-color-filled-hover));
      color: var(--button-hover-color, var(--button-color));
    }
}

.m_80f1301b {
  display: flex;
  align-items: center;
  justify-content: var(--button-justify, center);
  height: 100%;
  overflow: visible;
  transition:
    transform 150ms ease,
    opacity 100ms ease;
}

.m_811560b9 {
  white-space: nowrap;
  height: 100%;
  overflow: hidden;
  display: flex;
  align-items: center;
  opacity: 1;
}

.m_811560b9:where([data-loading]) {
    opacity: 0.2;
  }

.m_a74036a {
  display: flex;
  align-items: center;
}

.m_a74036a:where([data-position='left']) {
    margin-inline-end: var(--mantine-spacing-xs);
  }

.m_a74036a:where([data-position='right']) {
    margin-inline-start: var(--mantine-spacing-xs);
  }

.m_a25b86ee {
  position: absolute;
  left: 50%;
  top: 50%;
}

.m_80d6d844 {
  --button-border-width: calc(0.0625rem * var(--mantine-scale));
  display: flex;
}

.m_80d6d844 :where(*):focus {
      position: relative;
      z-index: 1;
    }

.m_80d6d844[data-orientation='horizontal'] {
    flex-direction: row;
  }

.m_80d6d844[data-orientation='horizontal'] .m_77c9d27d:not(:only-child):first-child {
        border-end-end-radius: 0;
        border-start-end-radius: 0;
        border-inline-end-width: calc(var(--button-border-width) / 2);
      }

.m_80d6d844[data-orientation='horizontal'] .m_77c9d27d:not(:only-child):last-child {
        border-end-start-radius: 0;
        border-start-start-radius: 0;
        border-inline-start-width: calc(var(--button-border-width) / 2);
      }

.m_80d6d844[data-orientation='horizontal'] .m_77c9d27d:not(:only-child):not(:first-child):not(:last-child) {
        border-radius: 0;
        border-inline-width: calc(var(--button-border-width) / 2);
      }

.m_80d6d844[data-orientation='vertical'] {
    flex-direction: column;
  }

.m_80d6d844[data-orientation='vertical'] .m_77c9d27d:not(:only-child):first-child {
        border-end-start-radius: 0;
        border-end-end-radius: 0;
        border-bottom-width: calc(var(--button-border-width) / 2);
      }

.m_80d6d844[data-orientation='vertical'] .m_77c9d27d:not(:only-child):last-child {
        border-start-start-radius: 0;
        border-start-end-radius: 0;
        border-top-width: calc(var(--button-border-width) / 2);
      }

.m_80d6d844[data-orientation='vertical'] .m_77c9d27d:not(:only-child):not(:first-child):not(:last-child) {
        border-radius: 0;
        border-bottom-width: calc(var(--button-border-width) / 2);
        border-top-width: calc(var(--button-border-width) / 2);
      }

.m_e615b15f {
  --card-padding: var(--mantine-spacing-md);

  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding: var(--card-padding);
  color: var(--mantine-color-text);
}

  :where([data-mantine-color-scheme='light']) .m_e615b15f {
    background-color: var(--mantine-color-white);
}

  :where([data-mantine-color-scheme='dark']) .m_e615b15f {
    background-color: var(--mantine-color-dark-6);
}

.m_599a2148 {
  display: block;
  margin-inline: calc(var(--card-padding) * -1);
}

.m_599a2148:where(:first-child) {
    margin-top: calc(var(--card-padding) * -1);
    border-top: none !important;
  }

.m_599a2148:where(:last-child) {
    margin-bottom: calc(var(--card-padding) * -1);
    border-bottom: none !important;
  }

.m_599a2148:where([data-inherit-padding]) {
    padding-inline: var(--card-padding);
  }

.m_599a2148:where([data-with-border]) {
    border-top: calc(0.0625rem * var(--mantine-scale)) solid;
    border-bottom: calc(0.0625rem * var(--mantine-scale)) solid;
  }

:where([data-mantine-color-scheme='light']) .m_599a2148 {
    border-color: var(--mantine-color-gray-3);
}

:where([data-mantine-color-scheme='dark']) .m_599a2148 {
    border-color: var(--mantine-color-dark-4);
}

.m_599a2148 + .m_599a2148 {
    border-top: none !important;
  }

.m_4451eb3a {
  display: flex;
  align-items: center;
  justify-content: center;
}

  .m_4451eb3a:where([data-inline]) {
    display: inline-flex;
  }

.m_f59ffda3 {
  --chip-size-xs: calc(1.4375rem * var(--mantine-scale));
  --chip-size-sm: calc(1.75rem * var(--mantine-scale));
  --chip-size-md: calc(2rem * var(--mantine-scale));
  --chip-size-lg: calc(2.25rem * var(--mantine-scale));
  --chip-size-xl: calc(2.5rem * var(--mantine-scale));

  --chip-icon-size-xs: calc(0.625rem * var(--mantine-scale));
  --chip-icon-size-sm: calc(0.75rem * var(--mantine-scale));
  --chip-icon-size-md: calc(0.875rem * var(--mantine-scale));
  --chip-icon-size-lg: calc(1rem * var(--mantine-scale));
  --chip-icon-size-xl: calc(1.125rem * var(--mantine-scale));

  --chip-padding-xs: calc(1rem * var(--mantine-scale));
  --chip-padding-sm: calc(1.25rem * var(--mantine-scale));
  --chip-padding-md: calc(1.5rem * var(--mantine-scale));
  --chip-padding-lg: calc(1.75rem * var(--mantine-scale));
  --chip-padding-xl: calc(2rem * var(--mantine-scale));

  --chip-checked-padding-xs: calc(0.46875rem * var(--mantine-scale));
  --chip-checked-padding-sm: calc(0.625rem * var(--mantine-scale));
  --chip-checked-padding-md: calc(0.73125rem * var(--mantine-scale));
  --chip-checked-padding-lg: calc(0.84375rem * var(--mantine-scale));
  --chip-checked-padding-xl: calc(0.78125rem * var(--mantine-scale));

  --chip-spacing-xs: calc(0.625rem * var(--mantine-scale));
  --chip-spacing-sm: calc(0.75rem * var(--mantine-scale));
  --chip-spacing-md: calc(1rem * var(--mantine-scale));
  --chip-spacing-lg: calc(1.25rem * var(--mantine-scale));
  --chip-spacing-xl: calc(1.375rem * var(--mantine-scale));

  --chip-size: var(--chip-size-sm);
  --chip-icon-size: var(--chip-icon-size-sm);
  --chip-padding: var(--chip-padding-sm);
  --chip-spacing: var(--chip-spacing-sm);
  --chip-checked-padding: var(--chip-checked-padding-sm);
  --chip-bg: var(--mantine-primary-color-filled);
  --chip-hover: var(--mantine-primary-color-filled-hover);
  --chip-color: var(--mantine-color-white);
  --chip-bd: calc(0.0625rem * var(--mantine-scale)) solid transparent;
}

.m_be049a53 {
  display: inline-flex;
  align-items: center;
  user-select: none;
  border-radius: var(--chip-radius, 1000rem);
  height: var(--chip-size);
  font-size: var(--chip-fz, var(--mantine-font-size-sm));
  line-height: calc(var(--chip-size) - calc(0.125rem * var(--mantine-scale)));
  padding-inline: var(--chip-padding);
  cursor: pointer;
  white-space: nowrap;
  -webkit-tap-highlight-color: transparent;
  border: calc(0.0625rem * var(--mantine-scale)) solid transparent;
  color: var(--mantine-color-text);
}

.m_be049a53:where([data-checked]) {
    padding: var(--chip-checked-padding);
  }

.m_be049a53:where([data-disabled]) {
    cursor: not-allowed;
  }

:where([data-mantine-color-scheme='light']) .m_be049a53:where([data-disabled]) {
      background-color: var(--mantine-color-gray-2);
      color: var(--mantine-color-gray-5);
}

:where([data-mantine-color-scheme='dark']) .m_be049a53:where([data-disabled]) {
      background-color: var(--mantine-color-dark-6);
      color: var(--mantine-color-dark-3);
}

:where([data-mantine-color-scheme='light']) .m_3904c1af:not([data-disabled]) {
    background-color: var(--mantine-color-white);
    border: 1px solid var(--mantine-color-gray-3);
}

:where([data-mantine-color-scheme='dark']) .m_3904c1af:not([data-disabled]) {
    background-color: var(--mantine-color-dark-6);
    border: 1px solid var(--mantine-color-dark-4);
}

@media (hover: hover) {
    :where([data-mantine-color-scheme='light']) .m_3904c1af:not([data-disabled]):hover {
      background-color: var(--mantine-color-gray-0);
  }

    :where([data-mantine-color-scheme='dark']) .m_3904c1af:not([data-disabled]):hover {
      background-color: var(--mantine-color-dark-5);
  }
}

@media (hover: none) {
    :where([data-mantine-color-scheme='light']) .m_3904c1af:not([data-disabled]):active {
      background-color: var(--mantine-color-gray-0);
  }

    :where([data-mantine-color-scheme='dark']) .m_3904c1af:not([data-disabled]):active {
      background-color: var(--mantine-color-dark-5);
  }
}

.m_3904c1af:not([data-disabled]):where([data-checked]) {
    --chip-icon-color: var(--chip-color);
    border: var(--chip-bd);
  }

@media (hover: hover) {

  .m_3904c1af:not([data-disabled]):where([data-checked]):hover {
      background-color: var(--chip-hover);
  }
}

@media (hover: none) {

  .m_3904c1af:not([data-disabled]):where([data-checked]):active {
      background-color: var(--chip-hover);
  }
}

.m_fa109255:not([data-disabled]),
.m_f7e165c3:not([data-disabled]) {
  border: calc(0.0625rem * var(--mantine-scale)) solid transparent;
  color: var(--mantine-color-text);
}

:where([data-mantine-color-scheme='light']) .m_fa109255:not([data-disabled]), :where([data-mantine-color-scheme='light']) .m_f7e165c3:not([data-disabled]) {
    background-color: var(--mantine-color-gray-1);
}

:where([data-mantine-color-scheme='dark']) .m_fa109255:not([data-disabled]), :where([data-mantine-color-scheme='dark']) .m_f7e165c3:not([data-disabled]) {
    background-color: var(--mantine-color-dark-5);
}

@media (hover: hover) {
    :where([data-mantine-color-scheme='light']) .m_fa109255:not([data-disabled]):hover, :where([data-mantine-color-scheme='light']) .m_f7e165c3:not([data-disabled]):hover {
      background-color: var(--mantine-color-gray-2);
  }

    :where([data-mantine-color-scheme='dark']) .m_fa109255:not([data-disabled]):hover, :where([data-mantine-color-scheme='dark']) .m_f7e165c3:not([data-disabled]):hover {
      background-color: var(--mantine-color-dark-4);
  }
}

@media (hover: none) {
    :where([data-mantine-color-scheme='light']) .m_fa109255:not([data-disabled]):active, :where([data-mantine-color-scheme='light']) .m_f7e165c3:not([data-disabled]):active {
      background-color: var(--mantine-color-gray-2);
  }

    :where([data-mantine-color-scheme='dark']) .m_fa109255:not([data-disabled]):active, :where([data-mantine-color-scheme='dark']) .m_f7e165c3:not([data-disabled]):active {
      background-color: var(--mantine-color-dark-4);
  }
}

.m_fa109255:not([data-disabled]):where([data-checked]), .m_f7e165c3:not([data-disabled]):where([data-checked]) {
    --chip-icon-color: var(--chip-color);
    color: var(--chip-color);
    background-color: var(--chip-bg);
  }

@media (hover: hover) {

  .m_fa109255:not([data-disabled]):where([data-checked]):hover, .m_f7e165c3:not([data-disabled]):where([data-checked]):hover {
      background-color: var(--chip-hover);
  }
}

@media (hover: none) {

  .m_fa109255:not([data-disabled]):where([data-checked]):active, .m_f7e165c3:not([data-disabled]):where([data-checked]):active {
      background-color: var(--chip-hover);
  }
}

.m_9ac86df9 {
  width: calc(var(--chip-icon-size) + (var(--chip-spacing) / 1.5));
  max-width: calc(var(--chip-icon-size) + (var(--chip-spacing) / 1.5));
  height: var(--chip-icon-size);
  display: flex;
  align-items: center;
  overflow: hidden;
}

.m_d6d72580 {
  width: var(--chip-icon-size);
  height: var(--chip-icon-size);
  display: block;
  color: var(--chip-icon-color, inherit);
}

.m_bde07329 {
  width: 0;
  height: 0;
  padding: 0;
  opacity: 0;
  margin: 0;
}

.m_bde07329:focus-visible + .m_be049a53 {
    outline: 2px solid var(--mantine-primary-color-filled);
    outline-offset: calc(0.125rem * var(--mantine-scale));
  }

.m_b183c0a2 {
  font-family: var(--mantine-font-family-monospace);
  line-height: var(--mantine-line-height);
  padding: 2px calc(var(--mantine-spacing-xs) / 2);
  border-radius: var(--mantine-radius-sm);
  font-size: var(--mantine-font-size-xs);
  margin: 0;
  overflow: auto;
}

  :where([data-mantine-color-scheme='light']) .m_b183c0a2 {
    background-color: var(--code-bg, var(--mantine-color-gray-1));
    color: var(--mantine-color-black);
}

  :where([data-mantine-color-scheme='dark']) .m_b183c0a2 {
    background-color: var(--code-bg, var(--mantine-color-dark-5));
    color: var(--mantine-color-white);
}

  .m_b183c0a2[data-block] {
    padding: var(--mantine-spacing-xs);
  }

.m_de3d2490 {
  --cs-size: calc(1.75rem * var(--mantine-scale));
  --cs-radius: calc(62.5rem * var(--mantine-scale));

  -webkit-tap-highlight-color: transparent;
  border: none;
  appearance: none;
  display: block;
  line-height: 1;
  position: relative;
  width: var(--cs-size);
  height: var(--cs-size);
  min-width: var(--cs-size);
  min-height: var(--cs-size);
  border-radius: var(--cs-radius);
  color: inherit;
  text-decoration: none;
}

  [data-mantine-color-scheme='light'] .m_de3d2490 {
    --alpha-overlay-color: var(--mantine-color-gray-3);
    --alpha-overlay-bg: var(--mantine-color-white);
}

  [data-mantine-color-scheme='dark'] .m_de3d2490 {
    --alpha-overlay-color: var(--mantine-color-dark-4);
    --alpha-overlay-bg: var(--mantine-color-dark-7);
}

.m_862f3d1b {
  position: absolute;
  inset: 0;
  border-radius: var(--cs-radius);
}

.m_98ae7f22 {
  position: absolute;
  inset: 0;
  border-radius: var(--cs-radius);
  z-index: 1;
  box-shadow:
    rgba(0, 0, 0, 0.1) 0 0 0 calc(0.0625rem * var(--mantine-scale)) inset,
    rgb(0, 0, 0, 0.15) 0 0 calc(0.25rem * var(--mantine-scale)) inset;
}

.m_95709ac0 {
  position: absolute;
  inset: 0;
  border-radius: var(--cs-radius);
  background-size: calc(0.5rem * var(--mantine-scale)) calc(0.5rem * var(--mantine-scale));
  background-position:
    0 0,
    0 calc(0.25rem * var(--mantine-scale)),
    calc(0.25rem * var(--mantine-scale)) calc(-0.25rem * var(--mantine-scale)),
    calc(-0.25rem * var(--mantine-scale)) 0;
  background-image: linear-gradient(45deg, var(--alpha-overlay-color) 25%, transparent 25%),
    linear-gradient(-45deg, var(--alpha-overlay-color) 25%, transparent 25%),
    linear-gradient(45deg, transparent 75%, var(--alpha-overlay-color) 75%),
    linear-gradient(-45deg, var(--alpha-overlay-bg) 75%, var(--alpha-overlay-color) 75%);
}

.m_93e74e3 {
  position: absolute;
  inset: 0;
  border-radius: var(--cs-radius);
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
}

.m_fee9c77 {
  --cp-width-xs: calc(11.25rem * var(--mantine-scale));
  --cp-width-sm: calc(12.5rem * var(--mantine-scale));
  --cp-width-md: calc(15rem * var(--mantine-scale));
  --cp-width-lg: calc(17.5rem * var(--mantine-scale));
  --cp-width-xl: calc(20rem * var(--mantine-scale));

  --cp-preview-size-xs: calc(1.625rem * var(--mantine-scale));
  --cp-preview-size-sm: calc(2.125rem * var(--mantine-scale));
  --cp-preview-size-md: calc(2.625rem * var(--mantine-scale));
  --cp-preview-size-lg: calc(3.125rem * var(--mantine-scale));
  --cp-preview-size-xl: calc(3.375rem * var(--mantine-scale));

  --cp-thumb-size-xs: calc(0.5rem * var(--mantine-scale));
  --cp-thumb-size-sm: calc(0.75rem * var(--mantine-scale));
  --cp-thumb-size-md: calc(1rem * var(--mantine-scale));
  --cp-thumb-size-lg: calc(1.25rem * var(--mantine-scale));
  --cp-thumb-size-xl: calc(1.375rem * var(--mantine-scale));

  --cp-saturation-height-xs: calc(6.25rem * var(--mantine-scale));
  --cp-saturation-height-sm: calc(6.875rem * var(--mantine-scale));
  --cp-saturation-height-md: calc(7.5rem * var(--mantine-scale));
  --cp-saturation-height-lg: calc(8.75rem * var(--mantine-scale));
  --cp-saturation-height-xl: calc(10rem * var(--mantine-scale));

  --cp-preview-size: var(--cp-preview-size-sm);
  --cp-thumb-size: var(--cp-thumb-size-sm);
  --cp-saturation-height: var(--cp-saturation-height-sm);
  --cp-width: var(--cp-width-sm);
  --cp-body-spacing: var(--mantine-spacing-sm);

  width: var(--cp-width);
  padding: calc(0.0625rem * var(--mantine-scale));
}

  .m_fee9c77:where([data-full-width]) {
    width: 100%;
  }

.m_9dddfbac {
  width: var(--cp-preview-size);
  height: var(--cp-preview-size);
}

.m_bffecc3e {
  display: flex;
  padding-top: calc(var(--cp-body-spacing) / 2);
}

.m_3283bb96 {
  flex: 1;
}

.m_3283bb96:not(:only-child) {
    margin-inline-end: var(--mantine-spacing-xs);
  }

.m_40d572ba {
  overflow: hidden;
  position: absolute;
  box-shadow: 0 0 1px rgba(0, 0, 0, 0.6);
  border: 2px solid var(--mantine-color-white);
  width: var(--cp-thumb-size);
  height: var(--cp-thumb-size);
  border-radius: var(--cp-thumb-size);
  left: calc(var(--thumb-x-offset) - var(--cp-thumb-size) / 2);
  top: calc(var(--thumb-y-offset) - var(--cp-thumb-size) / 2);
}

.m_d8ee6fd8 {
  height: unset !important;
  width: unset !important;
  min-width: 0 !important;
  min-height: 0 !important;
  margin: calc(0.125rem * var(--mantine-scale));
  cursor: pointer;
  padding-bottom: calc(var(--cp-swatch-size) - calc(0.25rem * var(--mantine-scale)));
  flex: 0 0 calc(var(--cp-swatch-size) - calc(0.25rem * var(--mantine-scale)));
}

.m_5711e686 {
  margin-top: calc(0.3125rem * var(--mantine-scale));
  margin-inline: calc(-0.125rem * var(--mantine-scale));
  display: flex;
  flex-wrap: wrap;
}

.m_202a296e {
  --cp-thumb-size-xs: calc(0.5rem * var(--mantine-scale));
  --cp-thumb-size-sm: calc(0.75rem * var(--mantine-scale));
  --cp-thumb-size-md: calc(1rem * var(--mantine-scale));
  --cp-thumb-size-lg: calc(1.25rem * var(--mantine-scale));
  --cp-thumb-size-xl: calc(1.375rem * var(--mantine-scale));

  -webkit-tap-highlight-color: transparent;
  position: relative;
  height: var(--cp-saturation-height);
  border-radius: var(--mantine-radius-sm);
  margin: calc(var(--cp-thumb-size) / 2);
}

.m_202a296e:where([data-focus-ring='auto']):focus:focus-visible .m_40d572ba {
        outline: 2px solid var(--mantine-color-blue-filled);
      }

.m_202a296e:where([data-focus-ring='always']):focus .m_40d572ba {
        outline: 2px solid var(--mantine-color-blue-filled);
      }

.m_11b3db02 {
  position: absolute;
  border-radius: var(--mantine-radius-sm);
  inset: calc(var(--cp-thumb-size) * -1 / 2 - calc(0.0625rem * var(--mantine-scale)));
}

.m_d856d47d {
  --cp-thumb-size-xs: calc(0.5rem * var(--mantine-scale));
  --cp-thumb-size-sm: calc(0.75rem * var(--mantine-scale));
  --cp-thumb-size-md: calc(1rem * var(--mantine-scale));
  --cp-thumb-size-lg: calc(1.25rem * var(--mantine-scale));
  --cp-thumb-size-xl: calc(1.375rem * var(--mantine-scale));
  --cp-thumb-size: var(--cp-thumb-size, calc(0.75rem * var(--mantine-scale)));

  position: relative;
  height: calc(var(--cp-thumb-size) + calc(0.125rem * var(--mantine-scale)));
  margin-inline: calc(var(--cp-thumb-size) / 2);
  outline: none;
}

.m_d856d47d + .m_d856d47d {
    margin-top: calc(0.375rem * var(--mantine-scale));
  }

.m_d856d47d:where([data-focus-ring='auto']):focus:focus-visible .m_40d572ba {
        outline: 2px solid var(--mantine-color-blue-filled);
      }

.m_d856d47d:where([data-focus-ring='always']):focus .m_40d572ba {
        outline: 2px solid var(--mantine-color-blue-filled);
      }

:where([data-mantine-color-scheme='light']) .m_d856d47d {
    --slider-checkers: var(--mantine-color-gray-3);
}

:where([data-mantine-color-scheme='dark']) .m_d856d47d {
    --slider-checkers: var(--mantine-color-dark-4);
}

.m_8f327113 {
  position: absolute;
  top: 0;
  bottom: 0;
  inset-inline: calc(var(--cp-thumb-size) * -1 / 2 - calc(0.0625rem * var(--mantine-scale)));
  border-radius: 10000rem;
}

.m_b077c2bc {
  --ci-eye-dropper-icon-size-xs: calc(0.875rem * var(--mantine-scale));
  --ci-eye-dropper-icon-size-sm: calc(1rem * var(--mantine-scale));
  --ci-eye-dropper-icon-size-md: calc(1.125rem * var(--mantine-scale));
  --ci-eye-dropper-icon-size-lg: calc(1.25rem * var(--mantine-scale));
  --ci-eye-dropper-icon-size-xl: calc(1.375rem * var(--mantine-scale));
  --ci-eye-dropper-icon-size: var(--ci-eye-dropper-icon-size-sm);
}

.m_c5ccdcab {
  --ci-preview-size-xs: calc(1rem * var(--mantine-scale));
  --ci-preview-size-sm: calc(1.125rem * var(--mantine-scale));
  --ci-preview-size-md: calc(1.375rem * var(--mantine-scale));
  --ci-preview-size-lg: calc(1.75rem * var(--mantine-scale));
  --ci-preview-size-xl: calc(2.25rem * var(--mantine-scale));
  --ci-preview-size: var(--ci-preview-size-sm);
}

.m_5ece2cd7 {
  padding: calc(0.5rem * var(--mantine-scale));
}

.m_7485cace {
  --container-size-xs: calc(33.75rem * var(--mantine-scale));
  --container-size-sm: calc(45rem * var(--mantine-scale));
  --container-size-md: calc(60rem * var(--mantine-scale));
  --container-size-lg: calc(71.25rem * var(--mantine-scale));
  --container-size-xl: calc(82.5rem * var(--mantine-scale));
  --container-size: var(--container-size-md);

  max-width: var(--container-size);
  padding-inline: var(--mantine-spacing-md);
  margin-inline: auto;
}

  .m_7485cace:where([data-fluid]) {
    max-width: 100%;
  }

.m_e2125a27 {
  --dialog-size-xs: calc(10rem * var(--mantine-scale));
  --dialog-size-sm: calc(12.5rem * var(--mantine-scale));
  --dialog-size-md: calc(21.25rem * var(--mantine-scale));
  --dialog-size-lg: calc(25rem * var(--mantine-scale));
  --dialog-size-xl: calc(31.25rem * var(--mantine-scale));
  --dialog-size: var(--dialog-size-md);

  position: relative;
  width: var(--dialog-size);
  max-width: calc(100vw - var(--mantine-spacing-xl) * 2);
  min-height: calc(3.125rem * var(--mantine-scale));
}

.m_5abab665 {
  position: absolute;
  top: calc(var(--mantine-spacing-md) / 2);
  inset-inline-end: calc(var(--mantine-spacing-md) / 2);
}

.m_3eebeb36 {
  --divider-size-xs: calc(0.0625rem * var(--mantine-scale));
  --divider-size-sm: calc(0.125rem * var(--mantine-scale));
  --divider-size-md: calc(0.1875rem * var(--mantine-scale));
  --divider-size-lg: calc(0.25rem * var(--mantine-scale));
  --divider-size-xl: calc(0.3125rem * var(--mantine-scale));
  --divider-size: var(--divider-size-xs);
}

  :where([data-mantine-color-scheme='light']) .m_3eebeb36 {
    --divider-color: var(--mantine-color-gray-3);
}

  :where([data-mantine-color-scheme='dark']) .m_3eebeb36 {
    --divider-color: var(--mantine-color-dark-4);
}

  .m_3eebeb36:where([data-orientation='horizontal']) {
    border-top: var(--divider-size) var(--divider-border-style, solid) var(--divider-color);
  }

  .m_3eebeb36:where([data-orientation='vertical']) {
    border-inline-start: var(--divider-size) var(--divider-border-style, solid) var(--divider-color);
    height: auto;
    align-self: stretch;
  }

  .m_3eebeb36:where([data-with-label]) {
    border: 0;
  }

.m_9e365f20 {
  display: flex;
  align-items: center;
  font-size: var(--mantine-font-size-xs);
  color: var(--mantine-color-dimmed);
  white-space: nowrap;
}

.m_9e365f20:where([data-position='left'])::before {
    display: none;
  }

.m_9e365f20:where([data-position='right'])::after {
    display: none;
  }

.m_9e365f20::before {
    content: '';
    flex: 1;
    height: calc(0.0625rem * var(--mantine-scale));
    border-top: var(--divider-size) var(--divider-border-style, solid) var(--divider-color);
    margin-inline-end: var(--mantine-spacing-xs);
  }

.m_9e365f20::after {
    content: '';
    flex: 1;
    height: calc(0.0625rem * var(--mantine-scale));
    border-top: var(--divider-size) var(--divider-border-style, solid) var(--divider-color);
    margin-inline-start: var(--mantine-spacing-xs);
  }

.m_f11b401e {
  --drawer-size-xs: calc(20rem * var(--mantine-scale));
  --drawer-size-sm: calc(23.75rem * var(--mantine-scale));
  --drawer-size-md: calc(27.5rem * var(--mantine-scale));
  --drawer-size-lg: calc(38.75rem * var(--mantine-scale));
  --drawer-size-xl: calc(48.75rem * var(--mantine-scale));
  --drawer-size: var(--drawer-size-md);
  --drawer-offset: 0rem;
}

.m_5a7c2c9 {
  z-index: 1000;
}

.m_b8a05bbd {
  flex: var(--drawer-flex, 0 0 var(--drawer-size));
  height: var(--drawer-height, calc(100% - var(--drawer-offset) * 2));
  margin: var(--drawer-offset);
  max-width: calc(100% - var(--drawer-offset) * 2);
  max-height: calc(100% - var(--drawer-offset) * 2);
  overflow-y: auto;
}

.m_31cd769a {
  display: flex;
  justify-content: var(--drawer-justify, flex-start);
  align-items: var(--drawer-align, flex-start);
}

.m_e9408a47 {
  padding: var(--mantine-spacing-lg);
  padding-top: var(--mantine-spacing-xs);
  border-radius: var(--fieldset-radius, var(--mantine-radius-default));
  min-inline-size: auto;
}

.m_84c9523a {
  border: calc(0.0625rem * var(--mantine-scale)) solid;
}

:where([data-mantine-color-scheme='light']) .m_84c9523a {
    border-color: var(--mantine-color-gray-3);
    background-color: var(--mantine-color-white);
}

:where([data-mantine-color-scheme='dark']) .m_84c9523a {
    border-color: var(--mantine-color-dark-4);
    background-color: var(--mantine-color-dark-7);
}

.m_ef274e49 {
  border: calc(0.0625rem * var(--mantine-scale)) solid;
}

:where([data-mantine-color-scheme='light']) .m_ef274e49 {
    border-color: var(--mantine-color-gray-3);
    background-color: var(--mantine-color-gray-0);
}

:where([data-mantine-color-scheme='dark']) .m_ef274e49 {
    border-color: var(--mantine-color-dark-4);
    background-color: var(--mantine-color-dark-6);
}

.m_eda993d3 {
  padding: 0;
  border: 0;
  border-radius: 0;
}

.m_90794832 {
  font-size: var(--mantine-font-size-sm);
}

.m_74ca27fe {
  padding: 0;
  margin-bottom: var(--mantine-spacing-sm);
}

.m_410352e9 {
  --grid-overflow: visible;
  --grid-margin: calc(var(--grid-gutter) / -2);
  --grid-col-padding: calc(var(--grid-gutter) / 2);

  overflow: var(--grid-overflow);
}

.m_dee7bd2f {
  width: calc(100% + var(--grid-gutter));
  display: flex;
  flex-wrap: wrap;
  justify-content: var(--grid-justify);
  align-items: var(--grid-align);
  margin: var(--grid-margin);
}

.m_96bdd299 {
  --col-flex-grow: 0;
  --col-offset: 0rem;

  flex-shrink: 0;
  order: var(--col-order);
  flex-basis: var(--col-flex-basis);
  width: var(--col-width);
  max-width: var(--col-max-width);
  flex-grow: var(--col-flex-grow);
  margin-inline-start: var(--col-offset);
  padding: var(--grid-col-padding);
}

.m_bcb3f3c2 {
  color: var(--mantine-color-black);
}

  :where([data-mantine-color-scheme='light']) .m_bcb3f3c2 {
    background-color: var(--mark-bg-light);
}

  :where([data-mantine-color-scheme='dark']) .m_bcb3f3c2 {
    background-color: var(--mark-bg-dark);
}

.m_9e117634 {
  display: block;
  flex: 0;
  object-fit: var(--image-object-fit, cover);
  width: 100%;
  border-radius: var(--image-radius, 0);
}

@keyframes m_885901b1 {
  0% {
    opacity: 0.6;
    transform: scale(0);
  }

  100% {
    opacity: 0;
    transform: scale(2.8);
  }
}

.m_e5262200 {
  --indicator-size: calc(0.625rem * var(--mantine-scale));
  --indicator-color: var(--mantine-primary-color-filled);

  position: relative;
  display: block;
}

.m_e5262200:where([data-inline]) {
    display: inline-block;
  }

.m_760d1fb1 {
  position: absolute;
  top: var(--indicator-top);
  left: var(--indicator-left);
  right: var(--indicator-right);
  bottom: var(--indicator-bottom);
  transform: translate(var(--indicator-translate-x), var(--indicator-translate-y));
  min-width: var(--indicator-size);
  height: var(--indicator-size);
  border-radius: var(--indicator-radius, 1000rem);
  z-index: var(--indicator-z-index, 200);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--mantine-font-size-xs);
  background-color: var(--indicator-color);
  color: var(--indicator-text-color, var(--mantine-color-white));
  white-space: nowrap;
}

.m_760d1fb1::before {
    content: '';
    position: absolute;
    inset: 0;
    background-color: var(--indicator-color);
    border-radius: var(--indicator-radius, 1000rem);
    z-index: -1;
  }

.m_760d1fb1:where([data-with-label]) {
    padding-inline: calc(var(--mantine-spacing-xs) / 2);
  }

.m_760d1fb1:where([data-with-border]) {
    border: 2px solid var(--mantine-color-body);
  }

.m_760d1fb1[data-processing]::before {
      animation: m_885901b1 1000ms linear infinite;
    }

.m_dc6f14e2 {
  --kbd-fz-xs: calc(0.625rem * var(--mantine-scale));
  --kbd-fz-sm: calc(0.75rem * var(--mantine-scale));
  --kbd-fz-md: calc(0.875rem * var(--mantine-scale));
  --kbd-fz-lg: calc(1rem * var(--mantine-scale));
  --kbd-fz-xl: calc(1.25rem * var(--mantine-scale));
  --kbd-fz: var(--kbd-fz-sm);

  --kbd-padding-xs: calc(0.125rem * var(--mantine-scale)) calc(0.25rem * var(--mantine-scale));
  --kbd-padding-sm: calc(0.1875rem * var(--mantine-scale)) calc(0.3125rem * var(--mantine-scale));
  --kbd-padding-md: calc(0.25rem * var(--mantine-scale)) calc(0.4375rem * var(--mantine-scale));
  --kbd-padding-lg: calc(0.3125rem * var(--mantine-scale)) calc(0.5625rem * var(--mantine-scale));
  --kbd-padding-xl: calc(0.5rem * var(--mantine-scale)) calc(0.875rem * var(--mantine-scale));
  --kbd-padding: var(--kbd-padding-sm);

  font-family: var(--mantine-font-family-monospace);
  line-height: var(--mantine-line-height);
  font-weight: 700;
  padding: var(--kbd-padding);
  font-size: var(--kbd-fz);
  border-radius: var(--mantine-radius-sm);
  border: calc(0.0625rem * var(--mantine-scale)) solid;
  border-bottom-width: calc(0.1875rem * var(--mantine-scale));
  unicode-bidi: embed;
}

  :where([data-mantine-color-scheme='light']) .m_dc6f14e2 {
    border-color: var(--mantine-color-gray-3);
    color: var(--mantine-color-gray-7);
    background-color: var(--mantine-color-gray-0);
}

  :where([data-mantine-color-scheme='dark']) .m_dc6f14e2 {
    border-color: var(--mantine-color-dark-4);
    color: var(--mantine-color-dark-0);
    background-color: var(--mantine-color-dark-6);
}

.m_abbac491 {
  --list-fz: var(--mantine-font-size-md);
  --list-lh: var(--mantine-line-height-md);

  list-style-position: inside;
  font-size: var(--list-fz);
  line-height: var(--list-lh);
  margin: 0;
  padding: 0;
}

  .m_abbac491:where([data-with-padding]) {
    padding-inline-start: var(--mantine-spacing-md);
  }

.m_abb6bec2 {
  white-space: nowrap;
  line-height: var(--list-lh);
}

.m_abb6bec2:where([data-with-icon]) {
    list-style: none;
  }

.m_abb6bec2:where([data-with-icon]) .m_75cd9f71 {
      --li-direction: row;
      --li-align: center;
    }

.m_abb6bec2:where(:not(:first-of-type)) {
    margin-top: var(--list-spacing, 0);
  }

.m_abb6bec2:where([data-centered]) {
    line-height: 1;
  }

.m_75cd9f71 {
  display: inline-flex;
  flex-direction: var(--li-direction, column);
  align-items: var(--li-align, flex-start);
  white-space: normal;
}

.m_60f83e5b {
  display: inline-block;
  vertical-align: middle;
  margin-inline-end: var(--mantine-spacing-sm);
}

.m_6e45937b {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  z-index: var(--lo-z-index);
}

.m_e8eb006c {
  position: relative;
  z-index: calc(var(--lo-z-index) + 1);
}

.m_df587f17 {
  z-index: var(--lo-z-index);
}

.m_dc9b7c9f {
  padding: calc(0.25rem * var(--mantine-scale));
}

.m_9bfac126 {
  color: var(--mantine-color-dimmed);
  font-weight: 500;
  font-size: var(--mantine-font-size-xs);
  padding: calc(var(--mantine-spacing-xs) / 2) var(--mantine-spacing-sm);
  cursor: default;
}

.m_efdf90cb {
  margin-top: calc(0.25rem * var(--mantine-scale));
  margin-bottom: calc(0.25rem * var(--mantine-scale));
  border-top: calc(0.0625rem * var(--mantine-scale)) solid;
}

:where([data-mantine-color-scheme='light']) .m_efdf90cb {
    border-color: var(--mantine-color-gray-2);
}

:where([data-mantine-color-scheme='dark']) .m_efdf90cb {
    border-color: var(--mantine-color-dark-4);
}

.m_99ac2aa1 {
  font-size: var(--mantine-font-size-sm);
  width: 100%;
  padding: calc(var(--mantine-spacing-xs) / 1.5) var(--mantine-spacing-sm);
  border-radius: var(--popover-radius, var(--mantine-radius-default));
  color: var(--menu-item-color, var(--mantine-color-text));
  display: flex;
  align-items: center;
  user-select: none;
}

.m_99ac2aa1:where([data-disabled], :disabled) {
    color: var(--mantine-color-dimmed);
    opacity: 0.6;
    pointer-events: none;
  }

:where([data-mantine-color-scheme='light']) .m_99ac2aa1:where([data-hovered]) {
      background-color: var(--menu-item-hover, var(--mantine-color-gray-1));
}

:where([data-mantine-color-scheme='dark']) .m_99ac2aa1:where([data-hovered]) {
      background-color: var(--menu-item-hover, var(--mantine-color-dark-4));
}

.m_5476e0d3 {
  flex: 1;
}

.m_8b75e504 {
  display: flex;
  justify-content: center;
  align-items: center;
}

.m_8b75e504:where([data-position='left']) {
    margin-inline-end: var(--mantine-spacing-xs);
  }

.m_8b75e504:where([data-position='right']) {
    margin-inline-start: var(--mantine-spacing-xs);
  }

.m_9df02822 {
  --modal-size-xs: calc(20rem * var(--mantine-scale));
  --modal-size-sm: calc(23.75rem * var(--mantine-scale));
  --modal-size-md: calc(27.5rem * var(--mantine-scale));
  --modal-size-lg: calc(38.75rem * var(--mantine-scale));
  --modal-size-xl: calc(48.75rem * var(--mantine-scale));
  --modal-size: var(--modal-size-md);

  --modal-y-offset: 5dvh;
  --modal-x-offset: 5vw;
}

  .m_9df02822[data-full-screen] {
    --modal-border-radius: 0 !important;
  }

  .m_9df02822[data-full-screen] .m_54c44539 {
      --modal-content-flex: 0 0 100%;
      --modal-content-max-height: auto;
      --modal-content-height: 100dvh;
    }

  .m_9df02822[data-full-screen] .m_1f958f16 {
      --modal-inner-y-offset: 0;
      --modal-inner-x-offset: 0;
    }

  .m_9df02822[data-centered] .m_1f958f16 {
      --modal-inner-align: center;
    }

.m_d0e2b9cd {
  border-start-start-radius: var(--modal-radius, var(--mantine-radius-default));
  border-start-end-radius: var(--modal-radius, var(--mantine-radius-default));
}

.m_54c44539 {
  flex: var(--modal-content-flex, 0 0 var(--modal-size));
  max-width: 100%;
  max-height: var(--modal-content-max-height, calc(100dvh - var(--modal-y-offset) * 2));
  height: var(--modal-content-height, auto);
  overflow-y: auto;
}

.m_54c44539[data-full-screen] {
    border-radius: 0;
  }

.m_1f958f16 {
  display: flex;
  justify-content: center;
  align-items: var(--modal-inner-align, flex-start);
  padding-top: var(--modal-inner-y-offset, var(--modal-y-offset));
  padding-bottom: var(--modal-inner-y-offset, var(--modal-y-offset));
  padding-inline: var(--modal-inner-x-offset, var(--modal-x-offset));
}

.m_7cda1cd6 {
  --pill-fz-xs: calc(0.625rem * var(--mantine-scale));
  --pill-fz-sm: calc(0.75rem * var(--mantine-scale));
  --pill-fz-md: calc(0.875rem * var(--mantine-scale));
  --pill-fz-lg: calc(1rem * var(--mantine-scale));
  --pill-fz-xl: calc(1.125rem * var(--mantine-scale));

  --pill-height-xs: calc(1.125rem * var(--mantine-scale));
  --pill-height-sm: calc(1.375rem * var(--mantine-scale));
  --pill-height-md: calc(1.5625rem * var(--mantine-scale));
  --pill-height-lg: calc(1.75rem * var(--mantine-scale));
  --pill-height-xl: calc(2rem * var(--mantine-scale));

  --pill-fz: var(--pill-fz-sm);
  --pill-height: var(--pill-height-sm);

  font-size: var(--pill-fz);
  flex: 0;
  height: var(--pill-height);
  padding-inline: 0.8em;
  display: inline-flex;
  align-items: center;
  border-radius: var(--pill-radius, 1000rem);
  line-height: 1;
  white-space: nowrap;
  user-select: none;
  -webkit-user-select: none;
  max-width: 100%;
}

  :where([data-mantine-color-scheme='dark']) .m_7cda1cd6 {
    background-color: var(--mantine-color-dark-7);
    color: var(--mantine-color-dark-0);
}

  :where([data-mantine-color-scheme='light']) .m_7cda1cd6 {
    color: var(--mantine-color-black);
}

  .m_7cda1cd6:where([data-with-remove]:not(:has(button:disabled))) {
    padding-inline-end: 0;
  }

  .m_7cda1cd6:where([data-disabled], :has(button:disabled)) {
    cursor: not-allowed;
  }

:where([data-mantine-color-scheme='light']) .m_44da308b {
    background-color: var(--mantine-color-gray-1);
}

:where([data-mantine-color-scheme='light']) .m_44da308b:where([data-disabled], :has(button:disabled)) {
      background-color: var(--mantine-color-gray-3);
    }

:where([data-mantine-color-scheme='light']) .m_e3a01f8 {
    background-color: var(--mantine-color-white);
}

:where([data-mantine-color-scheme='light']) .m_e3a01f8:where([data-disabled], :has(button:disabled)) {
      background-color: var(--mantine-color-gray-3);
    }

.m_1e0e6180 {
  cursor: inherit;
  overflow: hidden;
  height: 100%;
  line-height: var(--pill-height);
  text-overflow: ellipsis;
}

.m_ae386778 {
  color: inherit;
  font-size: inherit;
  height: 100%;
  min-height: unset;
  min-width: 2em;
  width: unset;
  border-radius: 0;
  padding-inline-start: 0.1em;
  padding-inline-end: 0.3em;
  flex: 0;
}

.m_7cda1cd6[data-disabled] > .m_ae386778,
  .m_ae386778:disabled {
    display: none;
    background-color: transparent;
    width: 0.8em;
    min-width: 0.8em;
    padding: 0;
    cursor: not-allowed;
  }

.m_7cda1cd6[data-disabled] > .m_ae386778 > svg, .m_ae386778:disabled > svg {
      display: none;
    }

.m_ae386778 > svg {
    pointer-events: none;
  }

.m_1dcfd90b {
  --pg-gap-xs: calc(0.375rem * var(--mantine-scale));
  --pg-gap-sm: calc(0.5rem * var(--mantine-scale));
  --pg-gap-md: calc(0.625rem * var(--mantine-scale));
  --pg-gap-lg: calc(0.75rem * var(--mantine-scale));
  --pg-gap-xl: calc(0.75rem * var(--mantine-scale));
  --pg-gap: var(--pg-gap-sm);

  display: flex;
  align-items: center;
  gap: var(--pg-gap);
  flex-wrap: wrap;
}

.m_45c4369d {
  background-color: transparent;
  appearance: none;
  min-width: calc(6.25rem * var(--mantine-scale));
  flex: 1;
  border: 0;
  font-size: inherit;
  height: 1.6em;
  color: inherit;
  padding: 0;
}

  .m_45c4369d::placeholder {
    color: var(--input-placeholder-color);
    opacity: 1;
  }

  .m_45c4369d:where([data-type='hidden'], [data-type='auto']) {
    height: calc(0.0625rem * var(--mantine-scale));
    width: calc(0.0625rem * var(--mantine-scale));
    top: 0;
    left: 0;
    pointer-events: none;
    position: absolute;
    opacity: 0;
  }

  .m_45c4369d:focus {
    outline: none;
  }

  .m_45c4369d:where([data-type='auto']:focus) {
    height: 1.6em;
    visibility: visible;
    opacity: 1;
    position: static;
  }

  .m_45c4369d:where([data-pointer]:not([data-disabled], :disabled)) {
    cursor: pointer;
  }

  .m_45c4369d:where([data-disabled], :disabled) {
    cursor: not-allowed;
  }

.m_f0824112 {
  --nl-bg: var(--mantine-primary-color-light);
  --nl-hover: var(--mantine-primary-color-light-hover);
  --nl-color: var(--mantine-primary-color-light-color);

  display: flex;
  align-items: center;
  width: 100%;
  padding: 8px var(--mantine-spacing-sm);
  user-select: none;
}

  @media (hover: hover) {
    :where([data-mantine-color-scheme='light']) .m_f0824112:hover {
      background-color: var(--mantine-color-gray-0);
  }

    :where([data-mantine-color-scheme='dark']) .m_f0824112:hover {
      background-color: var(--mantine-color-dark-6);
  }
}

  @media (hover: none) {
    :where([data-mantine-color-scheme='light']) .m_f0824112:active {
      background-color: var(--mantine-color-gray-0);
  }

    :where([data-mantine-color-scheme='dark']) .m_f0824112:active {
      background-color: var(--mantine-color-dark-6);
  }
}

  .m_f0824112:where([data-disabled]) {
    opacity: 0.4;
    pointer-events: none;
  }

  .m_f0824112:where([data-active], [aria-current='page']) {
    background-color: var(--nl-bg);
    color: var(--nl-color);
  }

  @media (hover: hover) {

  .m_f0824112:where([data-active], [aria-current='page']):hover {
      background-color: var(--nl-hover);
  }
}

  @media (hover: none) {

  .m_f0824112:where([data-active], [aria-current='page']):active {
      background-color: var(--nl-hover);
  }
}

  .m_f0824112:where([data-active], [aria-current='page']) .m_57492dcc {
      --description-opacity: 0.9;
      --description-color: var(--nl-color);
    }

.m_690090b5 {
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 150ms ease;
}

.m_690090b5 > svg {
    display: block;
  }

.m_690090b5:where([data-position='left']) {
    margin-inline-end: var(--mantine-spacing-sm);
  }

.m_690090b5:where([data-position='right']) {
    margin-inline-start: var(--mantine-spacing-sm);
  }

.m_690090b5:where([data-rotate]) {
    transform: rotate(90deg);
  }

.m_1f6ac4c4 {
  font-size: var(--mantine-font-size-sm);
}

.m_f07af9d2 {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
}

.m_f07af9d2:where([data-no-wrap]) {
    white-space: nowrap;
  }

.m_57492dcc {
  display: block;
  font-size: var(--mantine-font-size-xs);
  opacity: var(--description-opacity, 1);
  color: var(--description-color, var(--mantine-color-dimmed));
  overflow: hidden;
  text-overflow: ellipsis;
}

:where([data-no-wrap]) .m_57492dcc {
    white-space: nowrap;
  }

.m_e17b862f {
  padding-inline-start: var(--nl-offset, var(--mantine-spacing-lg));
}

.m_1fd8a00b {
  transform: rotate(-90deg);
}

.m_a513464 {
  --notification-radius: var(--mantine-radius-default);
  --notification-color: var(--mantine-primary-color-filled);

  overflow: hidden;
  box-sizing: border-box;
  position: relative;
  display: flex;
  align-items: center;
  padding-inline-start: calc(1.375rem * var(--mantine-scale));
  padding-inline-end: var(--mantine-spacing-xs);
  padding-top: var(--mantine-spacing-xs);
  padding-bottom: var(--mantine-spacing-xs);
  border-radius: var(--notification-radius);
  box-shadow: var(--mantine-shadow-lg);
}

  .m_a513464::before {
    content: '';
    display: block;
    position: absolute;
    width: calc(0.375rem * var(--mantine-scale));
    top: var(--notification-radius);
    bottom: var(--notification-radius);
    inset-inline-start: calc(0.25rem * var(--mantine-scale));
    border-radius: var(--notification-radius);
    background-color: var(--notification-color);
  }

  :where([data-mantine-color-scheme='light']) .m_a513464 {
    background-color: var(--mantine-color-white);
}

  :where([data-mantine-color-scheme='dark']) .m_a513464 {
    background-color: var(--mantine-color-dark-6);
}

  .m_a513464:where([data-with-icon]) {
    padding-inline-start: var(--mantine-spacing-xs);
  }

  .m_a513464:where([data-with-icon])::before {
      display: none;
    }

  :where([data-mantine-color-scheme='light']) .m_a513464:where([data-with-border]) {
      border: 1px solid var(--mantine-color-gray-3);
}

  :where([data-mantine-color-scheme='dark']) .m_a513464:where([data-with-border]) {
      border: 1px solid var(--mantine-color-dark-4);
}

.m_a4ceffb {
  box-sizing: border-box;
  margin-inline-end: var(--mantine-spacing-md);
  width: calc(1.75rem * var(--mantine-scale));
  height: calc(1.75rem * var(--mantine-scale));
  border-radius: calc(1.75rem * var(--mantine-scale));
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--notification-color);
  color: var(--mantine-color-white);
}

.m_b0920b15 {
  margin-inline-end: var(--mantine-spacing-md);
}

.m_a49ed24 {
  flex: 1;
  overflow: hidden;
  margin-inline-end: var(--mantine-spacing-xs);
}

.m_3feedf16 {
  margin-bottom: calc(0.125rem * var(--mantine-scale));
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: var(--mantine-font-size-sm);
  line-height: var(--mantine-line-height-sm);
  font-weight: 500;
}

:where([data-mantine-color-scheme='light']) .m_3feedf16 {
    color: var(--mantine-color-gray-9);
}

:where([data-mantine-color-scheme='dark']) .m_3feedf16 {
    color: var(--mantine-color-white);
}

.m_3d733a3a {
  font-size: var(--mantine-font-size-sm);
  line-height: var(--mantine-line-height-sm);
  overflow: hidden;
  text-overflow: ellipsis;
}

:where([data-mantine-color-scheme='light']) .m_3d733a3a {
    color: var(--mantine-color-black);
}

:where([data-mantine-color-scheme='dark']) .m_3d733a3a {
    color: var(--mantine-color-dark-0);
}

:where([data-mantine-color-scheme='light']) .m_3d733a3a:where([data-with-title]) {
      color: var(--mantine-color-gray-6);
}

:where([data-mantine-color-scheme='dark']) .m_3d733a3a:where([data-with-title]) {
      color: var(--mantine-color-dark-2);
}

@media (hover: hover) {
    :where([data-mantine-color-scheme='light']) .m_919a4d88:hover {
      background-color: var(--mantine-color-gray-0);
  }

    :where([data-mantine-color-scheme='dark']) .m_919a4d88:hover {
      background-color: var(--mantine-color-dark-8);
  }
}

@media (hover: none) {
    :where([data-mantine-color-scheme='light']) .m_919a4d88:active {
      background-color: var(--mantine-color-gray-0);
  }

    :where([data-mantine-color-scheme='dark']) .m_919a4d88:active {
      background-color: var(--mantine-color-dark-8);
  }
}

.m_e2f5cd4e {
  --ni-right-section-width-xs: calc(1.0625rem * var(--mantine-scale));
  --ni-right-section-width-sm: calc(1.5rem * var(--mantine-scale));
  --ni-right-section-width-md: calc(1.6875rem * var(--mantine-scale));
  --ni-right-section-width-lg: calc(1.9375rem * var(--mantine-scale));
  --ni-right-section-width-xl: calc(2.125rem * var(--mantine-scale));
}

.m_95e17d22 {
  --ni-chevron-size-xs: calc(0.625rem * var(--mantine-scale));
  --ni-chevron-size-sm: calc(0.875rem * var(--mantine-scale));
  --ni-chevron-size-md: calc(1rem * var(--mantine-scale));
  --ni-chevron-size-lg: calc(1.125rem * var(--mantine-scale));
  --ni-chevron-size-xl: calc(1.25rem * var(--mantine-scale));
  --ni-chevron-size: var(--ni-chevron-size-sm);

  display: flex;
  flex-direction: column;
  width: 100%;
  height: calc(var(--input-height) - calc(0.125rem * var(--mantine-scale)));
  max-width: calc(var(--ni-chevron-size) * 1.7);
  margin-inline-start: auto;
}

.m_80b4b171 {
  --control-border: 1px solid var(--input-bd);
  --control-radius: calc(var(--input-radius) - calc(0.0625rem * var(--mantine-scale)));

  flex: 0 0 50%;
  width: 100%;
  padding: 0;
  height: calc(var(--input-height) / 2 - calc(0.0625rem * var(--mantine-scale)));
  border-inline-start: var(--control-border);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--mantine-color-text);
  background-color: transparent;
  cursor: pointer;
}

.m_80b4b171:where(:disabled) {
    background-color: transparent;
    cursor: not-allowed;
    opacity: 0.6;
  }

:where([data-mantine-color-scheme='light']) .m_80b4b171:where(:disabled) {
      color: var(--mantine-color-gray-4);
}

:where([data-mantine-color-scheme='dark']) .m_80b4b171:where(:disabled) {
      color: var(--mantine-color-dark-3);
}

.m_e2f5cd4e[data-error] :where(.m_80b4b171) {
    color: var(--mantine-color-error);
  }

@media (hover: hover) {
    :where([data-mantine-color-scheme='light']) .m_80b4b171:hover {
      background-color: var(--mantine-color-gray-0);
  }

    :where([data-mantine-color-scheme='dark']) .m_80b4b171:hover {
      background-color: var(--mantine-color-dark-4);
  }
}

@media (hover: none) {
    :where([data-mantine-color-scheme='light']) .m_80b4b171:active {
      background-color: var(--mantine-color-gray-0);
  }

    :where([data-mantine-color-scheme='dark']) .m_80b4b171:active {
      background-color: var(--mantine-color-dark-4);
  }
}

.m_80b4b171:where(:first-of-type) {
    border-radius: 0;
    border-start-end-radius: var(--control-radius);
  }

.m_80b4b171:last-of-type {
    border-radius: 0;
    border-end-end-radius: var(--control-radius);
  }

.m_4addd315 {
  --pagination-control-size-xs: calc(1.375rem * var(--mantine-scale));
  --pagination-control-size-sm: calc(1.625rem * var(--mantine-scale));
  --pagination-control-size-md: calc(2rem * var(--mantine-scale));
  --pagination-control-size-lg: calc(2.375rem * var(--mantine-scale));
  --pagination-control-size-xl: calc(2.75rem * var(--mantine-scale));
  --pagination-control-size: var(--pagination-control-size-md);
  --pagination-control-fz: var(--mantine-font-size-md);
  --pagination-active-bg: var(--mantine-primary-color-filled);
}

.m_326d024a {
  display: flex;
  align-items: center;
  justify-content: center;
  border: calc(0.0625rem * var(--mantine-scale)) solid;
  cursor: pointer;
  color: var(--mantine-color-text);
  height: var(--pagination-control-size);
  min-width: var(--pagination-control-size);
  font-size: var(--pagination-control-fz);
  line-height: 1;
  border-radius: var(--pagination-control-radius, var(--mantine-radius-default));
}

.m_326d024a:where([data-with-padding]) {
    padding: calc(var(--pagination-control-size) / 4);
  }

.m_326d024a:where(:disabled, [data-disabled]) {
    cursor: not-allowed;
    opacity: 0.4;
  }

:where([data-mantine-color-scheme='light']) .m_326d024a {
    border-color: var(--mantine-color-gray-4);
    background-color: var(--mantine-color-white);
}

@media (hover: hover) {
      :where([data-mantine-color-scheme='light']) .m_326d024a:hover:where(:not(:disabled, [data-disabled])) {
        background-color: var(--mantine-color-gray-0);
      }
}

@media (hover: none) {
      :where([data-mantine-color-scheme='light']) .m_326d024a:active:where(:not(:disabled, [data-disabled])) {
        background-color: var(--mantine-color-gray-0);
      }
}

:where([data-mantine-color-scheme='dark']) .m_326d024a {
    border-color: var(--mantine-color-dark-4);
    background-color: var(--mantine-color-dark-6);
}

@media (hover: hover) {
      :where([data-mantine-color-scheme='dark']) .m_326d024a:hover:where(:not(:disabled, [data-disabled])) {
        background-color: var(--mantine-color-dark-5);
      }
}

@media (hover: none) {
      :where([data-mantine-color-scheme='dark']) .m_326d024a:active:where(:not(:disabled, [data-disabled])) {
        background-color: var(--mantine-color-dark-5);
      }
}

.m_326d024a:where([data-active]) {
    background-color: var(--pagination-active-bg);
    border-color: var(--pagination-active-bg);
    color: var(--pagination-active-color, var(--mantine-color-white));
  }

@media (hover: hover) {

  .m_326d024a:where([data-active]):hover {
      background-color: var(--pagination-active-bg);
  }
}

@media (hover: none) {

  .m_326d024a:where([data-active]):active {
      background-color: var(--pagination-active-bg);
  }
}

.m_4ad7767d {
  height: var(--pagination-control-size);
  min-width: var(--pagination-control-size);
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

.m_f61ca620 {
  --psi-button-size-xs: calc(1.375rem * var(--mantine-scale));
  --psi-button-size-sm: calc(1.625rem * var(--mantine-scale));
  --psi-button-size-md: calc(1.75rem * var(--mantine-scale));
  --psi-button-size-lg: calc(2rem * var(--mantine-scale));
  --psi-button-size-xl: calc(2.5rem * var(--mantine-scale));

  --psi-icon-size-xs: calc(0.75rem * var(--mantine-scale));
  --psi-icon-size-sm: calc(0.9375rem * var(--mantine-scale));
  --psi-icon-size-md: calc(1.0625rem * var(--mantine-scale));
  --psi-icon-size-lg: calc(1.1875rem * var(--mantine-scale));
  --psi-icon-size-xl: calc(1.3125rem * var(--mantine-scale));

  --psi-button-size: var(--psi-button-size-sm);
  --psi-icon-size: var(--psi-icon-size-sm);
}

.m_ccf8da4c {
  position: relative;
  overflow: hidden;
}

.m_f2d85dd2 {
  font-family: var(--mantine-font-family);
  background-color: transparent;
  border: 0;
  padding-inline-end: var(--input-padding-inline-end);
  padding-inline-start: var(--input-padding-inline-start);
  position: absolute;
  inset: 0;
  outline: 0;
  font-size: inherit;
  line-height: var(--mantine-line-height);
  height: 100%;
  width: 100%;
  color: inherit;
}

.m_ccf8da4c[data-disabled] .m_f2d85dd2,
  .m_f2d85dd2:disabled {
    cursor: not-allowed;
  }

.m_f2d85dd2::placeholder {
    color: var(--input-placeholder-color);
    opacity: 1;
  }

.m_f2d85dd2::-ms-reveal {
    display: none;
  }

.m_b1072d44 {
  width: var(--psi-button-size);
  height: var(--psi-button-size);
  min-width: var(--psi-button-size);
  min-height: var(--psi-button-size);
}

.m_b1072d44:disabled {
    display: none;
  }

.m_f1cb205a {
  --pin-input-size-xs: calc(1.875rem * var(--mantine-scale));
  --pin-input-size-sm: calc(2.25rem * var(--mantine-scale));
  --pin-input-size-md: calc(2.625rem * var(--mantine-scale));
  --pin-input-size-lg: calc(3.125rem * var(--mantine-scale));
  --pin-input-size-xl: calc(3.75rem * var(--mantine-scale));
  --pin-input-size: var(--pin-input-size-sm);
}

.m_cb288ead {
  width: var(--pin-input-size);
  height: var(--pin-input-size);
}

@keyframes m_81a374bd {
  0% {
    background-position: 0 0;
  }

  100% {
    background-position: calc(2.5rem * var(--mantine-scale)) 0;
  }
}

.m_db6d6462 {
  --progress-radius: var(--mantine-radius-default);
  --progress-size: var(--progress-size-md);

  --progress-size-xs: calc(0.1875rem * var(--mantine-scale));
  --progress-size-sm: calc(0.3125rem * var(--mantine-scale));
  --progress-size-md: calc(0.5rem * var(--mantine-scale));
  --progress-size-lg: calc(0.75rem * var(--mantine-scale));
  --progress-size-xl: calc(1rem * var(--mantine-scale));

  position: relative;
  height: var(--progress-size);
  border-radius: var(--progress-radius);
  overflow: hidden;
  display: flex;
}

:where([data-mantine-color-scheme='light']) .m_db6d6462 {
    background-color: var(--mantine-color-gray-2);
}

:where([data-mantine-color-scheme='dark']) .m_db6d6462 {
    background-color: var(--mantine-color-dark-4);
}

.m_2242eb65 {
  background-color: var(--progress-section-color);
  height: 100%;
  width: var(--progress-section-width);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background-size: calc(1.25rem * var(--mantine-scale)) calc(1.25rem * var(--mantine-scale));
  transition: width var(--progress-transition-duration, 100ms) ease;
}

.m_2242eb65:where([data-striped]) {
    background-image: linear-gradient(
      45deg,
      rgba(255, 255, 255, 0.15) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, 0.15) 50%,
      rgba(255, 255, 255, 0.15) 75%,
      transparent 75%,
      transparent
    );
  }

.m_2242eb65:where([data-animated]) {
    animation: m_81a374bd 1s linear infinite;
  }

.m_2242eb65:where(:last-of-type) {
    border-radius: 0;
    border-start-end-radius: var(--progress-radius);
    border-end-end-radius: var(--progress-radius);
  }

.m_2242eb65:where(:first-of-type) {
    border-radius: 0;
    border-start-start-radius: var(--progress-radius);
    border-end-start-radius: var(--progress-radius);
  }

.m_91e40b74 {
  color: var(--progress-label-color, var(--mantine-color-white));
  font-weight: bold;
  user-select: none;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: min(calc(var(--progress-size) * 0.65), calc(1.125rem * var(--mantine-scale)));
  line-height: 1;
  padding-inline: calc(0.25rem * var(--mantine-scale));
}

.m_9dc8ae12 {
  --card-radius: var(--mantine-radius-default);

  display: block;
  width: 100%;
  border-radius: var(--card-radius);
  cursor: pointer;
}

  .m_9dc8ae12 :where(*) {
    cursor: inherit;
  }

  .m_9dc8ae12:where([data-with-border]) {
    border: calc(0.0625rem * var(--mantine-scale)) solid transparent;
  }

  :where([data-mantine-color-scheme='light']) .m_9dc8ae12:where([data-with-border]) {
      border-color: var(--mantine-color-gray-3);
}

  :where([data-mantine-color-scheme='dark']) .m_9dc8ae12:where([data-with-border]) {
      border-color: var(--mantine-color-dark-4);
}

.m_717d7ff6 {
  --radio-size-xs: calc(1rem * var(--mantine-scale));
  --radio-size-sm: calc(1.25rem * var(--mantine-scale));
  --radio-size-md: calc(1.5rem * var(--mantine-scale));
  --radio-size-lg: calc(1.875rem * var(--mantine-scale));
  --radio-size-xl: calc(2.25rem * var(--mantine-scale));

  --radio-icon-size-xs: calc(0.375rem * var(--mantine-scale));
  --radio-icon-size-sm: calc(0.5rem * var(--mantine-scale));
  --radio-icon-size-md: calc(0.625rem * var(--mantine-scale));
  --radio-icon-size-lg: calc(0.875rem * var(--mantine-scale));
  --radio-icon-size-xl: calc(1rem * var(--mantine-scale));

  --radio-icon-size: var(--radio-icon-size-sm);
  --radio-size: var(--radio-size-sm);
  --radio-color: var(--mantine-primary-color-filled);
  --radio-icon-color: var(--mantine-color-white);

  position: relative;
  border: calc(0.0625rem * var(--mantine-scale)) solid transparent;
  width: var(--radio-size);
  min-width: var(--radio-size);
  height: var(--radio-size);
  min-height: var(--radio-size);
  border-radius: var(--radio-radius, 10000px);
  transition:
    border-color 100ms ease,
    background-color 100ms ease;
  cursor: var(--mantine-cursor-type);
  -webkit-tap-highlight-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
}

  :where([data-mantine-color-scheme='light']) .m_717d7ff6 {
    background-color: var(--mantine-color-white);
    border-color: var(--mantine-color-gray-4);
}

  :where([data-mantine-color-scheme='dark']) .m_717d7ff6 {
    background-color: var(--mantine-color-dark-6);
    border-color: var(--mantine-color-dark-4);
}

  .m_717d7ff6[data-indeterminate],
  .m_717d7ff6[data-checked] {
    background-color: var(--radio-color);
    border-color: var(--radio-color);
  }

  .m_717d7ff6[data-indeterminate] > .m_3e4da632, .m_717d7ff6[data-checked] > .m_3e4da632 {
      opacity: 1;
      transform: none;
      color: var(--radio-icon-color);
    }

  .m_717d7ff6[data-disabled] {
    cursor: not-allowed;
  }

  :where([data-mantine-color-scheme='light']) .m_717d7ff6[data-disabled] {
      background-color: var(--mantine-color-gray-2);
      border-color: var(--mantine-color-gray-3);
}

  :where([data-mantine-color-scheme='dark']) .m_717d7ff6[data-disabled] {
      background-color: var(--mantine-color-dark-6);
      border-color: var(--mantine-color-dark-6);
}

  [data-mantine-color-scheme='light'] .m_717d7ff6[data-disabled][data-checked] > .m_3e4da632 {
        color: var(--mantine-color-gray-5);
}

  [data-mantine-color-scheme='dark'] .m_717d7ff6[data-disabled][data-checked] > .m_3e4da632 {
        color: var(--mantine-color-dark-3);
}

.m_2980836c[data-indeterminate]:not([data-disabled]),
  .m_2980836c[data-checked]:not([data-disabled]) {
    background-color: transparent;
    border-color: var(--radio-color);
  }

.m_2980836c[data-indeterminate]:not([data-disabled]) > .m_3e4da632, .m_2980836c[data-checked]:not([data-disabled]) > .m_3e4da632 {
      color: var(--radio-color);
      opacity: 1;
      transform: none;
    }

.m_3e4da632 {
  display: block;
  width: var(--radio-icon-size);
  height: var(--radio-icon-size);
  color: transparent;
  pointer-events: none;
  transform: translateY(calc(0.3125rem * var(--mantine-scale))) scale(0.5);
  opacity: 1;
  transition:
    transform 100ms ease,
    opacity 100ms ease;
}

.m_f3f1af94 {
  --radio-size-xs: calc(1rem * var(--mantine-scale));
  --radio-size-sm: calc(1.25rem * var(--mantine-scale));
  --radio-size-md: calc(1.5rem * var(--mantine-scale));
  --radio-size-lg: calc(1.875rem * var(--mantine-scale));
  --radio-size-xl: calc(2.25rem * var(--mantine-scale));
  --radio-size: var(--radio-size-sm);

  --radio-icon-size-xs: calc(0.375rem * var(--mantine-scale));
  --radio-icon-size-sm: calc(0.5rem * var(--mantine-scale));
  --radio-icon-size-md: calc(0.625rem * var(--mantine-scale));
  --radio-icon-size-lg: calc(0.875rem * var(--mantine-scale));
  --radio-icon-size-xl: calc(1rem * var(--mantine-scale));
  --radio-icon-size: var(--radio-icon-size-sm);
  --radio-icon-color: var(--mantine-color-white);
}

.m_89c4f5e4 {
  position: relative;
  width: var(--radio-size);
  height: var(--radio-size);
  order: 1;
}

.m_89c4f5e4:where([data-label-position='left']) {
    order: 2;
  }

.m_f3ed6b2b {
  color: var(--radio-icon-color);
  opacity: var(--radio-icon-opacity, 0);
  transform: var(--radio-icon-transform, scale(0.2) translateY(calc(0.625rem * var(--mantine-scale))));
  transition:
    opacity 100ms ease,
    transform 200ms ease;
  pointer-events: none;
  width: var(--radio-icon-size);
  height: var(--radio-icon-size);
  position: absolute;
  top: calc(50% - var(--radio-icon-size) / 2);
  left: calc(50% - var(--radio-icon-size) / 2);
}

.m_8a3dbb89 {
  border: calc(0.0625rem * var(--mantine-scale)) solid;
  position: relative;
  appearance: none;
  width: var(--radio-size);
  height: var(--radio-size);
  border-radius: var(--radio-radius, var(--radio-size));
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition-property: background-color, border-color;
  transition-timing-function: ease;
  transition-duration: 100ms;
  cursor: var(--mantine-cursor-type);
  -webkit-tap-highlight-color: transparent;
}

:where([data-mantine-color-scheme='light']) .m_8a3dbb89 {
    background-color: var(--mantine-color-white);
    border-color: var(--mantine-color-gray-4);
}

:where([data-mantine-color-scheme='dark']) .m_8a3dbb89 {
    background-color: var(--mantine-color-dark-6);
    border-color: var(--mantine-color-dark-4);
}

.m_8a3dbb89:checked {
    background-color: var(--radio-color, var(--mantine-primary-color-filled));
    border-color: var(--radio-color, var(--mantine-primary-color-filled));
  }

.m_8a3dbb89:checked + .m_f3ed6b2b {
      --radio-icon-opacity: 1;
      --radio-icon-transform: scale(1);
    }

.m_8a3dbb89:disabled {
    cursor: not-allowed;
  }

:where([data-mantine-color-scheme='light']) .m_8a3dbb89:disabled {
      background-color: var(--mantine-color-gray-1);
      border-color: var(--mantine-color-gray-2);
}

:where([data-mantine-color-scheme='light']) .m_8a3dbb89:disabled + .m_f3ed6b2b {
        --radio-icon-color: var(--mantine-color-gray-3);
      }

:where([data-mantine-color-scheme='dark']) .m_8a3dbb89:disabled {
      background-color: var(--mantine-color-dark-5);
      border-color: var(--mantine-color-dark-4);
}

:where([data-mantine-color-scheme='dark']) .m_8a3dbb89:disabled + .m_f3ed6b2b {
        --radio-icon-color: var(--mantine-color-dark-7);
      }

.m_8a3dbb89:where([data-error]) {
    border-color: var(--mantine-color-error);
  }

.m_1bfe9d39 + .m_f3ed6b2b {
    --radio-icon-color: var(--radio-color);
  }

.m_1bfe9d39:checked:not(:disabled) {
    background-color: transparent;
    border-color: var(--radio-color);
  }

.m_1bfe9d39:checked:not(:disabled) + .m_f3ed6b2b {
      --radio-icon-color: var(--radio-color);
      --radio-icon-opacity: 1;
      --radio-icon-transform: none;
    }

.m_f8d312f2 {
  --rating-size-xs: calc(0.875rem * var(--mantine-scale));
  --rating-size-sm: calc(1.125rem * var(--mantine-scale));
  --rating-size-md: calc(1.25rem * var(--mantine-scale));
  --rating-size-lg: calc(1.75rem * var(--mantine-scale));
  --rating-size-xl: calc(2rem * var(--mantine-scale));

  display: flex;
  width: max-content;
}

  .m_f8d312f2:where(:has(input:disabled)) {
    pointer-events: none;
  }

.m_61734bb7 {
  position: relative;
  transition: transform 100ms ease;
}

.m_61734bb7:where([data-active]) {
    z-index: 1;
    transform: scale(1.1);
  }

.m_5662a89a {
  width: var(--rating-size);
  height: var(--rating-size);
  display: block;
}

:where([data-mantine-color-scheme='light']) .m_5662a89a {
    fill: var(--mantine-color-gray-3);
    stroke: var(--mantine-color-gray-3);
}

:where([data-mantine-color-scheme='dark']) .m_5662a89a {
    fill: var(--mantine-color-dark-3);
    stroke: var(--mantine-color-dark-3);
}

.m_5662a89a:where([data-filled]) {
    fill: var(--rating-color);
    stroke: var(--rating-color);
  }

.m_211007ba {
  height: 0;
  width: 0;
  position: absolute;
  overflow: hidden;
  white-space: nowrap;
  opacity: 0;
  -webkit-tap-highlight-color: transparent;
}

.m_211007ba:focus-visible + label {
    outline: 2px solid var(--mantine-primary-color-filled);
    outline-offset: calc(0.125rem * var(--mantine-scale));
  }

.m_21342ee4 {
  display: block;
  cursor: pointer;
  position: absolute;
  top: 0;
  left: 0;
  z-index: var(--rating-item-z-index, 0);
  -webkit-tap-highlight-color: transparent;
}

.m_21342ee4:where([data-read-only]) {
    cursor: default;
  }

.m_21342ee4:where(:last-of-type) {
    position: relative;
  }

.m_fae05d6a {
  clip-path: var(--rating-symbol-clip-path);
}

.m_1b3c8819 {
  --tooltip-radius: var(--mantine-radius-default);

  position: absolute;
  padding: calc(var(--mantine-spacing-xs) / 2) var(--mantine-spacing-xs);
  pointer-events: none;
  font-size: var(--mantine-font-size-sm);
  white-space: nowrap;
  border-radius: var(--tooltip-radius);
}

  :where([data-mantine-color-scheme='light']) .m_1b3c8819 {
    background-color: var(--tooltip-bg, var(--mantine-color-gray-9));
    color: var(--tooltip-color, var(--mantine-color-white));
}

  :where([data-mantine-color-scheme='dark']) .m_1b3c8819 {
    background-color: var(--tooltip-bg, var(--mantine-color-gray-2));
    color: var(--tooltip-color, var(--mantine-color-black));
}

  .m_1b3c8819:where([data-multiline]) {
    white-space: normal;
  }

  .m_1b3c8819:where([data-fixed]) {
    position: fixed;
  }

.m_f898399f {
  background-color: inherit;
  border: 0;
  z-index: 1;
}

.m_b32e4812 {
  position: relative;
  width: var(--rp-size);
  height: var(--rp-size);
  min-width: var(--rp-size);
  min-height: var(--rp-size);
}

.m_d43b5134 {
  width: var(--rp-size);
  height: var(--rp-size);
  min-width: var(--rp-size);
  min-height: var(--rp-size);
  transform: rotate(-90deg);
}

.m_b1ca1fbf {
  stroke: var(--curve-color, var(--rp-curve-root-color));
}

[data-mantine-color-scheme='light'] .m_b1ca1fbf {
    --rp-curve-root-color: var(--mantine-color-gray-2);
}

[data-mantine-color-scheme='dark'] .m_b1ca1fbf {
    --rp-curve-root-color: var(--mantine-color-dark-4);
}

.m_b23f9dc4 {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  inset-inline: var(--rp-label-offset);
}

.m_cf365364 {
  --sc-padding-xs: calc(0.1875rem * var(--mantine-scale)) calc(0.375rem * var(--mantine-scale));
  --sc-padding-sm: calc(0.3125rem * var(--mantine-scale)) calc(0.625rem * var(--mantine-scale));
  --sc-padding-md: calc(0.4375rem * var(--mantine-scale)) calc(0.875rem * var(--mantine-scale));
  --sc-padding-lg: calc(0.5625rem * var(--mantine-scale)) calc(1rem * var(--mantine-scale));
  --sc-padding-xl: calc(0.75rem * var(--mantine-scale)) calc(1.25rem * var(--mantine-scale));

  --sc-transition-duration: 200ms;
  --sc-padding: var(--sc-padding-sm);
  --sc-transition-timing-function: ease;
  --sc-font-size: var(--mantine-font-size-sm);

  position: relative;
  display: inline-flex;
  flex-direction: row;
  width: auto;
  border-radius: var(--sc-radius, var(--mantine-radius-default));
  overflow: hidden;
  padding: calc(0.25rem * var(--mantine-scale));
}

  .m_cf365364:where([data-full-width]) {
    display: flex;
  }

  .m_cf365364:where([data-orientation='vertical']) {
    display: flex;
    flex-direction: column;
    width: max-content;
  }

  .m_cf365364:where([data-orientation='vertical']):where([data-full-width]) {
      width: auto;
    }

  :where([data-mantine-color-scheme='light']) .m_cf365364 {
    background-color: var(--mantine-color-gray-1);
}

  :where([data-mantine-color-scheme='dark']) .m_cf365364 {
    background-color: var(--mantine-color-dark-8);
}

.m_9e182ccd {
  position: absolute;
  display: block;
  z-index: 1;
  border-radius: var(--sc-radius, var(--mantine-radius-default));
}

:where([data-mantine-color-scheme='light']) .m_9e182ccd {
    box-shadow: var(--sc-shadow, none);
    background-color: var(--sc-color, var(--mantine-color-white));
}

:where([data-mantine-color-scheme='dark']) .m_9e182ccd {
    box-shadow: none;
    background-color: var(--sc-color, var(--mantine-color-dark-5));
}

.m_1738fcb2 {
  -webkit-tap-highlight-color: transparent;
  font-weight: 500;
  display: block;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  user-select: none;
  border-radius: var(--sc-radius, var(--mantine-radius-default));
  font-size: var(--sc-font-size);
  padding: var(--sc-padding);
  transition: color var(--sc-transition-duration) var(--sc-transition-timing-function);
  cursor: pointer;

  /* outline is controlled by .input */
  outline: var(--segmented-control-outline, none);
}

:where([data-mantine-color-scheme='light']) .m_1738fcb2 {
    color: var(--mantine-color-gray-7);
}

:where([data-mantine-color-scheme='dark']) .m_1738fcb2 {
    color: var(--mantine-color-dark-1);
}

.m_1738fcb2:where([data-read-only]) {
    cursor: default;
  }

fieldset:disabled .m_1738fcb2,
  .m_1738fcb2:where([data-disabled]) {
    cursor: not-allowed;
  }

:where([data-mantine-color-scheme='light']) fieldset:disabled .m_1738fcb2, :where([data-mantine-color-scheme='light']) .m_1738fcb2:where([data-disabled]) {
      color: var(--mantine-color-gray-5);
}

:where([data-mantine-color-scheme='dark']) fieldset:disabled .m_1738fcb2, :where([data-mantine-color-scheme='dark']) .m_1738fcb2:where([data-disabled]) {
      color: var(--mantine-color-dark-3);
}

:where([data-mantine-color-scheme='light']) .m_1738fcb2:where([data-active]) {
      color: var(--sc-label-color, var(--mantine-color-black));
}

:where([data-mantine-color-scheme='dark']) .m_1738fcb2:where([data-active]) {
      color: var(--sc-label-color, var(--mantine-color-white));
}

.m_cf365364:where([data-initialized]) .m_1738fcb2:where([data-active])::before {
        display: none;
      }

.m_1738fcb2:where([data-active])::before {
      content: '';
      inset: 0;
      z-index: 0;
      position: absolute;
      border-radius: var(--sc-radius, var(--mantine-radius-default));
}

:where([data-mantine-color-scheme='light']) .m_1738fcb2:where([data-active])::before {
        box-shadow: var(--sc-shadow, none);
        background-color: var(--sc-color, var(--mantine-color-white));
}

:where([data-mantine-color-scheme='dark']) .m_1738fcb2:where([data-active])::before {
        box-shadow: none;
        background-color: var(--sc-color, var(--mantine-color-dark-5));
}

@media (hover: hover) {
      :where([data-mantine-color-scheme='light']) .m_1738fcb2:where(:not([data-disabled], [data-active], [data-read-only])):hover {
        color: var(--mantine-color-black);
  }

      :where([data-mantine-color-scheme='dark']) .m_1738fcb2:where(:not([data-disabled], [data-active], [data-read-only])):hover {
        color: var(--mantine-color-white);
  }
}

@media (hover: none) {
      :where([data-mantine-color-scheme='light']) .m_1738fcb2:where(:not([data-disabled], [data-active], [data-read-only])):active {
        color: var(--mantine-color-black);
  }

      :where([data-mantine-color-scheme='dark']) .m_1738fcb2:where(:not([data-disabled], [data-active], [data-read-only])):active {
        color: var(--mantine-color-white);
  }
}

@media (hover: hover) {
      :where([data-mantine-color-scheme='light']) fieldset:disabled .m_1738fcb2:hover {
        color: var(--mantine-color-gray-5) !important;
  }

      :where([data-mantine-color-scheme='dark']) fieldset:disabled .m_1738fcb2:hover {
        color: var(--mantine-color-dark-3) !important;
  }
}

@media (hover: none) {
      :where([data-mantine-color-scheme='light']) fieldset:disabled .m_1738fcb2:active {
        color: var(--mantine-color-gray-5) !important;
  }

      :where([data-mantine-color-scheme='dark']) fieldset:disabled .m_1738fcb2:active {
        color: var(--mantine-color-dark-3) !important;
  }
}

.m_1714d588 {
  height: 0;
  width: 0;
  position: absolute;
  overflow: hidden;
  white-space: nowrap;
  opacity: 0;
}

.m_1714d588[data-focus-ring='auto']:focus:focus-visible + .m_1738fcb2 {
        --segmented-control-outline: 2px solid var(--mantine-primary-color-filled);
      }

.m_1714d588[data-focus-ring='always']:focus + .m_1738fcb2 {
        --segmented-control-outline: 2px solid var(--mantine-primary-color-filled);
      }

.m_69686b9b {
  position: relative;
  flex: 1;
  z-index: 2;
  transition: border-color var(--sc-transition-duration) var(--sc-transition-timing-function);
}

.m_cf365364[data-with-items-borders] :where(.m_69686b9b)::before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    inset-inline-start: 0;
    background-color: var(--separator-color);
    width: calc(0.0625rem * var(--mantine-scale));
    transition: background-color var(--sc-transition-duration) var(--sc-transition-timing-function);
  }

.m_69686b9b[data-orientation='vertical']::before {
      top: 0;
      inset-inline: 0;
      bottom: auto;
      height: calc(0.0625rem * var(--mantine-scale));
      width: auto;
    }

:where([data-mantine-color-scheme='light']) .m_69686b9b {
    --separator-color: var(--mantine-color-gray-3);
}

:where([data-mantine-color-scheme='dark']) .m_69686b9b {
    --separator-color: var(--mantine-color-dark-4);
}

.m_69686b9b:first-of-type::before {
      --separator-color: transparent;
    }

[data-mantine-color-scheme] .m_69686b9b[data-active]::before, [data-mantine-color-scheme] .m_69686b9b[data-active] + .m_69686b9b::before {
          --separator-color: transparent;
        }

.m_78882f40 {
  position: relative;
  z-index: 2;
}

.m_925c2d2c {
  container: simple-grid / inline-size;
}

.m_2415a157 {
  display: grid;
  grid-template-columns: repeat(var(--sg-cols), minmax(0, 1fr));
  gap: var(--sg-spacing-y) var(--sg-spacing-x);
}

@keyframes m_299c329c {
  0%,
  100% {
    opacity: 0.4;
  }

  50% {
    opacity: 1;
  }
}

.m_18320242 {
  height: var(--skeleton-height, auto);
  width: var(--skeleton-width, 100%);
  border-radius: var(--skeleton-radius, var(--mantine-radius-default));
  position: relative;
  transform: translateZ(0);
  -webkit-transform: translateZ(0);
}

.m_18320242:where([data-animate])::after {
    animation: m_299c329c 1500ms linear infinite;
  }

.m_18320242:where([data-visible]) {
    overflow: hidden;
  }

.m_18320242:where([data-visible])::before {
      position: absolute;
      content: '';
      inset: 0;
      z-index: 10;
      background-color: var(--mantine-color-body);
    }

.m_18320242:where([data-visible])::after {
      position: absolute;
      content: '';
      inset: 0;
      z-index: 11;
    }

:where([data-mantine-color-scheme='light']) .m_18320242:where([data-visible])::after {
        background-color: var(--mantine-color-gray-3);
}

:where([data-mantine-color-scheme='dark']) .m_18320242:where([data-visible])::after {
        background-color: var(--mantine-color-dark-4);
}

.m_dd36362e {
  --slider-size-xs: calc(0.25rem * var(--mantine-scale));
  --slider-size-sm: calc(0.375rem * var(--mantine-scale));
  --slider-size-md: calc(0.5rem * var(--mantine-scale));
  --slider-size-lg: calc(0.625rem * var(--mantine-scale));
  --slider-size-xl: calc(0.75rem * var(--mantine-scale));

  --slider-size: var(--slider-size-md);
  --slider-radius: calc(62.5rem * var(--mantine-scale));
  --slider-color: var(--mantine-primary-color-filled);

  -webkit-tap-highlight-color: transparent;
  outline: none;
  height: calc(var(--slider-size) * 2);
  padding-inline: var(--slider-size);
  display: flex;
  flex-direction: column;
  align-items: center;
  touch-action: none;
  position: relative;
}

  [data-mantine-color-scheme='light'] .m_dd36362e {
    --slider-track-bg: var(--mantine-color-gray-2);
    --slider-track-disabled-bg: var(--mantine-color-gray-4);
}

  [data-mantine-color-scheme='dark'] .m_dd36362e {
    --slider-track-bg: var(--mantine-color-dark-4);
    --slider-track-disabled-bg: var(--mantine-color-dark-3);
}

.m_c9357328 {
  position: absolute;
  top: calc(-2.25rem * var(--mantine-scale));
  font-size: var(--mantine-font-size-xs);
  color: var(--mantine-color-white);
  padding: calc(var(--mantine-spacing-xs) / 2);
  border-radius: var(--mantine-radius-sm);
  white-space: nowrap;
  pointer-events: none;
  user-select: none;
  touch-action: none;
}

:where([data-mantine-color-scheme='light']) .m_c9357328 {
    background-color: var(--mantine-color-gray-9);
}

:where([data-mantine-color-scheme='dark']) .m_c9357328 {
    background-color: var(--mantine-color-dark-4);
}

.m_c9a9a60a {
  position: absolute;
  display: flex;
  height: var(--slider-thumb-size);
  width: var(--slider-thumb-size);
  border: calc(0.25rem * var(--mantine-scale)) solid;
  transform: translate(-50%, -50%);
  color: var(--slider-color);
  top: 50%;
  cursor: pointer;
  border-radius: var(--slider-radius);
  align-items: center;
  justify-content: center;
  transition:
    box-shadow 100ms ease,
    transform 100ms ease;
  z-index: 3;
  user-select: none;
  touch-action: none;
  outline-offset: calc(0.125rem * var(--mantine-scale));
  left: var(--slider-thumb-offset);
}

:where([dir="rtl"]) .m_c9a9a60a {
    left: auto;
    right: calc(var(--slider-thumb-offset) - var(--slider-thumb-size));
}

fieldset:disabled .m_c9a9a60a,
  .m_c9a9a60a:where([data-disabled]) {
    display: none;
  }

.m_c9a9a60a:where([data-dragging]) {
    transform: translate(-50%, -50%) scale(1.05);
    box-shadow: var(--mantine-shadow-sm);
  }

:where([data-mantine-color-scheme='light']) .m_c9a9a60a {
    border-color: var(--slider-color);
    background-color: var(--mantine-color-white);
}

:where([data-mantine-color-scheme='dark']) .m_c9a9a60a {
    border-color: var(--mantine-color-white);
    background-color: var(--slider-color);
}

.m_a8645c2 {
  display: flex;
  align-items: center;
  width: 100%;
  height: calc(var(--slider-size) * 2);
  cursor: pointer;
}

fieldset:disabled .m_a8645c2,
  .m_a8645c2:where([data-disabled]) {
    cursor: not-allowed;
  }

.m_c9ade57f {
  position: relative;
  width: 100%;
  height: var(--slider-size);
}

.m_c9ade57f:where([data-inverted]:not([data-disabled])) {
    --track-bg: var(--slider-color);
  }

fieldset:disabled .m_c9ade57f:where([data-inverted]),
  .m_c9ade57f:where([data-inverted][data-disabled]) {
    --track-bg: var(--slider-track-disabled-bg);
  }

.m_c9ade57f::before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    border-radius: var(--slider-radius);
    inset-inline: calc(var(--slider-size) * -1);
    background-color: var(--track-bg, var(--slider-track-bg));
    z-index: 0;
  }

.m_38aeed47 {
  position: absolute;
  z-index: 1;
  top: 0;
  bottom: 0;
  background-color: var(--slider-color);
  border-radius: var(--slider-radius);
  width: var(--slider-bar-width);
  inset-inline-start: var(--slider-bar-offset);
}

.m_38aeed47:where([data-inverted]) {
    background-color: var(--slider-track-bg);
  }

:where([data-mantine-color-scheme='light']) fieldset:disabled .m_38aeed47:where(:not([data-inverted])), :where([data-mantine-color-scheme='light']) .m_38aeed47:where([data-disabled]:not([data-inverted])) {
      background-color: var(--mantine-color-gray-4);
}

:where([data-mantine-color-scheme='dark']) fieldset:disabled .m_38aeed47:where(:not([data-inverted])), :where([data-mantine-color-scheme='dark']) .m_38aeed47:where([data-disabled]:not([data-inverted])) {
      background-color: var(--mantine-color-dark-3);
}

.m_b7b0423a {
  position: absolute;
  inset-inline-start: calc(var(--mark-offset) - var(--slider-size) / 2);
  top: 0;
  z-index: 2;
  height: 0;
  pointer-events: none;
}

.m_dd33bc19 {
  border: calc(0.125rem * var(--mantine-scale)) solid;
  height: var(--slider-size);
  width: var(--slider-size);
  border-radius: calc(62.5rem * var(--mantine-scale));
  transform: translateX((calc(var(--slider-size) / -2)));
  background-color: var(--mantine-color-white);
  pointer-events: none;
}

:where([data-mantine-color-scheme='light']) .m_dd33bc19 {
    border-color: var(--mantine-color-gray-2);
}

:where([data-mantine-color-scheme='dark']) .m_dd33bc19 {
    border-color: var(--mantine-color-dark-4);
}

.m_dd33bc19:where([data-filled]) {
    border-color: var(--slider-color);
  }

:where([data-mantine-color-scheme='light']) .m_dd33bc19:where([data-filled]):where([data-disabled]) {
        border-color: var(--mantine-color-gray-4);
}

:where([data-mantine-color-scheme='dark']) .m_dd33bc19:where([data-filled]):where([data-disabled]) {
        border-color: var(--mantine-color-dark-3);
}

.m_68c77a5b {
  transform: translate(calc(-50% + var(--slider-size) / 2), calc(var(--mantine-spacing-xs) / 2));
  font-size: var(--mantine-font-size-sm);
  white-space: nowrap;
  cursor: pointer;
  user-select: none;
}

:where([data-mantine-color-scheme='light']) .m_68c77a5b {
    color: var(--mantine-color-gray-6);
}

:where([data-mantine-color-scheme='dark']) .m_68c77a5b {
    color: var(--mantine-color-dark-2);
}

.m_559cce2d {
  position: relative;
}

  .m_559cce2d:where([data-has-spoiler]) {
    margin-bottom: calc(1.5rem * var(--mantine-scale));
  }

.m_b912df4e {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition: max-height var(--spoiler-transition-duration, 200ms) ease;
}

.m_b9131032 {
  position: absolute;
  inset-inline-start: 0;
  top: 100%;
  height: calc(1.5rem * var(--mantine-scale));
}

.m_6d731127 {
  display: flex;
  flex-direction: column;
  align-items: var(--stack-align, stretch);
  justify-content: var(--stack-justify, flex-start);
  gap: var(--stack-gap, var(--mantine-spacing-md));
}

.m_cbb4ea7e {
  --stepper-icon-size-xs: calc(2.125rem * var(--mantine-scale));
  --stepper-icon-size-sm: calc(2.25rem * var(--mantine-scale));
  --stepper-icon-size-md: calc(2.625rem * var(--mantine-scale));
  --stepper-icon-size-lg: calc(3rem * var(--mantine-scale));
  --stepper-icon-size-xl: calc(3.25rem * var(--mantine-scale));

  --stepper-icon-size: var(--stepper-icon-size-md);
  --stepper-color: var(--mantine-primary-color-filled);
  --stepper-content-padding: var(--mantine-spacing-md);
  --stepper-spacing: var(--mantine-spacing-md);
  --stepper-radius: calc(62.5rem * var(--mantine-scale));
  --stepper-fz: var(--mantine-font-size-md);
}

.m_aaf89d0b {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
}

.m_aaf89d0b:where([data-wrap]) {
    flex-wrap: wrap;
    gap: var(--mantine-spacing-md) 0;
  }

.m_aaf89d0b:where([data-orientation='vertical']) {
    flex-direction: column;
  }

.m_aaf89d0b:where([data-orientation='vertical']):where([data-icon-position='left']) {
      align-items: flex-start;
    }

.m_aaf89d0b:where([data-orientation='vertical']):where([data-icon-position='right']) {
      align-items: flex-end;
    }

.m_aaf89d0b:where([data-orientation='horizontal']) {
    flex-direction: row;
  }

.m_2a371ac9 {
  --separator-offset: calc(var(--stepper-icon-size) / 2 - calc(0.0625rem * var(--mantine-scale)));

  transition: background-color 150ms ease;
  flex: 1;
}

:where([data-mantine-color-scheme='light']) .m_2a371ac9 {
    background-color: var(--mantine-color-gray-2);
}

:where([data-mantine-color-scheme='dark']) .m_2a371ac9 {
    background-color: var(--mantine-color-dark-2);
}

.m_2a371ac9:where([data-active]) {
    background-color: var(--stepper-color);
  }

.m_2a371ac9:where([data-orientation='horizontal']) {
    height: calc(0.125rem * var(--mantine-scale));
    margin-inline: var(--mantine-spacing-md);
  }

.m_2a371ac9:where([data-orientation='vertical']) {
    width: calc(0.125rem * var(--mantine-scale));
    margin-top: calc(var(--mantine-spacing-xs) / 2);
    margin-bottom: calc(var(--mantine-spacing-xs) - calc(0.125rem * var(--mantine-scale)));
  }

.m_2a371ac9:where([data-orientation='vertical']):where([data-icon-position='left']) {
      margin-inline-start: var(--separator-offset);
    }

.m_2a371ac9:where([data-orientation='vertical']):where([data-icon-position='right']) {
      margin-inline-end: var(--separator-offset);
    }

.m_78da155d {
  padding-top: var(--stepper-content-padding);
}

.m_cbb57068 {
  --step-color: var(--stepper-color);

  display: flex;
  cursor: default;
}

.m_cbb57068:where([data-allow-click]) {
    cursor: pointer;
  }

.m_cbb57068:where([data-icon-position='left']) {
    flex-direction: row;
  }

.m_cbb57068:where([data-icon-position='right']) {
    flex-direction: row-reverse;
  }

.m_f56b1e2c {
  align-items: center;
}

.m_833edb7e {
  --separator-spacing: calc(var(--mantine-spacing-xs) / 2);

  justify-content: flex-start;
  min-height: calc(var(--stepper-icon-size) + var(--mantine-spacing-xl) + var(--separator-spacing));
  margin-top: var(--separator-spacing);
  overflow: hidden;
}

.m_833edb7e:where(:first-of-type) {
    margin-top: 0;
  }

.m_833edb7e:where(:last-of-type) .m_6496b3f3 {
    display: none;
  }

.m_818e70b {
  position: relative;
}

.m_6496b3f3 {
  top: calc(var(--stepper-icon-size) + var(--separator-spacing));
  inset-inline-start: calc(var(--stepper-icon-size) / 2);
  height: 100vh;
  position: absolute;
  border-inline-start: calc(0.125rem * var(--mantine-scale)) solid;
}

:where([data-mantine-color-scheme='light']) .m_6496b3f3 {
    border-color: var(--mantine-color-gray-1);
}

:where([data-mantine-color-scheme='dark']) .m_6496b3f3 {
    border-color: var(--mantine-color-dark-5);
}

.m_6496b3f3:where([data-active]) {
    border-color: var(--stepper-color);
  }

.m_1959ad01 {
  height: var(--stepper-icon-size);
  width: var(--stepper-icon-size);
  min-height: var(--stepper-icon-size);
  min-width: var(--stepper-icon-size);
  border-radius: var(--stepper-radius);
  font-size: var(--stepper-fz);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  font-weight: bold;
  transition:
    background-color 150ms ease,
    border-color 150ms ease;
  border: calc(0.125rem * var(--mantine-scale)) solid;
}

:where([data-mantine-color-scheme='light']) .m_1959ad01 {
    background-color: var(--mantine-color-gray-1);
    border-color: var(--mantine-color-gray-1);
    color: var(--mantine-color-gray-7);
}

:where([data-mantine-color-scheme='dark']) .m_1959ad01 {
    background-color: var(--mantine-color-dark-5);
    border-color: var(--mantine-color-dark-5);
    color: var(--mantine-color-dark-1);
}

.m_1959ad01:where([data-progress]) {
    border-color: var(--step-color);
  }

.m_1959ad01:where([data-completed]) {
    color: var(--stepper-icon-color, var(--mantine-color-white));
    background-color: var(--step-color);
    border-color: var(--step-color);
  }

.m_a79331dc {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--stepper-icon-color, var(--mantine-color-white));
}

.m_1956aa2a {
  display: flex;
  flex-direction: column;
}

.m_1956aa2a:where([data-icon-position='left']) {
    margin-inline-start: var(--mantine-spacing-sm);
  }

.m_1956aa2a:where([data-icon-position='right']) {
    text-align: right;
    margin-inline-end: var(--mantine-spacing-sm);
  }

:where([dir="rtl"]) .m_1956aa2a:where([data-icon-position='right']) {
      text-align: left;
}

.m_12051f6c {
  font-weight: 500;
  font-size: var(--stepper-fz);
  line-height: 1;
}

.m_164eea74 {
  margin-top: calc(var(--stepper-spacing) / 3);
  margin-bottom: calc(var(--stepper-spacing) / 3);
  font-size: calc(var(--stepper-fz) - calc(0.125rem * var(--mantine-scale)));
  line-height: 1;
  color: var(--mantine-color-dimmed);
}

.m_5f93f3bb {
  --switch-height-xs: calc(1rem * var(--mantine-scale));
  --switch-height-sm: calc(1.25rem * var(--mantine-scale));
  --switch-height-md: calc(1.5rem * var(--mantine-scale));
  --switch-height-lg: calc(1.875rem * var(--mantine-scale));
  --switch-height-xl: calc(2.25rem * var(--mantine-scale));

  --switch-width-xs: calc(2rem * var(--mantine-scale));
  --switch-width-sm: calc(2.375rem * var(--mantine-scale));
  --switch-width-md: calc(2.875rem * var(--mantine-scale));
  --switch-width-lg: calc(3.5rem * var(--mantine-scale));
  --switch-width-xl: calc(4.5rem * var(--mantine-scale));

  --switch-thumb-size-xs: calc(0.75rem * var(--mantine-scale));
  --switch-thumb-size-sm: calc(0.875rem * var(--mantine-scale));
  --switch-thumb-size-md: calc(1.125rem * var(--mantine-scale));
  --switch-thumb-size-lg: calc(1.375rem * var(--mantine-scale));
  --switch-thumb-size-xl: calc(1.75rem * var(--mantine-scale));

  --switch-label-font-size-xs: calc(0.3125rem * var(--mantine-scale));
  --switch-label-font-size-sm: calc(0.375rem * var(--mantine-scale));
  --switch-label-font-size-md: calc(0.4375rem * var(--mantine-scale));
  --switch-label-font-size-lg: calc(0.5625rem * var(--mantine-scale));
  --switch-label-font-size-xl: calc(0.6875rem * var(--mantine-scale));

  --switch-track-label-padding-xs: calc(0.0625rem * var(--mantine-scale));
  --switch-track-label-padding-sm: calc(0.125rem * var(--mantine-scale));
  --switch-track-label-padding-md: calc(0.125rem * var(--mantine-scale));
  --switch-track-label-padding-lg: calc(0.1875rem * var(--mantine-scale));
  --switch-track-label-padding-xl: calc(0.1875rem * var(--mantine-scale));

  --switch-height: var(--switch-height-sm);
  --switch-width: var(--switch-width-sm);
  --switch-thumb-size: var(--switch-thumb-size-sm);
  --switch-label-font-size: var(--switch-label-font-size-sm);
  --switch-track-label-padding: var(--switch-track-label-padding-sm);
  --switch-radius: calc(62.5rem * var(--mantine-scale));
  --switch-color: var(--mantine-primary-color-filled);

  position: relative;
}

.m_926b4011 {
  height: 0;
  width: 0;
  opacity: 0;
  margin: 0;
  padding: 0;
  position: absolute;
  overflow: hidden;
  white-space: nowrap;
}

.m_9307d992 {
  -webkit-tap-highlight-color: transparent;
  cursor: var(--switch-cursor, var(--mantine-cursor-type));
  overflow: hidden;
  position: relative;
  border-radius: var(--switch-radius);
  background-color: var(--switch-bg);
  border: 1px solid var(--switch-bd);
  height: var(--switch-height);
  min-width: var(--switch-width);
  margin: 0;
  transition:
    background-color 150ms ease,
    border-color 150ms ease;
  appearance: none;
  display: flex;
  align-items: center;
  font-size: var(--switch-label-font-size);
  font-weight: 600;
  order: var(--switch-order, 1);
  user-select: none;
  z-index: 0;
  line-height: 0;
  color: var(--switch-text-color);
}

.m_926b4011:focus-visible + .m_9307d992 {
    outline: 2px solid var(--mantine-primary-color-filled);
    outline-offset: calc(0.125rem * var(--mantine-scale));
  }

.m_926b4011:checked + .m_9307d992 {
    --switch-bg: var(--switch-color);
    --switch-bd: var(--switch-color);
    --switch-text-color: var(--mantine-color-white);
  }

.m_926b4011:disabled + .m_9307d992,
  .m_926b4011[data-disabled] + .m_9307d992 {
    --switch-bg: var(--switch-disabled-color);
    --switch-bd: var(--switch-disabled-color);
    --switch-cursor: not-allowed;
  }

[data-mantine-color-scheme='light'] .m_9307d992 {
    --switch-bg: var(--mantine-color-gray-2);
    --switch-bd: var(--mantine-color-gray-3);
    --switch-text-color: var(--mantine-color-gray-6);
    --switch-disabled-color: var(--mantine-color-gray-2);
}

[data-mantine-color-scheme='dark'] .m_9307d992 {
    --switch-bg: var(--mantine-color-dark-6);
    --switch-bd: var(--mantine-color-dark-4);
    --switch-text-color: var(--mantine-color-dark-1);
    --switch-disabled-color: var(--mantine-color-dark-4);
}

.m_9307d992[data-error] {
    --switch-bd: var(--mantine-color-error);
  }

.m_9307d992[data-label-position='left'] {
    --switch-order: 2;
  }

.m_93039a1d {
  position: absolute;
  z-index: 1;
  border-radius: var(--switch-radius);
  display: flex;
  background-color: var(--switch-thumb-bg, var(--mantine-color-white));
  height: var(--switch-thumb-size);
  width: var(--switch-thumb-size);
  border: 1px solid var(--switch-thumb-bd);
  inset-inline-start: var(--switch-thumb-start, var(--switch-track-label-padding));
  transition: inset-inline-start 150ms ease;
}

.m_93039a1d > * {
    margin: auto;
  }

.m_926b4011:checked + * > .m_93039a1d {
    --switch-thumb-start: calc(100% - var(--switch-thumb-size) - var(--switch-track-label-padding));
    --switch-thumb-bd: var(--mantine-color-white);
  }

.m_926b4011:disabled + * > .m_93039a1d,
  .m_926b4011[data-disabled] + * > .m_93039a1d {
    --switch-thumb-bd: var(--switch-thumb-bg-disabled);
    --switch-thumb-bg: var(--switch-thumb-bg-disabled);
  }

[data-mantine-color-scheme='light'] .m_93039a1d {
    --switch-thumb-bd: var(--mantine-color-gray-3);
    --switch-thumb-bg-disabled: var(--mantine-color-gray-0);
}

[data-mantine-color-scheme='dark'] .m_93039a1d {
    --switch-thumb-bd: var(--mantine-color-white);
    --switch-thumb-bg-disabled: var(--mantine-color-dark-3);
}

.m_8277e082 {
  height: 100%;
  display: grid;
  place-content: center;
  min-width: calc(var(--switch-width) - var(--switch-thumb-size));
  padding-inline: var(--switch-track-label-padding);
  margin-inline-start: calc(var(--switch-thumb-size) + var(--switch-track-label-padding));
  transition: margin 150ms ease;
}

.m_926b4011:checked + * > .m_8277e082 {
    margin-inline-end: calc(var(--switch-thumb-size) + var(--switch-track-label-padding));
    margin-inline-start: 0;
  }

.m_b23fa0ef {
  width: 100%;
  border-collapse: collapse;
  line-height: var(--mantine-line-height);
  font-size: var(--mantine-font-size-sm);
  table-layout: var(--table-layout, auto);
  caption-side: var(--table-caption-side, bottom);
  border: none;
}

  :where([data-mantine-color-scheme='light']) .m_b23fa0ef {
    --table-hover-color: var(--mantine-color-gray-1);
    --table-striped-color: var(--mantine-color-gray-0);
    --table-border-color: var(--mantine-color-gray-3);
}

  :where([data-mantine-color-scheme='dark']) .m_b23fa0ef {
    --table-hover-color: var(--mantine-color-dark-5);
    --table-striped-color: var(--mantine-color-dark-6);
    --table-border-color: var(--mantine-color-dark-4);
}

  .m_b23fa0ef:where([data-with-table-border]) {
    border: calc(0.0625rem * var(--mantine-scale)) solid var(--table-border-color);
  }

.m_4e7aa4f3 {
  text-align: left;
}

:where([dir="rtl"]) .m_4e7aa4f3 {
    text-align: right;
}

.m_4e7aa4fd {
  border-bottom: none;
  background-color: transparent;
}

@media (hover: hover) {
    .m_4e7aa4fd:hover:where([data-hover]) {
      background-color: var(--tr-hover-bg);
    }
}

@media (hover: none) {
    .m_4e7aa4fd:active:where([data-hover]) {
      background-color: var(--tr-hover-bg);
    }
}

.m_4e7aa4fd:where([data-with-row-border]) {
    border-bottom: calc(0.0625rem * var(--mantine-scale)) solid var(--table-border-color);
  }

.m_4e7aa4ef,
.m_4e7aa4f3 {
  padding: var(--table-vertical-spacing) var(--table-horizontal-spacing, var(--mantine-spacing-xs));
}

.m_4e7aa4ef:where([data-with-column-border]:not(:last-child)), .m_4e7aa4f3:where([data-with-column-border]:not(:last-child)) {
    border-inline-end: calc(0.0625rem * var(--mantine-scale)) solid var(--table-border-color);
  }

.m_b2404537 :where(tr):where([data-with-row-border]:last-of-type) {
      border-bottom: none;
    }

.m_b2404537 :where(tr):where([data-striped='odd']:nth-of-type(odd)) {
      background-color: var(--table-striped-color);
    }

.m_b2404537 :where(tr):where([data-striped='even']:nth-of-type(even)) {
      background-color: var(--table-striped-color);
    }

.m_b2404537 :where(tr)[data-hover] {
      --tr-hover-bg: var(--table-highlight-on-hover-color, var(--table-hover-color));
    }

.m_b242d975 {
  top: var(--table-sticky-header-offset, 0);
  z-index: 1;
}

.m_b242d975:where([data-sticky]) {
    position: sticky;
    background-color: var(--mantine-color-body);
  }

.m_9e5a3ac7 {
  color: var(--mantine-color-dimmed);
}

.m_9e5a3ac7:where([data-side='top']) {
    margin-bottom: var(--mantine-spacing-xs);
  }

.m_9e5a3ac7:where([data-side='bottom']) {
    margin-top: var(--mantine-spacing-xs);
  }

.m_a100c15 {
  overflow-x: var(--table-overflow);
}

.m_62259741 {
  min-width: var(--table-min-width);
}

.m_89d60db1 {
  display: var(--tabs-display);
  flex-direction: var(--tabs-flex-direction);

  --tab-justify: flex-start;
  --tabs-list-direction: row;
  --tabs-panel-grow: unset;
  --tabs-display: block;
  --tabs-flex-direction: row;
  --tabs-list-border-width: 0;
  --tabs-list-border-size: 0 0 var(--tabs-list-border-width) 0;
  --tabs-list-gap: unset;

  --tabs-list-line-bottom: 0;
  --tabs-list-line-top: unset;
  --tabs-list-line-start: 0;
  --tabs-list-line-end: 0;

  --tab-radius: var(--tabs-radius) var(--tabs-radius) 0 0;
  --tab-border-width: 0 0 var(--tabs-list-border-width) 0;
}

  .m_89d60db1[data-inverted] {
    --tabs-list-line-bottom: unset;
    --tabs-list-line-top: 0;
    --tab-radius: 0 0 var(--tabs-radius) var(--tabs-radius);
    --tab-border-width: var(--tabs-list-border-width) 0 0 0;
  }

  .m_89d60db1[data-inverted] .m_576c9d4::before {
      top: 0;
      bottom: unset;
    }

  .m_89d60db1[data-orientation='vertical'] {
    --tabs-list-line-start: unset;
    --tabs-list-line-end: 0;
    --tabs-list-line-top: 0;
    --tabs-list-line-bottom: 0;
    --tabs-list-border-size: 0 var(--tabs-list-border-width) 0 0;
    --tab-border-width: 0 var(--tabs-list-border-width) 0 0;
    --tab-radius: var(--tabs-radius) 0 0 var(--tabs-radius);
    --tabs-list-direction: column;
    --tabs-panel-grow: 1;
    --tabs-display: flex;
  }

  [dir="rtl"] .m_89d60db1[data-orientation='vertical'] {
      --tabs-list-border-size: 0 0 0 var(--tabs-list-border-width);
      --tab-border-width: 0 0 0 var(--tabs-list-border-width);
      --tab-radius: 0 var(--tabs-radius) var(--tabs-radius) 0;
}

  .m_89d60db1[data-orientation='vertical'][data-placement='right'] {
      --tabs-flex-direction: row-reverse;
      --tabs-list-line-start: 0;
      --tabs-list-line-end: unset;
      --tabs-list-border-size: 0 0 0 var(--tabs-list-border-width);
      --tab-border-width: 0 0 0 var(--tabs-list-border-width);
      --tab-radius: 0 var(--tabs-radius) var(--tabs-radius) 0;
    }

  [dir="rtl"] .m_89d60db1[data-orientation='vertical'][data-placement='right'] {
        --tabs-list-border-size: 0 var(--tabs-list-border-width) 0 0;
        --tab-border-width: 0 var(--tabs-list-border-width) 0 0;
        --tab-radius: var(--tabs-radius) 0 0 var(--tabs-radius);
}

  [data-mantine-color-scheme='light'] .m_89d60db1 {
    --tab-border-color: var(--mantine-color-gray-3);
}

  [data-mantine-color-scheme='dark'] .m_89d60db1 {
    --tab-border-color: var(--mantine-color-dark-4);
}

  .m_89d60db1[data-orientation='horizontal'] {
    --tab-justify: center;
  }

  .m_89d60db1[data-variant='default'] {
    --tabs-list-border-width: calc(0.125rem * var(--mantine-scale));
  }

  [data-mantine-color-scheme='light'] .m_89d60db1[data-variant='default'] {
      --tab-hover-color: var(--mantine-color-gray-0);
}

  [data-mantine-color-scheme='dark'] .m_89d60db1[data-variant='default'] {
      --tab-hover-color: var(--mantine-color-dark-6);
}

  .m_89d60db1[data-variant='outline'] {
    --tabs-list-border-width: calc(0.0625rem * var(--mantine-scale));
  }

  .m_89d60db1[data-variant='pills'] {
    --tabs-list-gap: calc(var(--mantine-spacing-sm) / 2);
  }

  [data-mantine-color-scheme='light'] .m_89d60db1[data-variant='pills'] {
      --tab-hover-color: var(--mantine-color-gray-0);
}

  [data-mantine-color-scheme='dark'] .m_89d60db1[data-variant='pills'] {
      --tab-hover-color: var(--mantine-color-dark-6);
}

.m_89d33d6d {
  display: flex;
  flex-wrap: wrap;
  justify-content: var(--tabs-justify, flex-start);
  flex-direction: var(--tabs-list-direction);
  gap: var(--tabs-list-gap);

  --tab-grow: unset;
}

.m_89d33d6d[data-grow] {
    --tab-grow: 1;
  }

.m_b0c91715 {
  flex-grow: var(--tabs-panel-grow);
}

.m_4ec4dce6 {
  position: relative;
  padding: var(--mantine-spacing-xs) var(--mantine-spacing-md);
  font-size: var(--mantine-font-size-sm);
  white-space: nowrap;
  z-index: 0;
  display: flex;
  align-items: center;
  line-height: 1;
  user-select: none;
  flex-grow: var(--tab-grow);
  justify-content: var(--tab-justify);
}

.m_4ec4dce6:disabled,
  .m_4ec4dce6[data-disabled] {
    opacity: 0.5;
    cursor: not-allowed;
  }

.m_4ec4dce6:focus {
    z-index: 1;
  }

.m_fc420b1f {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: var(--tab-section-margin-left, 0);
  margin-right: var(--tab-section-margin-right, 0);
}

.m_fc420b1f[data-position='left']:not(:only-child) {
      --tab-section-margin-right: var(--mantine-spacing-xs);
    }

[dir="rtl"] .m_fc420b1f[data-position='left']:not(:only-child) {
        --tab-section-margin-right: 0rem;
        --tab-section-margin-left: var(--mantine-spacing-xs);
}

.m_fc420b1f[data-position='right']:not(:only-child) {
      --tab-section-margin-left: var(--mantine-spacing-xs);
    }

[dir="rtl"] .m_fc420b1f[data-position='right']:not(:only-child) {
        --tab-section-margin-left: 0rem;
        --tab-section-margin-right: var(--mantine-spacing-xs);
}

/*************************************** default variant ***************************************/
.m_576c9d4 {
  position: relative;
}
.m_576c9d4::before {
    content: '';
    position: absolute;
    border-color: var(--tab-border-color);
    border-width: var(--tabs-list-border-size);
    border-style: solid;
    bottom: var(--tabs-list-line-bottom);
    inset-inline-start: var(--tabs-list-line-start);
    inset-inline-end: var(--tabs-list-line-end);
    top: var(--tabs-list-line-top);
  }

.m_539e827b {
  border-radius: var(--tab-radius);
  border-width: var(--tab-border-width);
  border-style: solid;
  border-color: transparent;
  background-color: var(--tab-bg);

  --tab-bg: transparent;
}

.m_539e827b:where([data-active]) {
    border-color: var(--tabs-color);
  }

@media (hover: hover) {

  .m_539e827b:hover {
    --tab-bg: var(--tab-hover-color);
  }

    .m_539e827b:hover:where(:not([data-active])) {
      border-color: var(--tab-border-color);
    }
}

@media (hover: none) {

  .m_539e827b:active {
    --tab-bg: var(--tab-hover-color);
  }

    .m_539e827b:active:where(:not([data-active])) {
      border-color: var(--tab-border-color);
    }
}

@media (hover: hover) {

  .m_539e827b:disabled:hover, .m_539e827b[data-disabled]:hover {
      --tab-bg: transparent;
  }
}

@media (hover: none) {

  .m_539e827b:disabled:active, .m_539e827b[data-disabled]:active {
      --tab-bg: transparent;
  }
}

/*************************************** outline variant ***************************************/
.m_6772fbd5 {
  position: relative;
}
.m_6772fbd5::before {
    content: '';
    position: absolute;
    border-color: var(--tab-border-color);
    border-width: var(--tabs-list-border-size);
    border-style: solid;
    bottom: var(--tabs-list-line-bottom);
    inset-inline-start: var(--tabs-list-line-start);
    inset-inline-end: var(--tabs-list-line-end);
    top: var(--tabs-list-line-top);
  }

.m_b59ab47c {
  border-top: calc(0.0625rem * var(--mantine-scale)) solid transparent;
  border-bottom: calc(0.0625rem * var(--mantine-scale)) solid transparent;
  border-right: calc(0.0625rem * var(--mantine-scale)) solid transparent;
  border-left: calc(0.0625rem * var(--mantine-scale)) solid transparent;
  border-top-color: var(--tab-border-top-color);
  border-bottom-color: var(--tab-border-bottom-color);
  border-radius: var(--tab-radius);
  position: relative;

  --tab-border-bottom-color: transparent;
  --tab-border-top-color: transparent;
  --tab-border-inline-end-color: transparent;
  --tab-border-inline-start-color: transparent;
}

.m_b59ab47c:where([data-active])::before {
      content: '';
      position: absolute;
      background-color: var(--tab-border-color);
      bottom: var(--tab-before-bottom, calc(-0.0625rem * var(--mantine-scale)));
      left: var(--tab-before-left, calc(-0.0625rem * var(--mantine-scale)));
      right: var(--tab-before-right, auto);
      top: var(--tab-before-top, auto);
      width: calc(0.0625rem * var(--mantine-scale));
      height: calc(0.0625rem * var(--mantine-scale));
    }

.m_b59ab47c:where([data-active])::after {
      content: '';
      position: absolute;
      background-color: var(--tab-border-color);
      bottom: var(--tab-after-bottom, calc(-0.0625rem * var(--mantine-scale)));
      right: var(--tab-after-right, calc(-0.0625rem * var(--mantine-scale)));
      left: var(--tab-after-left, auto);
      top: var(--tab-after-top, auto);
      width: calc(0.0625rem * var(--mantine-scale));
      height: calc(0.0625rem * var(--mantine-scale));
    }

.m_b59ab47c:where([data-active]) {

    border-top-color: var(--tab-border-top-color);
    border-bottom-color: var(--tab-border-bottom-color);
    border-inline-start-color: var(--tab-border-inline-start-color);
    border-inline-end-color: var(--tab-border-inline-end-color);

    --tab-border-top-color: var(--tab-border-color);
    --tab-border-inline-start-color: var(--tab-border-color);
    --tab-border-inline-end-color: var(--tab-border-color);
    --tab-border-bottom-color: var(--mantine-color-body);
}

.m_b59ab47c:where([data-active])[data-inverted] {
      --tab-border-bottom-color: var(--tab-border-color);
      --tab-border-top-color: var(--mantine-color-body);

      --tab-before-bottom: auto;
      --tab-before-top: calc(-0.0625rem * var(--mantine-scale));
      --tab-after-bottom: auto;
      --tab-after-top: calc(-0.0625rem * var(--mantine-scale));
    }

.m_b59ab47c:where([data-active])[data-orientation='vertical'][data-placement='left'] {
        --tab-border-inline-end-color: var(--mantine-color-body);
        --tab-border-inline-start-color: var(--tab-border-color);
        --tab-border-bottom-color: var(--tab-border-color);

        --tab-before-right: calc(-0.0625rem * var(--mantine-scale));
        --tab-before-left: auto;
        --tab-before-bottom: auto;
        --tab-before-top: calc(-0.0625rem * var(--mantine-scale));
        --tab-after-left: auto;
        --tab-after-right: calc(-0.0625rem * var(--mantine-scale));
      }

[dir="rtl"] .m_b59ab47c:where([data-active])[data-orientation='vertical'][data-placement='left'] {
          --tab-before-right: auto;
          --tab-before-left: calc(-0.0625rem * var(--mantine-scale));
          --tab-after-left: calc(-0.0625rem * var(--mantine-scale));
          --tab-after-right: auto;
}

.m_b59ab47c:where([data-active])[data-orientation='vertical'][data-placement='right'] {
        --tab-border-inline-start-color: var(--mantine-color-body);
        --tab-border-inline-end-color: var(--tab-border-color);
        --tab-border-bottom-color: var(--tab-border-color);

        --tab-before-left: calc(-0.0625rem * var(--mantine-scale));
        --tab-before-right: auto;
        --tab-before-bottom: auto;
        --tab-before-top: calc(-0.0625rem * var(--mantine-scale));
        --tab-after-right: auto;
        --tab-after-left: calc(-0.0625rem * var(--mantine-scale));
      }

[dir="rtl"] .m_b59ab47c:where([data-active])[data-orientation='vertical'][data-placement='right'] {
          --tab-before-left: auto;
          --tab-before-right: calc(-0.0625rem * var(--mantine-scale));
          --tab-after-right: calc(-0.0625rem * var(--mantine-scale));
          --tab-after-left: auto;
}

/*************************************** pills variant ***************************************/
.m_c3381914 {
  border-radius: var(--tabs-radius);
  background-color: var(--tab-bg);
  color: var(--tab-color);

  --tab-bg: transparent;
  --tab-color: inherit;
}
@media (hover: hover) {

  .m_c3381914:not([data-disabled]):hover {
      --tab-bg: var(--tab-hover-color);
  }
}
@media (hover: none) {

  .m_c3381914:not([data-disabled]):active {
      --tab-bg: var(--tab-hover-color);
  }
}
.m_c3381914[data-active][data-active] {
    --tab-bg: var(--tabs-color);
    --tab-color: var(--tabs-text-color, var(--mantine-color-white));
  }
@media (hover: hover) {

  .m_c3381914[data-active][data-active]:hover {
      --tab-bg: var(--tabs-color);
  }
}
@media (hover: none) {

  .m_c3381914[data-active][data-active]:active {
      --tab-bg: var(--tabs-color);
  }
}

.m_7341320d {
  --ti-size-xs: calc(1.125rem * var(--mantine-scale));
  --ti-size-sm: calc(1.375rem * var(--mantine-scale));
  --ti-size-md: calc(1.75rem * var(--mantine-scale));
  --ti-size-lg: calc(2.125rem * var(--mantine-scale));
  --ti-size-xl: calc(2.75rem * var(--mantine-scale));
  --ti-size: var(--ti-size-md);

  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  user-select: none;

  width: var(--ti-size);
  height: var(--ti-size);
  min-width: var(--ti-size);
  min-height: var(--ti-size);
  border-radius: var(--ti-radius, var(--mantine-radius-default));
  background: var(--ti-bg, var(--mantine-primary-color-filled));
  color: var(--ti-color, var(--mantine-color-white));
  border: var(--ti-bd, 1px solid transparent);
}

.m_43657ece {
  --offset: calc(var(--tl-bullet-size) / 2 + var(--tl-line-width) / 2);
  --tl-bullet-size: calc(1.25rem * var(--mantine-scale));
  --tl-line-width: calc(0.25rem * var(--mantine-scale));
  --tl-radius: calc(62.5rem * var(--mantine-scale));
  --tl-color: var(--mantine-primary-color-filled);
}

  .m_43657ece:where([data-align='left']) {
    padding-inline-start: var(--offset);
  }

  .m_43657ece:where([data-align='right']) {
    padding-inline-end: var(--offset);
  }

.m_2ebe8099 {
  font-weight: 500;
  line-height: 1;
  margin-bottom: calc(var(--mantine-spacing-xs) / 2);
}

.m_436178ff {
  --item-border: var(--tl-line-width) var(--tli-border-style, solid) var(--item-border-color);

  position: relative;
  color: var(--mantine-color-text);
}

.m_436178ff::before {
    content: '';
    pointer-events: none;
    position: absolute;
    top: 0;
    left: var(--timeline-line-left, 0);
    right: var(--timeline-line-right, 0);
    bottom: calc(var(--mantine-spacing-xl) * -1);
    border-inline-start: var(--item-border);
    display: var(--timeline-line-display, none);
  }

.m_43657ece[data-align='left'] .m_436178ff::before {
      --timeline-line-left: calc(var(--tl-line-width) * -1);
      --timeline-line-right: auto;
    }

[dir="rtl"] .m_43657ece[data-align='left'] .m_436178ff::before {
        --timeline-line-left: auto;
        --timeline-line-right: calc(var(--tl-line-width) * -1);
}

.m_43657ece[data-align='right'] .m_436178ff::before {
      --timeline-line-left: auto;
      --timeline-line-right: calc(var(--tl-line-width) * -1);
    }

[dir="rtl"] .m_43657ece[data-align='right'] .m_436178ff::before {
        --timeline-line-left: calc(var(--tl-line-width) * -1);
        --timeline-line-right: auto;
}

.m_43657ece:where([data-align='left']) .m_436178ff {
    padding-inline-start: var(--offset);
    text-align: left;
  }

.m_43657ece:where([data-align='right']) .m_436178ff {
    padding-inline-end: var(--offset);
    text-align: right;
  }

:where([data-mantine-color-scheme='light']) .m_436178ff {
    --item-border-color: var(--mantine-color-gray-3);
}

:where([data-mantine-color-scheme='dark']) .m_436178ff {
    --item-border-color: var(--mantine-color-dark-4);
}

.m_436178ff:where([data-line-active])::before {
      border-color: var(--tli-color, var(--tl-color));
    }

.m_436178ff:where(:not(:last-of-type)) {
    --timeline-line-display: block;
  }

.m_436178ff:where(:not(:first-of-type)) {
    margin-top: var(--mantine-spacing-xl);
  }

.m_8affcee1 {
  width: var(--tl-bullet-size);
  height: var(--tl-bullet-size);
  border-radius: var(--tli-radius, var(--tl-radius));
  border: var(--tl-line-width) solid;
  background-color: var(--mantine-color-body);
  position: absolute;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--mantine-color-text);
}

:where([data-mantine-color-scheme='light']) .m_8affcee1 {
    border-color: var(--mantine-color-gray-3);
}

:where([data-mantine-color-scheme='dark']) .m_8affcee1 {
    border-color: var(--mantine-color-dark-4);
}

.m_43657ece:where([data-align='left']) .m_8affcee1 {
    left: calc((var(--tl-bullet-size) / 2 + var(--tl-line-width) / 2) * -1);
    right: auto;
  }

:where([dir="rtl"]) .m_43657ece:where([data-align='left']) .m_8affcee1 {
      left: auto;
      right: calc((var(--tl-bullet-size) / 2 + var(--tl-line-width) / 2) * -1);
}

.m_43657ece:where([data-align='right']) .m_8affcee1 {
    left: auto;
    right: calc((var(--tl-bullet-size) / 2 + var(--tl-line-width) / 2) * -1);
  }

:where([dir="rtl"]) .m_43657ece:where([data-align='right']) .m_8affcee1 {
      left: calc((var(--tl-bullet-size) / 2 + var(--tl-line-width) / 2) * -1);
      right: auto;
}

.m_8affcee1:where([data-with-child]) {
    border-width: var(--tl-line-width);
  }

:where([data-mantine-color-scheme='light']) .m_8affcee1:where([data-with-child]) {
      background-color: var(--mantine-color-gray-3);
}

:where([data-mantine-color-scheme='dark']) .m_8affcee1:where([data-with-child]) {
      background-color: var(--mantine-color-dark-4);
}

.m_8affcee1:where([data-active]) {
    border-color: var(--tli-color, var(--tl-color));
    background-color: var(--mantine-color-white);
    color: var(--tl-icon-color, var(--mantine-color-white));
  }

.m_8affcee1:where([data-active]):where([data-with-child]) {
      background-color: var(--tli-color, var(--tl-color));
      color: var(--tl-icon-color, var(--mantine-color-white));
    }

.m_43657ece:where([data-align='left']) .m_540e8f41 {
    padding-inline-start: var(--offset);
    text-align: left;
  }

:where([dir="rtl"]) .m_43657ece:where([data-align='left']) .m_540e8f41 {
      text-align: right;
}

.m_43657ece:where([data-align='right']) .m_540e8f41 {
    padding-inline-end: var(--offset);
    text-align: right;
  }

:where([dir="rtl"]) .m_43657ece:where([data-align='right']) .m_540e8f41 {
      text-align: left;
}

.m_8a5d1357 {
  margin: 0;
  font-weight: var(--title-fw);
  font-size: var(--title-fz);
  line-height: var(--title-lh);
  font-family: var(--mantine-font-family-headings);
  text-wrap: var(--title-text-wrap, var(--mantine-heading-text-wrap));
}

  .m_8a5d1357:where([data-line-clamp]) {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: var(--title-line-clamp);
    -webkit-box-orient: vertical;
  }

.m_f698e191 {
  --level-offset: var(--mantine-spacing-lg);
  margin: 0;
  padding: 0;
  user-select: none;
}

.m_75f3ecf {
  margin: 0;
  padding: 0;
}

.m_f6970eb1 {
  cursor: pointer;
  list-style: none;
  margin: 0;
  padding: 0;
  outline: 0;
}

.m_f6970eb1:focus-visible > .m_dc283425 {
      outline: 2px solid var(--mantine-primary-color-filled);
      outline-offset: calc(0.125rem * var(--mantine-scale));
    }

.m_dc283425 {
  padding-inline-start: var(--label-offset);
}

:where([data-mantine-color-scheme='light']) .m_dc283425:where([data-selected]) {
      background-color: var(--mantine-color-gray-1);
}

:where([data-mantine-color-scheme='dark']) .m_dc283425:where([data-selected]) {
      background-color: var(--mantine-color-dark-5);
}

.m_d6493fad :first-child {
    margin-top: 0;
  }
  .m_d6493fad :last-child {
    margin-bottom: 0;
  }
  .m_d6493fad :where(h1, h2, h3, h4, h5, h6) {
    margin-bottom: var(--mantine-spacing-xs);
    text-wrap: var(--mantine-heading-text-wrap);
  }
  .m_d6493fad :where(h1) {
    margin-top: calc(1.5 * var(--mantine-spacing-xl));
    font-size: var(--mantine-h1-font-size);
    line-height: var(--mantine-h1-line-height);
    font-weight: var(--mantine-h1-font-weight);
  }
  .m_d6493fad :where(h2) {
    margin-top: var(--mantine-spacing-xl);
    font-size: var(--mantine-h2-font-size);
    line-height: var(--mantine-h2-line-height);
    font-weight: var(--mantine-h2-font-weight);
  }
  .m_d6493fad :where(h3) {
    margin-top: calc(0.8 * var(--mantine-spacing-xl));
    font-size: var(--mantine-h3-font-size);
    line-height: var(--mantine-h3-line-height);
    font-weight: var(--mantine-h3-font-weight);
  }
  .m_d6493fad :where(h4) {
    margin-top: calc(0.8 * var(--mantine-spacing-xl));
    font-size: var(--mantine-h4-font-size);
    line-height: var(--mantine-h4-line-height);
    font-weight: var(--mantine-h4-font-weight);
  }
  .m_d6493fad :where(h5) {
    margin-top: calc(0.5 * var(--mantine-spacing-xl));
    font-size: var(--mantine-h5-font-size);
    line-height: var(--mantine-h5-line-height);
    font-weight: var(--mantine-h5-font-weight);
  }
  .m_d6493fad :where(h6) {
    margin-top: calc(0.5 * var(--mantine-spacing-xl));
    font-size: var(--mantine-h6-font-size);
    line-height: var(--mantine-h6-line-height);
    font-weight: var(--mantine-h6-font-weight);
  }
  .m_d6493fad :where(img) {
    max-width: 100%;
    margin-bottom: var(--mantine-spacing-xs);
  }
  .m_d6493fad :where(p) {
    margin-top: 0;
    margin-bottom: var(--mantine-spacing-lg);
  }
  :where([data-mantine-color-scheme='light']) .m_d6493fad :where(mark) {
      background-color: var(--mantine-color-yellow-2);
      color: inherit;
}
  :where([data-mantine-color-scheme='dark']) .m_d6493fad :where(mark) {
      background-color: var(--mantine-color-yellow-5);
      color: var(--mantine-color-black);
}
  .m_d6493fad :where(a) {
    color: var(--mantine-color-anchor);
    text-decoration: none;
  }
  @media (hover: hover) {
    .m_d6493fad :where(a):hover {
      text-decoration: underline;
    }
}
  @media (hover: none) {
    .m_d6493fad :where(a):active {
      text-decoration: underline;
    }
}
  .m_d6493fad :where(hr) {
    margin-top: var(--mantine-spacing-md);
    margin-bottom: var(--mantine-spacing-md);
    border: 0;
    border-top: calc(0.0625rem * var(--mantine-scale)) solid;
  }
  :where([data-mantine-color-scheme='light']) .m_d6493fad :where(hr) {
      border-color: var(--mantine-color-gray-3);
}
  :where([data-mantine-color-scheme='dark']) .m_d6493fad :where(hr) {
      border-color: var(--mantine-color-dark-3);
}
  .m_d6493fad :where(pre) {
    padding: var(--mantine-spacing-xs);
    line-height: var(--mantine-line-height);
    margin: 0;
    margin-top: var(--mantine-spacing-md);
    margin-bottom: var(--mantine-spacing-md);
    overflow-x: auto;
    font-family: var(--mantine-font-family-monospace);
    font-size: var(--mantine-font-size-xs);
    border-radius: var(--mantine-radius-sm);
  }
  :where([data-mantine-color-scheme='light']) .m_d6493fad :where(pre) {
      background-color: var(--mantine-color-gray-0);
}
  :where([data-mantine-color-scheme='dark']) .m_d6493fad :where(pre) {
      background-color: var(--mantine-color-dark-8);
}
  .m_d6493fad :where(pre) :where(code) {
      background-color: transparent;
      padding: 0;
      border-radius: 0;
      color: inherit;
      border: 0;
    }
  .m_d6493fad :where(kbd) {
    --kbd-fz: calc(0.75rem * var(--mantine-scale));
    --kbd-padding: calc(0.1875rem * var(--mantine-scale)) calc(0.3125rem * var(--mantine-scale));

    font-family: var(--mantine-font-family-monospace);
    line-height: var(--mantine-line-height);
    font-weight: 700;
    padding: var(--kbd-padding);
    font-size: var(--kbd-fz);
    border-radius: var(--mantine-radius-sm);
    border: calc(0.0625rem * var(--mantine-scale)) solid;
    border-bottom-width: calc(0.1875rem * var(--mantine-scale));
  }
  :where([data-mantine-color-scheme='light']) .m_d6493fad :where(kbd) {
      border-color: var(--mantine-color-gray-3);
      color: var(--mantine-color-gray-7);
      background-color: var(--mantine-color-gray-0);
}
  :where([data-mantine-color-scheme='dark']) .m_d6493fad :where(kbd) {
      border-color: var(--mantine-color-dark-3);
      color: var(--mantine-color-dark-0);
      background-color: var(--mantine-color-dark-5);
}
  .m_d6493fad :where(code) {
    line-height: var(--mantine-line-height);
    padding: calc(0.0625rem * var(--mantine-scale)) calc(0.3125rem * var(--mantine-scale));
    border-radius: var(--mantine-radius-sm);
    font-family: var(--mantine-font-family-monospace);
    font-size: var(--mantine-font-size-xs);
  }
  :where([data-mantine-color-scheme='light']) .m_d6493fad :where(code) {
      background-color: var(--mantine-color-gray-0);
      color: var(--mantine-color-black);
}
  :where([data-mantine-color-scheme='dark']) .m_d6493fad :where(code) {
      background-color: var(--mantine-color-dark-5);
      color: var(--mantine-color-white);
}
  .m_d6493fad :where(ul, ol):not([data-type='taskList']) {
    margin-bottom: var(--mantine-spacing-md);
    padding-inline-start: calc(2.375rem * var(--mantine-scale));
  }
  .m_d6493fad :where(ul, ol):not([data-type='taskList']) :where(li) {
      margin-bottom: var(--mantine-spacing-xs);
    }
  .m_d6493fad :where(table) {
    width: 100%;
    border-collapse: collapse;
    caption-side: bottom;
    margin-bottom: var(--mantine-spacing-md);
  }
  .m_d6493fad :where(table) :where(caption) {
      margin-top: var(--mantine-spacing-xs);
      font-size: var(--mantine-font-size-sm);
      color: var(--mantine-color-gray-6);
    }
  .m_d6493fad :where(table) :where(th) {
      text-align: left;
      font-weight: bold;
      color: var(--mantine-color-gray-7);
      font-size: var(--mantine-font-size-sm);
      padding: var(--mantine-spacing-xs) var(--mantine-spacing-sm);
    }
  .m_d6493fad :where(table) :where(thead th) {
      border-bottom: calc(0.0625rem * var(--mantine-scale)) solid;
      border-color: var(--mantine-color-gray-3);
    }
  .m_d6493fad :where(table) :where(tfoot th) {
      border-top: calc(0.0625rem * var(--mantine-scale)) solid;
      border-color: var(--mantine-color-gray-3);
    }
  .m_d6493fad :where(table) :where(td) {
      padding: var(--mantine-spacing-xs) var(--mantine-spacing-sm);
      border-bottom: calc(0.0625rem * var(--mantine-scale)) solid;
      border-color: var(--mantine-color-gray-3);
      font-size: var(--mantine-font-size-sm);
    }
  .m_d6493fad :where(table) :where(tr:last-of-type td) {
      border-bottom: 0;
    }
  .m_d6493fad :where(blockquote) {
    font-size: var(--mantine-font-size-lg);
    line-height: var(--mantine-line-height);
    margin: var(--mantine-spacing-md) 0;
    border-radius: var(--mantine-radius-sm);
    padding: var(--mantine-spacing-md) var(--mantine-spacing-lg);
  }
  :where([data-mantine-color-scheme='light']) .m_d6493fad :where(blockquote) {
      background-color: var(--mantine-color-gray-0);
}
  :where([data-mantine-color-scheme='dark']) .m_d6493fad :where(blockquote) {
      background-color: var(--mantine-color-dark-8);
}
`, "",{"version":3,"sources":["webpack://./node_modules/@mantine/core/styles.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;;;EAGE,sBAAsB;AACxB;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA,8BAA8B;AAC9B;EACE,SAAS;EACT,uCAAuC;EACvC,sCAAsC;EACtC,uCAAuC;EACvC,2CAA2C;EAC3C,gCAAgC;;EAEhC,4DAA4D;EAC5D,0DAA0D;AAC5D;AACA;AACA;IACI;AACJ;EACE;;AAEF;IACI;MACE,gBAAgB;MAChB,eAAe;IACjB;EACF;;AAEF;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,sDAAsD;IACtD,qDAAqD;EACvD;;AAEF;IACI,sDAAsD;IACtD,qDAAqD;EACvD;;AAEF;IACI,aAAa;EACf;;AAEF;IACI,6DAA6D;EAC/D;;AAEF;IACI,yBAAyB;AAC7B;;AAEA,sCAAsC;;AAEtC;EACE,yCAAyC;;EAEzC,0BAA0B;EAC1B,4BAA4B;EAC5B,8BAA8B;EAC9B,8BAA8B;EAC9B,2BAA2B;;EAE3B,kBAAkB;EAClB,8BAA8B;EAC9B,4CAA4C;EAC5C,kCAAkC;EAClC,uCAAuC;EACvC,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B;iDAC+C;EAC/C;2CACyC;EACzC;wDACsD;EACtD,kCAAkC;EAClC,8DAA8D;EAC9D,sDAAsD;EACtD,sDAAsD;EACtD,sDAAsD;EACtD,sDAAsD;EACtD,sDAAsD;EACtD,sDAAsD;EACtD,sDAAsD;EACtD,sDAAsD;EACtD,sDAAsD;EACtD,sDAAsD;EACtD,gEAAgE;EAChE,4EAA4E;EAC5E,8DAA8D;EAC9D,0EAA0E;EAC1E,0EAA0E;EAC1E,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,2DAA2D;EAC3D,0DAA0D;EAC1D,uDAAuD;EACvD,0DAA0D;EAC1D,uDAAuD;EACvD,4DAA4D;EAC5D,6DAA6D;EAC7D,yDAAyD;EACzD,6DAA6D;EAC7D,4DAA4D;EAC5D,6BAA6B;EAC7B,8BAA8B;EAC9B,8BAA8B;EAC9B,6BAA6B;EAC7B,8BAA8B;EAC9B;;;wBAGsB;EACtB;;;;;oFAKkF;EAClF;;;;;mFAKiF;EACjF;;;;;6CAK2C;EAC3C;;;;;oFAKkF;EAClF,0DAA0D;EAC1D,yDAAyD;EACzD,wDAAwD;EACxD,sDAAsD;EACtD,sDAAsD;EACtD,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,6DAA6D;EAC7D,6BAA6B;EAC7B,6BAA6B;EAC7B,6DAA6D;EAC7D,8BAA8B;EAC9B,6BAA6B;EAC7B,6DAA6D;EAC7D,6BAA6B;EAC7B,6BAA6B;EAC7B,6DAA6D;EAC7D,8BAA8B;EAC9B,6BAA6B;EAC7B,yDAAyD;EACzD,6BAA6B;EAC7B,6BAA6B;EAC7B,6DAA6D;EAC7D,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;EAC5B,4DAA4D;EAC5D,kDAAkD;EAClD,iDAAiD;EACjD,iDAAiD;EACjD,iDAAiD;EACjD,wDAAwD;EACxD,mDAAmD;EACnD,oDAAoD;EACpD,0DAA0D;EAC1D,yDAAyD;EACzD,2DAA2D;EAC3D,mDAAmD;EACnD,sDAAsD;EACtD,wDAAwD;EACxD,8DAA8D;EAC9D,kDAAkD;EAClD,uDAAuD;EACvD,6DAA6D;EAC7D,yDAAyD;EACzD,0DAA0D;EAC1D,sDAAsD;EACtD,wDAAwD;EACxD,8DAA8D;EAC9D,qDAAqD;EACrD,0DAA0D;EAC1D,6DAA6D;EAC7D,yDAAyD;EACzD,6DAA6D;EAC7D,oDAAoD;EACpD,sDAAsD;EACtD,4DAA4D;EAC5D,kDAAkD;EAClD,uDAAuD;EACvD,2DAA2D;EAC3D,uDAAuD;EACvD,4DAA4D;EAC5D,sDAAsD;EACtD,wDAAwD;EACxD,8DAA8D;EAC9D,oDAAoD;EACpD,yDAAyD;EACzD,6DAA6D;EAC7D,yDAAyD;EACzD,6DAA6D;EAC7D,wDAAwD;EACxD,0DAA0D;EAC1D,gEAAgE;EAChE,qDAAqD;EACrD,0DAA0D;EAC1D,+DAA+D;EAC/D,2DAA2D;EAC3D,8DAA8D;EAC9D,0DAA0D;EAC1D,4DAA4D;EAC5D,kEAAkE;EAClE,sDAAsD;EACtD,2DAA2D;EAC3D,iEAAiE;EACjE,6DAA6D;EAC7D,+DAA+D;EAC/D,0DAA0D;EAC1D,4DAA4D;EAC5D,kEAAkE;EAClE,sDAAsD;EACtD,2DAA2D;EAC3D,iEAAiE;EACjE,6DAA6D;EAC7D,+DAA+D;EAC/D,sDAAsD;EACtD,wDAAwD;EACxD,8DAA8D;EAC9D,oDAAoD;EACpD,yDAAyD;EACzD,6DAA6D;EAC7D,yDAAyD;EACzD,4DAA4D;EAC5D,sDAAsD;EACtD,wDAAwD;EACxD,8DAA8D;EAC9D,oDAAoD;EACpD,yDAAyD;EACzD,6DAA6D;EAC7D,yDAAyD;EACzD,4DAA4D;EAC5D,sDAAsD;EACtD,wDAAwD;EACxD,8DAA8D;EAC9D,oDAAoD;EACpD,yDAAyD;EACzD,6DAA6D;EAC7D,yDAAyD;EACzD,4DAA4D;EAC5D,wDAAwD;EACxD,0DAA0D;EAC1D,gEAAgE;EAChE,oDAAoD;EACpD,yDAAyD;EACzD,+DAA+D;EAC/D,2DAA2D;EAC3D,8DAA8D;EAC9D,sDAAsD;EACtD,wDAAwD;EACxD,8DAA8D;EAC9D,oDAAoD;EACpD,yDAAyD;EACzD,6DAA6D;EAC7D,yDAAyD;EACzD,4DAA4D;EAC5D,0DAA0D;EAC1D,4DAA4D;EAC5D,kEAAkE;EAClE,qDAAqD;EACrD,0DAA0D;EAC1D,iEAAiE;EACjE,6DAA6D;EAC7D,8DAA8D;EAC9D,0DAA0D;EAC1D,4DAA4D;EAC5D,kEAAkE;EAClE,sDAAsD;EACtD,2DAA2D;EAC3D,iEAAiE;EACjE,6DAA6D;EAC7D,8DAA8D;AAChE;;AAEA;EACE,6BAA6B;EAC7B,kDAAkD;EAClD,gDAAgD;EAChD,gDAAgD;EAChD,4DAA4D;EAC5D,iDAAiD;EACjD,wDAAwD;EACxD,2DAA2D;EAC3D,mDAAmD;EACnD,0DAA0D;EAC1D,0DAA0D;EAC1D,2DAA2D;EAC3D,mDAAmD;EACnD,2DAA2D;EAC3D,wDAAwD;EACxD,8DAA8D;EAC9D,iDAAiD;EACjD,wDAAwD;EACxD,6DAA6D;EAC7D,yDAAyD;EACzD,0DAA0D;EAC1D,2DAA2D;EAC3D,wDAAwD;EACxD,8DAA8D;EAC9D,oDAAoD;EACpD,2DAA2D;EAC3D,6DAA6D;EAC7D,yDAAyD;EACzD,6DAA6D;EAC7D,yDAAyD;EACzD,sDAAsD;EACtD,4DAA4D;EAC5D,iDAAiD;EACjD,wDAAwD;EACxD,2DAA2D;EAC3D,uDAAuD;EACvD,0DAA0D;EAC1D,2DAA2D;EAC3D,wDAAwD;EACxD,8DAA8D;EAC9D,mDAAmD;EACnD,0DAA0D;EAC1D,6DAA6D;EAC7D,yDAAyD;EACzD,4DAA4D;EAC5D,6DAA6D;EAC7D,0DAA0D;EAC1D,gEAAgE;EAChE,oDAAoD;EACpD,2DAA2D;EAC3D,+DAA+D;EAC/D,2DAA2D;EAC3D,6DAA6D;EAC7D,+DAA+D;EAC/D,4DAA4D;EAC5D,kEAAkE;EAClE,qDAAqD;EACrD,4DAA4D;EAC5D,iEAAiE;EACjE,6DAA6D;EAC7D,8DAA8D;EAC9D,+DAA+D;EAC/D,4DAA4D;EAC5D,kEAAkE;EAClE,qDAAqD;EACrD,4DAA4D;EAC5D,iEAAiE;EACjE,6DAA6D;EAC7D,8DAA8D;EAC9D,2DAA2D;EAC3D,wDAAwD;EACxD,8DAA8D;EAC9D,mDAAmD;EACnD,0DAA0D;EAC1D,6DAA6D;EAC7D,yDAAyD;EACzD,4DAA4D;EAC5D,2DAA2D;EAC3D,wDAAwD;EACxD,8DAA8D;EAC9D,mDAAmD;EACnD,0DAA0D;EAC1D,6DAA6D;EAC7D,yDAAyD;EACzD,4DAA4D;EAC5D,2DAA2D;EAC3D,wDAAwD;EACxD,8DAA8D;EAC9D,mDAAmD;EACnD,0DAA0D;EAC1D,6DAA6D;EAC7D,yDAAyD;EACzD,4DAA4D;EAC5D,6DAA6D;EAC7D,0DAA0D;EAC1D,gEAAgE;EAChE,mDAAmD;EACnD,0DAA0D;EAC1D,+DAA+D;EAC/D,2DAA2D;EAC3D,4DAA4D;EAC5D,2DAA2D;EAC3D,wDAAwD;EACxD,8DAA8D;EAC9D,mDAAmD;EACnD,0DAA0D;EAC1D,6DAA6D;EAC7D,yDAAyD;EACzD,4DAA4D;EAC5D,+DAA+D;EAC/D,4DAA4D;EAC5D,kEAAkE;EAClE,oDAAoD;EACpD,2DAA2D;EAC3D,iEAAiE;EACjE,6DAA6D;EAC7D,6DAA6D;EAC7D,+DAA+D;EAC/D,4DAA4D;EAC5D,kEAAkE;EAClE,qDAAqD;EACrD,4DAA4D;EAC5D,iEAAiE;EACjE,6DAA6D;EAC7D,8DAA8D;AAChE;;AAEA;EACE,iEAAiE;;EAEjE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,iCAAiC;EACjC,WAAW;EACX,YAAY;AACd;;AAEA;IACI,aAAa;EACf;;AAEF;MACM,oDAAoD;MACpD,2BAA2B;IAC7B;;AAEJ;MACM,gDAAgD;IAClD;;AAEJ;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB;;sBAEoB;;EAEpB,mDAAmD;EACnD,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;IACI;MACE,6CAA6C;EACjD;;MAEI;QACE,oCAAoC;MACtC;;IAEF;MACE,6CAA6C;EACjD;;MAEI;QACE,0CAA0C;MAC5C;AACN;;AAEA;IACI;MACE,6CAA6C;EACjD;;MAEI;QACE,oCAAoC;MACtC;;IAEF;MACE,6CAA6C;EACjD;;MAEI;QACE,0CAA0C;MAC5C;AACN;;AAEA;IACI,aAAa;EACf;;AAEF;IACI,uCAAuC;IACvC,MAAM;IACN,8BAA8B;IAC9B,mBAAmB;EACrB;;AAEF;IACI,wCAAwC;IACxC,sBAAsB;IACtB,SAAS;IACT,qBAAqB;IACrB,wCAAwC;EAC1C;;AAEF;EACE,OAAO;EACP,+CAA+C;EAC/C,kBAAkB;EAClB,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,WAAW;IACX,YAAY;IACZ,+CAA+C;IAC/C,gDAAgD;EAClD;;AAEF;IACI,oCAAoC;AACxC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,8BAA8B;EAC9B,cAAc;EACd,mBAAmB;EACnB,SAAS;AACX;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,UAAU;EACZ;;AAEF;IACI,aAAa;EACf;;AAEF;EACE,6BAA6B;EAC7B,eAAe;EACf,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,sCAAsC;EACtC,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,0BAA0B;EAC1B,wCAAwC;AAC1C;;EAEE;IACE,iBAAiB;AACrB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,8CAA8C;EAC9C,6CAA6C;EAC7C,+CAA+C;EAC/C,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,6CAA6C;;EAE7C,UAAU;EACV,wCAAwC;EACxC,cAAc;EACd,0BAA0B;EAC1B,qBAAqB;EACrB,kCAAkC;EAClC,+BAA+B;EAC/B,2CAA2C;AAC7C;;EAEE;MACI,gFAAgF;AACtF;;EAEE;MACI,gFAAgF;AACtF;;AAEA;EACE,kBAAkB;EAClB,6CAA6C;EAC7C,4DAA4D;EAC5D,uCAAuC;EACvC,mEAAmE;AACrE;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mDAAmD;IACnD,4CAA4C;AAChD;;EAEE;IACE,mDAAmD;IACnD,6CAA6C;AACjD;;AAEA;EACE,yBAAyB;EACzB,6CAA6C;EAC7C,UAAU;AACZ;;AAEA;EACE,uDAAuD;EACvD,uDAAuD;EACvD,sDAAsD;EACtD,sDAAsD;EACtD,uDAAuD;EACvD,oCAAoC;EACpC,mDAAmD;AACrD;;AAEA,4BAA4B;AAC5B;EACE;IACE,qBAAqB;IACrB,UAAU;EACZ;;EAEA;;IAEE,mBAAmB;EACrB;AACF;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,0BAA0B;EAC1B,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,OAAO;EACP,+BAA+B;EAC/B,gEAAgE;EAChE,oDAAoD;AACtD;;AAEA;IACI,uBAAuB;EACzB;;AAEF;IACI,uBAAuB;EACzB;;AAEF;IACI,kBAAkB;EACpB;;AAEF,4BAA4B;AAC5B;EACE;;IAEE,mBAAmB;IACnB,UAAU;EACZ;;EAEA;IACE,qBAAqB;IACrB,YAAY;EACd;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kCAAkC;EAClC,kBAAkB;EAClB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,6DAA6D;EAC7D,8DAA8D;EAC9D,kBAAkB;EAClB,+BAA+B;EAC/B,yCAAyC;AAC3C;;AAEA;IACI,qBAAqB;EACvB;;AAEF,4BAA4B;AAC5B;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;IACI,WAAW;IACX,cAAc;IACd,yBAAyB;IACzB,0BAA0B;IAC1B,kDAAkD;IAClD,0CAA0C;IAC1C,mBAAmB;IACnB,qFAAqF;IACrF,0CAA0C;EAC5C;;AAEF;EACE,mDAAmD;EACnD,mDAAmD;EACnD,kDAAkD;EAClD,mDAAmD;EACnD,kDAAkD;;EAElD,yDAAyD;EACzD,wDAAwD;EACxD,yDAAyD;EACzD,yDAAyD;EACzD,wDAAwD;;EAExD,4BAA4B;EAC5B,sCAAsC;;EAEtC,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;;EAEhB,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;EAC1B,8DAA8D;EAC9D,6DAA6D;EAC7D,kDAAkD;EAClD,8EAA8E;EAC9E,eAAe;AACjB;;EAEE;IACE;MACE,4EAA4E;MAC5E,6CAA6C;IAC/C;AACJ;;EAEE;IACE;MACE,4EAA4E;MAC5E,6CAA6C;IAC/C;AACJ;;EAEE;IACE,mBAAmB;EACrB;;EAEA;MACI,UAAU;MACV,2BAA2B;IAC7B;;EAEF;IACE,mBAAmB;IACnB,gEAAgE;EAClE;;EAEA;MACI,6CAA6C;MAC7C,kCAAkC;AACxC;;EAEE;MACI,6CAA6C;MAC7C,kCAAkC;AACxC;;EAEE;MACI,eAAe;IACjB;;AAEJ;EACE,8CAA8C;EAC9C,kBAAkB;EAClB,8DAA8D;EAC9D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,qCAAqC;AACzC;;AAEA;EACE,yDAAyD;EACzD,aAAa;AACf;;AAEA;MACM,kBAAkB;MAClB,UAAU;IACZ;;AAEJ;IACI,mBAAmB;EACrB;;AAEF;QACQ,wBAAwB;QACxB,0BAA0B;QAC1B,yDAAyD;MAC3D;;AAEN;QACQ,0BAA0B;QAC1B,4BAA4B;QAC5B,2DAA2D;MAC7D;;AAEN;QACQ,gBAAgB;QAChB,qDAAqD;MACvD;;AAEN;IACI,sBAAsB;EACxB;;AAEF;QACQ,0BAA0B;QAC1B,wBAAwB;QACxB,qDAAqD;MACvD;;AAEN;QACQ,4BAA4B;QAC5B,0BAA0B;QAC1B,kDAAkD;MACpD;;AAEN;QACQ,gBAAgB;QAChB,qDAAqD;QACrD,kDAAkD;MACpD;;AAEN;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB;;sBAEoB;EACpB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mDAAmD;EACnD,mDAAmD;EACnD,kDAAkD;EAClD,mDAAmD;EACnD,kDAAkD;;EAElD,4BAA4B;EAC5B,mBAAmB;EACnB,0CAA0C;;EAE1C,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;;EAEjB,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;EAC1B,+BAA+B;AACjC;;EAEE;IACE,kCAAkC;AACtC;;EAEE;IACE,kCAAkC;AACtC;;EAEE;;IAEE,mBAAmB;IACnB,YAAY;EACd;;AAEF;IACI;MACE,6CAA6C;EACjD;;IAEE;MACE,6CAA6C;EACjD;AACF;;AAEA;IACI;MACE,6CAA6C;EACjD;;IAEE;MACE,6CAA6C;EACjD;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kCAAkC;EAClC,iDAAiD;EACjD,uCAAuC;EACvC,gDAAgD;AAClD;;EAEE;MACI,YAAY;MACZ,mCAAmC;IACrC;;AAEJ;EACE,QAAQ;EACR,kBAAkB;EAClB,iDAAiD;EACjD,sCAAsC;EACtC,8CAA8C;EAC9C,uCAAuC;EACvC,+BAA+B;AACjC;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;AAEF;EACE,cAAc;EACd,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qDAAqD;EACrD,+GAA+G;EAC/G,gBAAgB;EAChB,MAAM;EACN,2CAA2C;EAC3C,aAAa;EACb,gDAAgD;EAChD,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,WAAW;EACX,MAAM;EACN,SAAS;EACT,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,sDAAsD;AACxD;;AAEA;IACI,aAAa;EACf;;AAEF;IACI,+GAA+G;EACjH;;AAEF;EACE,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;EACrD,yDAAyD;AAC3D;;AAEA;IACI,cAAc;EAChB;;AAEF;EACE,kBAAkB;EAClB,yCAAyC;EACzC,+CAA+C;;EAE/C,wDAAwD;EACxD,uDAAuD;EACvD,wDAAwD;EACxD,wDAAwD;EACxD,uDAAuD;;EAEvD,4DAA4D;EAC5D,2DAA2D;EAC3D,yDAAyD;EACzD,2DAA2D;EAC3D,4DAA4D;;EAE5D,sCAAsC;EACtC,6CAA6C;;EAE7C,oBAAoB;EACpB,wBAAwB;EACxB,sFAAsF;EACtF,8CAA8C;EAC9C,kDAAkD;EAClD,gDAAgD;EAChD,2DAA2D;EAC3D,wCAAwC;;EAExC,6HAA6H;;EAE7H;;;GAGC;;EAED,iCAAiC;;EAEjC,mDAAmD;EACnD,4DAA4D;EAC5D,yEAAyE;;EAEzE,2DAA2D;EAC3D,0EAA0E;AAC5E;;EAEE;IACE,kBAAkB;IAClB,oBAAoB;IACpB,+BAA+B;IAC/B,6BAA6B;EAC/B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,6DAA6D;IAC7D,6DAA6D;IAC7D,4DAA4D;IAC5D,6DAA6D;IAC7D,4DAA4D;;IAE5D,kBAAkB;IAClB,+CAA+C;IAC/C,4CAA4C;EAC9C;;EAEA;IACE,4DAA4D;EAC9D;;EAEA;IACE,2DAA2D;EAC7D;;EAEA;IACE,gDAAgD;IAChD,mDAAmD;AACvD;;EAEE;MACI,uCAAuC;MACvC,sCAAsC;MACtC,qDAAqD;IACvD;;EAEF;MACI,uBAAuB;MACvB,uCAAuC;MACvC,qDAAqD;IACvD;;EAEF;MACI,uBAAuB;MACvB,uBAAuB;MACvB,6BAA6B;IAC/B;;EAEF;IACE,gDAAgD;IAChD,mDAAmD;AACvD;;EAEE;MACI,uCAAuC;MACvC,uCAAuC;MACvC,qDAAqD;IACvD;;EAEF;MACI,uBAAuB;MACvB,uCAAuC;MACvC,qDAAqD;IACvD;;EAEF;MACI,uBAAuB;MACvB,uBAAuB;MACvB,6BAA6B;IAC/B;;EAEF;MACI,sCAAsC;IACxC;;EAEF;;IAEE,yCAAyC;IACzC,qDAAqD;IACrD,iDAAiD;AACrD;;EAEE;IACE,yBAAyB;IACzB,yEAAyE;IACzE,0EAA0E;AAC9E;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,iCAAiC;EACjC,cAAc;EACd,WAAW;EACX,mCAAmC;;EAEnC,mCAAmC;EACnC,yBAAyB;EACzB,oEAAoE;EACpE,iCAAiC;EACjC,iEAAiE;EACjE,yBAAyB;EACzB,+BAA+B;EAC/B,qCAAqC;EACrC,wEAAwE;EACxE,kCAAkC;EAClC,uDAAuD;EACvD,mDAAmD;EACnD,yCAAyC;EACzC,4CAA4C;EAC5C,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA,uGAAuG;;AAEvG;IACI,wBAAwB;EAC1B;;AAEF,wGAAwG;;AAExG;IACI,yDAAyD;IACzD,sGAAsG;EACxG;;AAEF;;IAEI,aAAa;IACb,iCAAiC;EACnC;;AAEF;MACM,sCAAsC;IACxC;;AAEJ;IACI,qCAAqC;IACrC,UAAU;EACZ;;AAEF;;;;;;IAMI,gBAAgB;EAClB;;AAEF;IACI,0BAA0B;EAC5B;;AAEF;;IAEI,mBAAmB;IACnB,YAAY;IACZ,0CAA0C;IAC1C,kCAAkC;EACpC;;AAEF,gHAAgH;;AAEhH;IACI,mBAAmB;IACnB,YAAY;IACZ,0CAA0C;IAC1C,kCAAkC;EACpC;;AAEF;EACE,6CAA6C;EAC7C,kBAAkB;EAClB,UAAU;EACV,wCAAwC;EACxC,oCAAoC;EACpC,wBAAwB;EACxB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,2CAA2C;EAC3C,8DAA8D;AAChE;;AAEA;IACI,mEAAmE;IACnE,uCAAuC;IACvC,+CAA+C;IAC/C,2DAA2D;EAC7D;;AAEF;IACI,kEAAkE;IAClE,0CAA0C;IAC1C,8CAA8C;IAC9C,0DAA0D;EAC5D;;AAEF,kCAAkC;AAClC;EACE,uEAAuE;AACzE;AACA;IACI,+EAA+E;EACjF;;AAEF,8BAA8B;AAC9B;EACE,uCAAuC;AACzC;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,wCAAwC;EACxC,+DAA+D;AACjE;;AAEA;EACE,8DAA8D;AAChE;;AAEA;;EAEE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,iCAAiC;EACjC,6GAA6G;AAC/G;;AAEA;EACE,kCAAkC;EAClC,mHAAmH;AACrH;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,4BAA4B;;EAE5B,MAAM;EACN,OAAO;EACP,kBAAkB;EAClB,UAAU;EACV,6CAA6C;EAC7C,gCAAgC;EAChC,wBAAwB;AAC1B;;EAEE;IACE,+CAA+C;EACjD;;EAEA;IACE,qBAAqB;IACrB,aAAa;EACf;;AAEF;EACE,iDAAiD;AACnD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,gDAAgD;AAClD;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,yCAAyC;EACzC,UAAU;EACV,eAAe;EACf,6BAA6B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;EACzB;;AAEF;IACI,iCAAiC;AACrC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,YAAY;IACZ,mBAAmB;EACrB;;AAEF;MACM;QACE,6CAA6C;EACnD;;MAEI;QACE,6CAA6C;EACnD;AACF;;AAEA;MACM;QACE,6CAA6C;EACnD;;MAEI;QACE,6CAA6C;EACnD;AACF;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,OAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,sCAAsC;EACtC,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,sEAAsE;EACtE,4EAA4E;EAC5E,gFAAgF;EAChF,uBAAuB;AACzB;;AAEA;IACI,yBAAyB;EAC3B;;AAEF;IACI,4CAA4C;IAC5C,8CAA8C;EAChD;;AAEF;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4CAA4C;AAC9C;;AAEA;IACI,oBAAoB;IACpB,8CAA8C;EAChD;;AAEF;IACI,gDAAgD;IAChD,gDAAgD;AACpD;;AAEA;IACI,gDAAgD;IAChD,gDAAgD;AACpD;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,0CAA0C;EAC1C,uCAAuC;AACzC;;AAEA;IACI,0CAA0C;EAC5C;;AAEF;IACI,kDAAkD;IAClD,gDAAgD;EAClD;;AAEF;MACM,kDAAkD;MAClD,gDAAgD;IAClD;;AAEJ;IACI,gDAAgD;IAChD,8CAA8C;EAChD;;AAEF;MACM,gDAAgD;MAChD,8CAA8C;IAChD;;AAEJ;IACI,aAAa;EACf;;AAEF;EACE,sCAAsC;AACxC;;AAEA;IACI,0CAA0C;EAC5C;;AAEF;EACE,0CAA0C;EAC1C,sCAAsC;EACtC,gEAAgE;EAChE,uCAAuC;AACzC;;AAEA;IACI,sCAAsC;EACxC;;AAEF;MACM,4CAA4C;AAClD;;AAEA;MACM,6CAA6C;AACnD;;AAEA;IACI,qCAAqC;EACvC;;AAEF;EACE,eAAe;EACf,6BAA6B;EAC7B,qCAAqC;EACrC,oCAAoC;EACpC,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,6CAA6C;EAC7C,8CAA8C;EAC9C,oEAAoE;EACpE,uDAAuD;;EAEvD,4DAA4D;EAC5D,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;EACjC,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;IACI,6CAA6C;EAC/C;;AAEF;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,2CAA2C;EAC3C,4CAA4C;EAC5C,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,4CAA4C;EAC5C,kDAAkD;AACpD;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;EAC3B;;AAEF;IACI,iCAAiC;EACnC;;AAEF;EACE,2CAA2C;EAC3C,4CAA4C;EAC5C,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,qBAAqB;EACrB,sDAAsD;EACtD,0DAA0D;EAC1D,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,wBAAwB;AAC1B;;EAEE;IACE,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,iBAAiB;EACnB;;EAEA;MACI,cAAc;MACd,gBAAgB;AACtB;;EAEE;IACE,sCAAsC;IACtC,qBAAqB;IACrB,6BAA6B;IAC7B,oCAAoC;EACtC;;EAEA;IACE,gBAAgB;IAChB,uBAAuB;IACvB,oBAAoB;IACpB,0CAA0C;IAC1C,4BAA4B;EAC9B;;EAEA;IACE,oBAAoB;IACpB,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;AAEF;EACE,kCAAkC;EAClC,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,SAAS;EACT,6BAA6B;EAC7B,eAAe;AACjB;;EAEE;;EAEA;MACI,0BAA0B;EAC9B;AACF;;EAEE;;EAEA;MACI,0BAA0B;EAC9B;AACF;;EAEE;IACE,0BAA0B;EAC5B;;EAEA;;MAEI,qBAAqB;IACvB;;EAEF;IACE,oBAAoB;EACtB;;AAEF;IACI,+CAA+C;EACjD;EACA;IACE,0CAA0C;IAC1C,0CAA0C;EAC5C;EACA;IACE,qDAAqD;AACzD;EACE;IACE,qDAAqD;AACzD;;AAEA;;;;;EAKE,yDAAyD;EACzD,uEAAuE;AACzE;;AAEA;;EAEE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,yCAAyC;EACzC;;GAEC;EACD,2CAA2C;EAC3C,2CAA2C;AAC7C;;AAEA;IACI,SAAS;IACT,cAAc;EAChB;;AAEF;EACE,qBAAqB;EACrB,oCAAoC;EACpC,2CAA2C;EAC3C,4CAA4C;EAC5C,wCAAwC;AAC1C;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,0DAA0D;EAC5D;;AAEF;EACE,mBAAmB;EACnB,mCAAmC;EACnC,2CAA2C;EAC3C,uCAAuC;AACzC;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,4DAA4D;EAC9D;;AAEF;EACE,2FAA2F;EAC3F,wFAAwF;EACxF,kFAAkF;EAClF,qFAAqF;EACrF,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;;EAEE,eAAe;EACf,eAAe;EACf,2CAA2C;EAC3C,2CAA2C;AAC7C;;AAEA;IACI,wDAAwD;IACxD,qDAAqD;EACvD;;AAEF;EACE,MAAM;EACN,sCAAsC;EACtC,2CAA2C;EAC3C,4CAA4C;EAC5C,wCAAwC;AAC1C;;AAEA;IACI,sDAAsD;EACxD;;AAEF;EACE,SAAS;EACT,0EAA0E;EAC1E,2CAA2C;EAC3C,4CAA4C;EAC5C,wCAAwC;AAC1C;;AAEA;IACI,mDAAmD;EACrD;;AAEF;EACE,YAAY;AACd;;AAEA;IACI,YAAY;EACd;;AAEF;EACE,aAAa;EACb,eAAe;AACjB;;EAEE;IACE,6BAA6B;IAC7B,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;AAEF;EACE,wDAAwD;EACxD,gCAAgC;AAClC;;EAEE;IACE,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;;AAEF,kHAAkH;AAClH;;EAEE,sGAAsG;EACtG,yGAAyG;EACzG,sGAAsG;EACtG,qGAAqG;EACrG,wGAAwG;EACxG,4DAA4D;AAC9D;;AAEA;EACE,uCAAuC;EACvC,iEAAiE;EACjE,4CAA4C;EAC5C,6BAA6B;EAC7B,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;;AAEA;IACI,qDAAqD;IACrD,iCAAiC;EACnC;;AAEF;IACI,mBAAmB;IACnB,aAAa;EACf;;AAEF;MACM;QACE,6CAA6C;EACnD;;MAEI;QACE,6CAA6C;EACnD;AACF;;AAEA;MACM;QACE,6CAA6C;EACnD;;MAEI;QACE,6CAA6C;EACnD;AACF;;AAEA;EACE,iDAAiD;EACjD,8CAA8C;EAC9C,+CAA+C;EAC/C,mBAAmB;EACnB,sBAAsB;EACtB,0BAA0B;EAC1B,wBAAwB;EACxB,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;MACM,yCAAyC;AAC/C;;AAEA;MACM,yCAAyC;AAC/C;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,6CAA6C;AACjD;;AAEA;EACE,iEAAiE;EACjE,kBAAkB;EAClB,uCAAuC;EACvC,kCAAkC;AACpC;;AAEA;;EAEE,iEAAiE;EACjE,2BAA2B;EAC3B,iDAAiD;EACjD,uCAAuC;AACzC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;EACE,wDAAwD;EACxD,mCAAmC;EACnC,iDAAiD;AACnD;;AAEA;EACE,2DAA2D;EAC3D,sCAAsC;EACtC,8CAA8C;AAChD;;AAEA;IACI,aAAa;EACf;;AAEF;EACE,kCAAkC;EAClC,8EAA8E;EAC9E,uCAAuC;EACvC,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;IACI,WAAW;IACX,OAAO;IACP,eAAe;IACf,8CAA8C;IAC9C,8CAA8C;EAChD;;AAEF;MACM,6CAA6C;AACnD;;AAEA;MACM,6CAA6C;AACnD;;AAEA;IACI,aAAa;EACf;;AAEF,qCAAqC;AACrC;EACE,iEAAiE;EACjE,iEAAiE;EACjE,gEAAgE;EAChE,+DAA+D;EAC/D,gEAAgE;EAChE,wDAAwD;;EAExD,mCAAmC;EACnC,oCAAoC;AACtC;AACA;IACI,kCAAkC;AACtC;AACA;IACI,kCAAkC;AACtC;AACA;IACI,iCAAiC;EACnC;;AAEF,oCAAoC;AACpC;EACE,aAAa;EACb,mBAAmB;EACnB,wCAAwC;AAC1C;AACA;IACI,8BAA8B;EAChC;;AAEF;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,aAAa;AACf;;AAEA;IACI,UAAU;EACZ;;AAEF;EACE,gDAAgD;EAChD,mDAAmD;EACnD,kDAAkD;EAClD,oDAAoD;EACpD,mDAAmD;EACnD,8BAA8B;AAChC;;EAEE;IACE,gBAAgB;IAChB,6CAA6C;IAC7C,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,qBAAqB;IACrB,+CAA+C;EACjD;;AAEF;EACE,aAAa;AACf;;AAEA;EACE,0CAA0C;;EAE1C,wCAAwC;EACxC,oBAAoB;EACpB,sBAAsB;EACtB,uDAAuD;EACvD,4BAA4B;EAC5B,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;;IAEI,2BAA2B;EAC7B;;AAEF;EACE,2BAA2B;EAC3B,cAAc;EACd,+CAA+C;EAC/C,2CAA2C;AAC7C;;AAEA;MACM,kCAAkC;AACxC;;AAEA;MACM,kCAAkC;AACxC;;AAEA;EACE,+CAA+C;EAC/C,+CAA+C;EAC/C,2CAA2C;AAC7C;;AAEA;EACE,+CAA+C;EAC/C,+CAA+C;EAC/C,2CAA2C;AAC7C;;AAEA;EACE,4CAA4C;;EAE5C,cAAc;EACd,WAAW;EACX,iCAAiC;EACjC,eAAe;AACjB;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,gEAAgE;EAClE;;EAEA;MACI,yCAAyC;AAC/C;;EAEE;MACI,yCAAyC;AAC/C;;AAEA;EACE,qDAAqD;EACrD,wDAAwD;EACxD,uDAAuD;EACvD,yDAAyD;EACzD,wDAAwD;;EAExD,wCAAwC;EACxC,qDAAqD;EACrD,iDAAiD;;EAEjD,kBAAkB;EAClB,gEAAgE;EAChE,2BAA2B;EAC3B,+BAA+B;EAC/B,4BAA4B;EAC5B,gCAAgC;EAChC,oEAAoE;EACpE;;+BAE6B;EAC7B,kCAAkC;EAClC,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;EAEE;IACE,4CAA4C;IAC5C,yCAAyC;AAC7C;;EAEE;IACE,6CAA6C;IAC7C,yCAAyC;AAC7C;;EAEE;;IAEE,uCAAuC;IACvC,mCAAmC;EACrC;;EAEA;MACI,UAAU;MACV,eAAe;MACf,iCAAiC;IACnC;;EAEF;IACE,mBAAmB;EACrB;;EAEA;MACI,6CAA6C;MAC7C,yCAAyC;AAC/C;;EAEE;MACI,6CAA6C;MAC7C,yCAAyC;AAC/C;;EAEE;QACM,kCAAkC;AAC1C;;EAEE;QACM,kCAAkC;AAC1C;;AAEA;;IAEI,6BAA6B;IAC7B,mCAAmC;EACrC;;AAEF;MACM,4BAA4B;MAC5B,UAAU;MACV,eAAe;IACjB;;AAEJ;EACE,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,oBAAoB;EACpB,wEAAwE;EACxE,UAAU;EACV;;sBAEoB;AACtB;;AAEA;EACE,qDAAqD;EACrD,wDAAwD;EACxD,uDAAuD;EACvD,yDAAyD;EACzD,wDAAwD;;EAExD,wCAAwC;EACxC,qDAAqD;EACrD,iDAAiD;AACnD;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,4BAA4B;EAC5B,QAAQ;AACV;;AAEA;IACI,QAAQ;EACV;;AAEF;EACE,gBAAgB;EAChB,gEAAgE;EAChE,2BAA2B;EAC3B,4BAA4B;EAC5B,oEAAoE;EACpE,UAAU;EACV,cAAc;EACd,SAAS;EACT;;+BAE6B;EAC7B,kCAAkC;EAClC,wCAAwC;AAC1C;;AAEA;IACI,4CAA4C;IAC5C,yCAAyC;AAC7C;;AAEA;IACI,6CAA6C;IAC7C,yCAAyC;AAC7C;;AAEA;IACI,wCAAwC;EAC1C;;AAEF;;IAEI,uCAAuC;IACvC,mCAAmC;EACrC;;AAEF;MACM,UAAU;MACV,eAAe;IACjB;;AAEJ;IACI,mBAAmB;EACrB;;AAEF;MACM,6CAA6C;MAC7C,yCAAyC;AAC/C;;AAEA;MACM,6CAA6C;MAC7C,yCAAyC;AAC/C;;AAEA;QACQ,kCAAkC;AAC1C;;AAEA;QACQ,kCAAkC;AAC1C;;AAEA;IACI,4BAA4B;EAC9B;;AAEF;;IAEI,6BAA6B;IAC7B,mCAAmC;EACrC;;AAEF;MACM,4BAA4B;MAC5B,UAAU;MACV,eAAe;IACjB;;AAEJ;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,iCAAiC;EACjC,oBAAoB;EACpB,wEAAwE;EACxE,UAAU;EACV;;sBAEoB;AACtB;;AAEA,8BAA8B;AAC9B;EACE,uCAAuC;EACvC,yCAAyC;;EAEzC,aAAa;EACb,uCAAuC;AACzC;;AAEA,wBAAwB;AACxB;EACE,mDAAmD;EACnD,uDAAuD;EACvD,uDAAuD;EACvD,qDAAqD;EACrD,sDAAsD;;EAEtD,oCAAoC;EACpC,qDAAqD;EACrD,4CAA4C;EAC5C,qEAAqE;EACrE,qDAAqD;EACrD,uDAAuD;;EAEvD,wCAAwC;EACxC,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mCAAmC;EACnC,qBAAqB;EACrB,UAAU;EACV,yBAAyB;EACzB,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;IACI,qCAAqC;IACrC,2CAA2C;IAC3C,qCAAqC;EACvC;;AAEF;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mCAAmC;EACnC,uCAAuC;EACvC,4BAA4B;EAC5B,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;IACI,UAAU;IACV,WAAW;EACb;;AAEF;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,cAAc;EACd,WAAW;EACX,SAAS;EACT,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,oDAAoD;EACpD,wDAAwD;EACxD,uDAAuD;EACvD,wDAAwD;EACxD,oDAAoD;;EAEpD,qDAAqD;EACrD,oDAAoD;EACpD,qDAAqD;EACrD,qDAAqD;EACrD,gDAAgD;;EAEhD,2DAA2D;EAC3D,yDAAyD;EACzD,2DAA2D;EAC3D,0DAA0D;EAC1D,uDAAuD;;EAEvD,sCAAsC;EACtC,8BAA8B;EAC9B,4CAA4C;EAC5C,oDAAoD;EACpD,6EAA6E;EAC7E,yCAAyC;EACzC,+CAA+C;EAC/C,oEAAoE;;EAEpE,wCAAwC;EACxC,0BAA0B;EAC1B,kCAAkC;EAClC,2BAA2B;EAC3B,4BAA4B;EAC5B,qBAAqB;EACrB,iCAAiC;EACjC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,wDAAwD;EACxD,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;EACzB,2BAA2B;EAC3B,uBAAuB;AACzB;;EAEE;IACE,aAAa;IACb,WAAW;EACb;;EAEA;IACE,qDAAqD;IACrD,0BAA0B;EAC5B;;AAEF;EACE,iDAAiD;AACnD;;AAEA;IACI,4CAA4C;IAC5C,yCAAyC;IACzC,iCAAiC;AACrC;;AAEA;IACI,6CAA6C;IAC7C,yCAAyC;IACzC,iCAAiC;AACrC;;AAEA;IACI,WAAW;IACX,cAAc;IACd,4BAA4B;IAC5B,6BAA6B;IAC7B,oCAAoC;IACpC,wCAAwC;IACxC,wCAAwC;EAC1C;;AAEF;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,2DAA2D;;EAE3D,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;IACI,8CAA8C;EAChD;;AAEF;IACI,gDAAgD;EAClD;;AAEF;EACE,2CAA2C;;EAE3C,kBAAkB;EAClB,SAAS;EACT,6CAA6C;EAC7C,yCAAyC;EACzC,uCAAuC;EACvC,wEAAwE;AAC1E;;EAEE;IACE,oCAAoC;AACxC;;EAEE;IACE,mCAAmC;AACvC;;AAEA;EACE,wDAAwD;;EAExD,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;EAC3C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,iDAAiD;EACjD,0BAA0B;EAC1B,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,qCAAqC;EACrC,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,oEAAoE;EACpE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;EACE,sDAAsD;EACtD,uDAAuD;EACvD,qDAAqD;EACrD,uDAAuD;EACvD,uDAAuD;;EAEvD,oCAAoC;EACpC,iDAAiD;;EAEjD,2DAA2D;EAC3D,4DAA4D;EAC5D,4CAA4C;EAC5C,eAAe;AACjB;;EAEE;IACE,0CAA0C;AAC9C;;EAEE;IACE,0CAA0C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;;IAGI,cAAc;IACd,yBAAyB;IACzB,+BAA+B;IAC/B,qCAAqC;IACrC,iEAAiE;IACjE,gDAAgD;IAChD,6DAA6D;IAC7D,0EAA0E;EAC5E;;AAEF;;IAEI,kBAAkB;IAClB,WAAW;IACX,qBAAqB;EACvB;;AAEF;IACI,kCAAkC;EACpC;;AAEF;IACI,iCAAiC;EACnC;;AAEF;IACI,6BAA6B;EAC/B;;AAEF;MACM,iEAAiE;IACnE;;AAEJ;MACM,mEAAmE;IACrE;;AAEJ;EACE,yDAAyD;EACzD,wDAAwD;EACxD,yDAAyD;EACzD,yDAAyD;EACzD,wDAAwD;;EAExD,iEAAiE;EACjE,iEAAiE;EACjE,iEAAiE;EACjE,iEAAiE;EACjE,+DAA+D;;EAE/D,4DAA4D;EAC5D,4DAA4D;EAC5D,4DAA4D;EAC5D,4DAA4D;EAC5D,wDAAwD;;EAExD,qEAAqE;EACrE,kEAAkE;EAClE,oEAAoE;EACpE,mEAAmE;EACnE,oEAAoE;;EAEpE,wCAAwC;EACxC,8CAA8C;EAC9C,0CAA0C;;EAE1C,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;;EAEhB,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,kEAAkE;EAClE,wDAAwD;EACxD,iEAAiE;EACjE,kFAAkF;EAClF,sDAAsD;EACtD,qDAAqD;EACrD,mEAAmE;EACnE,sBAAsB;AACxB;;EAEE;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,yDAAyD;EAC3D;;EAEA;IACE,uDAAuD;EACzD;;EAEA;IACE,mBAAmB;IACnB,gEAAgE;IAChE,eAAe;EACjB;;EAEA;MACI,kCAAkC;MAClC,uCAAuC;AAC7C;;EAEE;MACI,kCAAkC;MAClC,uCAAuC;AAC7C;;EAEE;IACE,WAAW;IACX,oBAAoB;IACpB,kBAAkB;IAClB,8CAA8C;IAC9C,kEAAkE;IAClE,4BAA4B;IAC5B,UAAU;IACV,kBAAkB;IAClB;;wBAEoB;EACtB;;EAEA;MACI,2CAA2C;AACjD;;EAEE;MACI,qCAAqC;AAC3C;;EAEE;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;MACI,wBAAwB;MACxB,UAAU;IACZ;;EAEF;MACI,UAAU;MACV,2BAA2B;IAC7B;;EAEF;IACE;MACE,gFAAgF;MAChF,qDAAqD;IACvD;AACJ;;EAEE;IACE;MACE,gFAAgF;MAChF,qDAAqD;IACvD;AACJ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8CAA8C;EAC9C,YAAY;EACZ,iBAAiB;EACjB;;sBAEoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,UAAU;AACZ;;AAEA;IACI,YAAY;EACd;;AAEF;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;IACI,4CAA4C;EAC9C;;AAEF;IACI,8CAA8C;EAChD;;AAEF;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,6DAA6D;EAC7D,aAAa;AACf;;AAEA;MACM,kBAAkB;MAClB,UAAU;IACZ;;AAEJ;IACI,mBAAmB;EACrB;;AAEF;QACQ,wBAAwB;QACxB,0BAA0B;QAC1B,6DAA6D;MAC/D;;AAEN;QACQ,0BAA0B;QAC1B,4BAA4B;QAC5B,+DAA+D;MACjE;;AAEN;QACQ,gBAAgB;QAChB,yDAAyD;MAC3D;;AAEN;IACI,sBAAsB;EACxB;;AAEF;QACQ,0BAA0B;QAC1B,wBAAwB;QACxB,yDAAyD;MAC3D;;AAEN;QACQ,4BAA4B;QAC5B,0BAA0B;QAC1B,sDAAsD;MACxD;;AAEN;QACQ,gBAAgB;QAChB,yDAAyD;QACzD,sDAAsD;MACxD;;AAEN;EACE,yCAAyC;;EAEzC,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,4BAA4B;EAC5B,gCAAgC;AAClC;;EAEE;IACE,4CAA4C;AAChD;;EAEE;IACE,6CAA6C;AACjD;;AAEA;EACE,cAAc;EACd,6CAA6C;AAC/C;;AAEA;IACI,0CAA0C;IAC1C,2BAA2B;EAC7B;;AAEF;IACI,6CAA6C;IAC7C,8BAA8B;EAChC;;AAEF;IACI,mCAAmC;EACrC;;AAEF;IACI,wDAAwD;IACxD,2DAA2D;EAC7D;;AAEF;IACI,yCAAyC;AAC7C;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,2BAA2B;EAC7B;;AAEF;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;EAEE;IACE,oBAAoB;EACtB;;AAEF;EACE,sDAAsD;EACtD,oDAAoD;EACpD,iDAAiD;EACjD,oDAAoD;EACpD,mDAAmD;;EAEnD,0DAA0D;EAC1D,yDAAyD;EACzD,0DAA0D;EAC1D,sDAAsD;EACtD,0DAA0D;;EAE1D,oDAAoD;EACpD,uDAAuD;EACvD,sDAAsD;EACtD,uDAAuD;EACvD,oDAAoD;;EAEpD,kEAAkE;EAClE,gEAAgE;EAChE,kEAAkE;EAClE,kEAAkE;EAClE,kEAAkE;;EAElE,wDAAwD;EACxD,uDAAuD;EACvD,oDAAoD;EACpD,uDAAuD;EACvD,wDAAwD;;EAExD,gCAAgC;EAChC,0CAA0C;EAC1C,sCAAsC;EACtC,sCAAsC;EACtC,sDAAsD;EACtD,8CAA8C;EAC9C,uDAAuD;EACvD,wCAAwC;EACxC,mEAAmE;AACrE;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,0CAA0C;EAC1C,wBAAwB;EACxB,sDAAsD;EACtD,2EAA2E;EAC3E,mCAAmC;EACnC,eAAe;EACf,mBAAmB;EACnB,wCAAwC;EACxC,gEAAgE;EAChE,gCAAgC;AAClC;;AAEA;IACI,oCAAoC;EACtC;;AAEF;IACI,mBAAmB;EACrB;;AAEF;MACM,6CAA6C;MAC7C,kCAAkC;AACxC;;AAEA;MACM,6CAA6C;MAC7C,kCAAkC;AACxC;;AAEA;IACI,4CAA4C;IAC5C,6CAA6C;AACjD;;AAEA;IACI,6CAA6C;IAC7C,6CAA6C;AACjD;;AAEA;IACI;MACE,6CAA6C;EACjD;;IAEE;MACE,6CAA6C;EACjD;AACF;;AAEA;IACI;MACE,6CAA6C;EACjD;;IAEE;MACE,6CAA6C;EACjD;AACF;;AAEA;IACI,oCAAoC;IACpC,sBAAsB;EACxB;;AAEF;;EAEE;MACI,mCAAmC;EACvC;AACF;;AAEA;;EAEE;MACI,mCAAmC;EACvC;AACF;;AAEA;;EAEE,gEAAgE;EAChE,gCAAgC;AAClC;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI;MACE,6CAA6C;EACjD;;IAEE;MACE,6CAA6C;EACjD;AACF;;AAEA;IACI;MACE,6CAA6C;EACjD;;IAEE;MACE,6CAA6C;EACjD;AACF;;AAEA;IACI,oCAAoC;IACpC,wBAAwB;IACxB,gCAAgC;EAClC;;AAEF;;EAEE;MACI,mCAAmC;EACvC;AACF;;AAEA;;EAEE;MACI,mCAAmC;EACvC;AACF;;AAEA;EACE,gEAAgE;EAChE,oEAAoE;EACpE,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,UAAU;EACV,UAAU;EACV,SAAS;AACX;;AAEA;IACI,sDAAsD;IACtD,qDAAqD;EACvD;;AAEF;EACE,iDAAiD;EACjD,uCAAuC;EACvC,gDAAgD;EAChD,uCAAuC;EACvC,sCAAsC;EACtC,SAAS;EACT,cAAc;AAChB;;EAEE;IACE,6DAA6D;IAC7D,iCAAiC;AACrC;;EAEE;IACE,6DAA6D;IAC7D,iCAAiC;AACrC;;EAEE;IACE,kCAAkC;EACpC;;AAEF;EACE,+CAA+C;EAC/C,iDAAiD;;EAEjD,wCAAwC;EACxC,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;EAC1B,+BAA+B;EAC/B,cAAc;EACd,qBAAqB;AACvB;;EAEE;IACE,kDAAkD;IAClD,8CAA8C;AAClD;;EAEE;IACE,kDAAkD;IAClD,+CAA+C;AACnD;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,+BAA+B;EAC/B,UAAU;EACV;;qEAEmE;AACrE;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,+BAA+B;EAC/B,wFAAwF;EACxF;;;;2CAIyC;EACzC;;;wFAGsF;AACxF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,+BAA+B;EAC/B,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oDAAoD;EACpD,mDAAmD;EACnD,iDAAiD;EACjD,mDAAmD;EACnD,iDAAiD;;EAEjD,2DAA2D;EAC3D,2DAA2D;EAC3D,2DAA2D;EAC3D,2DAA2D;EAC3D,2DAA2D;;EAE3D,uDAAuD;EACvD,wDAAwD;EACxD,qDAAqD;EACrD,wDAAwD;EACxD,yDAAyD;;EAEzD,+DAA+D;EAC/D,gEAAgE;EAChE,8DAA8D;EAC9D,+DAA+D;EAC/D,6DAA6D;;EAE7D,4CAA4C;EAC5C,wCAAwC;EACxC,sDAAsD;EACtD,8BAA8B;EAC9B,4CAA4C;;EAE5C,sBAAsB;EACtB,+CAA+C;AACjD;;EAEE;IACE,WAAW;EACb;;AAEF;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,6CAA6C;AAC/C;;AAEA;EACE,OAAO;AACT;;AAEA;IACI,4CAA4C;EAC9C;;AAEF;EACE,gBAAgB;EAChB,kBAAkB;EAClB,sCAAsC;EACtC,4CAA4C;EAC5C,2BAA2B;EAC3B,4BAA4B;EAC5B,mCAAmC;EACnC,4DAA4D;EAC5D,2DAA2D;AAC7D;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,uBAAuB;EACvB,wBAAwB;EACxB,6CAA6C;EAC7C,eAAe;EACf,kFAAkF;EAClF,4EAA4E;AAC9E;;AAEA;EACE,kDAAkD;EAClD,qDAAqD;EACrD,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,uDAAuD;EACvD,wDAAwD;EACxD,qDAAqD;EACrD,wDAAwD;EACxD,yDAAyD;;EAEzD,wCAAwC;EACxC,kBAAkB;EAClB,mCAAmC;EACnC,uCAAuC;EACvC,sCAAsC;AACxC;;AAEA;QACQ,mDAAmD;MACrD;;AAEN;QACQ,mDAAmD;MACrD;;AAEN;EACE,kBAAkB;EAClB,uCAAuC;EACvC,mFAAmF;AACrF;;AAEA;EACE,uDAAuD;EACvD,wDAAwD;EACxD,qDAAqD;EACrD,wDAAwD;EACxD,yDAAyD;EACzD,2EAA2E;;EAE3E,kBAAkB;EAClB,0EAA0E;EAC1E,6CAA6C;EAC7C,aAAa;AACf;;AAEA;IACI,iDAAiD;EACnD;;AAEF;QACQ,mDAAmD;MACrD;;AAEN;QACQ,mDAAmD;MACrD;;AAEN;IACI,8CAA8C;AAClD;;AAEA;IACI,8CAA8C;AAClD;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,0FAA0F;EAC1F,uBAAuB;AACzB;;AAEA;EACE,oEAAoE;EACpE,gEAAgE;EAChE,oEAAoE;EACpE,mEAAmE;EACnE,oEAAoE;EACpE,8DAA8D;AAChE;;AAEA;EACE,uDAAuD;EACvD,2DAA2D;EAC3D,2DAA2D;EAC3D,0DAA0D;EAC1D,0DAA0D;EAC1D,4CAA4C;AAC9C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,0DAA0D;EAC1D,uDAAuD;EACvD,uDAAuD;EACvD,0DAA0D;EAC1D,yDAAyD;EACzD,0CAA0C;;EAE1C,gCAAgC;EAChC,yCAAyC;EACzC,mBAAmB;AACrB;;EAEE;IACE,eAAe;EACjB;;AAEF;EACE,oDAAoD;EACpD,sDAAsD;EACtD,uDAAuD;EACvD,oDAAoD;EACpD,uDAAuD;EACvD,oCAAoC;;EAEpC,kBAAkB;EAClB,yBAAyB;EACzB,sDAAsD;EACtD,iDAAiD;AACnD;;AAEA;EACE,kBAAkB;EAClB,wCAAwC;EACxC,qDAAqD;AACvD;;AAEA;EACE,yDAAyD;EACzD,wDAAwD;EACxD,yDAAyD;EACzD,uDAAuD;EACvD,yDAAyD;EACzD,sCAAsC;AACxC;;EAEE;IACE,4CAA4C;AAChD;;EAEE;IACE,4CAA4C;AAChD;;EAEE;IACE,uFAAuF;EACzF;;EAEA;IACE,gGAAgG;IAChG,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,SAAS;EACX;;AAEF;EACE,aAAa;EACb,mBAAmB;EACnB,sCAAsC;EACtC,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;IACI,aAAa;EACf;;AAEF;IACI,aAAa;EACf;;AAEF;IACI,WAAW;IACX,OAAO;IACP,8CAA8C;IAC9C,uFAAuF;IACvF,4CAA4C;EAC9C;;AAEF;IACI,WAAW;IACX,OAAO;IACP,8CAA8C;IAC9C,uFAAuF;IACvF,8CAA8C;EAChD;;AAEF;EACE,oDAAoD;EACpD,uDAAuD;EACvD,sDAAsD;EACtD,uDAAuD;EACvD,uDAAuD;EACvD,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gDAAgD;EAChD,mEAAmE;EACnE,4BAA4B;EAC5B,gDAAgD;EAChD,iDAAiD;EACjD,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kDAAkD;EAClD,4CAA4C;AAC9C;;AAEA;EACE,kCAAkC;EAClC,sCAAsC;EACtC,oEAAoE;EACpE,qBAAqB;AACvB;;AAEA;EACE,oDAAoD;AACtD;;AAEA;IACI,yCAAyC;IACzC,4CAA4C;AAChD;;AAEA;IACI,yCAAyC;IACzC,6CAA6C;AACjD;;AAEA;EACE,oDAAoD;AACtD;;AAEA;IACI,yCAAyC;IACzC,6CAA6C;AACjD;;AAEA;IACI,yCAAyC;IACzC,6CAA6C;AACjD;;AAEA;EACE,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,UAAU;EACV,wCAAwC;AAC1C;;AAEA;EACE,wBAAwB;EACxB,4CAA4C;EAC5C,gDAAgD;;EAEhD,8BAA8B;AAChC;;AAEA;EACE,sCAAsC;EACtC,aAAa;EACb,eAAe;EACf,oCAAoC;EACpC,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;;EAElB,cAAc;EACd,uBAAuB;EACvB,iCAAiC;EACjC,uBAAuB;EACvB,+BAA+B;EAC/B,+BAA+B;EAC/B,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;EAEE;IACE,sCAAsC;AAC1C;;EAEE;IACE,qCAAqC;AACzC;;AAEA;EACE,cAAc;EACd,OAAO;EACP,0CAA0C;EAC1C,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,qBAAqB;EACvB;AACF;;AAEA;EACE,uDAAuD;EACvD,sDAAsD;;EAEtD,kBAAkB;EAClB,cAAc;AAChB;;AAEA;IACI,qBAAqB;EACvB;;AAEF;EACE,kBAAkB;EAClB,yBAAyB;EACzB,2BAA2B;EAC3B,6BAA6B;EAC7B,+BAA+B;EAC/B,gFAAgF;EAChF,gCAAgC;EAChC,6BAA6B;EAC7B,+CAA+C;EAC/C,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,wCAAwC;EACxC,8DAA8D;EAC9D,mBAAmB;AACrB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,wCAAwC;IACxC,+CAA+C;IAC/C,WAAW;EACb;;AAEF;IACI,mDAAmD;EACrD;;AAEF;IACI,2CAA2C;EAC7C;;AAEF;MACM,4CAA4C;IAC9C;;AAEJ;EACE,kDAAkD;EAClD,iDAAiD;EACjD,kDAAkD;EAClD,8CAA8C;EAC9C,iDAAiD;EACjD,0BAA0B;;EAE1B,4FAA4F;EAC5F,+FAA+F;EAC/F,6FAA6F;EAC7F,+FAA+F;EAC/F,2FAA2F;EAC3F,oCAAoC;;EAEpC,iDAAiD;EACjD,uCAAuC;EACvC,gBAAgB;EAChB,2BAA2B;EAC3B,wBAAwB;EACxB,uCAAuC;EACvC,oDAAoD;EACpD,2DAA2D;EAC3D,mBAAmB;AACrB;;EAEE;IACE,yCAAyC;IACzC,kCAAkC;IAClC,6CAA6C;AACjD;;EAEE;IACE,yCAAyC;IACzC,kCAAkC;IAClC,6CAA6C;AACjD;;AAEA;EACE,sCAAsC;EACtC,wCAAwC;;EAExC,2BAA2B;EAC3B,yBAAyB;EACzB,2BAA2B;EAC3B,SAAS;EACT,UAAU;AACZ;;EAEE;IACE,+CAA+C;EACjD;;AAEF;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;IACI,gBAAgB;EAClB;;AAEF;MACM,mBAAmB;MACnB,kBAAkB;IACpB;;AAEJ;IACI,kCAAkC;EACpC;;AAEF;IACI,cAAc;EAChB;;AAEF;EACE,oBAAoB;EACpB,2CAA2C;EAC3C,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,sCAAsC;EACtC,sEAAsE;EACtE,eAAe;AACjB;;AAEA;EACE,gDAAgD;EAChD,mDAAmD;EACnD,wDAAwD;AAC1D;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;EACE,sCAAsC;EACtC,WAAW;EACX,wEAAwE;EACxE,mEAAmE;EACnE,wDAAwD;EACxD,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;IACI,kCAAkC;IAClC,YAAY;IACZ,oBAAoB;EACtB;;AAEF;MACM,qEAAqE;AAC3E;;AAEA;MACM,qEAAqE;AAC3E;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;IACI,4CAA4C;EAC9C;;AAEF;IACI,8CAA8C;EAChD;;AAEF;EACE,mDAAmD;EACnD,sDAAsD;EACtD,qDAAqD;EACrD,sDAAsD;EACtD,sDAAsD;EACtD,kCAAkC;;EAElC,sBAAsB;EACtB,qBAAqB;AACvB;;EAEE;IACE,mCAAmC;EACrC;;EAEA;MACI,8BAA8B;MAC9B,gCAAgC;MAChC,8BAA8B;IAChC;;EAEF;MACI,yBAAyB;MACzB,yBAAyB;IAC3B;;EAEF;MACI,2BAA2B;IAC7B;;AAEJ;EACE,6EAA6E;EAC7E,2EAA2E;AAC7E;;AAEA;EACE,sDAAsD;EACtD,eAAe;EACf,qFAAqF;EACrF,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;IACI,gBAAgB;EAClB;;AAEF;EACE,aAAa;EACb,uBAAuB;EACvB,iDAAiD;EACjD,+DAA+D;EAC/D,kEAAkE;EAClE,kEAAkE;AACpE;;AAEA;EACE,mDAAmD;EACnD,kDAAkD;EAClD,mDAAmD;EACnD,+CAA+C;EAC/C,mDAAmD;;EAEnD,uDAAuD;EACvD,uDAAuD;EACvD,wDAAwD;EACxD,sDAAsD;EACtD,mDAAmD;;EAEnD,4BAA4B;EAC5B,oCAAoC;;EAEpC,yBAAyB;EACzB,OAAO;EACP,0BAA0B;EAC1B,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,0CAA0C;EAC1C,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;AACjB;;EAEE;IACE,6CAA6C;IAC7C,kCAAkC;AACtC;;EAEE;IACE,iCAAiC;AACrC;;EAEE;IACE,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;EACrB;;AAEF;IACI,6CAA6C;AACjD;;AAEA;MACM,6CAA6C;IAC/C;;AAEJ;IACI,4CAA4C;AAChD;;AAEA;MACM,6CAA6C;IAC/C;;AAEJ;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,2BAA2B;EAC3B,yBAAyB;EACzB,OAAO;AACT;;AAEA;;IAEI,aAAa;IACb,6BAA6B;IAC7B,YAAY;IACZ,gBAAgB;IAChB,UAAU;IACV,mBAAmB;EACrB;;AAEF;MACM,aAAa;IACf;;AAEJ;IACI,oBAAoB;EACtB;;AAEF;EACE,kDAAkD;EAClD,gDAAgD;EAChD,kDAAkD;EAClD,iDAAiD;EACjD,iDAAiD;EACjD,0BAA0B;;EAE1B,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,+CAA+C;EAC/C,OAAO;EACP,SAAS;EACT,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,UAAU;AACZ;;EAEE;IACE,qCAAqC;IACrC,UAAU;EACZ;;EAEA;IACE,8CAA8C;IAC9C,6CAA6C;IAC7C,MAAM;IACN,OAAO;IACP,oBAAoB;IACpB,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;AAEF;EACE,2CAA2C;EAC3C,oDAAoD;EACpD,oDAAoD;;EAEpD,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sCAAsC;EACtC,iBAAiB;AACnB;;EAEE;IACE;MACE,6CAA6C;EACjD;;IAEE;MACE,6CAA6C;EACjD;AACF;;EAEE;IACE;MACE,6CAA6C;EACjD;;IAEE;MACE,6CAA6C;EACjD;AACF;;EAEE;IACE,YAAY;IACZ,oBAAoB;EACtB;;EAEA;IACE,8BAA8B;IAC9B,sBAAsB;EACxB;;EAEA;;EAEA;MACI,iCAAiC;EACrC;AACF;;EAEE;;EAEA;MACI,iCAAiC;EACrC;AACF;;EAEE;MACI,0BAA0B;MAC1B,oCAAoC;IACtC;;AAEJ;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;IACI,cAAc;EAChB;;AAEF;IACI,4CAA4C;EAC9C;;AAEF;IACI,8CAA8C;EAChD;;AAEF;IACI,wBAAwB;EAC1B;;AAEF;EACE,sCAAsC;AACxC;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;IACI,mBAAmB;EACrB;;AAEF;EACE,cAAc;EACd,sCAAsC;EACtC,sCAAsC;EACtC,4DAA4D;EAC5D,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;IACI,mBAAmB;EACrB;;AAEF;EACE,iEAAiE;AACnE;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oDAAoD;EACpD,yDAAyD;;EAEzD,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,2DAA2D;EAC3D,6CAA6C;EAC7C,sCAAsC;EACtC,yCAAyC;EACzC,yCAAyC;EACzC,oCAAoC;AACtC;;EAEE;IACE,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,4CAA4C;IAC5C,+BAA+B;IAC/B,kCAAkC;IAClC,wDAAwD;IACxD,yCAAyC;IACzC,2CAA2C;EAC7C;;EAEA;IACE,4CAA4C;AAChD;;EAEE;IACE,6CAA6C;AACjD;;EAEE;IACE,+CAA+C;EACjD;;EAEA;MACI,aAAa;IACf;;EAEF;MACI,6CAA6C;AACnD;;EAEE;MACI,6CAA6C;AACnD;;AAEA;EACE,sBAAsB;EACtB,4CAA4C;EAC5C,2CAA2C;EAC3C,4CAA4C;EAC5C,mDAAmD;EACnD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C;EAC3C,iCAAiC;AACnC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,oDAAoD;EACpD,gBAAgB;EAChB,uBAAuB;EACvB,sCAAsC;EACtC,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;EACE,sCAAsC;EACtC,0CAA0C;EAC1C,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;MACM,kCAAkC;AACxC;;AAEA;MACM,kCAAkC;AACxC;;AAEA;IACI;MACE,6CAA6C;EACjD;;IAEE;MACE,6CAA6C;EACjD;AACF;;AAEA;IACI;MACE,6CAA6C;EACjD;;IAEE;MACE,6CAA6C;EACjD;AACF;;AAEA;EACE,mEAAmE;EACnE,gEAAgE;EAChE,mEAAmE;EACnE,mEAAmE;EACnE,kEAAkE;AACpE;;AAEA;EACE,2DAA2D;EAC3D,2DAA2D;EAC3D,uDAAuD;EACvD,2DAA2D;EAC3D,0DAA0D;EAC1D,4CAA4C;;EAE5C,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,yEAAyE;EACzE,6CAA6C;EAC7C,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;EAC3C,oFAAoF;;EAEpF,aAAa;EACb,WAAW;EACX,UAAU;EACV,8EAA8E;EAC9E,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,YAAY;EACd;;AAEF;MACM,kCAAkC;AACxC;;AAEA;MACM,kCAAkC;AACxC;;AAEA;IACI,iCAAiC;EACnC;;AAEF;IACI;MACE,6CAA6C;EACjD;;IAEE;MACE,6CAA6C;EACjD;AACF;;AAEA;IACI;MACE,6CAA6C;EACjD;;IAEE;MACE,6CAA6C;EACjD;AACF;;AAEA;IACI,gBAAgB;IAChB,8CAA8C;EAChD;;AAEF;IACI,gBAAgB;IAChB,4CAA4C;EAC9C;;AAEF;EACE,mEAAmE;EACnE,mEAAmE;EACnE,+DAA+D;EAC/D,mEAAmE;EACnE,kEAAkE;EAClE,4DAA4D;EAC5D,oDAAoD;EACpD,2DAA2D;AAC7D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oDAAoD;EACpD,eAAe;EACf,gCAAgC;EAChC,sCAAsC;EACtC,yCAAyC;EACzC,uCAAuC;EACvC,cAAc;EACd,8EAA8E;AAChF;;AAEA;IACI,iDAAiD;EACnD;;AAEF;IACI,mBAAmB;IACnB,YAAY;EACd;;AAEF;IACI,yCAAyC;IACzC,4CAA4C;AAChD;;AAEA;MACM;QACE,6CAA6C;MAC/C;AACN;;AAEA;MACM;QACE,6CAA6C;MAC/C;AACN;;AAEA;IACI,yCAAyC;IACzC,6CAA6C;AACjD;;AAEA;MACM;QACE,6CAA6C;MAC/C;AACN;;AAEA;MACM;QACE,6CAA6C;MAC/C;AACN;;AAEA;IACI,6CAA6C;IAC7C,yCAAyC;IACzC,iEAAiE;EACnE;;AAEF;;EAEE;MACI,6CAA6C;EACjD;AACF;;AAEA;;EAEE;MACI,6CAA6C;EACjD;AACF;;AAEA;EACE,sCAAsC;EACtC,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,2DAA2D;EAC3D,2DAA2D;EAC3D,0DAA0D;EAC1D,uDAAuD;EACvD,yDAAyD;;EAEzD,wDAAwD;EACxD,0DAA0D;EAC1D,0DAA0D;EAC1D,0DAA0D;EAC1D,0DAA0D;;EAE1D,4CAA4C;EAC5C,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,6BAA6B;EAC7B,SAAS;EACT,mDAAmD;EACnD,uDAAuD;EACvD,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,kBAAkB;EAClB,uCAAuC;EACvC,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA;;IAEI,mBAAmB;EACrB;;AAEF;IACI,qCAAqC;IACrC,UAAU;EACZ;;AAEF;IACI,aAAa;EACf;;AAEF;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;IACI,aAAa;EACf;;AAEF;EACE,0DAA0D;EAC1D,yDAAyD;EACzD,0DAA0D;EAC1D,0DAA0D;EAC1D,yDAAyD;EACzD,0CAA0C;AAC5C;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,0DAA0D;EAC5D;AACF;;AAEA;EACE,gDAAgD;EAChD,wCAAwC;;EAExC,0DAA0D;EAC1D,0DAA0D;EAC1D,uDAAuD;EACvD,wDAAwD;EACxD,qDAAqD;;EAErD,kBAAkB;EAClB,4BAA4B;EAC5B,qCAAqC;EACrC,gBAAgB;EAChB,aAAa;AACf;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,6CAA6C;AACjD;;AAEA;EACE,+CAA+C;EAC/C,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,0FAA0F;EAC1F,iEAAiE;AACnE;;AAEA;IACI;;;;;;;;;KASC;EACH;;AAEF;IACI,wCAAwC;EAC1C;;AAEF;IACI,gBAAgB;IAChB,+CAA+C;IAC/C,6CAA6C;EAC/C;;AAEF;IACI,gBAAgB;IAChB,iDAAiD;IACjD,+CAA+C;EACjD;;AAEF;EACE,8DAA8D;EAC9D,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,wFAAwF;EACxF,cAAc;EACd,oDAAoD;AACtD;;AAEA;EACE,4CAA4C;;EAE5C,cAAc;EACd,WAAW;EACX,iCAAiC;EACjC,eAAe;AACjB;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,gEAAgE;EAClE;;EAEA;MACI,yCAAyC;AAC/C;;EAEE;MACI,yCAAyC;AAC/C;;AAEA;EACE,kDAAkD;EAClD,qDAAqD;EACrD,oDAAoD;EACpD,sDAAsD;EACtD,qDAAqD;;EAErD,2DAA2D;EAC3D,yDAAyD;EACzD,2DAA2D;EAC3D,2DAA2D;EAC3D,uDAAuD;;EAEvD,4CAA4C;EAC5C,kCAAkC;EAClC,kDAAkD;EAClD,8CAA8C;;EAE9C,kBAAkB;EAClB,gEAAgE;EAChE,wBAAwB;EACxB,4BAA4B;EAC5B,yBAAyB;EACzB,6BAA6B;EAC7B,2CAA2C;EAC3C;;+BAE6B;EAC7B,kCAAkC;EAClC,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;EAEE;IACE,4CAA4C;IAC5C,yCAAyC;AAC7C;;EAEE;IACE,6CAA6C;IAC7C,yCAAyC;AAC7C;;EAEE;;IAEE,oCAAoC;IACpC,gCAAgC;EAClC;;EAEA;MACI,UAAU;MACV,eAAe;MACf,8BAA8B;IAChC;;EAEF;IACE,mBAAmB;EACrB;;EAEA;MACI,6CAA6C;MAC7C,yCAAyC;AAC/C;;EAEE;MACI,6CAA6C;MAC7C,yCAAyC;AAC/C;;EAEE;QACM,kCAAkC;AAC1C;;EAEE;QACM,kCAAkC;AAC1C;;AAEA;;IAEI,6BAA6B;IAC7B,gCAAgC;EAClC;;AAEF;MACM,yBAAyB;MACzB,UAAU;MACV,eAAe;IACjB;;AAEJ;EACE,cAAc;EACd,6BAA6B;EAC7B,8BAA8B;EAC9B,kBAAkB;EAClB,oBAAoB;EACpB,wEAAwE;EACxE,UAAU;EACV;;sBAEoB;AACtB;;AAEA;EACE,kDAAkD;EAClD,qDAAqD;EACrD,oDAAoD;EACpD,sDAAsD;EACtD,qDAAqD;EACrD,kCAAkC;;EAElC,2DAA2D;EAC3D,yDAAyD;EACzD,2DAA2D;EAC3D,2DAA2D;EAC3D,uDAAuD;EACvD,4CAA4C;EAC5C,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,yBAAyB;EACzB,QAAQ;AACV;;AAEA;IACI,QAAQ;EACV;;AAEF;EACE,8BAA8B;EAC9B,qCAAqC;EACrC,oGAAoG;EACpG;;wBAEsB;EACtB,oBAAoB;EACpB,6BAA6B;EAC7B,8BAA8B;EAC9B,kBAAkB;EAClB,2CAA2C;EAC3C,4CAA4C;AAC9C;;AAEA;EACE,oDAAoD;EACpD,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,qDAAqD;EACrD,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mDAAmD;EACnD,gCAAgC;EAChC,0BAA0B;EAC1B,kCAAkC;EAClC,wCAAwC;AAC1C;;AAEA;IACI,4CAA4C;IAC5C,yCAAyC;AAC7C;;AAEA;IACI,6CAA6C;IAC7C,yCAAyC;AAC7C;;AAEA;IACI,yEAAyE;IACzE,qEAAqE;EACvE;;AAEF;MACM,uBAAuB;MACvB,gCAAgC;IAClC;;AAEJ;IACI,mBAAmB;EACrB;;AAEF;MACM,6CAA6C;MAC7C,yCAAyC;AAC/C;;AAEA;QACQ,+CAA+C;MACjD;;AAEN;MACM,6CAA6C;MAC7C,yCAAyC;AAC/C;;AAEA;QACQ,+CAA+C;MACjD;;AAEN;IACI,wCAAwC;EAC1C;;AAEF;IACI,sCAAsC;EACxC;;AAEF;IACI,6BAA6B;IAC7B,gCAAgC;EAClC;;AAEF;MACM,sCAAsC;MACtC,uBAAuB;MACvB,4BAA4B;IAC9B;;AAEJ;EACE,uDAAuD;EACvD,uDAAuD;EACvD,sDAAsD;EACtD,sDAAsD;EACtD,mDAAmD;;EAEnD,aAAa;EACb,kBAAkB;AACpB;;EAEE;IACE,oBAAoB;EACtB;;AAEF;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;IACI,UAAU;IACV,qBAAqB;EACvB;;AAEF;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;IACI,iCAAiC;IACjC,mCAAmC;AACvC;;AAEA;IACI,iCAAiC;IACjC,mCAAmC;AACvC;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;EAC7B;;AAEF;EACE,SAAS;EACT,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,wCAAwC;AAC1C;;AAEA;IACI,sDAAsD;IACtD,qDAAqD;EACvD;;AAEF;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,sCAAsC;EACtC,wCAAwC;AAC1C;;AAEA;IACI,eAAe;EACjB;;AAEF;IACI,kBAAkB;EACpB;;AAEF;EACE,yCAAyC;AAC3C;;AAEA;EACE,+CAA+C;;EAE/C,kBAAkB;EAClB,sEAAsE;EACtE,oBAAoB;EACpB,sCAAsC;EACtC,mBAAmB;EACnB,oCAAoC;AACtC;;EAEE;IACE,gEAAgE;IAChE,uDAAuD;AAC3D;;EAEE;IACE,gEAAgE;IAChE,uDAAuD;AAC3D;;EAEE;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;AAEF;EACE,yBAAyB;EACzB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,sDAAsD;AACxD;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,kDAAkD;AACtD;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EACE,6FAA6F;EAC7F,6FAA6F;EAC7F,6FAA6F;EAC7F,yFAAyF;EACzF,0FAA0F;;EAE1F,+BAA+B;EAC/B,kCAAkC;EAClC,qCAAqC;EACrC,2CAA2C;;EAE3C,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,8DAA8D;EAC9D,gBAAgB;EAChB,6CAA6C;AAC/C;;EAEE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;MACI,WAAW;IACb;;EAEF;IACE,6CAA6C;AACjD;;EAEE;IACE,6CAA6C;AACjD;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,8DAA8D;AAChE;;AAEA;IACI,kCAAkC;IAClC,6DAA6D;AACjE;;AAEA;IACI,gBAAgB;IAChB,8DAA8D;AAClE;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,8DAA8D;EAC9D,8BAA8B;EAC9B,0BAA0B;EAC1B,oFAAoF;EACpF,eAAe;;EAEf,oCAAoC;EACpC,+CAA+C;AACjD;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,eAAe;EACjB;;AAEF;;IAEI,mBAAmB;EACrB;;AAEF;MACM,kCAAkC;AACxC;;AAEA;MACM,kCAAkC;AACxC;;AAEA;MACM,wDAAwD;AAC9D;;AAEA;MACM,wDAAwD;AAC9D;;AAEA;QACQ,aAAa;MACf;;AAEN;MACM,WAAW;MACX,QAAQ;MACR,UAAU;MACV,kBAAkB;MAClB,8DAA8D;AACpE;;AAEA;QACQ,kCAAkC;QAClC,6DAA6D;AACrE;;AAEA;QACQ,gBAAgB;QAChB,8DAA8D;AACtE;;AAEA;MACM;QACE,iCAAiC;EACvC;;MAEI;QACE,iCAAiC;EACvC;AACF;;AAEA;MACM;QACE,iCAAiC;EACvC;;MAEI;QACE,iCAAiC;EACvC;AACF;;AAEA;MACM;QACE,6CAA6C;EACnD;;MAEI;QACE,6CAA6C;EACnD;AACF;;AAEA;MACM;QACE,6CAA6C;EACnD;;MAEI;QACE,6CAA6C;EACnD;AACF;;AAEA;EACE,SAAS;EACT,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;QACQ,0EAA0E;MAC5E;;AAEN;QACQ,0EAA0E;MAC5E;;AAEN;EACE,kBAAkB;EAClB,OAAO;EACP,UAAU;EACV,2FAA2F;AAC7F;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,qBAAqB;IACrB,wCAAwC;IACxC,6CAA6C;IAC7C,+FAA+F;EACjG;;AAEF;MACM,MAAM;MACN,eAAe;MACf,YAAY;MACZ,8CAA8C;MAC9C,WAAW;IACb;;AAEJ;IACI,8CAA8C;AAClD;;AAEA;IACI,8CAA8C;AAClD;;AAEA;MACM,8BAA8B;IAChC;;AAEJ;UACU,8BAA8B;QAChC;;AAER;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,6DAA6D;EAC7D,4CAA4C;AAC9C;;AAEA;EACE;;IAEE,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,oCAAoC;EACpC,kCAAkC;EAClC,oEAAoE;EACpE,kBAAkB;EAClB,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA;IACI,4CAA4C;EAC9C;;AAEF;IACI,gBAAgB;EAClB;;AAEF;MACM,kBAAkB;MAClB,WAAW;MACX,QAAQ;MACR,WAAW;MACX,2CAA2C;IAC7C;;AAEJ;MACM,kBAAkB;MAClB,WAAW;MACX,QAAQ;MACR,WAAW;IACb;;AAEJ;QACQ,6CAA6C;AACrD;;AAEA;QACQ,6CAA6C;AACrD;;AAEA;EACE,sDAAsD;EACtD,uDAAuD;EACvD,qDAAqD;EACrD,uDAAuD;EACvD,sDAAsD;;EAEtD,oCAAoC;EACpC,qDAAqD;EACrD,mDAAmD;;EAEnD,wCAAwC;EACxC,aAAa;EACb,oCAAoC;EACpC,kCAAkC;EAClC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;EAEE;IACE,8CAA8C;IAC9C,uDAAuD;AAC3D;;EAEE;IACE,8CAA8C;IAC9C,uDAAuD;AAC3D;;AAEA;EACE,kBAAkB;EAClB,0CAA0C;EAC1C,sCAAsC;EACtC,iCAAiC;EACjC,4CAA4C;EAC5C,uCAAuC;EACvC,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,6CAA6C;AACjD;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gCAAgC;EAChC,+BAA+B;EAC/B,kDAAkD;EAClD,gCAAgC;EAChC,0BAA0B;EAC1B,QAAQ;EACR,eAAe;EACf,mCAAmC;EACnC,mBAAmB;EACnB,uBAAuB;EACvB;;wBAEsB;EACtB,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,qDAAqD;EACrD,gCAAgC;AAClC;;AAEA;IACI,UAAU;IACV,kEAAkE;AACtE;;AAEA;;IAEI,aAAa;EACf;;AAEF;IACI,4CAA4C;IAC5C,oCAAoC;EACtC;;AAEF;IACI,iCAAiC;IACjC,4CAA4C;AAChD;;AAEA;IACI,wCAAwC;IACxC,qCAAqC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oCAAoC;EACpC,eAAe;AACjB;;AAEA;;IAEI,mBAAmB;EACrB;;AAEF;EACE,kBAAkB;EAClB,WAAW;EACX,0BAA0B;AAC5B;;AAEA;IACI,+BAA+B;EACjC;;AAEF;;IAEI,2CAA2C;EAC7C;;AAEF;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,mCAAmC;IACnC,2CAA2C;IAC3C,yDAAyD;IACzD,UAAU;EACZ;;AAEF;EACE,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,SAAS;EACT,qCAAqC;EACrC,mCAAmC;EACnC,8BAA8B;EAC9B,4CAA4C;AAC9C;;AAEA;IACI,wCAAwC;EAC1C;;AAEF;MACM,6CAA6C;AACnD;;AAEA;MACM,6CAA6C;AACnD;;AAEA;EACE,kBAAkB;EAClB,qEAAqE;EACrE,MAAM;EACN,UAAU;EACV,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,mDAAmD;EACnD,0BAA0B;EAC1B,yBAAyB;EACzB,mDAAmD;EACnD,sDAAsD;EACtD,4CAA4C;EAC5C,oBAAoB;AACtB;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,iCAAiC;EACnC;;AAEF;QACQ,yCAAyC;AACjD;;AAEA;QACQ,yCAAyC;AACjD;;AAEA;EACE,8FAA8F;EAC9F,sCAAsC;EACtC,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;EACE,kBAAkB;AACpB;;EAEE;IACE,kDAAkD;EACpD;;AAEF;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,qEAAqE;AACvE;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,SAAS;EACT,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,wCAAwC;EACxC,iDAAiD;EACjD,gDAAgD;AAClD;;AAEA;EACE,6DAA6D;EAC7D,4DAA4D;EAC5D,6DAA6D;EAC7D,yDAAyD;EACzD,4DAA4D;;EAE5D,gDAAgD;EAChD,oDAAoD;EACpD,oDAAoD;EACpD,4CAA4C;EAC5C,sDAAsD;EACtD,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;IACI,eAAe;IACf,gCAAgC;EAClC;;AAEF;IACI,sBAAsB;EACxB;;AAEF;MACM,uBAAuB;IACzB;;AAEJ;MACM,qBAAqB;IACvB;;AAEJ;IACI,mBAAmB;EACrB;;AAEF;EACE,+FAA+F;;EAE/F,uCAAuC;EACvC,OAAO;AACT;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,sCAAsC;EACxC;;AAEF;IACI,6CAA6C;IAC7C,wCAAwC;EAC1C;;AAEF;IACI,4CAA4C;IAC5C,+CAA+C;IAC/C,sFAAsF;EACxF;;AAEF;MACM,4CAA4C;IAC9C;;AAEJ;MACM,0CAA0C;IAC5C;;AAEJ;EACE,2CAA2C;AAC7C;;AAEA;EACE,kCAAkC;;EAElC,aAAa;EACb,eAAe;AACjB;;AAEA;IACI,eAAe;EACjB;;AAEF;IACI,mBAAmB;EACrB;;AAEF;IACI,2BAA2B;EAC7B;;AAEF;EACE,mBAAmB;AACrB;;AAEA;EACE,wDAAwD;;EAExD,2BAA2B;EAC3B,iGAAiG;EACjG,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;IACI,aAAa;EACf;;AAEF;IACI,aAAa;EACf;;AAEF;EACE,kBAAkB;AACpB;;AAEA;EACE,8DAA8D;EAC9D,sDAAsD;EACtD,aAAa;EACb,kBAAkB;EAClB,gEAAgE;AAClE;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,kCAAkC;EACpC;;AAEF;EACE,gCAAgC;EAChC,+BAA+B;EAC/B,oCAAoC;EACpC,mCAAmC;EACnC,oCAAoC;EACpC,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB;;2BAEyB;EACzB,mDAAmD;AACrD;;AAEA;IACI,6CAA6C;IAC7C,yCAAyC;IACzC,kCAAkC;AACtC;;AAEA;IACI,6CAA6C;IAC7C,yCAAyC;IACzC,kCAAkC;AACtC;;AAEA;IACI,+BAA+B;EACjC;;AAEF;IACI,4DAA4D;IAC5D,mCAAmC;IACnC,+BAA+B;EACjC;;AAEF;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4DAA4D;AAC9D;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;IACI,8CAA8C;EAChD;;AAEF;IACI,iBAAiB;IACjB,4CAA4C;EAC9C;;AAEF;MACM,gBAAgB;AACtB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,4CAA4C;EAC5C,+CAA+C;EAC/C,0EAA0E;EAC1E,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,qDAAqD;EACrD,wDAAwD;EACxD,uDAAuD;EACvD,yDAAyD;EACzD,wDAAwD;;EAExD,oDAAoD;EACpD,wDAAwD;EACxD,wDAAwD;EACxD,sDAAsD;EACtD,sDAAsD;;EAEtD,4DAA4D;EAC5D,6DAA6D;EAC7D,6DAA6D;EAC7D,6DAA6D;EAC7D,4DAA4D;;EAE5D,mEAAmE;EACnE,kEAAkE;EAClE,mEAAmE;EACnE,mEAAmE;EACnE,mEAAmE;;EAEnE,uEAAuE;EACvE,sEAAsE;EACtE,sEAAsE;EACtE,uEAAuE;EACvE,uEAAuE;;EAEvE,wCAAwC;EACxC,sCAAsC;EACtC,gDAAgD;EAChD,0DAA0D;EAC1D,kEAAkE;EAClE,qDAAqD;EACrD,mDAAmD;;EAEnD,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,QAAQ;EACR,UAAU;EACV,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,wDAAwD;EACxD,gBAAgB;EAChB,kBAAkB;EAClB,mCAAmC;EACnC,kCAAkC;EAClC,kCAAkC;EAClC,4BAA4B;EAC5B,8BAA8B;EAC9B,SAAS;EACT;;2BAEyB;EACzB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;EAChB,6BAA6B;EAC7B,iBAAiB;EACjB,UAAU;EACV,cAAc;EACd,+BAA+B;AACjC;;AAEA;IACI,sDAAsD;IACtD,qDAAqD;EACvD;;AAEF;IACI,gCAAgC;IAChC,gCAAgC;IAChC,+CAA+C;EACjD;;AAEF;;IAEI,yCAAyC;IACzC,yCAAyC;IACzC,4BAA4B;EAC9B;;AAEF;IACI,wCAAwC;IACxC,wCAAwC;IACxC,gDAAgD;IAChD,oDAAoD;AACxD;;AAEA;IACI,wCAAwC;IACxC,wCAAwC;IACxC,gDAAgD;IAChD,oDAAoD;AACxD;;AAEA;IACI,uCAAuC;EACzC;;AAEF;IACI,iBAAiB;EACnB;;AAEF;EACE,kBAAkB;EAClB,UAAU;EACV,mCAAmC;EACnC,aAAa;EACb,oEAAoE;EACpE,gCAAgC;EAChC,+BAA+B;EAC/B,wCAAwC;EACxC,gFAAgF;EAChF,yCAAyC;AAC3C;;AAEA;IACI,YAAY;EACd;;AAEF;IACI,+FAA+F;IAC/F,6CAA6C;EAC/C;;AAEF;;IAEI,kDAAkD;IAClD,kDAAkD;EACpD;;AAEF;IACI,8CAA8C;IAC9C,uDAAuD;AAC3D;;AAEA;IACI,6CAA6C;IAC7C,uDAAuD;AAC3D;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,+DAA+D;EAC/D,iDAAiD;EACjD,uFAAuF;EACvF,6BAA6B;AAC/B;;AAEA;IACI,qFAAqF;IACrF,sBAAsB;EACxB;;AAEF;EACE,WAAW;EACX,yBAAyB;EACzB,uCAAuC;EACvC,sCAAsC;EACtC,uCAAuC;EACvC,+CAA+C;EAC/C,YAAY;AACd;;EAEE;IACE,gDAAgD;IAChD,kDAAkD;IAClD,iDAAiD;AACrD;;EAEE;IACE,gDAAgD;IAChD,kDAAkD;IAClD,iDAAiD;AACrD;;EAEE;IACE,8EAA8E;EAChF;;AAEF;EACE,gBAAgB;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;IACI;MACE,oCAAoC;IACtC;AACJ;;AAEA;IACI;MACE,oCAAoC;IACtC;AACJ;;AAEA;IACI,qFAAqF;EACvF;;AAEF;;EAEE,iGAAiG;AACnG;;AAEA;IACI,yFAAyF;EAC3F;;AAEF;MACM,mBAAmB;IACrB;;AAEJ;MACM,4CAA4C;IAC9C;;AAEJ;MACM,4CAA4C;IAC9C;;AAEJ;MACM,8EAA8E;IAChF;;AAEJ;EACE,yCAAyC;EACzC,UAAU;AACZ;;AAEA;IACI,gBAAgB;IAChB,2CAA2C;EAC7C;;AAEF;EACE,kCAAkC;AACpC;;AAEA;IACI,wCAAwC;EAC1C;;AAEF;IACI,qCAAqC;EACvC;;AAEF;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,4BAA4B;EAC5B,0CAA0C;;EAE1C,yBAAyB;EACzB,0BAA0B;EAC1B,wBAAwB;EACxB,qBAAqB;EACrB,0BAA0B;EAC1B,2BAA2B;EAC3B,4DAA4D;EAC5D,sBAAsB;;EAEtB,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,uBAAuB;;EAEvB,uDAAuD;EACvD,uDAAuD;AACzD;;EAEE;IACE,8BAA8B;IAC9B,uBAAuB;IACvB,uDAAuD;IACvD,uDAAuD;EACzD;;EAEA;MACI,MAAM;MACN,aAAa;IACf;;EAEF;IACE,6BAA6B;IAC7B,uBAAuB;IACvB,uBAAuB;IACvB,0BAA0B;IAC1B,4DAA4D;IAC5D,uDAAuD;IACvD,uDAAuD;IACvD,6BAA6B;IAC7B,oBAAoB;IACpB,oBAAoB;EACtB;;EAEA;MACI,4DAA4D;MAC5D,uDAAuD;MACvD,uDAAuD;AAC7D;;EAEE;MACI,kCAAkC;MAClC,yBAAyB;MACzB,2BAA2B;MAC3B,4DAA4D;MAC5D,uDAAuD;MACvD,uDAAuD;IACzD;;EAEF;QACM,4DAA4D;QAC5D,uDAAuD;QACvD,uDAAuD;AAC/D;;EAEE;IACE,+CAA+C;AACnD;;EAEE;IACE,+CAA+C;AACnD;;EAEE;IACE,qBAAqB;EACvB;;EAEA;IACE,+DAA+D;EACjE;;EAEA;MACI,8CAA8C;AACpD;;EAEE;MACI,8CAA8C;AACpD;;EAEE;IACE,gEAAgE;EAClE;;EAEA;IACE,oDAAoD;EACtD;;EAEA;MACI,8CAA8C;AACpD;;EAEE;MACI,8CAA8C;AACpD;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gDAAgD;EAChD,0CAA0C;EAC1C,yBAAyB;;EAEzB,iBAAiB;AACnB;;AAEA;IACI,aAAa;EACf;;AAEF;EACE,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,4DAA4D;EAC5D,sCAAsC;EACtC,mBAAmB;EACnB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,0BAA0B;EAC1B,mCAAmC;AACrC;;AAEA;;IAEI,YAAY;IACZ,mBAAmB;EACrB;;AAEF;IACI,UAAU;EACZ;;AAEF;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8CAA8C;EAC9C,gDAAgD;AAClD;;AAEA;MACM,qDAAqD;IACvD;;AAEJ;QACQ,gCAAgC;QAChC,oDAAoD;AAC5D;;AAEA;MACM,oDAAoD;IACtD;;AAEJ;QACQ,+BAA+B;QAC/B,qDAAqD;AAC7D;;AAEA,gGAAgG;AAChG;EACE,kBAAkB;AACpB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,qCAAqC;IACrC,0CAA0C;IAC1C,mBAAmB;IACnB,oCAAoC;IACpC,+CAA+C;IAC/C,2CAA2C;IAC3C,8BAA8B;EAChC;;AAEF;EACE,gCAAgC;EAChC,qCAAqC;EACrC,mBAAmB;EACnB,yBAAyB;EACzB,+BAA+B;;EAE/B,qBAAqB;AACvB;;AAEA;IACI,+BAA+B;EACjC;;AAEF;;EAEE;IACE,gCAAgC;EAClC;;IAEE;MACE,qCAAqC;IACvC;AACJ;;AAEA;;EAEE;IACE,gCAAgC;EAClC;;IAEE;MACE,qCAAqC;IACvC;AACJ;;AAEA;;EAEE;MACI,qBAAqB;EACzB;AACF;;AAEA;;EAEE;MACI,qBAAqB;EACzB;AACF;;AAEA,gGAAgG;AAChG;EACE,kBAAkB;AACpB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,qCAAqC;IACrC,0CAA0C;IAC1C,mBAAmB;IACnB,oCAAoC;IACpC,+CAA+C;IAC/C,2CAA2C;IAC3C,8BAA8B;EAChC;;AAEF;EACE,oEAAoE;EACpE,uEAAuE;EACvE,sEAAsE;EACtE,qEAAqE;EACrE,6CAA6C;EAC7C,mDAAmD;EACnD,gCAAgC;EAChC,kBAAkB;;EAElB,sCAAsC;EACtC,mCAAmC;EACnC,0CAA0C;EAC1C,4CAA4C;AAC9C;;AAEA;MACM,WAAW;MACX,kBAAkB;MAClB,yCAAyC;MACzC,yEAAyE;MACzE,qEAAqE;MACrE,oCAAoC;MACpC,gCAAgC;MAChC,6CAA6C;MAC7C,8CAA8C;IAChD;;AAEJ;MACM,WAAW;MACX,kBAAkB;MAClB,yCAAyC;MACzC,wEAAwE;MACxE,sEAAsE;MACtE,iCAAiC;MACjC,+BAA+B;MAC/B,6CAA6C;MAC7C,8CAA8C;IAChD;;AAEJ;;IAEI,6CAA6C;IAC7C,mDAAmD;IACnD,+DAA+D;IAC/D,2DAA2D;;IAE3D,+CAA+C;IAC/C,wDAAwD;IACxD,sDAAsD;IACtD,oDAAoD;AACxD;;AAEA;MACM,kDAAkD;MAClD,iDAAiD;;MAEjD,yBAAyB;MACzB,yDAAyD;MACzD,wBAAwB;MACxB,wDAAwD;IAC1D;;AAEJ;QACQ,wDAAwD;QACxD,wDAAwD;QACxD,kDAAkD;;QAElD,2DAA2D;QAC3D,uBAAuB;QACvB,yBAAyB;QACzB,yDAAyD;QACzD,sBAAsB;QACtB,0DAA0D;MAC5D;;AAEN;UACU,wBAAwB;UACxB,0DAA0D;UAC1D,yDAAyD;UACzD,uBAAuB;AACjC;;AAEA;QACQ,0DAA0D;QAC1D,sDAAsD;QACtD,kDAAkD;;QAElD,0DAA0D;QAC1D,wBAAwB;QACxB,yBAAyB;QACzB,yDAAyD;QACzD,uBAAuB;QACvB,yDAAyD;MAC3D;;AAEN;UACU,uBAAuB;UACvB,2DAA2D;UAC3D,0DAA0D;UAC1D,sBAAsB;AAChC;;AAEA,8FAA8F;AAC9F;EACE,iCAAiC;EACjC,+BAA+B;EAC/B,uBAAuB;;EAEvB,qBAAqB;EACrB,oBAAoB;AACtB;AACA;;EAEE;MACI,gCAAgC;EACpC;AACF;AACA;;EAEE;MACI,gCAAgC;EACpC;AACF;AACA;IACI,2BAA2B;IAC3B,+DAA+D;EACjE;AACF;;EAEE;MACI,2BAA2B;EAC/B;AACF;AACA;;EAEE;MACI,2BAA2B;EAC/B;AACF;;AAEA;EACE,mDAAmD;EACnD,mDAAmD;EACnD,kDAAkD;EAClD,mDAAmD;EACnD,kDAAkD;EAClD,4BAA4B;;EAE5B,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;;EAEjB,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;EAC1B,8DAA8D;EAC9D,6DAA6D;EAC7D,kDAAkD;EAClD,2CAA2C;AAC7C;;AAEA;EACE,oEAAoE;EACpE,sDAAsD;EACtD,qDAAqD;EACrD,iDAAiD;EACjD,+CAA+C;AACjD;;EAEE;IACE,mCAAmC;EACrC;;EAEA;IACE,iCAAiC;EACnC;;AAEF;EACE,gBAAgB;EAChB,cAAc;EACd,kDAAkD;AACpD;;AAEA;EACE,2FAA2F;;EAE3F,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;IACI,WAAW;IACX,oBAAoB;IACpB,kBAAkB;IAClB,MAAM;IACN,kCAAkC;IAClC,oCAAoC;IACpC,4CAA4C;IAC5C,uCAAuC;IACvC,2CAA2C;EAC7C;;AAEF;MACM,qDAAqD;MACrD,2BAA2B;IAC7B;;AAEJ;QACQ,0BAA0B;QAC1B,sDAAsD;AAC9D;;AAEA;MACM,0BAA0B;MAC1B,sDAAsD;IACxD;;AAEJ;QACQ,qDAAqD;QACrD,2BAA2B;AACnC;;AAEA;IACI,mCAAmC;IACnC,gBAAgB;EAClB;;AAEF;IACI,iCAAiC;IACjC,iBAAiB;EACnB;;AAEF;IACI,gDAAgD;AACpD;;AAEA;IACI,gDAAgD;AACpD;;AAEA;MACM,+CAA+C;IACjD;;AAEJ;IACI,8BAA8B;EAChC;;AAEF;IACI,qCAAqC;EACvC;;AAEF;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,kDAAkD;EAClD,kCAAkC;EAClC,2CAA2C;EAC3C,kBAAkB;EAClB,MAAM;EACN,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,uEAAuE;IACvE,WAAW;EACb;;AAEF;MACM,UAAU;MACV,wEAAwE;AAC9E;;AAEA;IACI,UAAU;IACV,wEAAwE;EAC1E;;AAEF;MACM,uEAAuE;MACvE,WAAW;AACjB;;AAEA;IACI,kCAAkC;EACpC;;AAEF;MACM,6CAA6C;AACnD;;AAEA;MACM,6CAA6C;AACnD;;AAEA;IACI,+CAA+C;IAC/C,4CAA4C;IAC5C,uDAAuD;EACzD;;AAEF;MACM,mDAAmD;MACnD,uDAAuD;IACzD;;AAEJ;IACI,mCAAmC;IACnC,gBAAgB;EAClB;;AAEF;MACM,iBAAiB;AACvB;;AAEA;IACI,iCAAiC;IACjC,iBAAiB;EACnB;;AAEF;MACM,gBAAgB;AACtB;;AAEA;EACE,SAAS;EACT,4BAA4B;EAC5B,0BAA0B;EAC1B,4BAA4B;EAC5B,gDAAgD;EAChD,mEAAmE;AACrE;;EAEE;IACE,gBAAgB;IAChB,uBAAuB;IACvB,oBAAoB;IACpB,2CAA2C;IAC3C,4BAA4B;EAC9B;;AAEF;EACE,yCAAyC;EACzC,SAAS;EACT,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,UAAU;AACZ;;AAEA;MACM,sDAAsD;MACtD,qDAAqD;IACvD;;AAEJ;EACE,yCAAyC;AAC3C;;AAEA;MACM,6CAA6C;AACnD;;AAEA;MACM,6CAA6C;AACnD;;AAEA;IACI,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,wCAAwC;IACxC,2CAA2C;EAC7C;EACA;IACE,iDAAiD;IACjD,sCAAsC;IACtC,0CAA0C;IAC1C,0CAA0C;EAC5C;EACA;IACE,qCAAqC;IACrC,sCAAsC;IACtC,0CAA0C;IAC1C,0CAA0C;EAC5C;EACA;IACE,iDAAiD;IACjD,sCAAsC;IACtC,0CAA0C;IAC1C,0CAA0C;EAC5C;EACA;IACE,iDAAiD;IACjD,sCAAsC;IACtC,0CAA0C;IAC1C,0CAA0C;EAC5C;EACA;IACE,iDAAiD;IACjD,sCAAsC;IACtC,0CAA0C;IAC1C,0CAA0C;EAC5C;EACA;IACE,iDAAiD;IACjD,sCAAsC;IACtC,0CAA0C;IAC1C,0CAA0C;EAC5C;EACA;IACE,eAAe;IACf,wCAAwC;EAC1C;EACA;IACE,aAAa;IACb,wCAAwC;EAC1C;EACA;MACI,+CAA+C;MAC/C,cAAc;AACpB;EACE;MACI,+CAA+C;MAC/C,iCAAiC;AACvC;EACE;IACE,kCAAkC;IAClC,qBAAqB;EACvB;EACA;IACE;MACE,0BAA0B;IAC5B;AACJ;EACE;IACE;MACE,0BAA0B;IAC5B;AACJ;EACE;IACE,qCAAqC;IACrC,wCAAwC;IACxC,SAAS;IACT,wDAAwD;EAC1D;EACA;MACI,yCAAyC;AAC/C;EACE;MACI,yCAAyC;AAC/C;EACE;IACE,kCAAkC;IAClC,uCAAuC;IACvC,SAAS;IACT,qCAAqC;IACrC,wCAAwC;IACxC,gBAAgB;IAChB,iDAAiD;IACjD,sCAAsC;IACtC,uCAAuC;EACzC;EACA;MACI,6CAA6C;AACnD;EACE;MACI,6CAA6C;AACnD;EACE;MACI,6BAA6B;MAC7B,UAAU;MACV,gBAAgB;MAChB,cAAc;MACd,SAAS;IACX;EACF;IACE,8CAA8C;IAC9C,4FAA4F;;IAE5F,iDAAiD;IACjD,uCAAuC;IACvC,gBAAgB;IAChB,2BAA2B;IAC3B,wBAAwB;IACxB,uCAAuC;IACvC,oDAAoD;IACpD,2DAA2D;EAC7D;EACA;MACI,yCAAyC;MACzC,kCAAkC;MAClC,6CAA6C;AACnD;EACE;MACI,yCAAyC;MACzC,kCAAkC;MAClC,6CAA6C;AACnD;EACE;IACE,uCAAuC;IACvC,sFAAsF;IACtF,uCAAuC;IACvC,iDAAiD;IACjD,sCAAsC;EACxC;EACA;MACI,6CAA6C;MAC7C,iCAAiC;AACvC;EACE;MACI,6CAA6C;MAC7C,iCAAiC;AACvC;EACE;IACE,wCAAwC;IACxC,2DAA2D;EAC7D;EACA;MACI,wCAAwC;IAC1C;EACF;IACE,WAAW;IACX,yBAAyB;IACzB,oBAAoB;IACpB,wCAAwC;EAC1C;EACA;MACI,qCAAqC;MACrC,sCAAsC;MACtC,kCAAkC;IACpC;EACF;MACI,gBAAgB;MAChB,iBAAiB;MACjB,kCAAkC;MAClC,sCAAsC;MACtC,4DAA4D;IAC9D;EACF;MACI,2DAA2D;MAC3D,yCAAyC;IAC3C;EACF;MACI,wDAAwD;MACxD,yCAAyC;IAC3C;EACF;MACI,4DAA4D;MAC5D,2DAA2D;MAC3D,yCAAyC;MACzC,sCAAsC;IACxC;EACF;MACI,gBAAgB;IAClB;EACF;IACE,sCAAsC;IACtC,uCAAuC;IACvC,mCAAmC;IACnC,uCAAuC;IACvC,4DAA4D;EAC9D;EACA;MACI,6CAA6C;AACnD;EACE;MACI,6CAA6C;AACnD","sourcesContent":["/* ----- CSS reset ----- */\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\ninput,\nbutton,\ntextarea,\nselect {\n  font: inherit;\n}\n\nbutton,\nselect {\n  text-transform: none;\n}\n\n/* ----- Global styles ----- */\nbody {\n  margin: 0;\n  font-family: var(--mantine-font-family);\n  font-size: var(--mantine-font-size-md);\n  line-height: var(--mantine-line-height);\n  background-color: var(--mantine-color-body);\n  color: var(--mantine-color-text);\n\n  -webkit-font-smoothing: var(--mantine-webkit-font-smoothing);\n  -moz-osx-font-smoothing: var(--mantine-moz-font-smoothing);\n}\n@media screen and (max-device-width: 31.25em) {\nbody {\n    -webkit-text-size-adjust: 100%\n}\n  }\n\n@media (prefers-reduced-motion: reduce) {\n    [data-respect-reduced-motion] [data-reduce-motion] {\n      transition: none;\n      animation: none;\n    }\n  }\n\n[data-mantine-color-scheme='light'] .mantine-light-hidden {\n    display: none;\n}\n\n[data-mantine-color-scheme='dark'] .mantine-dark-hidden {\n    display: none;\n}\n\n.mantine-focus-auto:focus-visible {\n    outline: 2px solid var(--mantine-primary-color-filled);\n    outline-offset: calc(0.125rem * var(--mantine-scale));\n  }\n\n.mantine-focus-always:focus {\n    outline: 2px solid var(--mantine-primary-color-filled);\n    outline-offset: calc(0.125rem * var(--mantine-scale));\n  }\n\n.mantine-focus-never:focus {\n    outline: none;\n  }\n\n.mantine-active:active {\n    transform: translateY(calc(0.0625rem * var(--mantine-scale)));\n  }\n\n:where([dir=\"rtl\"]) .mantine-rotate-rtl {\n    transform: rotate(180deg);\n}\n\n/* ----- Default CSS variables ----- */\n\n:root {\n  color-scheme: var(--mantine-color-scheme);\n\n  --mantine-z-index-app: 100;\n  --mantine-z-index-modal: 200;\n  --mantine-z-index-popover: 300;\n  --mantine-z-index-overlay: 400;\n  --mantine-z-index-max: 9999;\n\n  --mantine-scale: 1;\n  --mantine-cursor-type: default;\n  --mantine-webkit-font-smoothing: antialiased;\n  --mantine-color-scheme: light dark;\n  --mantine-moz-font-smoothing: grayscale;\n  --mantine-color-white: #fff;\n  --mantine-color-black: #000;\n  --mantine-line-height: 1.55;\n  --mantine-font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial,\n    sans-serif, Apple Color Emoji, Segoe UI Emoji;\n  --mantine-font-family-monospace: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas,\n    Liberation Mono, Courier New, monospace;\n  --mantine-font-family-headings: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica,\n    Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji;\n  --mantine-heading-font-weight: 700;\n  --mantine-radius-default: calc(0.25rem * var(--mantine-scale));\n  --mantine-primary-color-0: var(--mantine-color-blue-0);\n  --mantine-primary-color-1: var(--mantine-color-blue-1);\n  --mantine-primary-color-2: var(--mantine-color-blue-2);\n  --mantine-primary-color-3: var(--mantine-color-blue-3);\n  --mantine-primary-color-4: var(--mantine-color-blue-4);\n  --mantine-primary-color-5: var(--mantine-color-blue-5);\n  --mantine-primary-color-6: var(--mantine-color-blue-6);\n  --mantine-primary-color-7: var(--mantine-color-blue-7);\n  --mantine-primary-color-8: var(--mantine-color-blue-8);\n  --mantine-primary-color-9: var(--mantine-color-blue-9);\n  --mantine-primary-color-filled: var(--mantine-color-blue-filled);\n  --mantine-primary-color-filled-hover: var(--mantine-color-blue-filled-hover);\n  --mantine-primary-color-light: var(--mantine-color-blue-light);\n  --mantine-primary-color-light-hover: var(--mantine-color-blue-light-hover);\n  --mantine-primary-color-light-color: var(--mantine-color-blue-light-color);\n  --mantine-breakpoint-xs: 36em;\n  --mantine-breakpoint-sm: 48em;\n  --mantine-breakpoint-md: 62em;\n  --mantine-breakpoint-lg: 75em;\n  --mantine-breakpoint-xl: 88em;\n  --mantine-spacing-xs: calc(0.625rem * var(--mantine-scale));\n  --mantine-spacing-sm: calc(0.75rem * var(--mantine-scale));\n  --mantine-spacing-md: calc(1rem * var(--mantine-scale));\n  --mantine-spacing-lg: calc(1.25rem * var(--mantine-scale));\n  --mantine-spacing-xl: calc(2rem * var(--mantine-scale));\n  --mantine-font-size-xs: calc(0.75rem * var(--mantine-scale));\n  --mantine-font-size-sm: calc(0.875rem * var(--mantine-scale));\n  --mantine-font-size-md: calc(1rem * var(--mantine-scale));\n  --mantine-font-size-lg: calc(1.125rem * var(--mantine-scale));\n  --mantine-font-size-xl: calc(1.25rem * var(--mantine-scale));\n  --mantine-line-height-xs: 1.4;\n  --mantine-line-height-sm: 1.45;\n  --mantine-line-height-md: 1.55;\n  --mantine-line-height-lg: 1.6;\n  --mantine-line-height-xl: 1.65;\n  --mantine-shadow-xs: 0 calc(0.0625rem * var(--mantine-scale))\n      calc(0.1875rem * var(--mantine-scale)) rgba(0, 0, 0, 0.05),\n    0 calc(0.0625rem * var(--mantine-scale)) calc(0.125rem * var(--mantine-scale))\n      rgba(0, 0, 0, 0.1);\n  --mantine-shadow-sm: 0 calc(0.0625rem * var(--mantine-scale))\n      calc(0.1875rem * var(--mantine-scale)) rgba(0, 0, 0, 0.05),\n    rgba(0, 0, 0, 0.05) 0 calc(0.625rem * var(--mantine-scale))\n      calc(0.9375rem * var(--mantine-scale)) calc(-0.3125rem * var(--mantine-scale)),\n    rgba(0, 0, 0, 0.04) 0 calc(0.4375rem * var(--mantine-scale))\n      calc(0.4375rem * var(--mantine-scale)) calc(-0.3125rem * var(--mantine-scale));\n  --mantine-shadow-md: 0 calc(0.0625rem * var(--mantine-scale))\n      calc(0.1875rem * var(--mantine-scale)) rgba(0, 0, 0, 0.05),\n    rgba(0, 0, 0, 0.05) 0 calc(1.25rem * var(--mantine-scale))\n      calc(1.5625rem * var(--mantine-scale)) calc(-0.3125rem * var(--mantine-scale)),\n    rgba(0, 0, 0, 0.04) 0 calc(0.625rem * var(--mantine-scale))\n      calc(0.625rem * var(--mantine-scale)) calc(-0.3125rem * var(--mantine-scale));\n  --mantine-shadow-lg: 0 calc(0.0625rem * var(--mantine-scale))\n      calc(0.1875rem * var(--mantine-scale)) rgba(0, 0, 0, 0.05),\n    rgba(0, 0, 0, 0.05) 0 calc(1.75rem * var(--mantine-scale))\n      calc(1.4375rem * var(--mantine-scale)) calc(-0.4375rem * var(--mantine-scale)),\n    rgba(0, 0, 0, 0.04) 0 calc(0.75rem * var(--mantine-scale)) calc(0.75rem * var(--mantine-scale))\n      calc(-0.4375rem * var(--mantine-scale));\n  --mantine-shadow-xl: 0 calc(0.0625rem * var(--mantine-scale))\n      calc(0.1875rem * var(--mantine-scale)) rgba(0, 0, 0, 0.05),\n    rgba(0, 0, 0, 0.05) 0 calc(2.25rem * var(--mantine-scale)) calc(1.75rem * var(--mantine-scale))\n      calc(-0.4375rem * var(--mantine-scale)),\n    rgba(0, 0, 0, 0.04) 0 calc(1.0625rem * var(--mantine-scale))\n      calc(1.0625rem * var(--mantine-scale)) calc(-0.4375rem * var(--mantine-scale));\n  --mantine-radius-xs: calc(0.125rem * var(--mantine-scale));\n  --mantine-radius-sm: calc(0.25rem * var(--mantine-scale));\n  --mantine-radius-md: calc(0.5rem * var(--mantine-scale));\n  --mantine-radius-lg: calc(1rem * var(--mantine-scale));\n  --mantine-radius-xl: calc(2rem * var(--mantine-scale));\n  --mantine-color-dark-0: #c9c9c9;\n  --mantine-color-dark-1: #b8b8b8;\n  --mantine-color-dark-2: #828282;\n  --mantine-color-dark-3: #696969;\n  --mantine-color-dark-4: #424242;\n  --mantine-color-dark-5: #3b3b3b;\n  --mantine-color-dark-6: #2e2e2e;\n  --mantine-color-dark-7: #242424;\n  --mantine-color-dark-8: #1f1f1f;\n  --mantine-color-dark-9: #141414;\n  --mantine-color-gray-0: #f8f9fa;\n  --mantine-color-gray-1: #f1f3f5;\n  --mantine-color-gray-2: #e9ecef;\n  --mantine-color-gray-3: #dee2e6;\n  --mantine-color-gray-4: #ced4da;\n  --mantine-color-gray-5: #adb5bd;\n  --mantine-color-gray-6: #868e96;\n  --mantine-color-gray-7: #495057;\n  --mantine-color-gray-8: #343a40;\n  --mantine-color-gray-9: #212529;\n  --mantine-color-red-0: #fff5f5;\n  --mantine-color-red-1: #ffe3e3;\n  --mantine-color-red-2: #ffc9c9;\n  --mantine-color-red-3: #ffa8a8;\n  --mantine-color-red-4: #ff8787;\n  --mantine-color-red-5: #ff6b6b;\n  --mantine-color-red-6: #fa5252;\n  --mantine-color-red-7: #f03e3e;\n  --mantine-color-red-8: #e03131;\n  --mantine-color-red-9: #c92a2a;\n  --mantine-color-pink-0: #fff0f6;\n  --mantine-color-pink-1: #ffdeeb;\n  --mantine-color-pink-2: #fcc2d7;\n  --mantine-color-pink-3: #faa2c1;\n  --mantine-color-pink-4: #f783ac;\n  --mantine-color-pink-5: #f06595;\n  --mantine-color-pink-6: #e64980;\n  --mantine-color-pink-7: #d6336c;\n  --mantine-color-pink-8: #c2255c;\n  --mantine-color-pink-9: #a61e4d;\n  --mantine-color-grape-0: #f8f0fc;\n  --mantine-color-grape-1: #f3d9fa;\n  --mantine-color-grape-2: #eebefa;\n  --mantine-color-grape-3: #e599f7;\n  --mantine-color-grape-4: #da77f2;\n  --mantine-color-grape-5: #cc5de8;\n  --mantine-color-grape-6: #be4bdb;\n  --mantine-color-grape-7: #ae3ec9;\n  --mantine-color-grape-8: #9c36b5;\n  --mantine-color-grape-9: #862e9c;\n  --mantine-color-violet-0: #f3f0ff;\n  --mantine-color-violet-1: #e5dbff;\n  --mantine-color-violet-2: #d0bfff;\n  --mantine-color-violet-3: #b197fc;\n  --mantine-color-violet-4: #9775fa;\n  --mantine-color-violet-5: #845ef7;\n  --mantine-color-violet-6: #7950f2;\n  --mantine-color-violet-7: #7048e8;\n  --mantine-color-violet-8: #6741d9;\n  --mantine-color-violet-9: #5f3dc4;\n  --mantine-color-indigo-0: #edf2ff;\n  --mantine-color-indigo-1: #dbe4ff;\n  --mantine-color-indigo-2: #bac8ff;\n  --mantine-color-indigo-3: #91a7ff;\n  --mantine-color-indigo-4: #748ffc;\n  --mantine-color-indigo-5: #5c7cfa;\n  --mantine-color-indigo-6: #4c6ef5;\n  --mantine-color-indigo-7: #4263eb;\n  --mantine-color-indigo-8: #3b5bdb;\n  --mantine-color-indigo-9: #364fc7;\n  --mantine-color-blue-0: #e7f5ff;\n  --mantine-color-blue-1: #d0ebff;\n  --mantine-color-blue-2: #a5d8ff;\n  --mantine-color-blue-3: #74c0fc;\n  --mantine-color-blue-4: #4dabf7;\n  --mantine-color-blue-5: #339af0;\n  --mantine-color-blue-6: #228be6;\n  --mantine-color-blue-7: #1c7ed6;\n  --mantine-color-blue-8: #1971c2;\n  --mantine-color-blue-9: #1864ab;\n  --mantine-color-cyan-0: #e3fafc;\n  --mantine-color-cyan-1: #c5f6fa;\n  --mantine-color-cyan-2: #99e9f2;\n  --mantine-color-cyan-3: #66d9e8;\n  --mantine-color-cyan-4: #3bc9db;\n  --mantine-color-cyan-5: #22b8cf;\n  --mantine-color-cyan-6: #15aabf;\n  --mantine-color-cyan-7: #1098ad;\n  --mantine-color-cyan-8: #0c8599;\n  --mantine-color-cyan-9: #0b7285;\n  --mantine-color-teal-0: #e6fcf5;\n  --mantine-color-teal-1: #c3fae8;\n  --mantine-color-teal-2: #96f2d7;\n  --mantine-color-teal-3: #63e6be;\n  --mantine-color-teal-4: #38d9a9;\n  --mantine-color-teal-5: #20c997;\n  --mantine-color-teal-6: #12b886;\n  --mantine-color-teal-7: #0ca678;\n  --mantine-color-teal-8: #099268;\n  --mantine-color-teal-9: #087f5b;\n  --mantine-color-green-0: #ebfbee;\n  --mantine-color-green-1: #d3f9d8;\n  --mantine-color-green-2: #b2f2bb;\n  --mantine-color-green-3: #8ce99a;\n  --mantine-color-green-4: #69db7c;\n  --mantine-color-green-5: #51cf66;\n  --mantine-color-green-6: #40c057;\n  --mantine-color-green-7: #37b24d;\n  --mantine-color-green-8: #2f9e44;\n  --mantine-color-green-9: #2b8a3e;\n  --mantine-color-lime-0: #f4fce3;\n  --mantine-color-lime-1: #e9fac8;\n  --mantine-color-lime-2: #d8f5a2;\n  --mantine-color-lime-3: #c0eb75;\n  --mantine-color-lime-4: #a9e34b;\n  --mantine-color-lime-5: #94d82d;\n  --mantine-color-lime-6: #82c91e;\n  --mantine-color-lime-7: #74b816;\n  --mantine-color-lime-8: #66a80f;\n  --mantine-color-lime-9: #5c940d;\n  --mantine-color-yellow-0: #fff9db;\n  --mantine-color-yellow-1: #fff3bf;\n  --mantine-color-yellow-2: #ffec99;\n  --mantine-color-yellow-3: #ffe066;\n  --mantine-color-yellow-4: #ffd43b;\n  --mantine-color-yellow-5: #fcc419;\n  --mantine-color-yellow-6: #fab005;\n  --mantine-color-yellow-7: #f59f00;\n  --mantine-color-yellow-8: #f08c00;\n  --mantine-color-yellow-9: #e67700;\n  --mantine-color-orange-0: #fff4e6;\n  --mantine-color-orange-1: #ffe8cc;\n  --mantine-color-orange-2: #ffd8a8;\n  --mantine-color-orange-3: #ffc078;\n  --mantine-color-orange-4: #ffa94d;\n  --mantine-color-orange-5: #ff922b;\n  --mantine-color-orange-6: #fd7e14;\n  --mantine-color-orange-7: #f76707;\n  --mantine-color-orange-8: #e8590c;\n  --mantine-color-orange-9: #d9480f;\n  --mantine-h1-font-size: calc(2.125rem * var(--mantine-scale));\n  --mantine-h1-line-height: 1.3;\n  --mantine-h1-font-weight: 700;\n  --mantine-h2-font-size: calc(1.625rem * var(--mantine-scale));\n  --mantine-h2-line-height: 1.35;\n  --mantine-h2-font-weight: 700;\n  --mantine-h3-font-size: calc(1.375rem * var(--mantine-scale));\n  --mantine-h3-line-height: 1.4;\n  --mantine-h3-font-weight: 700;\n  --mantine-h4-font-size: calc(1.125rem * var(--mantine-scale));\n  --mantine-h4-line-height: 1.45;\n  --mantine-h4-font-weight: 700;\n  --mantine-h5-font-size: calc(1rem * var(--mantine-scale));\n  --mantine-h5-line-height: 1.5;\n  --mantine-h5-font-weight: 700;\n  --mantine-h6-font-size: calc(0.875rem * var(--mantine-scale));\n  --mantine-h6-line-height: 1.5;\n  --mantine-h6-font-weight: 700;\n}\n\n:root[data-mantine-color-scheme='dark'] {\n  --mantine-color-scheme: dark;\n  --mantine-primary-color-contrast: var(--mantine-color-white);\n  --mantine-color-bright: var(--mantine-color-white);\n  --mantine-color-text: var(--mantine-color-dark-0);\n  --mantine-color-body: var(--mantine-color-dark-7);\n  --mantine-color-error: var(--mantine-color-red-8);\n  --mantine-color-placeholder: var(--mantine-color-dark-3);\n  --mantine-color-anchor: var(--mantine-color-blue-4);\n  --mantine-color-default: var(--mantine-color-dark-6);\n  --mantine-color-default-hover: var(--mantine-color-dark-5);\n  --mantine-color-default-color: var(--mantine-color-white);\n  --mantine-color-default-border: var(--mantine-color-dark-4);\n  --mantine-color-dimmed: var(--mantine-color-dark-2);\n  --mantine-color-dark-text: var(--mantine-color-dark-4);\n  --mantine-color-dark-filled: var(--mantine-color-dark-8);\n  --mantine-color-dark-filled-hover: var(--mantine-color-dark-7);\n  --mantine-color-dark-light: rgba(36, 36, 36, 0.15);\n  --mantine-color-dark-light-hover: rgba(36, 36, 36, 0.2);\n  --mantine-color-dark-light-color: var(--mantine-color-dark-3);\n  --mantine-color-dark-outline: var(--mantine-color-dark-4);\n  --mantine-color-dark-outline-hover: rgba(36, 36, 36, 0.05);\n  --mantine-color-gray-text: var(--mantine-color-gray-4);\n  --mantine-color-gray-filled: var(--mantine-color-gray-8);\n  --mantine-color-gray-filled-hover: var(--mantine-color-gray-9);\n  --mantine-color-gray-light: rgba(134, 142, 150, 0.15);\n  --mantine-color-gray-light-hover: rgba(134, 142, 150, 0.2);\n  --mantine-color-gray-light-color: var(--mantine-color-gray-3);\n  --mantine-color-gray-outline: var(--mantine-color-gray-4);\n  --mantine-color-gray-outline-hover: rgba(206, 212, 218, 0.05);\n  --mantine-color-red-text: var(--mantine-color-red-4);\n  --mantine-color-red-filled: var(--mantine-color-red-8);\n  --mantine-color-red-filled-hover: var(--mantine-color-red-9);\n  --mantine-color-red-light: rgba(250, 82, 82, 0.15);\n  --mantine-color-red-light-hover: rgba(250, 82, 82, 0.2);\n  --mantine-color-red-light-color: var(--mantine-color-red-3);\n  --mantine-color-red-outline: var(--mantine-color-red-4);\n  --mantine-color-red-outline-hover: rgba(255, 135, 135, 0.05);\n  --mantine-color-pink-text: var(--mantine-color-pink-4);\n  --mantine-color-pink-filled: var(--mantine-color-pink-8);\n  --mantine-color-pink-filled-hover: var(--mantine-color-pink-9);\n  --mantine-color-pink-light: rgba(230, 73, 128, 0.15);\n  --mantine-color-pink-light-hover: rgba(230, 73, 128, 0.2);\n  --mantine-color-pink-light-color: var(--mantine-color-pink-3);\n  --mantine-color-pink-outline: var(--mantine-color-pink-4);\n  --mantine-color-pink-outline-hover: rgba(247, 131, 172, 0.05);\n  --mantine-color-grape-text: var(--mantine-color-grape-4);\n  --mantine-color-grape-filled: var(--mantine-color-grape-8);\n  --mantine-color-grape-filled-hover: var(--mantine-color-grape-9);\n  --mantine-color-grape-light: rgba(190, 75, 219, 0.15);\n  --mantine-color-grape-light-hover: rgba(190, 75, 219, 0.2);\n  --mantine-color-grape-light-color: var(--mantine-color-grape-3);\n  --mantine-color-grape-outline: var(--mantine-color-grape-4);\n  --mantine-color-grape-outline-hover: rgba(218, 119, 242, 0.05);\n  --mantine-color-violet-text: var(--mantine-color-violet-4);\n  --mantine-color-violet-filled: var(--mantine-color-violet-8);\n  --mantine-color-violet-filled-hover: var(--mantine-color-violet-9);\n  --mantine-color-violet-light: rgba(121, 80, 242, 0.15);\n  --mantine-color-violet-light-hover: rgba(121, 80, 242, 0.2);\n  --mantine-color-violet-light-color: var(--mantine-color-violet-3);\n  --mantine-color-violet-outline: var(--mantine-color-violet-4);\n  --mantine-color-violet-outline-hover: rgba(151, 117, 250, 0.05);\n  --mantine-color-indigo-text: var(--mantine-color-indigo-4);\n  --mantine-color-indigo-filled: var(--mantine-color-indigo-8);\n  --mantine-color-indigo-filled-hover: var(--mantine-color-indigo-9);\n  --mantine-color-indigo-light: rgba(76, 110, 245, 0.15);\n  --mantine-color-indigo-light-hover: rgba(76, 110, 245, 0.2);\n  --mantine-color-indigo-light-color: var(--mantine-color-indigo-3);\n  --mantine-color-indigo-outline: var(--mantine-color-indigo-4);\n  --mantine-color-indigo-outline-hover: rgba(116, 143, 252, 0.05);\n  --mantine-color-blue-text: var(--mantine-color-blue-4);\n  --mantine-color-blue-filled: var(--mantine-color-blue-8);\n  --mantine-color-blue-filled-hover: var(--mantine-color-blue-9);\n  --mantine-color-blue-light: rgba(34, 139, 230, 0.15);\n  --mantine-color-blue-light-hover: rgba(34, 139, 230, 0.2);\n  --mantine-color-blue-light-color: var(--mantine-color-blue-3);\n  --mantine-color-blue-outline: var(--mantine-color-blue-4);\n  --mantine-color-blue-outline-hover: rgba(77, 171, 247, 0.05);\n  --mantine-color-cyan-text: var(--mantine-color-cyan-4);\n  --mantine-color-cyan-filled: var(--mantine-color-cyan-8);\n  --mantine-color-cyan-filled-hover: var(--mantine-color-cyan-9);\n  --mantine-color-cyan-light: rgba(21, 170, 191, 0.15);\n  --mantine-color-cyan-light-hover: rgba(21, 170, 191, 0.2);\n  --mantine-color-cyan-light-color: var(--mantine-color-cyan-3);\n  --mantine-color-cyan-outline: var(--mantine-color-cyan-4);\n  --mantine-color-cyan-outline-hover: rgba(59, 201, 219, 0.05);\n  --mantine-color-teal-text: var(--mantine-color-teal-4);\n  --mantine-color-teal-filled: var(--mantine-color-teal-8);\n  --mantine-color-teal-filled-hover: var(--mantine-color-teal-9);\n  --mantine-color-teal-light: rgba(18, 184, 134, 0.15);\n  --mantine-color-teal-light-hover: rgba(18, 184, 134, 0.2);\n  --mantine-color-teal-light-color: var(--mantine-color-teal-3);\n  --mantine-color-teal-outline: var(--mantine-color-teal-4);\n  --mantine-color-teal-outline-hover: rgba(56, 217, 169, 0.05);\n  --mantine-color-green-text: var(--mantine-color-green-4);\n  --mantine-color-green-filled: var(--mantine-color-green-8);\n  --mantine-color-green-filled-hover: var(--mantine-color-green-9);\n  --mantine-color-green-light: rgba(64, 192, 87, 0.15);\n  --mantine-color-green-light-hover: rgba(64, 192, 87, 0.2);\n  --mantine-color-green-light-color: var(--mantine-color-green-3);\n  --mantine-color-green-outline: var(--mantine-color-green-4);\n  --mantine-color-green-outline-hover: rgba(105, 219, 124, 0.05);\n  --mantine-color-lime-text: var(--mantine-color-lime-4);\n  --mantine-color-lime-filled: var(--mantine-color-lime-8);\n  --mantine-color-lime-filled-hover: var(--mantine-color-lime-9);\n  --mantine-color-lime-light: rgba(130, 201, 30, 0.15);\n  --mantine-color-lime-light-hover: rgba(130, 201, 30, 0.2);\n  --mantine-color-lime-light-color: var(--mantine-color-lime-3);\n  --mantine-color-lime-outline: var(--mantine-color-lime-4);\n  --mantine-color-lime-outline-hover: rgba(169, 227, 75, 0.05);\n  --mantine-color-yellow-text: var(--mantine-color-yellow-4);\n  --mantine-color-yellow-filled: var(--mantine-color-yellow-8);\n  --mantine-color-yellow-filled-hover: var(--mantine-color-yellow-9);\n  --mantine-color-yellow-light: rgba(250, 176, 5, 0.15);\n  --mantine-color-yellow-light-hover: rgba(250, 176, 5, 0.2);\n  --mantine-color-yellow-light-color: var(--mantine-color-yellow-3);\n  --mantine-color-yellow-outline: var(--mantine-color-yellow-4);\n  --mantine-color-yellow-outline-hover: rgba(255, 212, 59, 0.05);\n  --mantine-color-orange-text: var(--mantine-color-orange-4);\n  --mantine-color-orange-filled: var(--mantine-color-orange-8);\n  --mantine-color-orange-filled-hover: var(--mantine-color-orange-9);\n  --mantine-color-orange-light: rgba(253, 126, 20, 0.15);\n  --mantine-color-orange-light-hover: rgba(253, 126, 20, 0.2);\n  --mantine-color-orange-light-color: var(--mantine-color-orange-3);\n  --mantine-color-orange-outline: var(--mantine-color-orange-4);\n  --mantine-color-orange-outline-hover: rgba(255, 169, 77, 0.05);\n}\n\n:root[data-mantine-color-scheme='light'] {\n  --mantine-color-scheme: light;\n  --mantine-color-bright: var(--mantine-color-black);\n  --mantine-color-text: var(--mantine-color-black);\n  --mantine-color-body: var(--mantine-color-white);\n  --mantine-primary-color-contrast: var(--mantine-color-white);\n  --mantine-color-error: var(--mantine-color-red-6);\n  --mantine-color-placeholder: var(--mantine-color-gray-5);\n  --mantine-color-anchor: var(--mantine-primary-color-filled);\n  --mantine-color-default: var(--mantine-color-white);\n  --mantine-color-default-hover: var(--mantine-color-gray-0);\n  --mantine-color-default-color: var(--mantine-color-gray-9);\n  --mantine-color-default-border: var(--mantine-color-gray-4);\n  --mantine-color-dimmed: var(--mantine-color-gray-6);\n  --mantine-color-dark-text: var(--mantine-color-dark-filled);\n  --mantine-color-dark-filled: var(--mantine-color-dark-6);\n  --mantine-color-dark-filled-hover: var(--mantine-color-dark-7);\n  --mantine-color-dark-light: rgba(56, 56, 56, 0.1);\n  --mantine-color-dark-light-hover: rgba(56, 56, 56, 0.12);\n  --mantine-color-dark-light-color: var(--mantine-color-dark-6);\n  --mantine-color-dark-outline: var(--mantine-color-dark-6);\n  --mantine-color-dark-outline-hover: rgba(56, 56, 56, 0.05);\n  --mantine-color-gray-text: var(--mantine-color-gray-filled);\n  --mantine-color-gray-filled: var(--mantine-color-gray-6);\n  --mantine-color-gray-filled-hover: var(--mantine-color-gray-7);\n  --mantine-color-gray-light: rgba(134, 142, 150, 0.1);\n  --mantine-color-gray-light-hover: rgba(134, 142, 150, 0.12);\n  --mantine-color-gray-light-color: var(--mantine-color-gray-6);\n  --mantine-color-gray-outline: var(--mantine-color-gray-6);\n  --mantine-color-gray-outline-hover: rgba(134, 142, 150, 0.05);\n  --mantine-color-red-text: var(--mantine-color-red-filled);\n  --mantine-color-red-filled: var(--mantine-color-red-6);\n  --mantine-color-red-filled-hover: var(--mantine-color-red-7);\n  --mantine-color-red-light: rgba(250, 82, 82, 0.1);\n  --mantine-color-red-light-hover: rgba(250, 82, 82, 0.12);\n  --mantine-color-red-light-color: var(--mantine-color-red-6);\n  --mantine-color-red-outline: var(--mantine-color-red-6);\n  --mantine-color-red-outline-hover: rgba(250, 82, 82, 0.05);\n  --mantine-color-pink-text: var(--mantine-color-pink-filled);\n  --mantine-color-pink-filled: var(--mantine-color-pink-6);\n  --mantine-color-pink-filled-hover: var(--mantine-color-pink-7);\n  --mantine-color-pink-light: rgba(230, 73, 128, 0.1);\n  --mantine-color-pink-light-hover: rgba(230, 73, 128, 0.12);\n  --mantine-color-pink-light-color: var(--mantine-color-pink-6);\n  --mantine-color-pink-outline: var(--mantine-color-pink-6);\n  --mantine-color-pink-outline-hover: rgba(230, 73, 128, 0.05);\n  --mantine-color-grape-text: var(--mantine-color-grape-filled);\n  --mantine-color-grape-filled: var(--mantine-color-grape-6);\n  --mantine-color-grape-filled-hover: var(--mantine-color-grape-7);\n  --mantine-color-grape-light: rgba(190, 75, 219, 0.1);\n  --mantine-color-grape-light-hover: rgba(190, 75, 219, 0.12);\n  --mantine-color-grape-light-color: var(--mantine-color-grape-6);\n  --mantine-color-grape-outline: var(--mantine-color-grape-6);\n  --mantine-color-grape-outline-hover: rgba(190, 75, 219, 0.05);\n  --mantine-color-violet-text: var(--mantine-color-violet-filled);\n  --mantine-color-violet-filled: var(--mantine-color-violet-6);\n  --mantine-color-violet-filled-hover: var(--mantine-color-violet-7);\n  --mantine-color-violet-light: rgba(121, 80, 242, 0.1);\n  --mantine-color-violet-light-hover: rgba(121, 80, 242, 0.12);\n  --mantine-color-violet-light-color: var(--mantine-color-violet-6);\n  --mantine-color-violet-outline: var(--mantine-color-violet-6);\n  --mantine-color-violet-outline-hover: rgba(121, 80, 242, 0.05);\n  --mantine-color-indigo-text: var(--mantine-color-indigo-filled);\n  --mantine-color-indigo-filled: var(--mantine-color-indigo-6);\n  --mantine-color-indigo-filled-hover: var(--mantine-color-indigo-7);\n  --mantine-color-indigo-light: rgba(76, 110, 245, 0.1);\n  --mantine-color-indigo-light-hover: rgba(76, 110, 245, 0.12);\n  --mantine-color-indigo-light-color: var(--mantine-color-indigo-6);\n  --mantine-color-indigo-outline: var(--mantine-color-indigo-6);\n  --mantine-color-indigo-outline-hover: rgba(76, 110, 245, 0.05);\n  --mantine-color-blue-text: var(--mantine-color-blue-filled);\n  --mantine-color-blue-filled: var(--mantine-color-blue-6);\n  --mantine-color-blue-filled-hover: var(--mantine-color-blue-7);\n  --mantine-color-blue-light: rgba(34, 139, 230, 0.1);\n  --mantine-color-blue-light-hover: rgba(34, 139, 230, 0.12);\n  --mantine-color-blue-light-color: var(--mantine-color-blue-6);\n  --mantine-color-blue-outline: var(--mantine-color-blue-6);\n  --mantine-color-blue-outline-hover: rgba(34, 139, 230, 0.05);\n  --mantine-color-cyan-text: var(--mantine-color-cyan-filled);\n  --mantine-color-cyan-filled: var(--mantine-color-cyan-6);\n  --mantine-color-cyan-filled-hover: var(--mantine-color-cyan-7);\n  --mantine-color-cyan-light: rgba(21, 170, 191, 0.1);\n  --mantine-color-cyan-light-hover: rgba(21, 170, 191, 0.12);\n  --mantine-color-cyan-light-color: var(--mantine-color-cyan-6);\n  --mantine-color-cyan-outline: var(--mantine-color-cyan-6);\n  --mantine-color-cyan-outline-hover: rgba(21, 170, 191, 0.05);\n  --mantine-color-teal-text: var(--mantine-color-teal-filled);\n  --mantine-color-teal-filled: var(--mantine-color-teal-6);\n  --mantine-color-teal-filled-hover: var(--mantine-color-teal-7);\n  --mantine-color-teal-light: rgba(18, 184, 134, 0.1);\n  --mantine-color-teal-light-hover: rgba(18, 184, 134, 0.12);\n  --mantine-color-teal-light-color: var(--mantine-color-teal-6);\n  --mantine-color-teal-outline: var(--mantine-color-teal-6);\n  --mantine-color-teal-outline-hover: rgba(18, 184, 134, 0.05);\n  --mantine-color-green-text: var(--mantine-color-green-filled);\n  --mantine-color-green-filled: var(--mantine-color-green-6);\n  --mantine-color-green-filled-hover: var(--mantine-color-green-7);\n  --mantine-color-green-light: rgba(64, 192, 87, 0.1);\n  --mantine-color-green-light-hover: rgba(64, 192, 87, 0.12);\n  --mantine-color-green-light-color: var(--mantine-color-green-6);\n  --mantine-color-green-outline: var(--mantine-color-green-6);\n  --mantine-color-green-outline-hover: rgba(64, 192, 87, 0.05);\n  --mantine-color-lime-text: var(--mantine-color-lime-filled);\n  --mantine-color-lime-filled: var(--mantine-color-lime-6);\n  --mantine-color-lime-filled-hover: var(--mantine-color-lime-7);\n  --mantine-color-lime-light: rgba(130, 201, 30, 0.1);\n  --mantine-color-lime-light-hover: rgba(130, 201, 30, 0.12);\n  --mantine-color-lime-light-color: var(--mantine-color-lime-6);\n  --mantine-color-lime-outline: var(--mantine-color-lime-6);\n  --mantine-color-lime-outline-hover: rgba(130, 201, 30, 0.05);\n  --mantine-color-yellow-text: var(--mantine-color-yellow-filled);\n  --mantine-color-yellow-filled: var(--mantine-color-yellow-6);\n  --mantine-color-yellow-filled-hover: var(--mantine-color-yellow-7);\n  --mantine-color-yellow-light: rgba(250, 176, 5, 0.1);\n  --mantine-color-yellow-light-hover: rgba(250, 176, 5, 0.12);\n  --mantine-color-yellow-light-color: var(--mantine-color-yellow-6);\n  --mantine-color-yellow-outline: var(--mantine-color-yellow-6);\n  --mantine-color-yellow-outline-hover: rgba(250, 176, 5, 0.05);\n  --mantine-color-orange-text: var(--mantine-color-orange-filled);\n  --mantine-color-orange-filled: var(--mantine-color-orange-6);\n  --mantine-color-orange-filled-hover: var(--mantine-color-orange-7);\n  --mantine-color-orange-light: rgba(253, 126, 20, 0.1);\n  --mantine-color-orange-light-hover: rgba(253, 126, 20, 0.12);\n  --mantine-color-orange-light-color: var(--mantine-color-orange-6);\n  --mantine-color-orange-outline: var(--mantine-color-orange-6);\n  --mantine-color-orange-outline-hover: rgba(253, 126, 20, 0.05);\n}\n\n.m_d57069b5 {\n  --scrollarea-scrollbar-size: calc(0.75rem * var(--mantine-scale));\n\n  position: relative;\n  overflow: hidden;\n}\n\n.m_c0783ff9 {\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n  -webkit-overflow-scrolling: touch;\n  width: 100%;\n  height: 100%;\n}\n\n.m_c0783ff9::-webkit-scrollbar {\n    display: none;\n  }\n\n.m_c0783ff9:where([data-scrollbars='xy'], [data-scrollbars='y']):where([data-offset-scrollbars='xy'], [data-offset-scrollbars='y']) {\n      padding-inline-end: var(--scrollarea-scrollbar-size);\n      padding-inline-start: unset;\n    }\n\n.m_c0783ff9:where([data-scrollbars='xy'], [data-scrollbars='x']):where([data-offset-scrollbars='xy'], [data-offset-scrollbars='x']) {\n      padding-bottom: var(--scrollarea-scrollbar-size);\n    }\n\n.m_f8f631dd {\n  min-width: 100%;\n  display: table;\n}\n\n.m_c44ba933 {\n  user-select: none;\n  touch-action: none;\n  box-sizing: border-box;\n  transition:\n    background-color 150ms ease,\n    opacity 150ms ease;\n\n  padding: calc(var(--scrollarea-scrollbar-size) / 5);\n  display: flex;\n  background-color: transparent;\n  flex-direction: row;\n}\n\n@media (hover: hover) {\n    :where([data-mantine-color-scheme='light']) .m_c44ba933:hover {\n      background-color: var(--mantine-color-gray-0);\n  }\n\n      :where([data-mantine-color-scheme='light']) .m_c44ba933:hover > .m_d8b5e363 {\n        background-color: rgba(0, 0, 0, 0.5);\n      }\n\n    :where([data-mantine-color-scheme='dark']) .m_c44ba933:hover {\n      background-color: var(--mantine-color-dark-8);\n  }\n\n      :where([data-mantine-color-scheme='dark']) .m_c44ba933:hover > .m_d8b5e363 {\n        background-color: rgba(255, 255, 255, 0.5);\n      }\n}\n\n@media (hover: none) {\n    :where([data-mantine-color-scheme='light']) .m_c44ba933:active {\n      background-color: var(--mantine-color-gray-0);\n  }\n\n      :where([data-mantine-color-scheme='light']) .m_c44ba933:active > .m_d8b5e363 {\n        background-color: rgba(0, 0, 0, 0.5);\n      }\n\n    :where([data-mantine-color-scheme='dark']) .m_c44ba933:active {\n      background-color: var(--mantine-color-dark-8);\n  }\n\n      :where([data-mantine-color-scheme='dark']) .m_c44ba933:active > .m_d8b5e363 {\n        background-color: rgba(255, 255, 255, 0.5);\n      }\n}\n\n.m_c44ba933:where([data-hidden], [data-state='hidden']) {\n    display: none;\n  }\n\n.m_c44ba933:where([data-orientation='vertical']) {\n    width: var(--scrollarea-scrollbar-size);\n    top: 0;\n    bottom: var(--sa-corner-width);\n    inset-inline-end: 0;\n  }\n\n.m_c44ba933:where([data-orientation='horizontal']) {\n    height: var(--scrollarea-scrollbar-size);\n    flex-direction: column;\n    bottom: 0;\n    inset-inline-start: 0;\n    inset-inline-end: var(--sa-corner-width);\n  }\n\n.m_d8b5e363 {\n  flex: 1;\n  border-radius: var(--scrollarea-scrollbar-size);\n  position: relative;\n  transition: background-color 150ms ease;\n  overflow: hidden;\n}\n\n.m_d8b5e363::before {\n    content: '\"\"';\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 100%;\n    height: 100%;\n    min-width: calc(2.75rem * var(--mantine-scale));\n    min-height: calc(2.75rem * var(--mantine-scale));\n  }\n\n:where([data-mantine-color-scheme='light']) .m_d8b5e363 {\n    background-color: rgba(0, 0, 0, 0.4);\n}\n\n:where([data-mantine-color-scheme='dark']) .m_d8b5e363 {\n    background-color: rgba(255, 255, 255, 0.4);\n}\n\n.m_21657268 {\n  position: absolute;\n  opacity: 0;\n  transition: opacity 150ms ease;\n  display: block;\n  inset-inline-end: 0;\n  bottom: 0;\n}\n\n:where([data-mantine-color-scheme='light']) .m_21657268 {\n    background-color: var(--mantine-color-gray-0);\n}\n\n:where([data-mantine-color-scheme='dark']) .m_21657268 {\n    background-color: var(--mantine-color-dark-8);\n}\n\n.m_21657268:where([data-hovered]) {\n    opacity: 1;\n  }\n\n.m_21657268:where([data-hidden]) {\n    display: none;\n  }\n\n.m_87cf2631 {\n  background-color: transparent;\n  cursor: pointer;\n  border: 0;\n  padding: 0;\n  appearance: none;\n  font-size: var(--mantine-font-size-md);\n  text-align: left;\n  text-decoration: none;\n  color: inherit;\n  touch-action: manipulation;\n  -webkit-tap-highlight-color: transparent;\n}\n\n  :where([dir=\"rtl\"]) .m_87cf2631 {\n    text-align: right;\n}\n\n.m_515a97f8 {\n  border: 0;\n  clip: rect(0 0 0 0);\n  height: calc(0.0625rem * var(--mantine-scale));\n  width: calc(0.0625rem * var(--mantine-scale));\n  margin: calc(-0.0625rem * var(--mantine-scale));\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  white-space: nowrap;\n}\n\n.m_1b7284a3 {\n  --paper-radius: var(--mantine-radius-default);\n\n  outline: 0;\n  -webkit-tap-highlight-color: transparent;\n  display: block;\n  touch-action: manipulation;\n  text-decoration: none;\n  border-radius: var(--paper-radius);\n  box-shadow: var(--paper-shadow);\n  background-color: var(--mantine-color-body);\n}\n\n  :where([data-mantine-color-scheme='light']) .m_1b7284a3:where([data-with-border]) {\n      border: calc(0.0625rem * var(--mantine-scale)) solid var(--mantine-color-gray-3);\n}\n\n  :where([data-mantine-color-scheme='dark']) .m_1b7284a3:where([data-with-border]) {\n      border: calc(0.0625rem * var(--mantine-scale)) solid var(--mantine-color-dark-4);\n}\n\n.m_38a85659 {\n  position: absolute;\n  border: 1px solid var(--popover-border-color);\n  padding: var(--mantine-spacing-sm) var(--mantine-spacing-md);\n  box-shadow: var(--popover-shadow, none);\n  border-radius: var(--popover-radius, var(--mantine-radius-default));\n}\n\n  .m_38a85659:where([data-fixed]) {\n    position: fixed;\n  }\n\n  .m_38a85659:focus {\n    outline: none;\n  }\n\n  :where([data-mantine-color-scheme='light']) .m_38a85659 {\n    --popover-border-color: var(--mantine-color-gray-2);\n    background-color: var(--mantine-color-white);\n}\n\n  :where([data-mantine-color-scheme='dark']) .m_38a85659 {\n    --popover-border-color: var(--mantine-color-dark-4);\n    background-color: var(--mantine-color-dark-6);\n}\n\n.m_a31dc6c1 {\n  background-color: inherit;\n  border: 1px solid var(--popover-border-color);\n  z-index: 1;\n}\n\n.m_5ae2e3c {\n  --loader-size-xs: calc(1.125rem * var(--mantine-scale));\n  --loader-size-sm: calc(1.375rem * var(--mantine-scale));\n  --loader-size-md: calc(2.25rem * var(--mantine-scale));\n  --loader-size-lg: calc(2.75rem * var(--mantine-scale));\n  --loader-size-xl: calc(3.625rem * var(--mantine-scale));\n  --loader-size: var(--loader-size-md);\n  --loader-color: var(--mantine-primary-color-filled);\n}\n\n/* ----- Bars loader ----- */\n@keyframes m_5d2b3b9d {\n  0% {\n    transform: scale(0.6);\n    opacity: 0;\n  }\n\n  50%,\n  100% {\n    transform: scale(1);\n  }\n}\n\n.m_7a2bd4cd {\n  position: relative;\n  width: var(--loader-size);\n  height: var(--loader-size);\n  display: flex;\n  gap: calc(var(--loader-size) / 5);\n}\n\n.m_870bb79 {\n  flex: 1;\n  background: var(--loader-color);\n  animation: m_5d2b3b9d 1.2s cubic-bezier(0, 0.5, 0.5, 1) infinite;\n  border-radius: calc(0.125rem * var(--mantine-scale));\n}\n\n.m_870bb79:nth-of-type(1) {\n    animation-delay: -240ms;\n  }\n\n.m_870bb79:nth-of-type(2) {\n    animation-delay: -120ms;\n  }\n\n.m_870bb79:nth-of-type(3) {\n    animation-delay: 0;\n  }\n\n/* ----- Dots loader ----- */\n@keyframes m_aac34a1 {\n  0%,\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n\n  50% {\n    transform: scale(0.6);\n    opacity: 0.5;\n  }\n}\n\n.m_4e3f22d7 {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: calc(var(--loader-size) / 10);\n  position: relative;\n  width: var(--loader-size);\n  height: var(--loader-size);\n}\n\n.m_870c4af {\n  width: calc(var(--loader-size) / 3 - var(--loader-size) / 15);\n  height: calc(var(--loader-size) / 3 - var(--loader-size) / 15);\n  border-radius: 50%;\n  background: var(--loader-color);\n  animation: m_aac34a1 0.8s infinite linear;\n}\n\n.m_870c4af:nth-child(2) {\n    animation-delay: 0.4s;\n  }\n\n/* ----- Oval loader ----- */\n@keyframes m_f8e89c4b {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.m_b34414df {\n  display: inline-block;\n  width: var(--loader-size);\n  height: var(--loader-size);\n}\n\n.m_b34414df::after {\n    content: '';\n    display: block;\n    width: var(--loader-size);\n    height: var(--loader-size);\n    border-radius: calc(625rem * var(--mantine-scale));\n    border-width: calc(var(--loader-size) / 8);\n    border-style: solid;\n    border-color: var(--loader-color) var(--loader-color) var(--loader-color) transparent;\n    animation: m_f8e89c4b 1.2s linear infinite;\n  }\n\n.m_8d3f4000 {\n  --ai-size-xs: calc(1.125rem * var(--mantine-scale));\n  --ai-size-sm: calc(1.375rem * var(--mantine-scale));\n  --ai-size-md: calc(1.75rem * var(--mantine-scale));\n  --ai-size-lg: calc(2.125rem * var(--mantine-scale));\n  --ai-size-xl: calc(2.75rem * var(--mantine-scale));\n\n  --ai-size-input-xs: calc(1.875rem * var(--mantine-scale));\n  --ai-size-input-sm: calc(2.25rem * var(--mantine-scale));\n  --ai-size-input-md: calc(2.625rem * var(--mantine-scale));\n  --ai-size-input-lg: calc(3.125rem * var(--mantine-scale));\n  --ai-size-input-xl: calc(3.75rem * var(--mantine-scale));\n\n  --ai-size: var(--ai-size-md);\n  --ai-color: var(--mantine-color-white);\n\n  line-height: 1;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  user-select: none;\n  overflow: hidden;\n\n  width: var(--ai-size);\n  height: var(--ai-size);\n  min-width: var(--ai-size);\n  min-height: var(--ai-size);\n  border-radius: var(--ai-radius, var(--mantine-radius-default));\n  background: var(--ai-bg, var(--mantine-primary-color-filled));\n  color: var(--ai-color, var(--mantine-color-white));\n  border: var(--ai-bd, calc(0.0625rem * var(--mantine-scale)) solid transparent);\n  cursor: pointer;\n}\n\n  @media (hover: hover) {\n    .m_8d3f4000:hover:where(:not([data-loading], :disabled, [data-disabled])) {\n      background-color: var(--ai-hover, var(--mantine-primary-color-filled-hover));\n      color: var(--ai-hover-color, var(--ai-color));\n    }\n}\n\n  @media (hover: none) {\n    .m_8d3f4000:active:where(:not([data-loading], :disabled, [data-disabled])) {\n      background-color: var(--ai-hover, var(--mantine-primary-color-filled-hover));\n      color: var(--ai-hover-color, var(--ai-color));\n    }\n}\n\n  .m_8d3f4000[data-loading] {\n    cursor: not-allowed;\n  }\n\n  .m_8d3f4000[data-loading] .m_8d3afb97 {\n      opacity: 0;\n      transform: translateY(100%);\n    }\n\n  .m_8d3f4000:where(:disabled:not([data-loading]), [data-disabled]:not([data-loading])) {\n    cursor: not-allowed;\n    border: calc(0.0625rem * var(--mantine-scale)) solid transparent;\n  }\n\n  :where([data-mantine-color-scheme='light']) .m_8d3f4000:where(:disabled:not([data-loading]), [data-disabled]:not([data-loading])) {\n      background-color: var(--mantine-color-gray-1);\n      color: var(--mantine-color-gray-5);\n}\n\n  :where([data-mantine-color-scheme='dark']) .m_8d3f4000:where(:disabled:not([data-loading]), [data-disabled]:not([data-loading])) {\n      background-color: var(--mantine-color-dark-6);\n      color: var(--mantine-color-dark-3);\n}\n\n  .m_8d3f4000:where(:disabled:not([data-loading]), [data-disabled]:not([data-loading])):active {\n      transform: none;\n    }\n\n.m_302b9fb1 {\n  inset: calc(-0.0625rem * var(--mantine-scale));\n  position: absolute;\n  border-radius: var(--ai-radius, var(--mantine-radius-default));\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n:where([data-mantine-color-scheme='light']) .m_302b9fb1 {\n    background-color: rgba(255, 255, 255, 0.15);\n}\n\n:where([data-mantine-color-scheme='dark']) .m_302b9fb1 {\n    background-color: rgba(0, 0, 0, 0.15);\n}\n\n.m_1a0f1b21 {\n  --ai-border-width: calc(0.0625rem * var(--mantine-scale));\n  display: flex;\n}\n\n.m_1a0f1b21 :where(*):focus {\n      position: relative;\n      z-index: 1;\n    }\n\n.m_1a0f1b21[data-orientation='horizontal'] {\n    flex-direction: row;\n  }\n\n.m_1a0f1b21[data-orientation='horizontal'] .m_8d3f4000:not(:only-child):first-child {\n        border-end-end-radius: 0;\n        border-start-end-radius: 0;\n        border-inline-end-width: calc(var(--ai-border-width) / 2);\n      }\n\n.m_1a0f1b21[data-orientation='horizontal'] .m_8d3f4000:not(:only-child):last-child {\n        border-end-start-radius: 0;\n        border-start-start-radius: 0;\n        border-inline-start-width: calc(var(--ai-border-width) / 2);\n      }\n\n.m_1a0f1b21[data-orientation='horizontal'] .m_8d3f4000:not(:only-child):not(:first-child):not(:last-child) {\n        border-radius: 0;\n        border-inline-width: calc(var(--ai-border-width) / 2);\n      }\n\n.m_1a0f1b21[data-orientation='vertical'] {\n    flex-direction: column;\n  }\n\n.m_1a0f1b21[data-orientation='vertical'] .m_8d3f4000:not(:only-child):first-child {\n        border-end-start-radius: 0;\n        border-end-end-radius: 0;\n        border-bottom-width: calc(var(--ai-border-width) / 2);\n      }\n\n.m_1a0f1b21[data-orientation='vertical'] .m_8d3f4000:not(:only-child):last-child {\n        border-start-start-radius: 0;\n        border-start-end-radius: 0;\n        border-top-width: calc(var(--ai-border-width) / 2);\n      }\n\n.m_1a0f1b21[data-orientation='vertical'] .m_8d3f4000:not(:only-child):not(:first-child):not(:last-child) {\n        border-radius: 0;\n        border-bottom-width: calc(var(--ai-border-width) / 2);\n        border-top-width: calc(var(--ai-border-width) / 2);\n      }\n\n.m_8d3afb97 {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition:\n    transform 150ms ease,\n    opacity 100ms ease;\n  width: 100%;\n  height: 100%;\n}\n\n.m_86a44da5 {\n  --cb-size-xs: calc(1.125rem * var(--mantine-scale));\n  --cb-size-sm: calc(1.375rem * var(--mantine-scale));\n  --cb-size-md: calc(1.75rem * var(--mantine-scale));\n  --cb-size-lg: calc(2.125rem * var(--mantine-scale));\n  --cb-size-xl: calc(2.75rem * var(--mantine-scale));\n\n  --cb-size: var(--cb-size-md);\n  --cb-icon-size: 70%;\n  --cb-radius: var(--mantine-radius-default);\n\n  line-height: 1;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  user-select: none;\n\n  width: var(--cb-size);\n  height: var(--cb-size);\n  min-width: var(--cb-size);\n  min-height: var(--cb-size);\n  border-radius: var(--cb-radius);\n}\n\n  :where([data-mantine-color-scheme='light']) .m_86a44da5 {\n    color: var(--mantine-color-gray-7);\n}\n\n  :where([data-mantine-color-scheme='dark']) .m_86a44da5 {\n    color: var(--mantine-color-dark-1);\n}\n\n  .m_86a44da5[data-disabled],\n  .m_86a44da5:disabled {\n    cursor: not-allowed;\n    opacity: 0.6;\n  }\n\n@media (hover: hover) {\n    :where([data-mantine-color-scheme='light']) .m_220c80f2:where(:not([data-disabled], :disabled)):hover {\n      background-color: var(--mantine-color-gray-0);\n  }\n\n    :where([data-mantine-color-scheme='dark']) .m_220c80f2:where(:not([data-disabled], :disabled)):hover {\n      background-color: var(--mantine-color-dark-6);\n  }\n}\n\n@media (hover: none) {\n    :where([data-mantine-color-scheme='light']) .m_220c80f2:where(:not([data-disabled], :disabled)):active {\n      background-color: var(--mantine-color-gray-0);\n  }\n\n    :where([data-mantine-color-scheme='dark']) .m_220c80f2:where(:not([data-disabled], :disabled)):active {\n      background-color: var(--mantine-color-dark-6);\n  }\n}\n\n.m_4081bf90 {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: var(--group-wrap, wrap);\n  justify-content: var(--group-justify, flex-start);\n  align-items: var(--group-align, center);\n  gap: var(--group-gap, var(--mantine-spacing-md));\n}\n\n  .m_4081bf90:where([data-grow]) > * {\n      flex-grow: 1;\n      max-width: var(--group-child-width);\n    }\n\n.m_9814e45f {\n  inset: 0;\n  position: absolute;\n  background: var(--overlay-bg, rgba(0, 0, 0, 0.6));\n  backdrop-filter: var(--overlay-filter);\n  -webkit-backdrop-filter: var(--overlay-filter);\n  border-radius: var(--overlay-radius, 0);\n  z-index: var(--overlay-z-index);\n}\n\n  .m_9814e45f:where([data-fixed]) {\n    position: fixed;\n  }\n\n  .m_9814e45f:where([data-center]) {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n.m_615af6c9 {\n  line-height: 1;\n  padding: 0;\n  margin: 0;\n  font-weight: 400;\n  font-size: var(--mantine-font-size-md);\n}\n\n.m_b5489c3c {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: var(--mb-padding, var(--mantine-spacing-md));\n  padding-inline-end: calc(var(--mb-padding, var(--mantine-spacing-md)) - calc(0.3125rem * var(--mantine-scale)));\n  position: sticky;\n  top: 0;\n  background-color: var(--mantine-color-body);\n  z-index: 1000;\n  min-height: calc(3.75rem * var(--mantine-scale));\n  transition: padding-inline-end 100ms;\n}\n\n.m_60c222c7 {\n  position: fixed;\n  width: 100%;\n  top: 0;\n  bottom: 0;\n  z-index: var(--mb-z-index);\n  pointer-events: none;\n}\n\n.m_fd1ab0aa {\n  pointer-events: all;\n  box-shadow: var(--mb-shadow, var(--mantine-shadow-xl));\n}\n\n.m_fd1ab0aa [data-mantine-scrollbar] {\n    z-index: 1001;\n  }\n\n.m_fd1ab0aa:has([data-mantine-scrollbar][data-state='visible']) .m_b5489c3c {\n    padding-inline-end: calc(var(--mb-padding, var(--mantine-spacing-md)) + calc(0.3125rem * var(--mantine-scale)));\n  }\n\n.m_606cb269 {\n  margin-inline-start: auto;\n}\n\n.m_5df29311 {\n  padding: var(--mb-padding, var(--mantine-spacing-md));\n  padding-top: var(--mb-padding, var(--mantine-spacing-md));\n}\n\n.m_5df29311:where(:not(:only-child)) {\n    padding-top: 0;\n  }\n\n.m_6c018570 {\n  position: relative;\n  margin-top: var(--input-margin-top, 0rem);\n  margin-bottom: var(--input-margin-bottom, 0rem);\n\n  --input-height-xs: calc(1.875rem * var(--mantine-scale));\n  --input-height-sm: calc(2.25rem * var(--mantine-scale));\n  --input-height-md: calc(2.625rem * var(--mantine-scale));\n  --input-height-lg: calc(3.125rem * var(--mantine-scale));\n  --input-height-xl: calc(3.75rem * var(--mantine-scale));\n\n  --input-padding-y-xs: calc(0.3125rem * var(--mantine-scale));\n  --input-padding-y-sm: calc(0.375rem * var(--mantine-scale));\n  --input-padding-y-md: calc(0.5rem * var(--mantine-scale));\n  --input-padding-y-lg: calc(0.625rem * var(--mantine-scale));\n  --input-padding-y-xl: calc(0.8125rem * var(--mantine-scale));\n\n  --input-height: var(--input-height-sm);\n  --input-radius: var(--mantine-radius-default);\n\n  --input-cursor: text;\n  --input-text-align: left;\n  --input-line-height: calc(var(--input-height) - calc(0.125rem * var(--mantine-scale)));\n  --input-padding: calc(var(--input-height) / 3);\n  --input-padding-inline-start: var(--input-padding);\n  --input-padding-inline-end: var(--input-padding);\n  --input-placeholder-color: var(--mantine-color-placeholder);\n  --input-color: var(--mantine-color-text);\n\n  --input-left-section-size: var(--input-left-section-width, calc(var(--input-height) - calc(0.125rem * var(--mantine-scale))));\n\n  --input-right-section-size: var(\n    --input-right-section-width,\n    calc(var(--input-height) - calc(0.125rem * var(--mantine-scale)))\n  );\n\n  --input-size: var(--input-height);\n\n  --section-y: calc(0.0625rem * var(--mantine-scale));\n  --left-section-start: calc(0.0625rem * var(--mantine-scale));\n  --left-section-border-radius: var(--input-radius) 0 0 var(--input-radius);\n\n  --right-section-end: calc(0.0625rem * var(--mantine-scale));\n  --right-section-border-radius: 0 var(--input-radius) var(--input-radius) 0;\n}\n\n  .m_6c018570[data-variant='unstyled'] {\n    --input-padding: 0;\n    --input-padding-y: 0;\n    --input-padding-inline-start: 0;\n    --input-padding-inline-end: 0;\n  }\n\n  .m_6c018570[data-pointer] {\n    --input-cursor: pointer;\n  }\n\n  .m_6c018570[data-multiline] {\n    --input-padding-y-xs: calc(0.28125rem * var(--mantine-scale));\n    --input-padding-y-sm: calc(0.34375rem * var(--mantine-scale));\n    --input-padding-y-md: calc(0.4375rem * var(--mantine-scale));\n    --input-padding-y-lg: calc(0.59375rem * var(--mantine-scale));\n    --input-padding-y-xl: calc(0.8125rem * var(--mantine-scale));\n\n    --input-size: auto;\n    --input-line-height: var(--mantine-line-height);\n    --input-padding-y: var(--input-padding-y-sm);\n  }\n\n  .m_6c018570[data-with-left-section] {\n    --input-padding-inline-start: var(--input-left-section-size);\n  }\n\n  .m_6c018570[data-with-right-section] {\n    --input-padding-inline-end: var(--input-right-section-size);\n  }\n\n  [data-mantine-color-scheme='light'] .m_6c018570 {\n    --input-disabled-bg: var(--mantine-color-gray-1);\n    --input-disabled-color: var(--mantine-color-gray-6);\n}\n\n  [data-mantine-color-scheme='light'] .m_6c018570[data-variant='default'] {\n      --input-bd: var(--mantine-color-gray-4);\n      --input-bg: var(--mantine-color-white);\n      --input-bd-focus: var(--mantine-primary-color-filled);\n    }\n\n  [data-mantine-color-scheme='light'] .m_6c018570[data-variant='filled'] {\n      --input-bd: transparent;\n      --input-bg: var(--mantine-color-gray-1);\n      --input-bd-focus: var(--mantine-primary-color-filled);\n    }\n\n  [data-mantine-color-scheme='light'] .m_6c018570[data-variant='unstyled'] {\n      --input-bd: transparent;\n      --input-bg: transparent;\n      --input-bd-focus: transparent;\n    }\n\n  [data-mantine-color-scheme='dark'] .m_6c018570 {\n    --input-disabled-bg: var(--mantine-color-dark-6);\n    --input-disabled-color: var(--mantine-color-dark-2);\n}\n\n  [data-mantine-color-scheme='dark'] .m_6c018570[data-variant='default'] {\n      --input-bd: var(--mantine-color-dark-4);\n      --input-bg: var(--mantine-color-dark-6);\n      --input-bd-focus: var(--mantine-primary-color-filled);\n    }\n\n  [data-mantine-color-scheme='dark'] .m_6c018570[data-variant='filled'] {\n      --input-bd: transparent;\n      --input-bg: var(--mantine-color-dark-5);\n      --input-bd-focus: var(--mantine-primary-color-filled);\n    }\n\n  [data-mantine-color-scheme='dark'] .m_6c018570[data-variant='unstyled'] {\n      --input-bd: transparent;\n      --input-bg: transparent;\n      --input-bd-focus: transparent;\n    }\n\n  [data-mantine-color-scheme] .m_6c018570[data-error]:not([data-variant='unstyled']) {\n      --input-bd: var(--mantine-color-error);\n    }\n\n  [data-mantine-color-scheme] .m_6c018570[data-error] {\n\n    --input-color: var(--mantine-color-error);\n    --input-placeholder-color: var(--mantine-color-error);\n    --input-section-color: var(--mantine-color-error);\n}\n\n  :where([dir=\"rtl\"]) .m_6c018570 {\n    --input-text-align: right;\n    --left-section-border-radius: 0 var(--input-radius) var(--input-radius) 0;\n    --right-section-border-radius: var(--input-radius) 0 0 var(--input-radius);\n}\n\n.m_8fb7ebe7 {\n  -webkit-tap-highlight-color: transparent;\n  appearance: none;\n  resize: var(--input-resize, none);\n  display: block;\n  width: 100%;\n  transition: border-color 100ms ease;\n\n  text-align: var(--input-text-align);\n  color: var(--input-color);\n  border: calc(0.0625rem * var(--mantine-scale)) solid var(--input-bd);\n  background-color: var(--input-bg);\n  font-family: var(--input-font-family, var(--mantine-font-family));\n  height: var(--input-size);\n  min-height: var(--input-height);\n  line-height: var(--input-line-height);\n  font-size: var(--input-fz, var(--input-fz, var(--mantine-font-size-sm)));\n  border-radius: var(--input-radius);\n  padding-inline-start: var(--input-padding-inline-start);\n  padding-inline-end: var(--input-padding-inline-end);\n  padding-top: var(--input-padding-y, 0rem);\n  padding-bottom: var(--input-padding-y, 0rem);\n  cursor: var(--input-cursor);\n  overflow: var(--input-overflow);\n}\n\n/* Used as data attribute in Textarea component, does not have associated prop on the Input component */\n\n.m_8fb7ebe7[data-no-overflow] {\n    --input-overflow: hidden;\n  }\n\n/* Used as data attribute in JsonInput component, does not have associated prop on the Input component */\n\n.m_8fb7ebe7[data-monospace] {\n    --input-font-family: var(--mantine-font-family-monospace);\n    --input-fz: calc(var(--input-fz, var(--mantine-font-size-sm)) - calc(0.125rem * var(--mantine-scale)));\n  }\n\n.m_8fb7ebe7:focus,\n  .m_8fb7ebe7:focus-within {\n    outline: none;\n    --input-bd: var(--input-bd-focus);\n  }\n\n[data-error] .m_8fb7ebe7:focus, [data-error] .m_8fb7ebe7:focus-within {\n      --input-bd: var(--mantine-color-error);\n    }\n\n.m_8fb7ebe7::placeholder {\n    color: var(--input-placeholder-color);\n    opacity: 1;\n  }\n\n.m_8fb7ebe7::-webkit-inner-spin-button,\n  .m_8fb7ebe7::-webkit-outer-spin-button,\n  .m_8fb7ebe7::-webkit-search-decoration,\n  .m_8fb7ebe7::-webkit-search-cancel-button,\n  .m_8fb7ebe7::-webkit-search-results-button,\n  .m_8fb7ebe7::-webkit-search-results-decoration {\n    appearance: none;\n  }\n\n.m_8fb7ebe7[type='number'] {\n    -moz-appearance: textfield;\n  }\n\n.m_8fb7ebe7:disabled,\n  .m_8fb7ebe7[data-disabled] {\n    cursor: not-allowed;\n    opacity: 0.6;\n    background-color: var(--input-disabled-bg);\n    color: var(--input-disabled-color);\n  }\n\n/* Required to be a separate selector to work in Firefox, can be merged with &:disabled once :has is supported */\n\n.m_8fb7ebe7:has(input:disabled) {\n    cursor: not-allowed;\n    opacity: 0.6;\n    background-color: var(--input-disabled-bg);\n    color: var(--input-disabled-color);\n  }\n\n.m_82577fc2 {\n  pointer-events: var(--section-pointer-events);\n  position: absolute;\n  z-index: 1;\n  inset-inline-start: var(--section-start);\n  inset-inline-end: var(--section-end);\n  bottom: var(--section-y);\n  top: var(--section-y);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: var(--section-size);\n  border-radius: var(--section-border-radius);\n  color: var(--input-section-color, var(--mantine-color-dimmed));\n}\n\n.m_82577fc2[data-position='right'] {\n    --section-pointer-events: var(--input-right-section-pointer-events);\n    --section-end: var(--right-section-end);\n    --section-size: var(--input-right-section-size);\n    --section-border-radius: var(--right-section-border-radius);\n  }\n\n.m_82577fc2[data-position='left'] {\n    --section-pointer-events: var(--input-left-section-pointer-events);\n    --section-start: var(--left-section-start);\n    --section-size: var(--input-left-section-size);\n    --section-border-radius: var(--left-section-border-radius);\n  }\n\n/* ----- Input.Placeholder ----- */\n.m_88bacfd0 {\n  color: var(--input-placeholder-color, var(--mantine-color-placeholder));\n}\n[data-error] .m_88bacfd0 {\n    --input-placeholder-color: var(--input-color, var(--mantine-color-placeholder));\n  }\n\n/* ----- Input.Wrapper ----- */\n.m_46b77525 {\n  line-height: var(--mantine-line-height);\n}\n\n.m_8fdc1311 {\n  display: inline-block;\n  font-weight: 500;\n  word-break: break-word;\n  cursor: default;\n  -webkit-tap-highlight-color: transparent;\n  font-size: var(--input-label-size, var(--mantine-font-size-sm));\n}\n\n.m_78a94662 {\n  color: var(--input-asterisk-color, var(--mantine-color-error));\n}\n\n.m_8f816625,\n.m_fe47ce59 {\n  word-wrap: break-word;\n  line-height: 1.2;\n  display: block;\n  margin: 0;\n  padding: 0;\n}\n\n.m_8f816625 {\n  color: var(--mantine-color-error);\n  font-size: var(--input-error-size, calc(var(--mantine-font-size-sm) - calc(0.125rem * var(--mantine-scale))));\n}\n\n.m_fe47ce59 {\n  color: var(--mantine-color-dimmed);\n  font-size: var(--input-description-size, calc(var(--mantine-font-size-sm) - calc(0.125rem * var(--mantine-scale))));\n}\n\n.m_8bffd616 {\n  display: flex;\n}\n\n.m_96b553a6 {\n  --transition-duration: 150ms;\n\n  top: 0;\n  left: 0;\n  position: absolute;\n  z-index: 0;\n  transition-property: transform, width, height;\n  transition-timing-function: ease;\n  transition-duration: 0ms;\n}\n\n  .m_96b553a6:where([data-initialized]) {\n    transition-duration: var(--transition-duration);\n  }\n\n  .m_96b553a6:where([data-hidden]) {\n    background-color: red;\n    display: none;\n  }\n\n.m_9bdbb667 {\n  --accordion-radius: var(--mantine-radius-default);\n}\n\n.m_df78851f {\n  word-break: break-word;\n}\n\n.m_4ba554d4 {\n  padding: var(--mantine-spacing-md);\n  padding-top: calc(var(--mantine-spacing-xs) / 2);\n}\n\n.m_8fa820a0 {\n  margin: 0;\n  padding: 0;\n}\n\n.m_4ba585b8 {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  flex-direction: row-reverse;\n  padding-inline: var(--mantine-spacing-md);\n  opacity: 1;\n  cursor: pointer;\n  background-color: transparent;\n}\n\n.m_4ba585b8:where([data-chevron-position='left']) {\n    flex-direction: row;\n    padding-inline-start: 0;\n  }\n\n:where([data-mantine-color-scheme='light']) .m_4ba585b8 {\n    color: var(--mantine-color-black);\n}\n\n:where([data-mantine-color-scheme='dark']) .m_4ba585b8 {\n    color: var(--mantine-color-dark-0);\n}\n\n.m_4ba585b8:where(:disabled, [data-disabled]) {\n    opacity: 0.4;\n    cursor: not-allowed;\n  }\n\n@media (hover: hover) {\n      :where([data-mantine-color-scheme='light']) .m_6939a5e9:where(:not(:disabled, [data-disabled])):hover, :where([data-mantine-color-scheme='light']) .m_4271d21b:where(:not(:disabled, [data-disabled])):hover {\n        background-color: var(--mantine-color-gray-0);\n  }\n\n      :where([data-mantine-color-scheme='dark']) .m_6939a5e9:where(:not(:disabled, [data-disabled])):hover, :where([data-mantine-color-scheme='dark']) .m_4271d21b:where(:not(:disabled, [data-disabled])):hover {\n        background-color: var(--mantine-color-dark-6);\n  }\n}\n\n@media (hover: none) {\n      :where([data-mantine-color-scheme='light']) .m_6939a5e9:where(:not(:disabled, [data-disabled])):active, :where([data-mantine-color-scheme='light']) .m_4271d21b:where(:not(:disabled, [data-disabled])):active {\n        background-color: var(--mantine-color-gray-0);\n  }\n\n      :where([data-mantine-color-scheme='dark']) .m_6939a5e9:where(:not(:disabled, [data-disabled])):active, :where([data-mantine-color-scheme='dark']) .m_4271d21b:where(:not(:disabled, [data-disabled])):active {\n        background-color: var(--mantine-color-dark-6);\n  }\n}\n\n.m_df3ffa0f {\n  color: inherit;\n  font-weight: 400;\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  padding-top: var(--mantine-spacing-sm);\n  padding-bottom: var(--mantine-spacing-sm);\n}\n\n.m_3f35ae96 {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  transition: transform var(--accordion-transition-duration, 200ms) ease;\n  width: var(--accordion-chevron-size, calc(0.9375rem * var(--mantine-scale)));\n  min-width: var(--accordion-chevron-size, calc(0.9375rem * var(--mantine-scale)));\n  transform: rotate(0deg);\n}\n\n.m_3f35ae96:where([data-rotate]) {\n    transform: rotate(180deg);\n  }\n\n.m_3f35ae96:where([data-position='left']) {\n    margin-inline-end: var(--mantine-spacing-md);\n    margin-inline-start: var(--mantine-spacing-md);\n  }\n\n.m_9bd771fe {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-inline-end: var(--mantine-spacing-sm);\n}\n\n.m_9bd771fe:where([data-chevron-position='left']) {\n    margin-inline-end: 0;\n    margin-inline-start: var(--mantine-spacing-lg);\n  }\n\n:where([data-mantine-color-scheme='light']) .m_9bd7b098 {\n    --item-border-color: var(--mantine-color-gray-3);\n    --item-filled-color: var(--mantine-color-gray-0);\n}\n\n:where([data-mantine-color-scheme='dark']) .m_9bd7b098 {\n    --item-border-color: var(--mantine-color-dark-4);\n    --item-filled-color: var(--mantine-color-dark-6);\n}\n\n.m_fe19b709 {\n  border-bottom: 1px solid var(--item-border-color);\n}\n\n.m_1f921b3b {\n  border: 1px solid var(--item-border-color);\n  transition: background-color 150ms ease;\n}\n\n.m_1f921b3b:where([data-active]) {\n    background-color: var(--item-filled-color);\n  }\n\n.m_1f921b3b:first-of-type {\n    border-start-start-radius: var(--accordion-radius);\n    border-start-end-radius: var(--accordion-radius);\n  }\n\n.m_1f921b3b:first-of-type > [data-accordion-control] {\n      border-start-start-radius: var(--accordion-radius);\n      border-start-end-radius: var(--accordion-radius);\n    }\n\n.m_1f921b3b:last-of-type {\n    border-end-start-radius: var(--accordion-radius);\n    border-end-end-radius: var(--accordion-radius);\n  }\n\n.m_1f921b3b:last-of-type > [data-accordion-control] {\n      border-end-start-radius: var(--accordion-radius);\n      border-end-end-radius: var(--accordion-radius);\n    }\n\n.m_1f921b3b + .m_1f921b3b {\n    border-top: 0;\n  }\n\n.m_2cdf939a {\n  border-radius: var(--accordion-radius);\n}\n\n.m_2cdf939a:where([data-active]) {\n    background-color: var(--item-filled-color);\n  }\n\n.m_9f59b069 {\n  background-color: var(--item-filled-color);\n  border-radius: var(--accordion-radius);\n  border: calc(0.0625rem * var(--mantine-scale)) solid transparent;\n  transition: background-color 150ms ease;\n}\n\n.m_9f59b069[data-active] {\n    border-color: var(--item-border-color);\n  }\n\n:where([data-mantine-color-scheme='light']) .m_9f59b069[data-active] {\n      background-color: var(--mantine-color-white);\n}\n\n:where([data-mantine-color-scheme='dark']) .m_9f59b069[data-active] {\n      background-color: var(--mantine-color-dark-7);\n}\n\n.m_9f59b069 + .m_9f59b069 {\n    margin-top: var(--mantine-spacing-md);\n  }\n\n.m_7f854edf {\n  position: fixed;\n  z-index: var(--affix-z-index);\n  inset-inline-start: var(--affix-left);\n  inset-inline-end: var(--affix-right);\n  top: var(--affix-top);\n  bottom: var(--affix-bottom);\n}\n\n.m_66836ed3 {\n  --alert-radius: var(--mantine-radius-default);\n  --alert-bg: var(--mantine-primary-color-light);\n  --alert-bd: calc(0.0625rem * var(--mantine-scale)) solid transparent;\n  --alert-color: var(--mantine-primary-color-light-color);\n\n  padding: var(--mantine-spacing-md) var(--mantine-spacing-md);\n  border-radius: var(--alert-radius);\n  position: relative;\n  overflow: hidden;\n  background-color: var(--alert-bg);\n  border: var(--alert-bd);\n  color: var(--alert-color);\n}\n\n.m_a5d60502 {\n  display: flex;\n}\n\n.m_667c2793 {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: var(--mantine-spacing-xs);\n}\n\n.m_6a03f287 {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: var(--mantine-font-size-sm);\n  font-weight: 700;\n}\n\n.m_6a03f287:where([data-with-close-button]) {\n    padding-inline-end: var(--mantine-spacing-md);\n  }\n\n.m_698f4f23 {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.m_667f2a6a {\n  line-height: 1;\n  width: calc(1.25rem * var(--mantine-scale));\n  height: calc(1.25rem * var(--mantine-scale));\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  margin-inline-end: var(--mantine-spacing-md);\n  margin-top: calc(0.0625rem * var(--mantine-scale));\n}\n\n.m_7fa78076 {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  font-size: var(--mantine-font-size-sm);\n}\n\n:where([data-mantine-color-scheme='light']) .m_7fa78076 {\n    color: var(--mantine-color-black);\n}\n\n:where([data-mantine-color-scheme='dark']) .m_7fa78076 {\n    color: var(--mantine-color-white);\n}\n\n.m_7fa78076:where([data-variant='filled']) {\n    color: var(--alert-color);\n  }\n\n.m_7fa78076:where([data-variant='white']) {\n    color: var(--mantine-color-black);\n  }\n\n.m_87f54839 {\n  width: calc(1.25rem * var(--mantine-scale));\n  height: calc(1.25rem * var(--mantine-scale));\n  color: var(--alert-color);\n}\n\n.m_b6d8b162 {\n  -webkit-tap-highlight-color: transparent;\n  text-decoration: none;\n  font-size: var(--text-fz, var(--mantine-font-size-md));\n  line-height: var(--text-lh, var(--mantine-line-height-md));\n  font-weight: normal;\n  margin: 0;\n  padding: 0;\n  color: var(--text-color);\n}\n\n  .m_b6d8b162:where([data-truncate]) {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .m_b6d8b162:where([data-truncate='start']) {\n    direction: rtl;\n    text-align: right;\n  }\n\n  :where([dir=\"rtl\"]) .m_b6d8b162:where([data-truncate='start']) {\n      direction: ltr;\n      text-align: left;\n}\n\n  .m_b6d8b162:where([data-variant='gradient']) {\n    background-image: var(--text-gradient);\n    background-clip: text;\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n  }\n\n  .m_b6d8b162:where([data-line-clamp]) {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-line-clamp: var(--text-line-clamp);\n    -webkit-box-orient: vertical;\n  }\n\n  .m_b6d8b162:where([data-inherit]) {\n    line-height: inherit;\n    font-weight: inherit;\n    font-size: inherit;\n  }\n\n  .m_b6d8b162:where([data-inline]) {\n    line-height: 1;\n  }\n\n.m_849cf0da {\n  color: var(--mantine-color-anchor);\n  text-decoration: none;\n  appearance: none;\n  border: none;\n  display: inline;\n  padding: 0;\n  margin: 0;\n  background-color: transparent;\n  cursor: pointer;\n}\n\n  @media (hover: hover) {\n\n  .m_849cf0da:where([data-underline='hover']):hover {\n      text-decoration: underline;\n  }\n}\n\n  @media (hover: none) {\n\n  .m_849cf0da:where([data-underline='hover']):active {\n      text-decoration: underline;\n  }\n}\n\n  .m_849cf0da:where([data-underline='always']) {\n    text-decoration: underline;\n  }\n\n  .m_849cf0da:where([data-variant='gradient']),\n    .m_849cf0da:where([data-variant='gradient']):hover {\n      text-decoration: none;\n    }\n\n  .m_849cf0da:where([data-line-clamp]) {\n    display: -webkit-box;\n  }\n\n.m_89ab340[data-resizing] {\n    --app-shell-transition-duration: 0ms !important;\n  }\n  .m_89ab340[data-disabled] {\n    --app-shell-header-offset: 0rem !important;\n    --app-shell-navbar-offset: 0rem !important;\n  }\n  [data-mantine-color-scheme='light'] .m_89ab340 {\n    --app-shell-border-color: var(--mantine-color-gray-3);\n}\n  [data-mantine-color-scheme='dark'] .m_89ab340 {\n    --app-shell-border-color: var(--mantine-color-dark-4);\n}\n\n.m_45252eee,\n.m_9cdde9a,\n.m_3b16f56b,\n.m_8983817,\n.m_3840c879 {\n  transition-duration: var(--app-shell-transition-duration);\n  transition-timing-function: var(--app-shell-transition-timing-function);\n}\n\n.m_45252eee,\n.m_9cdde9a {\n  position: fixed;\n  display: flex;\n  flex-direction: column;\n  top: var(--app-shell-header-offset, 0rem);\n  height: calc(\n    100dvh - var(--app-shell-header-offset, 0rem) - var(--app-shell-footer-offset, 0rem)\n  );\n  background-color: var(--mantine-color-body);\n  transition-property: transform, top, height;\n}\n\n:where([data-layout='alt']) .m_45252eee, :where([data-layout='alt']) .m_9cdde9a {\n    top: 0rem;\n    height: 100dvh;\n  }\n\n.m_45252eee {\n  inset-inline-start: 0;\n  width: var(--app-shell-navbar-width);\n  transition-property: transform, top, height;\n  transform: var(--app-shell-navbar-transform);\n  z-index: var(--app-shell-navbar-z-index);\n}\n\n:where([dir=\"rtl\"]) .m_45252eee {\n    transform: var(--app-shell-navbar-transform-rtl);\n}\n\n.m_45252eee:where([data-with-border]) {\n    border-inline-end: 1px solid var(--app-shell-border-color);\n  }\n\n.m_9cdde9a {\n  inset-inline-end: 0;\n  width: var(--app-shell-aside-width);\n  transform: var(--app-shell-aside-transform);\n  z-index: var(--app-shell-aside-z-index);\n}\n\n:where([dir=\"rtl\"]) .m_9cdde9a {\n    transform: var(--app-shell-aside-transform-rtl);\n}\n\n.m_9cdde9a:where([data-with-border]) {\n    border-inline-start: 1px solid var(--app-shell-border-color);\n  }\n\n.m_8983817 {\n  padding-inline-start: calc(var(--app-shell-navbar-offset, 0rem) + var(--app-shell-padding));\n  padding-inline-end: calc(var(--app-shell-aside-offset, 0rem) + var(--app-shell-padding));\n  padding-top: calc(var(--app-shell-header-offset, 0rem) + var(--app-shell-padding));\n  padding-bottom: calc(var(--app-shell-footer-offset, 0rem) + var(--app-shell-padding));\n  min-height: 100dvh;\n  transition-property: padding;\n}\n\n.m_3b16f56b,\n.m_3840c879 {\n  position: fixed;\n  inset-inline: 0;\n  transition-property: transform, left, right;\n  background-color: var(--mantine-color-body);\n}\n\n:where([data-layout='alt']) .m_3b16f56b, :where([data-layout='alt']) .m_3840c879 {\n    inset-inline-start: var(--app-shell-navbar-offset, 0rem);\n    inset-inline-end: var(--app-shell-aside-offset, 0rem);\n  }\n\n.m_3b16f56b {\n  top: 0;\n  height: var(--app-shell-header-height);\n  background-color: var(--mantine-color-body);\n  transform: var(--app-shell-header-transform);\n  z-index: var(--app-shell-header-z-index);\n}\n\n.m_3b16f56b:where([data-with-border]) {\n    border-bottom: 1px solid var(--app-shell-border-color);\n  }\n\n.m_3840c879 {\n  bottom: 0;\n  height: calc(var(--app-shell-footer-height) + env(safe-area-inset-bottom));\n  padding-bottom: env(safe-area-inset-bottom);\n  transform: var(--app-shell-footer-transform);\n  z-index: var(--app-shell-footer-z-index);\n}\n\n.m_3840c879:where([data-with-border]) {\n    border-top: 1px solid var(--app-shell-border-color);\n  }\n\n.m_6dcfc7c7 {\n  flex-grow: 0;\n}\n\n.m_6dcfc7c7:where([data-grow]) {\n    flex-grow: 1;\n  }\n\n.m_71ac47fc {\n  --ar-ratio: 1;\n  max-width: 100%;\n}\n\n  .m_71ac47fc > :where(*:not(style)) {\n    aspect-ratio: var(--ar-ratio);\n    width: 100%;\n  }\n\n  .m_71ac47fc > :where(img, video) {\n    object-fit: cover;\n  }\n\n.m_88b62a41 {\n  --combobox-padding: calc(0.25rem * var(--mantine-scale));\n  padding: var(--combobox-padding);\n}\n\n  .m_88b62a41:has([data-mantine-scrollbar]) {\n    padding-inline-end: 0;\n  }\n\n  .m_88b62a41[data-hidden] {\n    display: none;\n  }\n\n/* Variables must be both on dropdown and options to support usage of Combobox.Options without Combobox.Dropdown */\n.m_88b62a41,\n.m_b2821a6e {\n  --combobox-option-padding-xs: calc(0.25rem * var(--mantine-scale)) calc(0.5rem * var(--mantine-scale));\n  --combobox-option-padding-sm: calc(0.375rem * var(--mantine-scale)) calc(0.625rem * var(--mantine-scale));\n  --combobox-option-padding-md: calc(0.5rem * var(--mantine-scale)) calc(0.75rem * var(--mantine-scale));\n  --combobox-option-padding-lg: calc(0.625rem * var(--mantine-scale)) calc(1rem * var(--mantine-scale));\n  --combobox-option-padding-xl: calc(0.875rem * var(--mantine-scale)) calc(1.25rem * var(--mantine-scale));\n  --combobox-option-padding: var(--combobox-option-padding-sm);\n}\n\n.m_92253aa5 {\n  padding: var(--combobox-option-padding);\n  font-size: var(--combobox-option-fz, var(--mantine-font-size-sm));\n  border-radius: var(--mantine-radius-default);\n  background-color: transparent;\n  color: inherit;\n  cursor: pointer;\n  word-break: break-word;\n}\n\n.m_92253aa5:where([data-combobox-selected]) {\n    background-color: var(--mantine-primary-color-filled);\n    color: var(--mantine-color-white);\n  }\n\n.m_92253aa5:where([data-combobox-disabled]) {\n    cursor: not-allowed;\n    opacity: 0.35;\n  }\n\n@media (hover: hover) {\n      :where([data-mantine-color-scheme='light']) .m_92253aa5:hover:where(:not([data-combobox-selected], [data-combobox-disabled])) {\n        background-color: var(--mantine-color-gray-0);\n  }\n\n      :where([data-mantine-color-scheme='dark']) .m_92253aa5:hover:where(:not([data-combobox-selected], [data-combobox-disabled])) {\n        background-color: var(--mantine-color-dark-7);\n  }\n}\n\n@media (hover: none) {\n      :where([data-mantine-color-scheme='light']) .m_92253aa5:active:where(:not([data-combobox-selected], [data-combobox-disabled])) {\n        background-color: var(--mantine-color-gray-0);\n  }\n\n      :where([data-mantine-color-scheme='dark']) .m_92253aa5:active:where(:not([data-combobox-selected], [data-combobox-disabled])) {\n        background-color: var(--mantine-color-dark-7);\n  }\n}\n\n.m_985517d8 {\n  margin-inline: calc(var(--combobox-padding) * -1);\n  margin-top: calc(var(--combobox-padding) * -1);\n  width: calc(100% + var(--combobox-padding) * 2);\n  border-top-width: 0;\n  border-inline-width: 0;\n  border-end-start-radius: 0;\n  border-end-end-radius: 0;\n  margin-bottom: var(--combobox-padding);\n  position: relative;\n}\n\n:where([data-mantine-color-scheme='light']) .m_985517d8, :where([data-mantine-color-scheme='light']) .m_985517d8:focus {\n      border-color: var(--mantine-color-gray-2);\n}\n\n:where([data-mantine-color-scheme='dark']) .m_985517d8, :where([data-mantine-color-scheme='dark']) .m_985517d8:focus {\n      border-color: var(--mantine-color-dark-4);\n}\n\n:where([data-mantine-color-scheme='light']) .m_985517d8 {\n    background-color: var(--mantine-color-white);\n}\n\n:where([data-mantine-color-scheme='dark']) .m_985517d8 {\n    background-color: var(--mantine-color-dark-7);\n}\n\n.m_2530cd1d {\n  font-size: var(--combobox-option-fz, var(--mantine-font-size-sm));\n  text-align: center;\n  padding: var(--combobox-option-padding);\n  color: var(--mantine-color-dimmed);\n}\n\n.m_858f94bd,\n.m_82b967cb {\n  font-size: var(--combobox-option-fz, var(--mantine-font-size-sm));\n  border: 0 solid transparent;\n  margin-inline: calc(var(--combobox-padding) * -1);\n  padding: var(--combobox-option-padding);\n}\n\n:where([data-mantine-color-scheme='light']) .m_858f94bd, :where([data-mantine-color-scheme='light']) .m_82b967cb {\n    border-color: var(--mantine-color-gray-2);\n}\n\n:where([data-mantine-color-scheme='dark']) .m_858f94bd, :where([data-mantine-color-scheme='dark']) .m_82b967cb {\n    border-color: var(--mantine-color-dark-4);\n}\n\n.m_82b967cb {\n  border-top-width: calc(0.0625rem * var(--mantine-scale));\n  margin-top: var(--combobox-padding);\n  margin-bottom: calc(var(--combobox-padding) * -1);\n}\n\n.m_858f94bd {\n  border-bottom-width: calc(0.0625rem * var(--mantine-scale));\n  margin-bottom: var(--combobox-padding);\n  margin-top: calc(var(--combobox-padding) * -1);\n}\n\n.m_254f3e4f:has(.m_2bb2e9e5:only-child) {\n    display: none;\n  }\n\n.m_2bb2e9e5 {\n  color: var(--mantine-color-dimmed);\n  font-size: calc(var(--combobox-option-fz, var(--mantine-font-size-sm)) * 0.85);\n  padding: var(--combobox-option-padding);\n  font-weight: 500;\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.m_2bb2e9e5::after {\n    content: '';\n    flex: 1;\n    inset-inline: 0;\n    height: calc(0.0625rem * var(--mantine-scale));\n    margin-inline-start: var(--mantine-spacing-xs);\n  }\n\n:where([data-mantine-color-scheme='light']) .m_2bb2e9e5::after {\n      background-color: var(--mantine-color-gray-2);\n}\n\n:where([data-mantine-color-scheme='dark']) .m_2bb2e9e5::after {\n      background-color: var(--mantine-color-dark-4);\n}\n\n.m_2bb2e9e5:only-child {\n    display: none;\n  }\n\n/* ------- Combobox.Chevron ------- */\n.m_2943220b {\n  --combobox-chevron-size-xs: calc(0.875rem * var(--mantine-scale));\n  --combobox-chevron-size-sm: calc(1.125rem * var(--mantine-scale));\n  --combobox-chevron-size-md: calc(1.25rem * var(--mantine-scale));\n  --combobox-chevron-size-lg: calc(1.5rem * var(--mantine-scale));\n  --combobox-chevron-size-xl: calc(1.75rem * var(--mantine-scale));\n  --combobox-chevron-size: var(--combobox-chevron-size-sm);\n\n  width: var(--combobox-chevron-size);\n  height: var(--combobox-chevron-size);\n}\n:where([data-mantine-color-scheme='light']) .m_2943220b {\n    color: var(--mantine-color-gray-6);\n}\n:where([data-mantine-color-scheme='dark']) .m_2943220b {\n    color: var(--mantine-color-dark-3);\n}\n.m_2943220b:where([data-error]) {\n    color: var(--mantine-color-error);\n  }\n\n/* ------- OptionsDropdown ------- */\n.m_390b5f4 {\n  display: flex;\n  align-items: center;\n  gap: calc(0.5rem * var(--mantine-scale));\n}\n.m_390b5f4:where([data-reverse]) {\n    justify-content: space-between;\n  }\n\n.m_8ee53fc2 {\n  opacity: 0.4;\n  width: 0.8em;\n  min-width: 0.8em;\n  height: 0.8em;\n}\n\n:where([data-combobox-selected]) .m_8ee53fc2 {\n    opacity: 1;\n  }\n\n.m_5f75b09e {\n  --label-lh-xs: calc(1rem * var(--mantine-scale));\n  --label-lh-sm: calc(1.25rem * var(--mantine-scale));\n  --label-lh-md: calc(1.5rem * var(--mantine-scale));\n  --label-lh-lg: calc(1.875rem * var(--mantine-scale));\n  --label-lh-xl: calc(2.25rem * var(--mantine-scale));\n  --label-lh: var(--label-lh-sm);\n}\n\n  .m_5f75b09e[data-label-position='left'] {\n    --label-order: 1;\n    --label-offset-end: var(--mantine-spacing-sm);\n    --label-offset-start: 0;\n  }\n\n  .m_5f75b09e[data-label-position='right'] {\n    --label-order: 2;\n    --label-offset-end: 0;\n    --label-offset-start: var(--mantine-spacing-sm);\n  }\n\n.m_5f6e695e {\n  display: flex;\n}\n\n.m_d3ea56bb {\n  --label-cursor: var(--mantine-cursor-type);\n\n  -webkit-tap-highlight-color: transparent;\n  display: inline-flex;\n  flex-direction: column;\n  font-size: var(--label-fz, var(--mantine-font-size-sm));\n  line-height: var(--label-lh);\n  cursor: var(--label-cursor);\n  order: var(--label-order);\n}\n\nfieldset:disabled .m_d3ea56bb,\n  .m_d3ea56bb[data-disabled] {\n    --label-cursor: not-allowed;\n  }\n\n.m_8ee546b8 {\n  cursor: var(--label-cursor);\n  color: inherit;\n  padding-inline-start: var(--label-offset-start);\n  padding-inline-end: var(--label-offset-end);\n}\n\n:where([data-mantine-color-scheme='light']) fieldset:disabled .m_8ee546b8, :where([data-mantine-color-scheme='light']) .m_8ee546b8:where([data-disabled]) {\n      color: var(--mantine-color-gray-5);\n}\n\n:where([data-mantine-color-scheme='dark']) fieldset:disabled .m_8ee546b8, :where([data-mantine-color-scheme='dark']) .m_8ee546b8:where([data-disabled]) {\n      color: var(--mantine-color-dark-3);\n}\n\n.m_328f68c0 {\n  margin-top: calc(var(--mantine-spacing-xs) / 2);\n  padding-inline-start: var(--label-offset-start);\n  padding-inline-end: var(--label-offset-end);\n}\n\n.m_8e8a99cc {\n  margin-top: calc(var(--mantine-spacing-xs) / 2);\n  padding-inline-start: var(--label-offset-start);\n  padding-inline-end: var(--label-offset-end);\n}\n\n.m_26775b0a {\n  --card-radius: var(--mantine-radius-default);\n\n  display: block;\n  width: 100%;\n  border-radius: var(--card-radius);\n  cursor: pointer;\n}\n\n  .m_26775b0a :where(*) {\n    cursor: inherit;\n  }\n\n  .m_26775b0a:where([data-with-border]) {\n    border: calc(0.0625rem * var(--mantine-scale)) solid transparent;\n  }\n\n  :where([data-mantine-color-scheme='light']) .m_26775b0a:where([data-with-border]) {\n      border-color: var(--mantine-color-gray-3);\n}\n\n  :where([data-mantine-color-scheme='dark']) .m_26775b0a:where([data-with-border]) {\n      border-color: var(--mantine-color-dark-4);\n}\n\n.m_5e5256ee {\n  --checkbox-size-xs: calc(1rem * var(--mantine-scale));\n  --checkbox-size-sm: calc(1.25rem * var(--mantine-scale));\n  --checkbox-size-md: calc(1.5rem * var(--mantine-scale));\n  --checkbox-size-lg: calc(1.875rem * var(--mantine-scale));\n  --checkbox-size-xl: calc(2.25rem * var(--mantine-scale));\n\n  --checkbox-size: var(--checkbox-size-sm);\n  --checkbox-color: var(--mantine-primary-color-filled);\n  --checkbox-icon-color: var(--mantine-color-white);\n\n  position: relative;\n  border: calc(0.0625rem * var(--mantine-scale)) solid transparent;\n  width: var(--checkbox-size);\n  min-width: var(--checkbox-size);\n  height: var(--checkbox-size);\n  min-height: var(--checkbox-size);\n  border-radius: var(--checkbox-radius, var(--mantine-radius-default));\n  transition:\n    border-color 100ms ease,\n    background-color 100ms ease;\n  cursor: var(--mantine-cursor-type);\n  -webkit-tap-highlight-color: transparent;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n  :where([data-mantine-color-scheme='light']) .m_5e5256ee {\n    background-color: var(--mantine-color-white);\n    border-color: var(--mantine-color-gray-4);\n}\n\n  :where([data-mantine-color-scheme='dark']) .m_5e5256ee {\n    background-color: var(--mantine-color-dark-6);\n    border-color: var(--mantine-color-dark-4);\n}\n\n  .m_5e5256ee[data-indeterminate],\n  .m_5e5256ee[data-checked] {\n    background-color: var(--checkbox-color);\n    border-color: var(--checkbox-color);\n  }\n\n  .m_5e5256ee[data-indeterminate] > .m_1b1c543a, .m_5e5256ee[data-checked] > .m_1b1c543a {\n      opacity: 1;\n      transform: none;\n      color: var(--checkbox-icon-color);\n    }\n\n  .m_5e5256ee[data-disabled] {\n    cursor: not-allowed;\n  }\n\n  :where([data-mantine-color-scheme='light']) .m_5e5256ee[data-disabled] {\n      background-color: var(--mantine-color-gray-2);\n      border-color: var(--mantine-color-gray-3);\n}\n\n  :where([data-mantine-color-scheme='dark']) .m_5e5256ee[data-disabled] {\n      background-color: var(--mantine-color-dark-6);\n      border-color: var(--mantine-color-dark-6);\n}\n\n  [data-mantine-color-scheme='light'] .m_5e5256ee[data-disabled][data-checked] > .m_1b1c543a {\n        color: var(--mantine-color-gray-5);\n}\n\n  [data-mantine-color-scheme='dark'] .m_5e5256ee[data-disabled][data-checked] > .m_1b1c543a {\n        color: var(--mantine-color-dark-3);\n}\n\n.m_76e20374[data-indeterminate]:not([data-disabled]),\n  .m_76e20374[data-checked]:not([data-disabled]) {\n    background-color: transparent;\n    border-color: var(--checkbox-color);\n  }\n\n.m_76e20374[data-indeterminate]:not([data-disabled]) > .m_1b1c543a, .m_76e20374[data-checked]:not([data-disabled]) > .m_1b1c543a {\n      color: var(--checkbox-color);\n      opacity: 1;\n      transform: none;\n    }\n\n.m_1b1c543a {\n  display: block;\n  width: 60%;\n  color: transparent;\n  pointer-events: none;\n  transform: translateY(calc(0.3125rem * var(--mantine-scale))) scale(0.5);\n  opacity: 1;\n  transition:\n    transform 100ms ease,\n    opacity 100ms ease;\n}\n\n.m_bf2d988c {\n  --checkbox-size-xs: calc(1rem * var(--mantine-scale));\n  --checkbox-size-sm: calc(1.25rem * var(--mantine-scale));\n  --checkbox-size-md: calc(1.5rem * var(--mantine-scale));\n  --checkbox-size-lg: calc(1.875rem * var(--mantine-scale));\n  --checkbox-size-xl: calc(2.25rem * var(--mantine-scale));\n\n  --checkbox-size: var(--checkbox-size-sm);\n  --checkbox-color: var(--mantine-primary-color-filled);\n  --checkbox-icon-color: var(--mantine-color-white);\n}\n\n.m_26062bec {\n  position: relative;\n  width: var(--checkbox-size);\n  height: var(--checkbox-size);\n  order: 1;\n}\n\n.m_26062bec:where([data-label-position='left']) {\n    order: 2;\n  }\n\n.m_26063560 {\n  appearance: none;\n  border: calc(0.0625rem * var(--mantine-scale)) solid transparent;\n  width: var(--checkbox-size);\n  height: var(--checkbox-size);\n  border-radius: var(--checkbox-radius, var(--mantine-radius-default));\n  padding: 0;\n  display: block;\n  margin: 0;\n  transition:\n    border-color 100ms ease,\n    background-color 100ms ease;\n  cursor: var(--mantine-cursor-type);\n  -webkit-tap-highlight-color: transparent;\n}\n\n:where([data-mantine-color-scheme='light']) .m_26063560 {\n    background-color: var(--mantine-color-white);\n    border-color: var(--mantine-color-gray-4);\n}\n\n:where([data-mantine-color-scheme='dark']) .m_26063560 {\n    background-color: var(--mantine-color-dark-6);\n    border-color: var(--mantine-color-dark-4);\n}\n\n.m_26063560:where([data-error]) {\n    border-color: var(--mantine-color-error);\n  }\n\n.m_26063560[data-indeterminate],\n  .m_26063560:checked {\n    background-color: var(--checkbox-color);\n    border-color: var(--checkbox-color);\n  }\n\n.m_26063560[data-indeterminate] + .m_bf295423, .m_26063560:checked + .m_bf295423 {\n      opacity: 1;\n      transform: none;\n    }\n\n.m_26063560:disabled {\n    cursor: not-allowed;\n  }\n\n:where([data-mantine-color-scheme='light']) .m_26063560:disabled {\n      background-color: var(--mantine-color-gray-2);\n      border-color: var(--mantine-color-gray-3);\n}\n\n:where([data-mantine-color-scheme='dark']) .m_26063560:disabled {\n      background-color: var(--mantine-color-dark-6);\n      border-color: var(--mantine-color-dark-6);\n}\n\n[data-mantine-color-scheme='light'] .m_26063560:disabled + .m_bf295423 {\n        color: var(--mantine-color-gray-5);\n}\n\n[data-mantine-color-scheme='dark'] .m_26063560:disabled + .m_bf295423 {\n        color: var(--mantine-color-dark-3);\n}\n\n.m_215c4542 + .m_bf295423 {\n    color: var(--checkbox-color);\n  }\n\n.m_215c4542[data-indeterminate]:not(:disabled),\n  .m_215c4542:checked:not(:disabled) {\n    background-color: transparent;\n    border-color: var(--checkbox-color);\n  }\n\n.m_215c4542[data-indeterminate]:not(:disabled) + .m_bf295423, .m_215c4542:checked:not(:disabled) + .m_bf295423 {\n      color: var(--checkbox-color);\n      opacity: 1;\n      transform: none;\n    }\n\n.m_bf295423 {\n  position: absolute;\n  inset: 0;\n  width: 60%;\n  margin: auto;\n  color: var(--checkbox-icon-color);\n  pointer-events: none;\n  transform: translateY(calc(0.3125rem * var(--mantine-scale))) scale(0.5);\n  opacity: 0;\n  transition:\n    transform 100ms ease,\n    opacity 100ms ease;\n}\n\n/* Avatar.Group root element */\n.m_11def92b {\n  --ag-spacing: var(--mantine-spacing-sm);\n  --ag-offset: calc(var(--ag-spacing) * -1);\n\n  display: flex;\n  padding-inline-start: var(--ag-spacing);\n}\n\n/* Avatar root element */\n.m_f85678b6 {\n  --avatar-size-xs: calc(1rem * var(--mantine-scale));\n  --avatar-size-sm: calc(1.625rem * var(--mantine-scale));\n  --avatar-size-md: calc(2.375rem * var(--mantine-scale));\n  --avatar-size-lg: calc(3.5rem * var(--mantine-scale));\n  --avatar-size-xl: calc(5.25rem * var(--mantine-scale));\n\n  --avatar-size: var(--avatar-size-md);\n  --avatar-radius: calc(62.5rem * var(--mantine-scale));\n  --avatar-bg: var(--mantine-color-gray-light);\n  --avatar-bd: calc(0.0625rem * var(--mantine-scale)) solid transparent;\n  --avatar-color: var(--mantine-color-gray-light-color);\n  --avatar-placeholder-fz: calc(var(--avatar-size) / 2.5);\n\n  -webkit-tap-highlight-color: transparent;\n  position: relative;\n  display: block;\n  user-select: none;\n  overflow: hidden;\n  border-radius: var(--avatar-radius);\n  text-decoration: none;\n  padding: 0;\n  width: var(--avatar-size);\n  height: var(--avatar-size);\n  min-width: var(--avatar-size);\n}\n.m_f85678b6:where([data-within-group]) {\n    margin-inline-start: var(--ag-offset);\n    border: 2px solid var(--mantine-color-body);\n    background: var(--mantine-color-body);\n  }\n\n.m_11f8ac07 {\n  object-fit: cover;\n  width: 100%;\n  height: 100%;\n  display: block;\n}\n\n.m_104cd71f {\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  user-select: none;\n  border-radius: var(--avatar-radius);\n  font-size: var(--avatar-placeholder-fz);\n  background: var(--avatar-bg);\n  border: var(--avatar-bd);\n  color: var(--avatar-color);\n}\n\n.m_104cd71f > [data-avatar-placeholder-icon] {\n    width: 70%;\n    height: 70%;\n  }\n\n.m_2ce0de02 {\n  background-size: cover;\n  background-position: center;\n  display: block;\n  width: 100%;\n  border: 0;\n  text-decoration: none;\n  border-radius: var(--bi-radius, 0);\n}\n\n.m_347db0ec {\n  --badge-height-xs: calc(1rem * var(--mantine-scale));\n  --badge-height-sm: calc(1.125rem * var(--mantine-scale));\n  --badge-height-md: calc(1.25rem * var(--mantine-scale));\n  --badge-height-lg: calc(1.625rem * var(--mantine-scale));\n  --badge-height-xl: calc(2rem * var(--mantine-scale));\n\n  --badge-fz-xs: calc(0.5625rem * var(--mantine-scale));\n  --badge-fz-sm: calc(0.625rem * var(--mantine-scale));\n  --badge-fz-md: calc(0.6875rem * var(--mantine-scale));\n  --badge-fz-lg: calc(0.8125rem * var(--mantine-scale));\n  --badge-fz-xl: calc(1rem * var(--mantine-scale));\n\n  --badge-padding-x-xs: calc(0.375rem * var(--mantine-scale));\n  --badge-padding-x-sm: calc(0.5rem * var(--mantine-scale));\n  --badge-padding-x-md: calc(0.625rem * var(--mantine-scale));\n  --badge-padding-x-lg: calc(0.75rem * var(--mantine-scale));\n  --badge-padding-x-xl: calc(1rem * var(--mantine-scale));\n\n  --badge-height: var(--badge-height-md);\n  --badge-fz: var(--badge-fz-md);\n  --badge-padding-x: var(--badge-padding-x-md);\n  --badge-radius: calc(62.5rem * var(--mantine-scale));\n  --badge-lh: calc(var(--badge-height) - calc(0.125rem * var(--mantine-scale)));\n  --badge-color: var(--mantine-color-white);\n  --badge-bg: var(--mantine-primary-color-filled);\n  --badge-bd: calc(0.0625rem * var(--mantine-scale)) solid transparent;\n\n  -webkit-tap-highlight-color: transparent;\n  font-size: var(--badge-fz);\n  border-radius: var(--badge-radius);\n  height: var(--badge-height);\n  line-height: var(--badge-lh);\n  text-decoration: none;\n  padding: 0 var(--badge-padding-x);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: fit-content;\n  text-transform: uppercase;\n  font-weight: 700;\n  letter-spacing: calc(0.015625rem * var(--mantine-scale));\n  cursor: inherit;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  color: var(--badge-color);\n  background: var(--badge-bg);\n  border: var(--badge-bd);\n}\n\n  .m_347db0ec:where([data-block]) {\n    display: flex;\n    width: 100%;\n  }\n\n  .m_347db0ec:where([data-circle]) {\n    padding-inline: calc(0.125rem * var(--mantine-scale));\n    width: var(--badge-height);\n  }\n\n.m_fbd81e3d {\n  --badge-dot-size: calc(var(--badge-height) / 3.4);\n}\n\n:where([data-mantine-color-scheme='light']) .m_fbd81e3d {\n    background-color: var(--mantine-color-white);\n    border-color: var(--mantine-color-gray-4);\n    color: var(--mantine-color-black);\n}\n\n:where([data-mantine-color-scheme='dark']) .m_fbd81e3d {\n    background-color: var(--mantine-color-dark-5);\n    border-color: var(--mantine-color-dark-5);\n    color: var(--mantine-color-white);\n}\n\n.m_fbd81e3d::before {\n    content: '';\n    display: block;\n    width: var(--badge-dot-size);\n    height: var(--badge-dot-size);\n    border-radius: var(--badge-dot-size);\n    background-color: var(--badge-dot-color);\n    margin-inline-end: var(--badge-dot-size);\n  }\n\n.m_5add502a {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.m_91fdda9b {\n  --badge-section-margin: calc(var(--mantine-spacing-xs) / 2);\n\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.m_91fdda9b:where([data-position='left']) {\n    margin-inline-end: var(--badge-section-margin);\n  }\n\n.m_91fdda9b:where([data-position='right']) {\n    margin-inline-start: var(--badge-section-margin);\n  }\n\n.m_ddec01c0 {\n  --blockquote-border: 3px solid var(--bq-bd);\n\n  position: relative;\n  margin: 0;\n  border-inline-start: var(--blockquote-border);\n  border-start-end-radius: var(--bq-radius);\n  border-end-end-radius: var(--bq-radius);\n  padding: var(--mantine-spacing-xl) calc(2.375rem * var(--mantine-scale));\n}\n\n  :where([data-mantine-color-scheme='light']) .m_ddec01c0 {\n    background-color: var(--bq-bg-light);\n}\n\n  :where([data-mantine-color-scheme='dark']) .m_ddec01c0 {\n    background-color: var(--bq-bg-dark);\n}\n\n.m_dde7bd57 {\n  --blockquote-icon-offset: calc(var(--bq-icon-size) / -2);\n\n  position: absolute;\n  color: var(--bq-bd);\n  background-color: var(--mantine-color-body);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  top: var(--blockquote-icon-offset);\n  inset-inline-start: var(--blockquote-icon-offset);\n  width: var(--bq-icon-size);\n  height: var(--bq-icon-size);\n  border-radius: var(--bq-icon-size);\n}\n\n.m_dde51a35 {\n  display: block;\n  margin-top: var(--mantine-spacing-md);\n  opacity: 0.6;\n  font-size: 85%;\n}\n\n.m_8b3717df {\n  display: flex;\n  align-items: center;\n}\n\n.m_f678d540 {\n  line-height: 1;\n  white-space: nowrap;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.m_3b8f2208 {\n  margin-inline: var(--bc-separator-margin, var(--mantine-spacing-xs));\n  line-height: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n:where([data-mantine-color-scheme='light']) .m_3b8f2208 {\n    color: var(--mantine-color-gray-7);\n}\n\n:where([data-mantine-color-scheme='dark']) .m_3b8f2208 {\n    color: var(--mantine-color-dark-2);\n}\n\n.m_fea6bf1a {\n  --burger-size-xs: calc(0.75rem * var(--mantine-scale));\n  --burger-size-sm: calc(1.125rem * var(--mantine-scale));\n  --burger-size-md: calc(1.5rem * var(--mantine-scale));\n  --burger-size-lg: calc(2.125rem * var(--mantine-scale));\n  --burger-size-xl: calc(2.625rem * var(--mantine-scale));\n\n  --burger-size: var(--burger-size-md);\n  --burger-line-size: calc(var(--burger-size) / 12);\n\n  width: calc(var(--burger-size) + var(--mantine-spacing-xs));\n  height: calc(var(--burger-size) + var(--mantine-spacing-xs));\n  padding: calc(var(--mantine-spacing-xs) / 2);\n  cursor: pointer;\n}\n\n  :where([data-mantine-color-scheme='light']) .m_fea6bf1a {\n    --burger-color: var(--mantine-color-black);\n}\n\n  :where([data-mantine-color-scheme='dark']) .m_fea6bf1a {\n    --burger-color: var(--mantine-color-white);\n}\n\n.m_d4fb9cad {\n  position: relative;\n  user-select: none;\n}\n\n.m_d4fb9cad,\n  .m_d4fb9cad::before,\n  .m_d4fb9cad::after {\n    display: block;\n    width: var(--burger-size);\n    height: var(--burger-line-size);\n    background-color: var(--burger-color);\n    outline: calc(0.0625rem * var(--mantine-scale)) solid transparent;\n    transition-property: background-color, transform;\n    transition-duration: var(--burger-transition-duration, 300ms);\n    transition-timing-function: var(--burger-transition-timing-function, ease);\n  }\n\n.m_d4fb9cad::before,\n  .m_d4fb9cad::after {\n    position: absolute;\n    content: '';\n    inset-inline-start: 0;\n  }\n\n.m_d4fb9cad::before {\n    top: calc(var(--burger-size) / -3);\n  }\n\n.m_d4fb9cad::after {\n    top: calc(var(--burger-size) / 3);\n  }\n\n.m_d4fb9cad[data-opened] {\n    background-color: transparent;\n  }\n\n.m_d4fb9cad[data-opened]::before {\n      transform: translateY(calc(var(--burger-size) / 3)) rotate(45deg);\n    }\n\n.m_d4fb9cad[data-opened]::after {\n      transform: translateY(calc(var(--burger-size) / -3)) rotate(-45deg);\n    }\n\n.m_77c9d27d {\n  --button-height-xs: calc(1.875rem * var(--mantine-scale));\n  --button-height-sm: calc(2.25rem * var(--mantine-scale));\n  --button-height-md: calc(2.625rem * var(--mantine-scale));\n  --button-height-lg: calc(3.125rem * var(--mantine-scale));\n  --button-height-xl: calc(3.75rem * var(--mantine-scale));\n\n  --button-height-compact-xs: calc(1.375rem * var(--mantine-scale));\n  --button-height-compact-sm: calc(1.625rem * var(--mantine-scale));\n  --button-height-compact-md: calc(1.875rem * var(--mantine-scale));\n  --button-height-compact-lg: calc(2.125rem * var(--mantine-scale));\n  --button-height-compact-xl: calc(2.5rem * var(--mantine-scale));\n\n  --button-padding-x-xs: calc(0.875rem * var(--mantine-scale));\n  --button-padding-x-sm: calc(1.125rem * var(--mantine-scale));\n  --button-padding-x-md: calc(1.375rem * var(--mantine-scale));\n  --button-padding-x-lg: calc(1.625rem * var(--mantine-scale));\n  --button-padding-x-xl: calc(2rem * var(--mantine-scale));\n\n  --button-padding-x-compact-xs: calc(0.4375rem * var(--mantine-scale));\n  --button-padding-x-compact-sm: calc(0.5rem * var(--mantine-scale));\n  --button-padding-x-compact-md: calc(0.625rem * var(--mantine-scale));\n  --button-padding-x-compact-lg: calc(0.75rem * var(--mantine-scale));\n  --button-padding-x-compact-xl: calc(0.875rem * var(--mantine-scale));\n\n  --button-height: var(--button-height-sm);\n  --button-padding-x: var(--button-padding-x-sm);\n  --button-color: var(--mantine-color-white);\n\n  user-select: none;\n  font-weight: 600;\n  position: relative;\n  line-height: 1;\n  text-align: center;\n  overflow: hidden;\n\n  width: auto;\n  cursor: pointer;\n  display: inline-block;\n  border-radius: var(--button-radius, var(--mantine-radius-default));\n  font-size: var(--button-fz, var(--mantine-font-size-sm));\n  background: var(--button-bg, var(--mantine-primary-color-filled));\n  border: var(--button-bd, calc(0.0625rem * var(--mantine-scale)) solid transparent);\n  color: var(--button-color, var(--mantine-color-white));\n  height: var(--button-height, var(--button-height-sm));\n  padding-inline: var(--button-padding-x, var(--button-padding-x-sm));\n  vertical-align: middle;\n}\n\n  .m_77c9d27d:where([data-block]) {\n    display: block;\n    width: 100%;\n  }\n\n  .m_77c9d27d:where([data-with-left-section]) {\n    padding-inline-start: calc(var(--button-padding-x) / 1.5);\n  }\n\n  .m_77c9d27d:where([data-with-right-section]) {\n    padding-inline-end: calc(var(--button-padding-x) / 1.5);\n  }\n\n  .m_77c9d27d:where(:disabled:not([data-loading]), [data-disabled]:not([data-loading])) {\n    cursor: not-allowed;\n    border: calc(0.0625rem * var(--mantine-scale)) solid transparent;\n    transform: none;\n  }\n\n  :where([data-mantine-color-scheme='light']) .m_77c9d27d:where(:disabled:not([data-loading]), [data-disabled]:not([data-loading])) {\n      color: var(--mantine-color-gray-5);\n      background: var(--mantine-color-gray-1);\n}\n\n  :where([data-mantine-color-scheme='dark']) .m_77c9d27d:where(:disabled:not([data-loading]), [data-disabled]:not([data-loading])) {\n      color: var(--mantine-color-dark-3);\n      background: var(--mantine-color-dark-6);\n}\n\n  .m_77c9d27d::before {\n    content: '';\n    pointer-events: none;\n    position: absolute;\n    inset: calc(-0.0625rem * var(--mantine-scale));\n    border-radius: var(--button-radius, var(--mantine-radius-default));\n    transform: translateY(-100%);\n    opacity: 0;\n    filter: blur(12px);\n    transition:\n      transform 150ms ease,\n      opacity 100ms ease;\n  }\n\n  :where([data-mantine-color-scheme='light']) .m_77c9d27d::before {\n      background-color: rgba(255, 255, 255, 0.15);\n}\n\n  :where([data-mantine-color-scheme='dark']) .m_77c9d27d::before {\n      background-color: rgba(0, 0, 0, 0.15);\n}\n\n  .m_77c9d27d:where([data-loading]) {\n    cursor: not-allowed;\n    transform: none;\n  }\n\n  .m_77c9d27d:where([data-loading])::before {\n      transform: translateY(0);\n      opacity: 1;\n    }\n\n  .m_77c9d27d:where([data-loading]) .m_80f1301b {\n      opacity: 0;\n      transform: translateY(100%);\n    }\n\n  @media (hover: hover) {\n    .m_77c9d27d:hover:where(:not([data-loading], :disabled, [data-disabled])) {\n      background-color: var(--button-hover, var(--mantine-primary-color-filled-hover));\n      color: var(--button-hover-color, var(--button-color));\n    }\n}\n\n  @media (hover: none) {\n    .m_77c9d27d:active:where(:not([data-loading], :disabled, [data-disabled])) {\n      background-color: var(--button-hover, var(--mantine-primary-color-filled-hover));\n      color: var(--button-hover-color, var(--button-color));\n    }\n}\n\n.m_80f1301b {\n  display: flex;\n  align-items: center;\n  justify-content: var(--button-justify, center);\n  height: 100%;\n  overflow: visible;\n  transition:\n    transform 150ms ease,\n    opacity 100ms ease;\n}\n\n.m_811560b9 {\n  white-space: nowrap;\n  height: 100%;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  opacity: 1;\n}\n\n.m_811560b9:where([data-loading]) {\n    opacity: 0.2;\n  }\n\n.m_a74036a {\n  display: flex;\n  align-items: center;\n}\n\n.m_a74036a:where([data-position='left']) {\n    margin-inline-end: var(--mantine-spacing-xs);\n  }\n\n.m_a74036a:where([data-position='right']) {\n    margin-inline-start: var(--mantine-spacing-xs);\n  }\n\n.m_a25b86ee {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n}\n\n.m_80d6d844 {\n  --button-border-width: calc(0.0625rem * var(--mantine-scale));\n  display: flex;\n}\n\n.m_80d6d844 :where(*):focus {\n      position: relative;\n      z-index: 1;\n    }\n\n.m_80d6d844[data-orientation='horizontal'] {\n    flex-direction: row;\n  }\n\n.m_80d6d844[data-orientation='horizontal'] .m_77c9d27d:not(:only-child):first-child {\n        border-end-end-radius: 0;\n        border-start-end-radius: 0;\n        border-inline-end-width: calc(var(--button-border-width) / 2);\n      }\n\n.m_80d6d844[data-orientation='horizontal'] .m_77c9d27d:not(:only-child):last-child {\n        border-end-start-radius: 0;\n        border-start-start-radius: 0;\n        border-inline-start-width: calc(var(--button-border-width) / 2);\n      }\n\n.m_80d6d844[data-orientation='horizontal'] .m_77c9d27d:not(:only-child):not(:first-child):not(:last-child) {\n        border-radius: 0;\n        border-inline-width: calc(var(--button-border-width) / 2);\n      }\n\n.m_80d6d844[data-orientation='vertical'] {\n    flex-direction: column;\n  }\n\n.m_80d6d844[data-orientation='vertical'] .m_77c9d27d:not(:only-child):first-child {\n        border-end-start-radius: 0;\n        border-end-end-radius: 0;\n        border-bottom-width: calc(var(--button-border-width) / 2);\n      }\n\n.m_80d6d844[data-orientation='vertical'] .m_77c9d27d:not(:only-child):last-child {\n        border-start-start-radius: 0;\n        border-start-end-radius: 0;\n        border-top-width: calc(var(--button-border-width) / 2);\n      }\n\n.m_80d6d844[data-orientation='vertical'] .m_77c9d27d:not(:only-child):not(:first-child):not(:last-child) {\n        border-radius: 0;\n        border-bottom-width: calc(var(--button-border-width) / 2);\n        border-top-width: calc(var(--button-border-width) / 2);\n      }\n\n.m_e615b15f {\n  --card-padding: var(--mantine-spacing-md);\n\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  padding: var(--card-padding);\n  color: var(--mantine-color-text);\n}\n\n  :where([data-mantine-color-scheme='light']) .m_e615b15f {\n    background-color: var(--mantine-color-white);\n}\n\n  :where([data-mantine-color-scheme='dark']) .m_e615b15f {\n    background-color: var(--mantine-color-dark-6);\n}\n\n.m_599a2148 {\n  display: block;\n  margin-inline: calc(var(--card-padding) * -1);\n}\n\n.m_599a2148:where(:first-child) {\n    margin-top: calc(var(--card-padding) * -1);\n    border-top: none !important;\n  }\n\n.m_599a2148:where(:last-child) {\n    margin-bottom: calc(var(--card-padding) * -1);\n    border-bottom: none !important;\n  }\n\n.m_599a2148:where([data-inherit-padding]) {\n    padding-inline: var(--card-padding);\n  }\n\n.m_599a2148:where([data-with-border]) {\n    border-top: calc(0.0625rem * var(--mantine-scale)) solid;\n    border-bottom: calc(0.0625rem * var(--mantine-scale)) solid;\n  }\n\n:where([data-mantine-color-scheme='light']) .m_599a2148 {\n    border-color: var(--mantine-color-gray-3);\n}\n\n:where([data-mantine-color-scheme='dark']) .m_599a2148 {\n    border-color: var(--mantine-color-dark-4);\n}\n\n.m_599a2148 + .m_599a2148 {\n    border-top: none !important;\n  }\n\n.m_4451eb3a {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n  .m_4451eb3a:where([data-inline]) {\n    display: inline-flex;\n  }\n\n.m_f59ffda3 {\n  --chip-size-xs: calc(1.4375rem * var(--mantine-scale));\n  --chip-size-sm: calc(1.75rem * var(--mantine-scale));\n  --chip-size-md: calc(2rem * var(--mantine-scale));\n  --chip-size-lg: calc(2.25rem * var(--mantine-scale));\n  --chip-size-xl: calc(2.5rem * var(--mantine-scale));\n\n  --chip-icon-size-xs: calc(0.625rem * var(--mantine-scale));\n  --chip-icon-size-sm: calc(0.75rem * var(--mantine-scale));\n  --chip-icon-size-md: calc(0.875rem * var(--mantine-scale));\n  --chip-icon-size-lg: calc(1rem * var(--mantine-scale));\n  --chip-icon-size-xl: calc(1.125rem * var(--mantine-scale));\n\n  --chip-padding-xs: calc(1rem * var(--mantine-scale));\n  --chip-padding-sm: calc(1.25rem * var(--mantine-scale));\n  --chip-padding-md: calc(1.5rem * var(--mantine-scale));\n  --chip-padding-lg: calc(1.75rem * var(--mantine-scale));\n  --chip-padding-xl: calc(2rem * var(--mantine-scale));\n\n  --chip-checked-padding-xs: calc(0.46875rem * var(--mantine-scale));\n  --chip-checked-padding-sm: calc(0.625rem * var(--mantine-scale));\n  --chip-checked-padding-md: calc(0.73125rem * var(--mantine-scale));\n  --chip-checked-padding-lg: calc(0.84375rem * var(--mantine-scale));\n  --chip-checked-padding-xl: calc(0.78125rem * var(--mantine-scale));\n\n  --chip-spacing-xs: calc(0.625rem * var(--mantine-scale));\n  --chip-spacing-sm: calc(0.75rem * var(--mantine-scale));\n  --chip-spacing-md: calc(1rem * var(--mantine-scale));\n  --chip-spacing-lg: calc(1.25rem * var(--mantine-scale));\n  --chip-spacing-xl: calc(1.375rem * var(--mantine-scale));\n\n  --chip-size: var(--chip-size-sm);\n  --chip-icon-size: var(--chip-icon-size-sm);\n  --chip-padding: var(--chip-padding-sm);\n  --chip-spacing: var(--chip-spacing-sm);\n  --chip-checked-padding: var(--chip-checked-padding-sm);\n  --chip-bg: var(--mantine-primary-color-filled);\n  --chip-hover: var(--mantine-primary-color-filled-hover);\n  --chip-color: var(--mantine-color-white);\n  --chip-bd: calc(0.0625rem * var(--mantine-scale)) solid transparent;\n}\n\n.m_be049a53 {\n  display: inline-flex;\n  align-items: center;\n  user-select: none;\n  border-radius: var(--chip-radius, 1000rem);\n  height: var(--chip-size);\n  font-size: var(--chip-fz, var(--mantine-font-size-sm));\n  line-height: calc(var(--chip-size) - calc(0.125rem * var(--mantine-scale)));\n  padding-inline: var(--chip-padding);\n  cursor: pointer;\n  white-space: nowrap;\n  -webkit-tap-highlight-color: transparent;\n  border: calc(0.0625rem * var(--mantine-scale)) solid transparent;\n  color: var(--mantine-color-text);\n}\n\n.m_be049a53:where([data-checked]) {\n    padding: var(--chip-checked-padding);\n  }\n\n.m_be049a53:where([data-disabled]) {\n    cursor: not-allowed;\n  }\n\n:where([data-mantine-color-scheme='light']) .m_be049a53:where([data-disabled]) {\n      background-color: var(--mantine-color-gray-2);\n      color: var(--mantine-color-gray-5);\n}\n\n:where([data-mantine-color-scheme='dark']) .m_be049a53:where([data-disabled]) {\n      background-color: var(--mantine-color-dark-6);\n      color: var(--mantine-color-dark-3);\n}\n\n:where([data-mantine-color-scheme='light']) .m_3904c1af:not([data-disabled]) {\n    background-color: var(--mantine-color-white);\n    border: 1px solid var(--mantine-color-gray-3);\n}\n\n:where([data-mantine-color-scheme='dark']) .m_3904c1af:not([data-disabled]) {\n    background-color: var(--mantine-color-dark-6);\n    border: 1px solid var(--mantine-color-dark-4);\n}\n\n@media (hover: hover) {\n    :where([data-mantine-color-scheme='light']) .m_3904c1af:not([data-disabled]):hover {\n      background-color: var(--mantine-color-gray-0);\n  }\n\n    :where([data-mantine-color-scheme='dark']) .m_3904c1af:not([data-disabled]):hover {\n      background-color: var(--mantine-color-dark-5);\n  }\n}\n\n@media (hover: none) {\n    :where([data-mantine-color-scheme='light']) .m_3904c1af:not([data-disabled]):active {\n      background-color: var(--mantine-color-gray-0);\n  }\n\n    :where([data-mantine-color-scheme='dark']) .m_3904c1af:not([data-disabled]):active {\n      background-color: var(--mantine-color-dark-5);\n  }\n}\n\n.m_3904c1af:not([data-disabled]):where([data-checked]) {\n    --chip-icon-color: var(--chip-color);\n    border: var(--chip-bd);\n  }\n\n@media (hover: hover) {\n\n  .m_3904c1af:not([data-disabled]):where([data-checked]):hover {\n      background-color: var(--chip-hover);\n  }\n}\n\n@media (hover: none) {\n\n  .m_3904c1af:not([data-disabled]):where([data-checked]):active {\n      background-color: var(--chip-hover);\n  }\n}\n\n.m_fa109255:not([data-disabled]),\n.m_f7e165c3:not([data-disabled]) {\n  border: calc(0.0625rem * var(--mantine-scale)) solid transparent;\n  color: var(--mantine-color-text);\n}\n\n:where([data-mantine-color-scheme='light']) .m_fa109255:not([data-disabled]), :where([data-mantine-color-scheme='light']) .m_f7e165c3:not([data-disabled]) {\n    background-color: var(--mantine-color-gray-1);\n}\n\n:where([data-mantine-color-scheme='dark']) .m_fa109255:not([data-disabled]), :where([data-mantine-color-scheme='dark']) .m_f7e165c3:not([data-disabled]) {\n    background-color: var(--mantine-color-dark-5);\n}\n\n@media (hover: hover) {\n    :where([data-mantine-color-scheme='light']) .m_fa109255:not([data-disabled]):hover, :where([data-mantine-color-scheme='light']) .m_f7e165c3:not([data-disabled]):hover {\n      background-color: var(--mantine-color-gray-2);\n  }\n\n    :where([data-mantine-color-scheme='dark']) .m_fa109255:not([data-disabled]):hover, :where([data-mantine-color-scheme='dark']) .m_f7e165c3:not([data-disabled]):hover {\n      background-color: var(--mantine-color-dark-4);\n  }\n}\n\n@media (hover: none) {\n    :where([data-mantine-color-scheme='light']) .m_fa109255:not([data-disabled]):active, :where([data-mantine-color-scheme='light']) .m_f7e165c3:not([data-disabled]):active {\n      background-color: var(--mantine-color-gray-2);\n  }\n\n    :where([data-mantine-color-scheme='dark']) .m_fa109255:not([data-disabled]):active, :where([data-mantine-color-scheme='dark']) .m_f7e165c3:not([data-disabled]):active {\n      background-color: var(--mantine-color-dark-4);\n  }\n}\n\n.m_fa109255:not([data-disabled]):where([data-checked]), .m_f7e165c3:not([data-disabled]):where([data-checked]) {\n    --chip-icon-color: var(--chip-color);\n    color: var(--chip-color);\n    background-color: var(--chip-bg);\n  }\n\n@media (hover: hover) {\n\n  .m_fa109255:not([data-disabled]):where([data-checked]):hover, .m_f7e165c3:not([data-disabled]):where([data-checked]):hover {\n      background-color: var(--chip-hover);\n  }\n}\n\n@media (hover: none) {\n\n  .m_fa109255:not([data-disabled]):where([data-checked]):active, .m_f7e165c3:not([data-disabled]):where([data-checked]):active {\n      background-color: var(--chip-hover);\n  }\n}\n\n.m_9ac86df9 {\n  width: calc(var(--chip-icon-size) + (var(--chip-spacing) / 1.5));\n  max-width: calc(var(--chip-icon-size) + (var(--chip-spacing) / 1.5));\n  height: var(--chip-icon-size);\n  display: flex;\n  align-items: center;\n  overflow: hidden;\n}\n\n.m_d6d72580 {\n  width: var(--chip-icon-size);\n  height: var(--chip-icon-size);\n  display: block;\n  color: var(--chip-icon-color, inherit);\n}\n\n.m_bde07329 {\n  width: 0;\n  height: 0;\n  padding: 0;\n  opacity: 0;\n  margin: 0;\n}\n\n.m_bde07329:focus-visible + .m_be049a53 {\n    outline: 2px solid var(--mantine-primary-color-filled);\n    outline-offset: calc(0.125rem * var(--mantine-scale));\n  }\n\n.m_b183c0a2 {\n  font-family: var(--mantine-font-family-monospace);\n  line-height: var(--mantine-line-height);\n  padding: 2px calc(var(--mantine-spacing-xs) / 2);\n  border-radius: var(--mantine-radius-sm);\n  font-size: var(--mantine-font-size-xs);\n  margin: 0;\n  overflow: auto;\n}\n\n  :where([data-mantine-color-scheme='light']) .m_b183c0a2 {\n    background-color: var(--code-bg, var(--mantine-color-gray-1));\n    color: var(--mantine-color-black);\n}\n\n  :where([data-mantine-color-scheme='dark']) .m_b183c0a2 {\n    background-color: var(--code-bg, var(--mantine-color-dark-5));\n    color: var(--mantine-color-white);\n}\n\n  .m_b183c0a2[data-block] {\n    padding: var(--mantine-spacing-xs);\n  }\n\n.m_de3d2490 {\n  --cs-size: calc(1.75rem * var(--mantine-scale));\n  --cs-radius: calc(62.5rem * var(--mantine-scale));\n\n  -webkit-tap-highlight-color: transparent;\n  border: none;\n  appearance: none;\n  display: block;\n  line-height: 1;\n  position: relative;\n  width: var(--cs-size);\n  height: var(--cs-size);\n  min-width: var(--cs-size);\n  min-height: var(--cs-size);\n  border-radius: var(--cs-radius);\n  color: inherit;\n  text-decoration: none;\n}\n\n  [data-mantine-color-scheme='light'] .m_de3d2490 {\n    --alpha-overlay-color: var(--mantine-color-gray-3);\n    --alpha-overlay-bg: var(--mantine-color-white);\n}\n\n  [data-mantine-color-scheme='dark'] .m_de3d2490 {\n    --alpha-overlay-color: var(--mantine-color-dark-4);\n    --alpha-overlay-bg: var(--mantine-color-dark-7);\n}\n\n.m_862f3d1b {\n  position: absolute;\n  inset: 0;\n  border-radius: var(--cs-radius);\n}\n\n.m_98ae7f22 {\n  position: absolute;\n  inset: 0;\n  border-radius: var(--cs-radius);\n  z-index: 1;\n  box-shadow:\n    rgba(0, 0, 0, 0.1) 0 0 0 calc(0.0625rem * var(--mantine-scale)) inset,\n    rgb(0, 0, 0, 0.15) 0 0 calc(0.25rem * var(--mantine-scale)) inset;\n}\n\n.m_95709ac0 {\n  position: absolute;\n  inset: 0;\n  border-radius: var(--cs-radius);\n  background-size: calc(0.5rem * var(--mantine-scale)) calc(0.5rem * var(--mantine-scale));\n  background-position:\n    0 0,\n    0 calc(0.25rem * var(--mantine-scale)),\n    calc(0.25rem * var(--mantine-scale)) calc(-0.25rem * var(--mantine-scale)),\n    calc(-0.25rem * var(--mantine-scale)) 0;\n  background-image: linear-gradient(45deg, var(--alpha-overlay-color) 25%, transparent 25%),\n    linear-gradient(-45deg, var(--alpha-overlay-color) 25%, transparent 25%),\n    linear-gradient(45deg, transparent 75%, var(--alpha-overlay-color) 75%),\n    linear-gradient(-45deg, var(--alpha-overlay-bg) 75%, var(--alpha-overlay-color) 75%);\n}\n\n.m_93e74e3 {\n  position: absolute;\n  inset: 0;\n  border-radius: var(--cs-radius);\n  z-index: 2;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.m_fee9c77 {\n  --cp-width-xs: calc(11.25rem * var(--mantine-scale));\n  --cp-width-sm: calc(12.5rem * var(--mantine-scale));\n  --cp-width-md: calc(15rem * var(--mantine-scale));\n  --cp-width-lg: calc(17.5rem * var(--mantine-scale));\n  --cp-width-xl: calc(20rem * var(--mantine-scale));\n\n  --cp-preview-size-xs: calc(1.625rem * var(--mantine-scale));\n  --cp-preview-size-sm: calc(2.125rem * var(--mantine-scale));\n  --cp-preview-size-md: calc(2.625rem * var(--mantine-scale));\n  --cp-preview-size-lg: calc(3.125rem * var(--mantine-scale));\n  --cp-preview-size-xl: calc(3.375rem * var(--mantine-scale));\n\n  --cp-thumb-size-xs: calc(0.5rem * var(--mantine-scale));\n  --cp-thumb-size-sm: calc(0.75rem * var(--mantine-scale));\n  --cp-thumb-size-md: calc(1rem * var(--mantine-scale));\n  --cp-thumb-size-lg: calc(1.25rem * var(--mantine-scale));\n  --cp-thumb-size-xl: calc(1.375rem * var(--mantine-scale));\n\n  --cp-saturation-height-xs: calc(6.25rem * var(--mantine-scale));\n  --cp-saturation-height-sm: calc(6.875rem * var(--mantine-scale));\n  --cp-saturation-height-md: calc(7.5rem * var(--mantine-scale));\n  --cp-saturation-height-lg: calc(8.75rem * var(--mantine-scale));\n  --cp-saturation-height-xl: calc(10rem * var(--mantine-scale));\n\n  --cp-preview-size: var(--cp-preview-size-sm);\n  --cp-thumb-size: var(--cp-thumb-size-sm);\n  --cp-saturation-height: var(--cp-saturation-height-sm);\n  --cp-width: var(--cp-width-sm);\n  --cp-body-spacing: var(--mantine-spacing-sm);\n\n  width: var(--cp-width);\n  padding: calc(0.0625rem * var(--mantine-scale));\n}\n\n  .m_fee9c77:where([data-full-width]) {\n    width: 100%;\n  }\n\n.m_9dddfbac {\n  width: var(--cp-preview-size);\n  height: var(--cp-preview-size);\n}\n\n.m_bffecc3e {\n  display: flex;\n  padding-top: calc(var(--cp-body-spacing) / 2);\n}\n\n.m_3283bb96 {\n  flex: 1;\n}\n\n.m_3283bb96:not(:only-child) {\n    margin-inline-end: var(--mantine-spacing-xs);\n  }\n\n.m_40d572ba {\n  overflow: hidden;\n  position: absolute;\n  box-shadow: 0 0 1px rgba(0, 0, 0, 0.6);\n  border: 2px solid var(--mantine-color-white);\n  width: var(--cp-thumb-size);\n  height: var(--cp-thumb-size);\n  border-radius: var(--cp-thumb-size);\n  left: calc(var(--thumb-x-offset) - var(--cp-thumb-size) / 2);\n  top: calc(var(--thumb-y-offset) - var(--cp-thumb-size) / 2);\n}\n\n.m_d8ee6fd8 {\n  height: unset !important;\n  width: unset !important;\n  min-width: 0 !important;\n  min-height: 0 !important;\n  margin: calc(0.125rem * var(--mantine-scale));\n  cursor: pointer;\n  padding-bottom: calc(var(--cp-swatch-size) - calc(0.25rem * var(--mantine-scale)));\n  flex: 0 0 calc(var(--cp-swatch-size) - calc(0.25rem * var(--mantine-scale)));\n}\n\n.m_5711e686 {\n  margin-top: calc(0.3125rem * var(--mantine-scale));\n  margin-inline: calc(-0.125rem * var(--mantine-scale));\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.m_202a296e {\n  --cp-thumb-size-xs: calc(0.5rem * var(--mantine-scale));\n  --cp-thumb-size-sm: calc(0.75rem * var(--mantine-scale));\n  --cp-thumb-size-md: calc(1rem * var(--mantine-scale));\n  --cp-thumb-size-lg: calc(1.25rem * var(--mantine-scale));\n  --cp-thumb-size-xl: calc(1.375rem * var(--mantine-scale));\n\n  -webkit-tap-highlight-color: transparent;\n  position: relative;\n  height: var(--cp-saturation-height);\n  border-radius: var(--mantine-radius-sm);\n  margin: calc(var(--cp-thumb-size) / 2);\n}\n\n.m_202a296e:where([data-focus-ring='auto']):focus:focus-visible .m_40d572ba {\n        outline: 2px solid var(--mantine-color-blue-filled);\n      }\n\n.m_202a296e:where([data-focus-ring='always']):focus .m_40d572ba {\n        outline: 2px solid var(--mantine-color-blue-filled);\n      }\n\n.m_11b3db02 {\n  position: absolute;\n  border-radius: var(--mantine-radius-sm);\n  inset: calc(var(--cp-thumb-size) * -1 / 2 - calc(0.0625rem * var(--mantine-scale)));\n}\n\n.m_d856d47d {\n  --cp-thumb-size-xs: calc(0.5rem * var(--mantine-scale));\n  --cp-thumb-size-sm: calc(0.75rem * var(--mantine-scale));\n  --cp-thumb-size-md: calc(1rem * var(--mantine-scale));\n  --cp-thumb-size-lg: calc(1.25rem * var(--mantine-scale));\n  --cp-thumb-size-xl: calc(1.375rem * var(--mantine-scale));\n  --cp-thumb-size: var(--cp-thumb-size, calc(0.75rem * var(--mantine-scale)));\n\n  position: relative;\n  height: calc(var(--cp-thumb-size) + calc(0.125rem * var(--mantine-scale)));\n  margin-inline: calc(var(--cp-thumb-size) / 2);\n  outline: none;\n}\n\n.m_d856d47d + .m_d856d47d {\n    margin-top: calc(0.375rem * var(--mantine-scale));\n  }\n\n.m_d856d47d:where([data-focus-ring='auto']):focus:focus-visible .m_40d572ba {\n        outline: 2px solid var(--mantine-color-blue-filled);\n      }\n\n.m_d856d47d:where([data-focus-ring='always']):focus .m_40d572ba {\n        outline: 2px solid var(--mantine-color-blue-filled);\n      }\n\n:where([data-mantine-color-scheme='light']) .m_d856d47d {\n    --slider-checkers: var(--mantine-color-gray-3);\n}\n\n:where([data-mantine-color-scheme='dark']) .m_d856d47d {\n    --slider-checkers: var(--mantine-color-dark-4);\n}\n\n.m_8f327113 {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  inset-inline: calc(var(--cp-thumb-size) * -1 / 2 - calc(0.0625rem * var(--mantine-scale)));\n  border-radius: 10000rem;\n}\n\n.m_b077c2bc {\n  --ci-eye-dropper-icon-size-xs: calc(0.875rem * var(--mantine-scale));\n  --ci-eye-dropper-icon-size-sm: calc(1rem * var(--mantine-scale));\n  --ci-eye-dropper-icon-size-md: calc(1.125rem * var(--mantine-scale));\n  --ci-eye-dropper-icon-size-lg: calc(1.25rem * var(--mantine-scale));\n  --ci-eye-dropper-icon-size-xl: calc(1.375rem * var(--mantine-scale));\n  --ci-eye-dropper-icon-size: var(--ci-eye-dropper-icon-size-sm);\n}\n\n.m_c5ccdcab {\n  --ci-preview-size-xs: calc(1rem * var(--mantine-scale));\n  --ci-preview-size-sm: calc(1.125rem * var(--mantine-scale));\n  --ci-preview-size-md: calc(1.375rem * var(--mantine-scale));\n  --ci-preview-size-lg: calc(1.75rem * var(--mantine-scale));\n  --ci-preview-size-xl: calc(2.25rem * var(--mantine-scale));\n  --ci-preview-size: var(--ci-preview-size-sm);\n}\n\n.m_5ece2cd7 {\n  padding: calc(0.5rem * var(--mantine-scale));\n}\n\n.m_7485cace {\n  --container-size-xs: calc(33.75rem * var(--mantine-scale));\n  --container-size-sm: calc(45rem * var(--mantine-scale));\n  --container-size-md: calc(60rem * var(--mantine-scale));\n  --container-size-lg: calc(71.25rem * var(--mantine-scale));\n  --container-size-xl: calc(82.5rem * var(--mantine-scale));\n  --container-size: var(--container-size-md);\n\n  max-width: var(--container-size);\n  padding-inline: var(--mantine-spacing-md);\n  margin-inline: auto;\n}\n\n  .m_7485cace:where([data-fluid]) {\n    max-width: 100%;\n  }\n\n.m_e2125a27 {\n  --dialog-size-xs: calc(10rem * var(--mantine-scale));\n  --dialog-size-sm: calc(12.5rem * var(--mantine-scale));\n  --dialog-size-md: calc(21.25rem * var(--mantine-scale));\n  --dialog-size-lg: calc(25rem * var(--mantine-scale));\n  --dialog-size-xl: calc(31.25rem * var(--mantine-scale));\n  --dialog-size: var(--dialog-size-md);\n\n  position: relative;\n  width: var(--dialog-size);\n  max-width: calc(100vw - var(--mantine-spacing-xl) * 2);\n  min-height: calc(3.125rem * var(--mantine-scale));\n}\n\n.m_5abab665 {\n  position: absolute;\n  top: calc(var(--mantine-spacing-md) / 2);\n  inset-inline-end: calc(var(--mantine-spacing-md) / 2);\n}\n\n.m_3eebeb36 {\n  --divider-size-xs: calc(0.0625rem * var(--mantine-scale));\n  --divider-size-sm: calc(0.125rem * var(--mantine-scale));\n  --divider-size-md: calc(0.1875rem * var(--mantine-scale));\n  --divider-size-lg: calc(0.25rem * var(--mantine-scale));\n  --divider-size-xl: calc(0.3125rem * var(--mantine-scale));\n  --divider-size: var(--divider-size-xs);\n}\n\n  :where([data-mantine-color-scheme='light']) .m_3eebeb36 {\n    --divider-color: var(--mantine-color-gray-3);\n}\n\n  :where([data-mantine-color-scheme='dark']) .m_3eebeb36 {\n    --divider-color: var(--mantine-color-dark-4);\n}\n\n  .m_3eebeb36:where([data-orientation='horizontal']) {\n    border-top: var(--divider-size) var(--divider-border-style, solid) var(--divider-color);\n  }\n\n  .m_3eebeb36:where([data-orientation='vertical']) {\n    border-inline-start: var(--divider-size) var(--divider-border-style, solid) var(--divider-color);\n    height: auto;\n    align-self: stretch;\n  }\n\n  .m_3eebeb36:where([data-with-label]) {\n    border: 0;\n  }\n\n.m_9e365f20 {\n  display: flex;\n  align-items: center;\n  font-size: var(--mantine-font-size-xs);\n  color: var(--mantine-color-dimmed);\n  white-space: nowrap;\n}\n\n.m_9e365f20:where([data-position='left'])::before {\n    display: none;\n  }\n\n.m_9e365f20:where([data-position='right'])::after {\n    display: none;\n  }\n\n.m_9e365f20::before {\n    content: '';\n    flex: 1;\n    height: calc(0.0625rem * var(--mantine-scale));\n    border-top: var(--divider-size) var(--divider-border-style, solid) var(--divider-color);\n    margin-inline-end: var(--mantine-spacing-xs);\n  }\n\n.m_9e365f20::after {\n    content: '';\n    flex: 1;\n    height: calc(0.0625rem * var(--mantine-scale));\n    border-top: var(--divider-size) var(--divider-border-style, solid) var(--divider-color);\n    margin-inline-start: var(--mantine-spacing-xs);\n  }\n\n.m_f11b401e {\n  --drawer-size-xs: calc(20rem * var(--mantine-scale));\n  --drawer-size-sm: calc(23.75rem * var(--mantine-scale));\n  --drawer-size-md: calc(27.5rem * var(--mantine-scale));\n  --drawer-size-lg: calc(38.75rem * var(--mantine-scale));\n  --drawer-size-xl: calc(48.75rem * var(--mantine-scale));\n  --drawer-size: var(--drawer-size-md);\n  --drawer-offset: 0rem;\n}\n\n.m_5a7c2c9 {\n  z-index: 1000;\n}\n\n.m_b8a05bbd {\n  flex: var(--drawer-flex, 0 0 var(--drawer-size));\n  height: var(--drawer-height, calc(100% - var(--drawer-offset) * 2));\n  margin: var(--drawer-offset);\n  max-width: calc(100% - var(--drawer-offset) * 2);\n  max-height: calc(100% - var(--drawer-offset) * 2);\n  overflow-y: auto;\n}\n\n.m_31cd769a {\n  display: flex;\n  justify-content: var(--drawer-justify, flex-start);\n  align-items: var(--drawer-align, flex-start);\n}\n\n.m_e9408a47 {\n  padding: var(--mantine-spacing-lg);\n  padding-top: var(--mantine-spacing-xs);\n  border-radius: var(--fieldset-radius, var(--mantine-radius-default));\n  min-inline-size: auto;\n}\n\n.m_84c9523a {\n  border: calc(0.0625rem * var(--mantine-scale)) solid;\n}\n\n:where([data-mantine-color-scheme='light']) .m_84c9523a {\n    border-color: var(--mantine-color-gray-3);\n    background-color: var(--mantine-color-white);\n}\n\n:where([data-mantine-color-scheme='dark']) .m_84c9523a {\n    border-color: var(--mantine-color-dark-4);\n    background-color: var(--mantine-color-dark-7);\n}\n\n.m_ef274e49 {\n  border: calc(0.0625rem * var(--mantine-scale)) solid;\n}\n\n:where([data-mantine-color-scheme='light']) .m_ef274e49 {\n    border-color: var(--mantine-color-gray-3);\n    background-color: var(--mantine-color-gray-0);\n}\n\n:where([data-mantine-color-scheme='dark']) .m_ef274e49 {\n    border-color: var(--mantine-color-dark-4);\n    background-color: var(--mantine-color-dark-6);\n}\n\n.m_eda993d3 {\n  padding: 0;\n  border: 0;\n  border-radius: 0;\n}\n\n.m_90794832 {\n  font-size: var(--mantine-font-size-sm);\n}\n\n.m_74ca27fe {\n  padding: 0;\n  margin-bottom: var(--mantine-spacing-sm);\n}\n\n.m_410352e9 {\n  --grid-overflow: visible;\n  --grid-margin: calc(var(--grid-gutter) / -2);\n  --grid-col-padding: calc(var(--grid-gutter) / 2);\n\n  overflow: var(--grid-overflow);\n}\n\n.m_dee7bd2f {\n  width: calc(100% + var(--grid-gutter));\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: var(--grid-justify);\n  align-items: var(--grid-align);\n  margin: var(--grid-margin);\n}\n\n.m_96bdd299 {\n  --col-flex-grow: 0;\n  --col-offset: 0rem;\n\n  flex-shrink: 0;\n  order: var(--col-order);\n  flex-basis: var(--col-flex-basis);\n  width: var(--col-width);\n  max-width: var(--col-max-width);\n  flex-grow: var(--col-flex-grow);\n  margin-inline-start: var(--col-offset);\n  padding: var(--grid-col-padding);\n}\n\n.m_bcb3f3c2 {\n  color: var(--mantine-color-black);\n}\n\n  :where([data-mantine-color-scheme='light']) .m_bcb3f3c2 {\n    background-color: var(--mark-bg-light);\n}\n\n  :where([data-mantine-color-scheme='dark']) .m_bcb3f3c2 {\n    background-color: var(--mark-bg-dark);\n}\n\n.m_9e117634 {\n  display: block;\n  flex: 0;\n  object-fit: var(--image-object-fit, cover);\n  width: 100%;\n  border-radius: var(--image-radius, 0);\n}\n\n@keyframes m_885901b1 {\n  0% {\n    opacity: 0.6;\n    transform: scale(0);\n  }\n\n  100% {\n    opacity: 0;\n    transform: scale(2.8);\n  }\n}\n\n.m_e5262200 {\n  --indicator-size: calc(0.625rem * var(--mantine-scale));\n  --indicator-color: var(--mantine-primary-color-filled);\n\n  position: relative;\n  display: block;\n}\n\n.m_e5262200:where([data-inline]) {\n    display: inline-block;\n  }\n\n.m_760d1fb1 {\n  position: absolute;\n  top: var(--indicator-top);\n  left: var(--indicator-left);\n  right: var(--indicator-right);\n  bottom: var(--indicator-bottom);\n  transform: translate(var(--indicator-translate-x), var(--indicator-translate-y));\n  min-width: var(--indicator-size);\n  height: var(--indicator-size);\n  border-radius: var(--indicator-radius, 1000rem);\n  z-index: var(--indicator-z-index, 200);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: var(--mantine-font-size-xs);\n  background-color: var(--indicator-color);\n  color: var(--indicator-text-color, var(--mantine-color-white));\n  white-space: nowrap;\n}\n\n.m_760d1fb1::before {\n    content: '';\n    position: absolute;\n    inset: 0;\n    background-color: var(--indicator-color);\n    border-radius: var(--indicator-radius, 1000rem);\n    z-index: -1;\n  }\n\n.m_760d1fb1:where([data-with-label]) {\n    padding-inline: calc(var(--mantine-spacing-xs) / 2);\n  }\n\n.m_760d1fb1:where([data-with-border]) {\n    border: 2px solid var(--mantine-color-body);\n  }\n\n.m_760d1fb1[data-processing]::before {\n      animation: m_885901b1 1000ms linear infinite;\n    }\n\n.m_dc6f14e2 {\n  --kbd-fz-xs: calc(0.625rem * var(--mantine-scale));\n  --kbd-fz-sm: calc(0.75rem * var(--mantine-scale));\n  --kbd-fz-md: calc(0.875rem * var(--mantine-scale));\n  --kbd-fz-lg: calc(1rem * var(--mantine-scale));\n  --kbd-fz-xl: calc(1.25rem * var(--mantine-scale));\n  --kbd-fz: var(--kbd-fz-sm);\n\n  --kbd-padding-xs: calc(0.125rem * var(--mantine-scale)) calc(0.25rem * var(--mantine-scale));\n  --kbd-padding-sm: calc(0.1875rem * var(--mantine-scale)) calc(0.3125rem * var(--mantine-scale));\n  --kbd-padding-md: calc(0.25rem * var(--mantine-scale)) calc(0.4375rem * var(--mantine-scale));\n  --kbd-padding-lg: calc(0.3125rem * var(--mantine-scale)) calc(0.5625rem * var(--mantine-scale));\n  --kbd-padding-xl: calc(0.5rem * var(--mantine-scale)) calc(0.875rem * var(--mantine-scale));\n  --kbd-padding: var(--kbd-padding-sm);\n\n  font-family: var(--mantine-font-family-monospace);\n  line-height: var(--mantine-line-height);\n  font-weight: 700;\n  padding: var(--kbd-padding);\n  font-size: var(--kbd-fz);\n  border-radius: var(--mantine-radius-sm);\n  border: calc(0.0625rem * var(--mantine-scale)) solid;\n  border-bottom-width: calc(0.1875rem * var(--mantine-scale));\n  unicode-bidi: embed;\n}\n\n  :where([data-mantine-color-scheme='light']) .m_dc6f14e2 {\n    border-color: var(--mantine-color-gray-3);\n    color: var(--mantine-color-gray-7);\n    background-color: var(--mantine-color-gray-0);\n}\n\n  :where([data-mantine-color-scheme='dark']) .m_dc6f14e2 {\n    border-color: var(--mantine-color-dark-4);\n    color: var(--mantine-color-dark-0);\n    background-color: var(--mantine-color-dark-6);\n}\n\n.m_abbac491 {\n  --list-fz: var(--mantine-font-size-md);\n  --list-lh: var(--mantine-line-height-md);\n\n  list-style-position: inside;\n  font-size: var(--list-fz);\n  line-height: var(--list-lh);\n  margin: 0;\n  padding: 0;\n}\n\n  .m_abbac491:where([data-with-padding]) {\n    padding-inline-start: var(--mantine-spacing-md);\n  }\n\n.m_abb6bec2 {\n  white-space: nowrap;\n  line-height: var(--list-lh);\n}\n\n.m_abb6bec2:where([data-with-icon]) {\n    list-style: none;\n  }\n\n.m_abb6bec2:where([data-with-icon]) .m_75cd9f71 {\n      --li-direction: row;\n      --li-align: center;\n    }\n\n.m_abb6bec2:where(:not(:first-of-type)) {\n    margin-top: var(--list-spacing, 0);\n  }\n\n.m_abb6bec2:where([data-centered]) {\n    line-height: 1;\n  }\n\n.m_75cd9f71 {\n  display: inline-flex;\n  flex-direction: var(--li-direction, column);\n  align-items: var(--li-align, flex-start);\n  white-space: normal;\n}\n\n.m_60f83e5b {\n  display: inline-block;\n  vertical-align: middle;\n  margin-inline-end: var(--mantine-spacing-sm);\n}\n\n.m_6e45937b {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  z-index: var(--lo-z-index);\n}\n\n.m_e8eb006c {\n  position: relative;\n  z-index: calc(var(--lo-z-index) + 1);\n}\n\n.m_df587f17 {\n  z-index: var(--lo-z-index);\n}\n\n.m_dc9b7c9f {\n  padding: calc(0.25rem * var(--mantine-scale));\n}\n\n.m_9bfac126 {\n  color: var(--mantine-color-dimmed);\n  font-weight: 500;\n  font-size: var(--mantine-font-size-xs);\n  padding: calc(var(--mantine-spacing-xs) / 2) var(--mantine-spacing-sm);\n  cursor: default;\n}\n\n.m_efdf90cb {\n  margin-top: calc(0.25rem * var(--mantine-scale));\n  margin-bottom: calc(0.25rem * var(--mantine-scale));\n  border-top: calc(0.0625rem * var(--mantine-scale)) solid;\n}\n\n:where([data-mantine-color-scheme='light']) .m_efdf90cb {\n    border-color: var(--mantine-color-gray-2);\n}\n\n:where([data-mantine-color-scheme='dark']) .m_efdf90cb {\n    border-color: var(--mantine-color-dark-4);\n}\n\n.m_99ac2aa1 {\n  font-size: var(--mantine-font-size-sm);\n  width: 100%;\n  padding: calc(var(--mantine-spacing-xs) / 1.5) var(--mantine-spacing-sm);\n  border-radius: var(--popover-radius, var(--mantine-radius-default));\n  color: var(--menu-item-color, var(--mantine-color-text));\n  display: flex;\n  align-items: center;\n  user-select: none;\n}\n\n.m_99ac2aa1:where([data-disabled], :disabled) {\n    color: var(--mantine-color-dimmed);\n    opacity: 0.6;\n    pointer-events: none;\n  }\n\n:where([data-mantine-color-scheme='light']) .m_99ac2aa1:where([data-hovered]) {\n      background-color: var(--menu-item-hover, var(--mantine-color-gray-1));\n}\n\n:where([data-mantine-color-scheme='dark']) .m_99ac2aa1:where([data-hovered]) {\n      background-color: var(--menu-item-hover, var(--mantine-color-dark-4));\n}\n\n.m_5476e0d3 {\n  flex: 1;\n}\n\n.m_8b75e504 {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.m_8b75e504:where([data-position='left']) {\n    margin-inline-end: var(--mantine-spacing-xs);\n  }\n\n.m_8b75e504:where([data-position='right']) {\n    margin-inline-start: var(--mantine-spacing-xs);\n  }\n\n.m_9df02822 {\n  --modal-size-xs: calc(20rem * var(--mantine-scale));\n  --modal-size-sm: calc(23.75rem * var(--mantine-scale));\n  --modal-size-md: calc(27.5rem * var(--mantine-scale));\n  --modal-size-lg: calc(38.75rem * var(--mantine-scale));\n  --modal-size-xl: calc(48.75rem * var(--mantine-scale));\n  --modal-size: var(--modal-size-md);\n\n  --modal-y-offset: 5dvh;\n  --modal-x-offset: 5vw;\n}\n\n  .m_9df02822[data-full-screen] {\n    --modal-border-radius: 0 !important;\n  }\n\n  .m_9df02822[data-full-screen] .m_54c44539 {\n      --modal-content-flex: 0 0 100%;\n      --modal-content-max-height: auto;\n      --modal-content-height: 100dvh;\n    }\n\n  .m_9df02822[data-full-screen] .m_1f958f16 {\n      --modal-inner-y-offset: 0;\n      --modal-inner-x-offset: 0;\n    }\n\n  .m_9df02822[data-centered] .m_1f958f16 {\n      --modal-inner-align: center;\n    }\n\n.m_d0e2b9cd {\n  border-start-start-radius: var(--modal-radius, var(--mantine-radius-default));\n  border-start-end-radius: var(--modal-radius, var(--mantine-radius-default));\n}\n\n.m_54c44539 {\n  flex: var(--modal-content-flex, 0 0 var(--modal-size));\n  max-width: 100%;\n  max-height: var(--modal-content-max-height, calc(100dvh - var(--modal-y-offset) * 2));\n  height: var(--modal-content-height, auto);\n  overflow-y: auto;\n}\n\n.m_54c44539[data-full-screen] {\n    border-radius: 0;\n  }\n\n.m_1f958f16 {\n  display: flex;\n  justify-content: center;\n  align-items: var(--modal-inner-align, flex-start);\n  padding-top: var(--modal-inner-y-offset, var(--modal-y-offset));\n  padding-bottom: var(--modal-inner-y-offset, var(--modal-y-offset));\n  padding-inline: var(--modal-inner-x-offset, var(--modal-x-offset));\n}\n\n.m_7cda1cd6 {\n  --pill-fz-xs: calc(0.625rem * var(--mantine-scale));\n  --pill-fz-sm: calc(0.75rem * var(--mantine-scale));\n  --pill-fz-md: calc(0.875rem * var(--mantine-scale));\n  --pill-fz-lg: calc(1rem * var(--mantine-scale));\n  --pill-fz-xl: calc(1.125rem * var(--mantine-scale));\n\n  --pill-height-xs: calc(1.125rem * var(--mantine-scale));\n  --pill-height-sm: calc(1.375rem * var(--mantine-scale));\n  --pill-height-md: calc(1.5625rem * var(--mantine-scale));\n  --pill-height-lg: calc(1.75rem * var(--mantine-scale));\n  --pill-height-xl: calc(2rem * var(--mantine-scale));\n\n  --pill-fz: var(--pill-fz-sm);\n  --pill-height: var(--pill-height-sm);\n\n  font-size: var(--pill-fz);\n  flex: 0;\n  height: var(--pill-height);\n  padding-inline: 0.8em;\n  display: inline-flex;\n  align-items: center;\n  border-radius: var(--pill-radius, 1000rem);\n  line-height: 1;\n  white-space: nowrap;\n  user-select: none;\n  -webkit-user-select: none;\n  max-width: 100%;\n}\n\n  :where([data-mantine-color-scheme='dark']) .m_7cda1cd6 {\n    background-color: var(--mantine-color-dark-7);\n    color: var(--mantine-color-dark-0);\n}\n\n  :where([data-mantine-color-scheme='light']) .m_7cda1cd6 {\n    color: var(--mantine-color-black);\n}\n\n  .m_7cda1cd6:where([data-with-remove]:not(:has(button:disabled))) {\n    padding-inline-end: 0;\n  }\n\n  .m_7cda1cd6:where([data-disabled], :has(button:disabled)) {\n    cursor: not-allowed;\n  }\n\n:where([data-mantine-color-scheme='light']) .m_44da308b {\n    background-color: var(--mantine-color-gray-1);\n}\n\n:where([data-mantine-color-scheme='light']) .m_44da308b:where([data-disabled], :has(button:disabled)) {\n      background-color: var(--mantine-color-gray-3);\n    }\n\n:where([data-mantine-color-scheme='light']) .m_e3a01f8 {\n    background-color: var(--mantine-color-white);\n}\n\n:where([data-mantine-color-scheme='light']) .m_e3a01f8:where([data-disabled], :has(button:disabled)) {\n      background-color: var(--mantine-color-gray-3);\n    }\n\n.m_1e0e6180 {\n  cursor: inherit;\n  overflow: hidden;\n  height: 100%;\n  line-height: var(--pill-height);\n  text-overflow: ellipsis;\n}\n\n.m_ae386778 {\n  color: inherit;\n  font-size: inherit;\n  height: 100%;\n  min-height: unset;\n  min-width: 2em;\n  width: unset;\n  border-radius: 0;\n  padding-inline-start: 0.1em;\n  padding-inline-end: 0.3em;\n  flex: 0;\n}\n\n.m_7cda1cd6[data-disabled] > .m_ae386778,\n  .m_ae386778:disabled {\n    display: none;\n    background-color: transparent;\n    width: 0.8em;\n    min-width: 0.8em;\n    padding: 0;\n    cursor: not-allowed;\n  }\n\n.m_7cda1cd6[data-disabled] > .m_ae386778 > svg, .m_ae386778:disabled > svg {\n      display: none;\n    }\n\n.m_ae386778 > svg {\n    pointer-events: none;\n  }\n\n.m_1dcfd90b {\n  --pg-gap-xs: calc(0.375rem * var(--mantine-scale));\n  --pg-gap-sm: calc(0.5rem * var(--mantine-scale));\n  --pg-gap-md: calc(0.625rem * var(--mantine-scale));\n  --pg-gap-lg: calc(0.75rem * var(--mantine-scale));\n  --pg-gap-xl: calc(0.75rem * var(--mantine-scale));\n  --pg-gap: var(--pg-gap-sm);\n\n  display: flex;\n  align-items: center;\n  gap: var(--pg-gap);\n  flex-wrap: wrap;\n}\n\n.m_45c4369d {\n  background-color: transparent;\n  appearance: none;\n  min-width: calc(6.25rem * var(--mantine-scale));\n  flex: 1;\n  border: 0;\n  font-size: inherit;\n  height: 1.6em;\n  color: inherit;\n  padding: 0;\n}\n\n  .m_45c4369d::placeholder {\n    color: var(--input-placeholder-color);\n    opacity: 1;\n  }\n\n  .m_45c4369d:where([data-type='hidden'], [data-type='auto']) {\n    height: calc(0.0625rem * var(--mantine-scale));\n    width: calc(0.0625rem * var(--mantine-scale));\n    top: 0;\n    left: 0;\n    pointer-events: none;\n    position: absolute;\n    opacity: 0;\n  }\n\n  .m_45c4369d:focus {\n    outline: none;\n  }\n\n  .m_45c4369d:where([data-type='auto']:focus) {\n    height: 1.6em;\n    visibility: visible;\n    opacity: 1;\n    position: static;\n  }\n\n  .m_45c4369d:where([data-pointer]:not([data-disabled], :disabled)) {\n    cursor: pointer;\n  }\n\n  .m_45c4369d:where([data-disabled], :disabled) {\n    cursor: not-allowed;\n  }\n\n.m_f0824112 {\n  --nl-bg: var(--mantine-primary-color-light);\n  --nl-hover: var(--mantine-primary-color-light-hover);\n  --nl-color: var(--mantine-primary-color-light-color);\n\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: 8px var(--mantine-spacing-sm);\n  user-select: none;\n}\n\n  @media (hover: hover) {\n    :where([data-mantine-color-scheme='light']) .m_f0824112:hover {\n      background-color: var(--mantine-color-gray-0);\n  }\n\n    :where([data-mantine-color-scheme='dark']) .m_f0824112:hover {\n      background-color: var(--mantine-color-dark-6);\n  }\n}\n\n  @media (hover: none) {\n    :where([data-mantine-color-scheme='light']) .m_f0824112:active {\n      background-color: var(--mantine-color-gray-0);\n  }\n\n    :where([data-mantine-color-scheme='dark']) .m_f0824112:active {\n      background-color: var(--mantine-color-dark-6);\n  }\n}\n\n  .m_f0824112:where([data-disabled]) {\n    opacity: 0.4;\n    pointer-events: none;\n  }\n\n  .m_f0824112:where([data-active], [aria-current='page']) {\n    background-color: var(--nl-bg);\n    color: var(--nl-color);\n  }\n\n  @media (hover: hover) {\n\n  .m_f0824112:where([data-active], [aria-current='page']):hover {\n      background-color: var(--nl-hover);\n  }\n}\n\n  @media (hover: none) {\n\n  .m_f0824112:where([data-active], [aria-current='page']):active {\n      background-color: var(--nl-hover);\n  }\n}\n\n  .m_f0824112:where([data-active], [aria-current='page']) .m_57492dcc {\n      --description-opacity: 0.9;\n      --description-color: var(--nl-color);\n    }\n\n.m_690090b5 {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: transform 150ms ease;\n}\n\n.m_690090b5 > svg {\n    display: block;\n  }\n\n.m_690090b5:where([data-position='left']) {\n    margin-inline-end: var(--mantine-spacing-sm);\n  }\n\n.m_690090b5:where([data-position='right']) {\n    margin-inline-start: var(--mantine-spacing-sm);\n  }\n\n.m_690090b5:where([data-rotate]) {\n    transform: rotate(90deg);\n  }\n\n.m_1f6ac4c4 {\n  font-size: var(--mantine-font-size-sm);\n}\n\n.m_f07af9d2 {\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.m_f07af9d2:where([data-no-wrap]) {\n    white-space: nowrap;\n  }\n\n.m_57492dcc {\n  display: block;\n  font-size: var(--mantine-font-size-xs);\n  opacity: var(--description-opacity, 1);\n  color: var(--description-color, var(--mantine-color-dimmed));\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n:where([data-no-wrap]) .m_57492dcc {\n    white-space: nowrap;\n  }\n\n.m_e17b862f {\n  padding-inline-start: var(--nl-offset, var(--mantine-spacing-lg));\n}\n\n.m_1fd8a00b {\n  transform: rotate(-90deg);\n}\n\n.m_a513464 {\n  --notification-radius: var(--mantine-radius-default);\n  --notification-color: var(--mantine-primary-color-filled);\n\n  overflow: hidden;\n  box-sizing: border-box;\n  position: relative;\n  display: flex;\n  align-items: center;\n  padding-inline-start: calc(1.375rem * var(--mantine-scale));\n  padding-inline-end: var(--mantine-spacing-xs);\n  padding-top: var(--mantine-spacing-xs);\n  padding-bottom: var(--mantine-spacing-xs);\n  border-radius: var(--notification-radius);\n  box-shadow: var(--mantine-shadow-lg);\n}\n\n  .m_a513464::before {\n    content: '';\n    display: block;\n    position: absolute;\n    width: calc(0.375rem * var(--mantine-scale));\n    top: var(--notification-radius);\n    bottom: var(--notification-radius);\n    inset-inline-start: calc(0.25rem * var(--mantine-scale));\n    border-radius: var(--notification-radius);\n    background-color: var(--notification-color);\n  }\n\n  :where([data-mantine-color-scheme='light']) .m_a513464 {\n    background-color: var(--mantine-color-white);\n}\n\n  :where([data-mantine-color-scheme='dark']) .m_a513464 {\n    background-color: var(--mantine-color-dark-6);\n}\n\n  .m_a513464:where([data-with-icon]) {\n    padding-inline-start: var(--mantine-spacing-xs);\n  }\n\n  .m_a513464:where([data-with-icon])::before {\n      display: none;\n    }\n\n  :where([data-mantine-color-scheme='light']) .m_a513464:where([data-with-border]) {\n      border: 1px solid var(--mantine-color-gray-3);\n}\n\n  :where([data-mantine-color-scheme='dark']) .m_a513464:where([data-with-border]) {\n      border: 1px solid var(--mantine-color-dark-4);\n}\n\n.m_a4ceffb {\n  box-sizing: border-box;\n  margin-inline-end: var(--mantine-spacing-md);\n  width: calc(1.75rem * var(--mantine-scale));\n  height: calc(1.75rem * var(--mantine-scale));\n  border-radius: calc(1.75rem * var(--mantine-scale));\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: var(--notification-color);\n  color: var(--mantine-color-white);\n}\n\n.m_b0920b15 {\n  margin-inline-end: var(--mantine-spacing-md);\n}\n\n.m_a49ed24 {\n  flex: 1;\n  overflow: hidden;\n  margin-inline-end: var(--mantine-spacing-xs);\n}\n\n.m_3feedf16 {\n  margin-bottom: calc(0.125rem * var(--mantine-scale));\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-size: var(--mantine-font-size-sm);\n  line-height: var(--mantine-line-height-sm);\n  font-weight: 500;\n}\n\n:where([data-mantine-color-scheme='light']) .m_3feedf16 {\n    color: var(--mantine-color-gray-9);\n}\n\n:where([data-mantine-color-scheme='dark']) .m_3feedf16 {\n    color: var(--mantine-color-white);\n}\n\n.m_3d733a3a {\n  font-size: var(--mantine-font-size-sm);\n  line-height: var(--mantine-line-height-sm);\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n:where([data-mantine-color-scheme='light']) .m_3d733a3a {\n    color: var(--mantine-color-black);\n}\n\n:where([data-mantine-color-scheme='dark']) .m_3d733a3a {\n    color: var(--mantine-color-dark-0);\n}\n\n:where([data-mantine-color-scheme='light']) .m_3d733a3a:where([data-with-title]) {\n      color: var(--mantine-color-gray-6);\n}\n\n:where([data-mantine-color-scheme='dark']) .m_3d733a3a:where([data-with-title]) {\n      color: var(--mantine-color-dark-2);\n}\n\n@media (hover: hover) {\n    :where([data-mantine-color-scheme='light']) .m_919a4d88:hover {\n      background-color: var(--mantine-color-gray-0);\n  }\n\n    :where([data-mantine-color-scheme='dark']) .m_919a4d88:hover {\n      background-color: var(--mantine-color-dark-8);\n  }\n}\n\n@media (hover: none) {\n    :where([data-mantine-color-scheme='light']) .m_919a4d88:active {\n      background-color: var(--mantine-color-gray-0);\n  }\n\n    :where([data-mantine-color-scheme='dark']) .m_919a4d88:active {\n      background-color: var(--mantine-color-dark-8);\n  }\n}\n\n.m_e2f5cd4e {\n  --ni-right-section-width-xs: calc(1.0625rem * var(--mantine-scale));\n  --ni-right-section-width-sm: calc(1.5rem * var(--mantine-scale));\n  --ni-right-section-width-md: calc(1.6875rem * var(--mantine-scale));\n  --ni-right-section-width-lg: calc(1.9375rem * var(--mantine-scale));\n  --ni-right-section-width-xl: calc(2.125rem * var(--mantine-scale));\n}\n\n.m_95e17d22 {\n  --ni-chevron-size-xs: calc(0.625rem * var(--mantine-scale));\n  --ni-chevron-size-sm: calc(0.875rem * var(--mantine-scale));\n  --ni-chevron-size-md: calc(1rem * var(--mantine-scale));\n  --ni-chevron-size-lg: calc(1.125rem * var(--mantine-scale));\n  --ni-chevron-size-xl: calc(1.25rem * var(--mantine-scale));\n  --ni-chevron-size: var(--ni-chevron-size-sm);\n\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: calc(var(--input-height) - calc(0.125rem * var(--mantine-scale)));\n  max-width: calc(var(--ni-chevron-size) * 1.7);\n  margin-inline-start: auto;\n}\n\n.m_80b4b171 {\n  --control-border: 1px solid var(--input-bd);\n  --control-radius: calc(var(--input-radius) - calc(0.0625rem * var(--mantine-scale)));\n\n  flex: 0 0 50%;\n  width: 100%;\n  padding: 0;\n  height: calc(var(--input-height) / 2 - calc(0.0625rem * var(--mantine-scale)));\n  border-inline-start: var(--control-border);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--mantine-color-text);\n  background-color: transparent;\n  cursor: pointer;\n}\n\n.m_80b4b171:where(:disabled) {\n    background-color: transparent;\n    cursor: not-allowed;\n    opacity: 0.6;\n  }\n\n:where([data-mantine-color-scheme='light']) .m_80b4b171:where(:disabled) {\n      color: var(--mantine-color-gray-4);\n}\n\n:where([data-mantine-color-scheme='dark']) .m_80b4b171:where(:disabled) {\n      color: var(--mantine-color-dark-3);\n}\n\n.m_e2f5cd4e[data-error] :where(.m_80b4b171) {\n    color: var(--mantine-color-error);\n  }\n\n@media (hover: hover) {\n    :where([data-mantine-color-scheme='light']) .m_80b4b171:hover {\n      background-color: var(--mantine-color-gray-0);\n  }\n\n    :where([data-mantine-color-scheme='dark']) .m_80b4b171:hover {\n      background-color: var(--mantine-color-dark-4);\n  }\n}\n\n@media (hover: none) {\n    :where([data-mantine-color-scheme='light']) .m_80b4b171:active {\n      background-color: var(--mantine-color-gray-0);\n  }\n\n    :where([data-mantine-color-scheme='dark']) .m_80b4b171:active {\n      background-color: var(--mantine-color-dark-4);\n  }\n}\n\n.m_80b4b171:where(:first-of-type) {\n    border-radius: 0;\n    border-start-end-radius: var(--control-radius);\n  }\n\n.m_80b4b171:last-of-type {\n    border-radius: 0;\n    border-end-end-radius: var(--control-radius);\n  }\n\n.m_4addd315 {\n  --pagination-control-size-xs: calc(1.375rem * var(--mantine-scale));\n  --pagination-control-size-sm: calc(1.625rem * var(--mantine-scale));\n  --pagination-control-size-md: calc(2rem * var(--mantine-scale));\n  --pagination-control-size-lg: calc(2.375rem * var(--mantine-scale));\n  --pagination-control-size-xl: calc(2.75rem * var(--mantine-scale));\n  --pagination-control-size: var(--pagination-control-size-md);\n  --pagination-control-fz: var(--mantine-font-size-md);\n  --pagination-active-bg: var(--mantine-primary-color-filled);\n}\n\n.m_326d024a {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: calc(0.0625rem * var(--mantine-scale)) solid;\n  cursor: pointer;\n  color: var(--mantine-color-text);\n  height: var(--pagination-control-size);\n  min-width: var(--pagination-control-size);\n  font-size: var(--pagination-control-fz);\n  line-height: 1;\n  border-radius: var(--pagination-control-radius, var(--mantine-radius-default));\n}\n\n.m_326d024a:where([data-with-padding]) {\n    padding: calc(var(--pagination-control-size) / 4);\n  }\n\n.m_326d024a:where(:disabled, [data-disabled]) {\n    cursor: not-allowed;\n    opacity: 0.4;\n  }\n\n:where([data-mantine-color-scheme='light']) .m_326d024a {\n    border-color: var(--mantine-color-gray-4);\n    background-color: var(--mantine-color-white);\n}\n\n@media (hover: hover) {\n      :where([data-mantine-color-scheme='light']) .m_326d024a:hover:where(:not(:disabled, [data-disabled])) {\n        background-color: var(--mantine-color-gray-0);\n      }\n}\n\n@media (hover: none) {\n      :where([data-mantine-color-scheme='light']) .m_326d024a:active:where(:not(:disabled, [data-disabled])) {\n        background-color: var(--mantine-color-gray-0);\n      }\n}\n\n:where([data-mantine-color-scheme='dark']) .m_326d024a {\n    border-color: var(--mantine-color-dark-4);\n    background-color: var(--mantine-color-dark-6);\n}\n\n@media (hover: hover) {\n      :where([data-mantine-color-scheme='dark']) .m_326d024a:hover:where(:not(:disabled, [data-disabled])) {\n        background-color: var(--mantine-color-dark-5);\n      }\n}\n\n@media (hover: none) {\n      :where([data-mantine-color-scheme='dark']) .m_326d024a:active:where(:not(:disabled, [data-disabled])) {\n        background-color: var(--mantine-color-dark-5);\n      }\n}\n\n.m_326d024a:where([data-active]) {\n    background-color: var(--pagination-active-bg);\n    border-color: var(--pagination-active-bg);\n    color: var(--pagination-active-color, var(--mantine-color-white));\n  }\n\n@media (hover: hover) {\n\n  .m_326d024a:where([data-active]):hover {\n      background-color: var(--pagination-active-bg);\n  }\n}\n\n@media (hover: none) {\n\n  .m_326d024a:where([data-active]):active {\n      background-color: var(--pagination-active-bg);\n  }\n}\n\n.m_4ad7767d {\n  height: var(--pagination-control-size);\n  min-width: var(--pagination-control-size);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  pointer-events: none;\n}\n\n.m_f61ca620 {\n  --psi-button-size-xs: calc(1.375rem * var(--mantine-scale));\n  --psi-button-size-sm: calc(1.625rem * var(--mantine-scale));\n  --psi-button-size-md: calc(1.75rem * var(--mantine-scale));\n  --psi-button-size-lg: calc(2rem * var(--mantine-scale));\n  --psi-button-size-xl: calc(2.5rem * var(--mantine-scale));\n\n  --psi-icon-size-xs: calc(0.75rem * var(--mantine-scale));\n  --psi-icon-size-sm: calc(0.9375rem * var(--mantine-scale));\n  --psi-icon-size-md: calc(1.0625rem * var(--mantine-scale));\n  --psi-icon-size-lg: calc(1.1875rem * var(--mantine-scale));\n  --psi-icon-size-xl: calc(1.3125rem * var(--mantine-scale));\n\n  --psi-button-size: var(--psi-button-size-sm);\n  --psi-icon-size: var(--psi-icon-size-sm);\n}\n\n.m_ccf8da4c {\n  position: relative;\n  overflow: hidden;\n}\n\n.m_f2d85dd2 {\n  font-family: var(--mantine-font-family);\n  background-color: transparent;\n  border: 0;\n  padding-inline-end: var(--input-padding-inline-end);\n  padding-inline-start: var(--input-padding-inline-start);\n  position: absolute;\n  inset: 0;\n  outline: 0;\n  font-size: inherit;\n  line-height: var(--mantine-line-height);\n  height: 100%;\n  width: 100%;\n  color: inherit;\n}\n\n.m_ccf8da4c[data-disabled] .m_f2d85dd2,\n  .m_f2d85dd2:disabled {\n    cursor: not-allowed;\n  }\n\n.m_f2d85dd2::placeholder {\n    color: var(--input-placeholder-color);\n    opacity: 1;\n  }\n\n.m_f2d85dd2::-ms-reveal {\n    display: none;\n  }\n\n.m_b1072d44 {\n  width: var(--psi-button-size);\n  height: var(--psi-button-size);\n  min-width: var(--psi-button-size);\n  min-height: var(--psi-button-size);\n}\n\n.m_b1072d44:disabled {\n    display: none;\n  }\n\n.m_f1cb205a {\n  --pin-input-size-xs: calc(1.875rem * var(--mantine-scale));\n  --pin-input-size-sm: calc(2.25rem * var(--mantine-scale));\n  --pin-input-size-md: calc(2.625rem * var(--mantine-scale));\n  --pin-input-size-lg: calc(3.125rem * var(--mantine-scale));\n  --pin-input-size-xl: calc(3.75rem * var(--mantine-scale));\n  --pin-input-size: var(--pin-input-size-sm);\n}\n\n.m_cb288ead {\n  width: var(--pin-input-size);\n  height: var(--pin-input-size);\n}\n\n@keyframes m_81a374bd {\n  0% {\n    background-position: 0 0;\n  }\n\n  100% {\n    background-position: calc(2.5rem * var(--mantine-scale)) 0;\n  }\n}\n\n.m_db6d6462 {\n  --progress-radius: var(--mantine-radius-default);\n  --progress-size: var(--progress-size-md);\n\n  --progress-size-xs: calc(0.1875rem * var(--mantine-scale));\n  --progress-size-sm: calc(0.3125rem * var(--mantine-scale));\n  --progress-size-md: calc(0.5rem * var(--mantine-scale));\n  --progress-size-lg: calc(0.75rem * var(--mantine-scale));\n  --progress-size-xl: calc(1rem * var(--mantine-scale));\n\n  position: relative;\n  height: var(--progress-size);\n  border-radius: var(--progress-radius);\n  overflow: hidden;\n  display: flex;\n}\n\n:where([data-mantine-color-scheme='light']) .m_db6d6462 {\n    background-color: var(--mantine-color-gray-2);\n}\n\n:where([data-mantine-color-scheme='dark']) .m_db6d6462 {\n    background-color: var(--mantine-color-dark-4);\n}\n\n.m_2242eb65 {\n  background-color: var(--progress-section-color);\n  height: 100%;\n  width: var(--progress-section-width);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  background-size: calc(1.25rem * var(--mantine-scale)) calc(1.25rem * var(--mantine-scale));\n  transition: width var(--progress-transition-duration, 100ms) ease;\n}\n\n.m_2242eb65:where([data-striped]) {\n    background-image: linear-gradient(\n      45deg,\n      rgba(255, 255, 255, 0.15) 25%,\n      transparent 25%,\n      transparent 50%,\n      rgba(255, 255, 255, 0.15) 50%,\n      rgba(255, 255, 255, 0.15) 75%,\n      transparent 75%,\n      transparent\n    );\n  }\n\n.m_2242eb65:where([data-animated]) {\n    animation: m_81a374bd 1s linear infinite;\n  }\n\n.m_2242eb65:where(:last-of-type) {\n    border-radius: 0;\n    border-start-end-radius: var(--progress-radius);\n    border-end-end-radius: var(--progress-radius);\n  }\n\n.m_2242eb65:where(:first-of-type) {\n    border-radius: 0;\n    border-start-start-radius: var(--progress-radius);\n    border-end-start-radius: var(--progress-radius);\n  }\n\n.m_91e40b74 {\n  color: var(--progress-label-color, var(--mantine-color-white));\n  font-weight: bold;\n  user-select: none;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  font-size: min(calc(var(--progress-size) * 0.65), calc(1.125rem * var(--mantine-scale)));\n  line-height: 1;\n  padding-inline: calc(0.25rem * var(--mantine-scale));\n}\n\n.m_9dc8ae12 {\n  --card-radius: var(--mantine-radius-default);\n\n  display: block;\n  width: 100%;\n  border-radius: var(--card-radius);\n  cursor: pointer;\n}\n\n  .m_9dc8ae12 :where(*) {\n    cursor: inherit;\n  }\n\n  .m_9dc8ae12:where([data-with-border]) {\n    border: calc(0.0625rem * var(--mantine-scale)) solid transparent;\n  }\n\n  :where([data-mantine-color-scheme='light']) .m_9dc8ae12:where([data-with-border]) {\n      border-color: var(--mantine-color-gray-3);\n}\n\n  :where([data-mantine-color-scheme='dark']) .m_9dc8ae12:where([data-with-border]) {\n      border-color: var(--mantine-color-dark-4);\n}\n\n.m_717d7ff6 {\n  --radio-size-xs: calc(1rem * var(--mantine-scale));\n  --radio-size-sm: calc(1.25rem * var(--mantine-scale));\n  --radio-size-md: calc(1.5rem * var(--mantine-scale));\n  --radio-size-lg: calc(1.875rem * var(--mantine-scale));\n  --radio-size-xl: calc(2.25rem * var(--mantine-scale));\n\n  --radio-icon-size-xs: calc(0.375rem * var(--mantine-scale));\n  --radio-icon-size-sm: calc(0.5rem * var(--mantine-scale));\n  --radio-icon-size-md: calc(0.625rem * var(--mantine-scale));\n  --radio-icon-size-lg: calc(0.875rem * var(--mantine-scale));\n  --radio-icon-size-xl: calc(1rem * var(--mantine-scale));\n\n  --radio-icon-size: var(--radio-icon-size-sm);\n  --radio-size: var(--radio-size-sm);\n  --radio-color: var(--mantine-primary-color-filled);\n  --radio-icon-color: var(--mantine-color-white);\n\n  position: relative;\n  border: calc(0.0625rem * var(--mantine-scale)) solid transparent;\n  width: var(--radio-size);\n  min-width: var(--radio-size);\n  height: var(--radio-size);\n  min-height: var(--radio-size);\n  border-radius: var(--radio-radius, 10000px);\n  transition:\n    border-color 100ms ease,\n    background-color 100ms ease;\n  cursor: var(--mantine-cursor-type);\n  -webkit-tap-highlight-color: transparent;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n  :where([data-mantine-color-scheme='light']) .m_717d7ff6 {\n    background-color: var(--mantine-color-white);\n    border-color: var(--mantine-color-gray-4);\n}\n\n  :where([data-mantine-color-scheme='dark']) .m_717d7ff6 {\n    background-color: var(--mantine-color-dark-6);\n    border-color: var(--mantine-color-dark-4);\n}\n\n  .m_717d7ff6[data-indeterminate],\n  .m_717d7ff6[data-checked] {\n    background-color: var(--radio-color);\n    border-color: var(--radio-color);\n  }\n\n  .m_717d7ff6[data-indeterminate] > .m_3e4da632, .m_717d7ff6[data-checked] > .m_3e4da632 {\n      opacity: 1;\n      transform: none;\n      color: var(--radio-icon-color);\n    }\n\n  .m_717d7ff6[data-disabled] {\n    cursor: not-allowed;\n  }\n\n  :where([data-mantine-color-scheme='light']) .m_717d7ff6[data-disabled] {\n      background-color: var(--mantine-color-gray-2);\n      border-color: var(--mantine-color-gray-3);\n}\n\n  :where([data-mantine-color-scheme='dark']) .m_717d7ff6[data-disabled] {\n      background-color: var(--mantine-color-dark-6);\n      border-color: var(--mantine-color-dark-6);\n}\n\n  [data-mantine-color-scheme='light'] .m_717d7ff6[data-disabled][data-checked] > .m_3e4da632 {\n        color: var(--mantine-color-gray-5);\n}\n\n  [data-mantine-color-scheme='dark'] .m_717d7ff6[data-disabled][data-checked] > .m_3e4da632 {\n        color: var(--mantine-color-dark-3);\n}\n\n.m_2980836c[data-indeterminate]:not([data-disabled]),\n  .m_2980836c[data-checked]:not([data-disabled]) {\n    background-color: transparent;\n    border-color: var(--radio-color);\n  }\n\n.m_2980836c[data-indeterminate]:not([data-disabled]) > .m_3e4da632, .m_2980836c[data-checked]:not([data-disabled]) > .m_3e4da632 {\n      color: var(--radio-color);\n      opacity: 1;\n      transform: none;\n    }\n\n.m_3e4da632 {\n  display: block;\n  width: var(--radio-icon-size);\n  height: var(--radio-icon-size);\n  color: transparent;\n  pointer-events: none;\n  transform: translateY(calc(0.3125rem * var(--mantine-scale))) scale(0.5);\n  opacity: 1;\n  transition:\n    transform 100ms ease,\n    opacity 100ms ease;\n}\n\n.m_f3f1af94 {\n  --radio-size-xs: calc(1rem * var(--mantine-scale));\n  --radio-size-sm: calc(1.25rem * var(--mantine-scale));\n  --radio-size-md: calc(1.5rem * var(--mantine-scale));\n  --radio-size-lg: calc(1.875rem * var(--mantine-scale));\n  --radio-size-xl: calc(2.25rem * var(--mantine-scale));\n  --radio-size: var(--radio-size-sm);\n\n  --radio-icon-size-xs: calc(0.375rem * var(--mantine-scale));\n  --radio-icon-size-sm: calc(0.5rem * var(--mantine-scale));\n  --radio-icon-size-md: calc(0.625rem * var(--mantine-scale));\n  --radio-icon-size-lg: calc(0.875rem * var(--mantine-scale));\n  --radio-icon-size-xl: calc(1rem * var(--mantine-scale));\n  --radio-icon-size: var(--radio-icon-size-sm);\n  --radio-icon-color: var(--mantine-color-white);\n}\n\n.m_89c4f5e4 {\n  position: relative;\n  width: var(--radio-size);\n  height: var(--radio-size);\n  order: 1;\n}\n\n.m_89c4f5e4:where([data-label-position='left']) {\n    order: 2;\n  }\n\n.m_f3ed6b2b {\n  color: var(--radio-icon-color);\n  opacity: var(--radio-icon-opacity, 0);\n  transform: var(--radio-icon-transform, scale(0.2) translateY(calc(0.625rem * var(--mantine-scale))));\n  transition:\n    opacity 100ms ease,\n    transform 200ms ease;\n  pointer-events: none;\n  width: var(--radio-icon-size);\n  height: var(--radio-icon-size);\n  position: absolute;\n  top: calc(50% - var(--radio-icon-size) / 2);\n  left: calc(50% - var(--radio-icon-size) / 2);\n}\n\n.m_8a3dbb89 {\n  border: calc(0.0625rem * var(--mantine-scale)) solid;\n  position: relative;\n  appearance: none;\n  width: var(--radio-size);\n  height: var(--radio-size);\n  border-radius: var(--radio-radius, var(--radio-size));\n  margin: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition-property: background-color, border-color;\n  transition-timing-function: ease;\n  transition-duration: 100ms;\n  cursor: var(--mantine-cursor-type);\n  -webkit-tap-highlight-color: transparent;\n}\n\n:where([data-mantine-color-scheme='light']) .m_8a3dbb89 {\n    background-color: var(--mantine-color-white);\n    border-color: var(--mantine-color-gray-4);\n}\n\n:where([data-mantine-color-scheme='dark']) .m_8a3dbb89 {\n    background-color: var(--mantine-color-dark-6);\n    border-color: var(--mantine-color-dark-4);\n}\n\n.m_8a3dbb89:checked {\n    background-color: var(--radio-color, var(--mantine-primary-color-filled));\n    border-color: var(--radio-color, var(--mantine-primary-color-filled));\n  }\n\n.m_8a3dbb89:checked + .m_f3ed6b2b {\n      --radio-icon-opacity: 1;\n      --radio-icon-transform: scale(1);\n    }\n\n.m_8a3dbb89:disabled {\n    cursor: not-allowed;\n  }\n\n:where([data-mantine-color-scheme='light']) .m_8a3dbb89:disabled {\n      background-color: var(--mantine-color-gray-1);\n      border-color: var(--mantine-color-gray-2);\n}\n\n:where([data-mantine-color-scheme='light']) .m_8a3dbb89:disabled + .m_f3ed6b2b {\n        --radio-icon-color: var(--mantine-color-gray-3);\n      }\n\n:where([data-mantine-color-scheme='dark']) .m_8a3dbb89:disabled {\n      background-color: var(--mantine-color-dark-5);\n      border-color: var(--mantine-color-dark-4);\n}\n\n:where([data-mantine-color-scheme='dark']) .m_8a3dbb89:disabled + .m_f3ed6b2b {\n        --radio-icon-color: var(--mantine-color-dark-7);\n      }\n\n.m_8a3dbb89:where([data-error]) {\n    border-color: var(--mantine-color-error);\n  }\n\n.m_1bfe9d39 + .m_f3ed6b2b {\n    --radio-icon-color: var(--radio-color);\n  }\n\n.m_1bfe9d39:checked:not(:disabled) {\n    background-color: transparent;\n    border-color: var(--radio-color);\n  }\n\n.m_1bfe9d39:checked:not(:disabled) + .m_f3ed6b2b {\n      --radio-icon-color: var(--radio-color);\n      --radio-icon-opacity: 1;\n      --radio-icon-transform: none;\n    }\n\n.m_f8d312f2 {\n  --rating-size-xs: calc(0.875rem * var(--mantine-scale));\n  --rating-size-sm: calc(1.125rem * var(--mantine-scale));\n  --rating-size-md: calc(1.25rem * var(--mantine-scale));\n  --rating-size-lg: calc(1.75rem * var(--mantine-scale));\n  --rating-size-xl: calc(2rem * var(--mantine-scale));\n\n  display: flex;\n  width: max-content;\n}\n\n  .m_f8d312f2:where(:has(input:disabled)) {\n    pointer-events: none;\n  }\n\n.m_61734bb7 {\n  position: relative;\n  transition: transform 100ms ease;\n}\n\n.m_61734bb7:where([data-active]) {\n    z-index: 1;\n    transform: scale(1.1);\n  }\n\n.m_5662a89a {\n  width: var(--rating-size);\n  height: var(--rating-size);\n  display: block;\n}\n\n:where([data-mantine-color-scheme='light']) .m_5662a89a {\n    fill: var(--mantine-color-gray-3);\n    stroke: var(--mantine-color-gray-3);\n}\n\n:where([data-mantine-color-scheme='dark']) .m_5662a89a {\n    fill: var(--mantine-color-dark-3);\n    stroke: var(--mantine-color-dark-3);\n}\n\n.m_5662a89a:where([data-filled]) {\n    fill: var(--rating-color);\n    stroke: var(--rating-color);\n  }\n\n.m_211007ba {\n  height: 0;\n  width: 0;\n  position: absolute;\n  overflow: hidden;\n  white-space: nowrap;\n  opacity: 0;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.m_211007ba:focus-visible + label {\n    outline: 2px solid var(--mantine-primary-color-filled);\n    outline-offset: calc(0.125rem * var(--mantine-scale));\n  }\n\n.m_21342ee4 {\n  display: block;\n  cursor: pointer;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: var(--rating-item-z-index, 0);\n  -webkit-tap-highlight-color: transparent;\n}\n\n.m_21342ee4:where([data-read-only]) {\n    cursor: default;\n  }\n\n.m_21342ee4:where(:last-of-type) {\n    position: relative;\n  }\n\n.m_fae05d6a {\n  clip-path: var(--rating-symbol-clip-path);\n}\n\n.m_1b3c8819 {\n  --tooltip-radius: var(--mantine-radius-default);\n\n  position: absolute;\n  padding: calc(var(--mantine-spacing-xs) / 2) var(--mantine-spacing-xs);\n  pointer-events: none;\n  font-size: var(--mantine-font-size-sm);\n  white-space: nowrap;\n  border-radius: var(--tooltip-radius);\n}\n\n  :where([data-mantine-color-scheme='light']) .m_1b3c8819 {\n    background-color: var(--tooltip-bg, var(--mantine-color-gray-9));\n    color: var(--tooltip-color, var(--mantine-color-white));\n}\n\n  :where([data-mantine-color-scheme='dark']) .m_1b3c8819 {\n    background-color: var(--tooltip-bg, var(--mantine-color-gray-2));\n    color: var(--tooltip-color, var(--mantine-color-black));\n}\n\n  .m_1b3c8819:where([data-multiline]) {\n    white-space: normal;\n  }\n\n  .m_1b3c8819:where([data-fixed]) {\n    position: fixed;\n  }\n\n.m_f898399f {\n  background-color: inherit;\n  border: 0;\n  z-index: 1;\n}\n\n.m_b32e4812 {\n  position: relative;\n  width: var(--rp-size);\n  height: var(--rp-size);\n  min-width: var(--rp-size);\n  min-height: var(--rp-size);\n}\n\n.m_d43b5134 {\n  width: var(--rp-size);\n  height: var(--rp-size);\n  min-width: var(--rp-size);\n  min-height: var(--rp-size);\n  transform: rotate(-90deg);\n}\n\n.m_b1ca1fbf {\n  stroke: var(--curve-color, var(--rp-curve-root-color));\n}\n\n[data-mantine-color-scheme='light'] .m_b1ca1fbf {\n    --rp-curve-root-color: var(--mantine-color-gray-2);\n}\n\n[data-mantine-color-scheme='dark'] .m_b1ca1fbf {\n    --rp-curve-root-color: var(--mantine-color-dark-4);\n}\n\n.m_b23f9dc4 {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  inset-inline: var(--rp-label-offset);\n}\n\n.m_cf365364 {\n  --sc-padding-xs: calc(0.1875rem * var(--mantine-scale)) calc(0.375rem * var(--mantine-scale));\n  --sc-padding-sm: calc(0.3125rem * var(--mantine-scale)) calc(0.625rem * var(--mantine-scale));\n  --sc-padding-md: calc(0.4375rem * var(--mantine-scale)) calc(0.875rem * var(--mantine-scale));\n  --sc-padding-lg: calc(0.5625rem * var(--mantine-scale)) calc(1rem * var(--mantine-scale));\n  --sc-padding-xl: calc(0.75rem * var(--mantine-scale)) calc(1.25rem * var(--mantine-scale));\n\n  --sc-transition-duration: 200ms;\n  --sc-padding: var(--sc-padding-sm);\n  --sc-transition-timing-function: ease;\n  --sc-font-size: var(--mantine-font-size-sm);\n\n  position: relative;\n  display: inline-flex;\n  flex-direction: row;\n  width: auto;\n  border-radius: var(--sc-radius, var(--mantine-radius-default));\n  overflow: hidden;\n  padding: calc(0.25rem * var(--mantine-scale));\n}\n\n  .m_cf365364:where([data-full-width]) {\n    display: flex;\n  }\n\n  .m_cf365364:where([data-orientation='vertical']) {\n    display: flex;\n    flex-direction: column;\n    width: max-content;\n  }\n\n  .m_cf365364:where([data-orientation='vertical']):where([data-full-width]) {\n      width: auto;\n    }\n\n  :where([data-mantine-color-scheme='light']) .m_cf365364 {\n    background-color: var(--mantine-color-gray-1);\n}\n\n  :where([data-mantine-color-scheme='dark']) .m_cf365364 {\n    background-color: var(--mantine-color-dark-8);\n}\n\n.m_9e182ccd {\n  position: absolute;\n  display: block;\n  z-index: 1;\n  border-radius: var(--sc-radius, var(--mantine-radius-default));\n}\n\n:where([data-mantine-color-scheme='light']) .m_9e182ccd {\n    box-shadow: var(--sc-shadow, none);\n    background-color: var(--sc-color, var(--mantine-color-white));\n}\n\n:where([data-mantine-color-scheme='dark']) .m_9e182ccd {\n    box-shadow: none;\n    background-color: var(--sc-color, var(--mantine-color-dark-5));\n}\n\n.m_1738fcb2 {\n  -webkit-tap-highlight-color: transparent;\n  font-weight: 500;\n  display: block;\n  text-align: center;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  user-select: none;\n  border-radius: var(--sc-radius, var(--mantine-radius-default));\n  font-size: var(--sc-font-size);\n  padding: var(--sc-padding);\n  transition: color var(--sc-transition-duration) var(--sc-transition-timing-function);\n  cursor: pointer;\n\n  /* outline is controlled by .input */\n  outline: var(--segmented-control-outline, none);\n}\n\n:where([data-mantine-color-scheme='light']) .m_1738fcb2 {\n    color: var(--mantine-color-gray-7);\n}\n\n:where([data-mantine-color-scheme='dark']) .m_1738fcb2 {\n    color: var(--mantine-color-dark-1);\n}\n\n.m_1738fcb2:where([data-read-only]) {\n    cursor: default;\n  }\n\nfieldset:disabled .m_1738fcb2,\n  .m_1738fcb2:where([data-disabled]) {\n    cursor: not-allowed;\n  }\n\n:where([data-mantine-color-scheme='light']) fieldset:disabled .m_1738fcb2, :where([data-mantine-color-scheme='light']) .m_1738fcb2:where([data-disabled]) {\n      color: var(--mantine-color-gray-5);\n}\n\n:where([data-mantine-color-scheme='dark']) fieldset:disabled .m_1738fcb2, :where([data-mantine-color-scheme='dark']) .m_1738fcb2:where([data-disabled]) {\n      color: var(--mantine-color-dark-3);\n}\n\n:where([data-mantine-color-scheme='light']) .m_1738fcb2:where([data-active]) {\n      color: var(--sc-label-color, var(--mantine-color-black));\n}\n\n:where([data-mantine-color-scheme='dark']) .m_1738fcb2:where([data-active]) {\n      color: var(--sc-label-color, var(--mantine-color-white));\n}\n\n.m_cf365364:where([data-initialized]) .m_1738fcb2:where([data-active])::before {\n        display: none;\n      }\n\n.m_1738fcb2:where([data-active])::before {\n      content: '';\n      inset: 0;\n      z-index: 0;\n      position: absolute;\n      border-radius: var(--sc-radius, var(--mantine-radius-default));\n}\n\n:where([data-mantine-color-scheme='light']) .m_1738fcb2:where([data-active])::before {\n        box-shadow: var(--sc-shadow, none);\n        background-color: var(--sc-color, var(--mantine-color-white));\n}\n\n:where([data-mantine-color-scheme='dark']) .m_1738fcb2:where([data-active])::before {\n        box-shadow: none;\n        background-color: var(--sc-color, var(--mantine-color-dark-5));\n}\n\n@media (hover: hover) {\n      :where([data-mantine-color-scheme='light']) .m_1738fcb2:where(:not([data-disabled], [data-active], [data-read-only])):hover {\n        color: var(--mantine-color-black);\n  }\n\n      :where([data-mantine-color-scheme='dark']) .m_1738fcb2:where(:not([data-disabled], [data-active], [data-read-only])):hover {\n        color: var(--mantine-color-white);\n  }\n}\n\n@media (hover: none) {\n      :where([data-mantine-color-scheme='light']) .m_1738fcb2:where(:not([data-disabled], [data-active], [data-read-only])):active {\n        color: var(--mantine-color-black);\n  }\n\n      :where([data-mantine-color-scheme='dark']) .m_1738fcb2:where(:not([data-disabled], [data-active], [data-read-only])):active {\n        color: var(--mantine-color-white);\n  }\n}\n\n@media (hover: hover) {\n      :where([data-mantine-color-scheme='light']) fieldset:disabled .m_1738fcb2:hover {\n        color: var(--mantine-color-gray-5) !important;\n  }\n\n      :where([data-mantine-color-scheme='dark']) fieldset:disabled .m_1738fcb2:hover {\n        color: var(--mantine-color-dark-3) !important;\n  }\n}\n\n@media (hover: none) {\n      :where([data-mantine-color-scheme='light']) fieldset:disabled .m_1738fcb2:active {\n        color: var(--mantine-color-gray-5) !important;\n  }\n\n      :where([data-mantine-color-scheme='dark']) fieldset:disabled .m_1738fcb2:active {\n        color: var(--mantine-color-dark-3) !important;\n  }\n}\n\n.m_1714d588 {\n  height: 0;\n  width: 0;\n  position: absolute;\n  overflow: hidden;\n  white-space: nowrap;\n  opacity: 0;\n}\n\n.m_1714d588[data-focus-ring='auto']:focus:focus-visible + .m_1738fcb2 {\n        --segmented-control-outline: 2px solid var(--mantine-primary-color-filled);\n      }\n\n.m_1714d588[data-focus-ring='always']:focus + .m_1738fcb2 {\n        --segmented-control-outline: 2px solid var(--mantine-primary-color-filled);\n      }\n\n.m_69686b9b {\n  position: relative;\n  flex: 1;\n  z-index: 2;\n  transition: border-color var(--sc-transition-duration) var(--sc-transition-timing-function);\n}\n\n.m_cf365364[data-with-items-borders] :where(.m_69686b9b)::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    inset-inline-start: 0;\n    background-color: var(--separator-color);\n    width: calc(0.0625rem * var(--mantine-scale));\n    transition: background-color var(--sc-transition-duration) var(--sc-transition-timing-function);\n  }\n\n.m_69686b9b[data-orientation='vertical']::before {\n      top: 0;\n      inset-inline: 0;\n      bottom: auto;\n      height: calc(0.0625rem * var(--mantine-scale));\n      width: auto;\n    }\n\n:where([data-mantine-color-scheme='light']) .m_69686b9b {\n    --separator-color: var(--mantine-color-gray-3);\n}\n\n:where([data-mantine-color-scheme='dark']) .m_69686b9b {\n    --separator-color: var(--mantine-color-dark-4);\n}\n\n.m_69686b9b:first-of-type::before {\n      --separator-color: transparent;\n    }\n\n[data-mantine-color-scheme] .m_69686b9b[data-active]::before, [data-mantine-color-scheme] .m_69686b9b[data-active] + .m_69686b9b::before {\n          --separator-color: transparent;\n        }\n\n.m_78882f40 {\n  position: relative;\n  z-index: 2;\n}\n\n.m_925c2d2c {\n  container: simple-grid / inline-size;\n}\n\n.m_2415a157 {\n  display: grid;\n  grid-template-columns: repeat(var(--sg-cols), minmax(0, 1fr));\n  gap: var(--sg-spacing-y) var(--sg-spacing-x);\n}\n\n@keyframes m_299c329c {\n  0%,\n  100% {\n    opacity: 0.4;\n  }\n\n  50% {\n    opacity: 1;\n  }\n}\n\n.m_18320242 {\n  height: var(--skeleton-height, auto);\n  width: var(--skeleton-width, 100%);\n  border-radius: var(--skeleton-radius, var(--mantine-radius-default));\n  position: relative;\n  transform: translateZ(0);\n  -webkit-transform: translateZ(0);\n}\n\n.m_18320242:where([data-animate])::after {\n    animation: m_299c329c 1500ms linear infinite;\n  }\n\n.m_18320242:where([data-visible]) {\n    overflow: hidden;\n  }\n\n.m_18320242:where([data-visible])::before {\n      position: absolute;\n      content: '';\n      inset: 0;\n      z-index: 10;\n      background-color: var(--mantine-color-body);\n    }\n\n.m_18320242:where([data-visible])::after {\n      position: absolute;\n      content: '';\n      inset: 0;\n      z-index: 11;\n    }\n\n:where([data-mantine-color-scheme='light']) .m_18320242:where([data-visible])::after {\n        background-color: var(--mantine-color-gray-3);\n}\n\n:where([data-mantine-color-scheme='dark']) .m_18320242:where([data-visible])::after {\n        background-color: var(--mantine-color-dark-4);\n}\n\n.m_dd36362e {\n  --slider-size-xs: calc(0.25rem * var(--mantine-scale));\n  --slider-size-sm: calc(0.375rem * var(--mantine-scale));\n  --slider-size-md: calc(0.5rem * var(--mantine-scale));\n  --slider-size-lg: calc(0.625rem * var(--mantine-scale));\n  --slider-size-xl: calc(0.75rem * var(--mantine-scale));\n\n  --slider-size: var(--slider-size-md);\n  --slider-radius: calc(62.5rem * var(--mantine-scale));\n  --slider-color: var(--mantine-primary-color-filled);\n\n  -webkit-tap-highlight-color: transparent;\n  outline: none;\n  height: calc(var(--slider-size) * 2);\n  padding-inline: var(--slider-size);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  touch-action: none;\n  position: relative;\n}\n\n  [data-mantine-color-scheme='light'] .m_dd36362e {\n    --slider-track-bg: var(--mantine-color-gray-2);\n    --slider-track-disabled-bg: var(--mantine-color-gray-4);\n}\n\n  [data-mantine-color-scheme='dark'] .m_dd36362e {\n    --slider-track-bg: var(--mantine-color-dark-4);\n    --slider-track-disabled-bg: var(--mantine-color-dark-3);\n}\n\n.m_c9357328 {\n  position: absolute;\n  top: calc(-2.25rem * var(--mantine-scale));\n  font-size: var(--mantine-font-size-xs);\n  color: var(--mantine-color-white);\n  padding: calc(var(--mantine-spacing-xs) / 2);\n  border-radius: var(--mantine-radius-sm);\n  white-space: nowrap;\n  pointer-events: none;\n  user-select: none;\n  touch-action: none;\n}\n\n:where([data-mantine-color-scheme='light']) .m_c9357328 {\n    background-color: var(--mantine-color-gray-9);\n}\n\n:where([data-mantine-color-scheme='dark']) .m_c9357328 {\n    background-color: var(--mantine-color-dark-4);\n}\n\n.m_c9a9a60a {\n  position: absolute;\n  display: flex;\n  height: var(--slider-thumb-size);\n  width: var(--slider-thumb-size);\n  border: calc(0.25rem * var(--mantine-scale)) solid;\n  transform: translate(-50%, -50%);\n  color: var(--slider-color);\n  top: 50%;\n  cursor: pointer;\n  border-radius: var(--slider-radius);\n  align-items: center;\n  justify-content: center;\n  transition:\n    box-shadow 100ms ease,\n    transform 100ms ease;\n  z-index: 3;\n  user-select: none;\n  touch-action: none;\n  outline-offset: calc(0.125rem * var(--mantine-scale));\n  left: var(--slider-thumb-offset);\n}\n\n:where([dir=\"rtl\"]) .m_c9a9a60a {\n    left: auto;\n    right: calc(var(--slider-thumb-offset) - var(--slider-thumb-size));\n}\n\nfieldset:disabled .m_c9a9a60a,\n  .m_c9a9a60a:where([data-disabled]) {\n    display: none;\n  }\n\n.m_c9a9a60a:where([data-dragging]) {\n    transform: translate(-50%, -50%) scale(1.05);\n    box-shadow: var(--mantine-shadow-sm);\n  }\n\n:where([data-mantine-color-scheme='light']) .m_c9a9a60a {\n    border-color: var(--slider-color);\n    background-color: var(--mantine-color-white);\n}\n\n:where([data-mantine-color-scheme='dark']) .m_c9a9a60a {\n    border-color: var(--mantine-color-white);\n    background-color: var(--slider-color);\n}\n\n.m_a8645c2 {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: calc(var(--slider-size) * 2);\n  cursor: pointer;\n}\n\nfieldset:disabled .m_a8645c2,\n  .m_a8645c2:where([data-disabled]) {\n    cursor: not-allowed;\n  }\n\n.m_c9ade57f {\n  position: relative;\n  width: 100%;\n  height: var(--slider-size);\n}\n\n.m_c9ade57f:where([data-inverted]:not([data-disabled])) {\n    --track-bg: var(--slider-color);\n  }\n\nfieldset:disabled .m_c9ade57f:where([data-inverted]),\n  .m_c9ade57f:where([data-inverted][data-disabled]) {\n    --track-bg: var(--slider-track-disabled-bg);\n  }\n\n.m_c9ade57f::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    border-radius: var(--slider-radius);\n    inset-inline: calc(var(--slider-size) * -1);\n    background-color: var(--track-bg, var(--slider-track-bg));\n    z-index: 0;\n  }\n\n.m_38aeed47 {\n  position: absolute;\n  z-index: 1;\n  top: 0;\n  bottom: 0;\n  background-color: var(--slider-color);\n  border-radius: var(--slider-radius);\n  width: var(--slider-bar-width);\n  inset-inline-start: var(--slider-bar-offset);\n}\n\n.m_38aeed47:where([data-inverted]) {\n    background-color: var(--slider-track-bg);\n  }\n\n:where([data-mantine-color-scheme='light']) fieldset:disabled .m_38aeed47:where(:not([data-inverted])), :where([data-mantine-color-scheme='light']) .m_38aeed47:where([data-disabled]:not([data-inverted])) {\n      background-color: var(--mantine-color-gray-4);\n}\n\n:where([data-mantine-color-scheme='dark']) fieldset:disabled .m_38aeed47:where(:not([data-inverted])), :where([data-mantine-color-scheme='dark']) .m_38aeed47:where([data-disabled]:not([data-inverted])) {\n      background-color: var(--mantine-color-dark-3);\n}\n\n.m_b7b0423a {\n  position: absolute;\n  inset-inline-start: calc(var(--mark-offset) - var(--slider-size) / 2);\n  top: 0;\n  z-index: 2;\n  height: 0;\n  pointer-events: none;\n}\n\n.m_dd33bc19 {\n  border: calc(0.125rem * var(--mantine-scale)) solid;\n  height: var(--slider-size);\n  width: var(--slider-size);\n  border-radius: calc(62.5rem * var(--mantine-scale));\n  transform: translateX((calc(var(--slider-size) / -2)));\n  background-color: var(--mantine-color-white);\n  pointer-events: none;\n}\n\n:where([data-mantine-color-scheme='light']) .m_dd33bc19 {\n    border-color: var(--mantine-color-gray-2);\n}\n\n:where([data-mantine-color-scheme='dark']) .m_dd33bc19 {\n    border-color: var(--mantine-color-dark-4);\n}\n\n.m_dd33bc19:where([data-filled]) {\n    border-color: var(--slider-color);\n  }\n\n:where([data-mantine-color-scheme='light']) .m_dd33bc19:where([data-filled]):where([data-disabled]) {\n        border-color: var(--mantine-color-gray-4);\n}\n\n:where([data-mantine-color-scheme='dark']) .m_dd33bc19:where([data-filled]):where([data-disabled]) {\n        border-color: var(--mantine-color-dark-3);\n}\n\n.m_68c77a5b {\n  transform: translate(calc(-50% + var(--slider-size) / 2), calc(var(--mantine-spacing-xs) / 2));\n  font-size: var(--mantine-font-size-sm);\n  white-space: nowrap;\n  cursor: pointer;\n  user-select: none;\n}\n\n:where([data-mantine-color-scheme='light']) .m_68c77a5b {\n    color: var(--mantine-color-gray-6);\n}\n\n:where([data-mantine-color-scheme='dark']) .m_68c77a5b {\n    color: var(--mantine-color-dark-2);\n}\n\n.m_559cce2d {\n  position: relative;\n}\n\n  .m_559cce2d:where([data-has-spoiler]) {\n    margin-bottom: calc(1.5rem * var(--mantine-scale));\n  }\n\n.m_b912df4e {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  transition: max-height var(--spoiler-transition-duration, 200ms) ease;\n}\n\n.m_b9131032 {\n  position: absolute;\n  inset-inline-start: 0;\n  top: 100%;\n  height: calc(1.5rem * var(--mantine-scale));\n}\n\n.m_6d731127 {\n  display: flex;\n  flex-direction: column;\n  align-items: var(--stack-align, stretch);\n  justify-content: var(--stack-justify, flex-start);\n  gap: var(--stack-gap, var(--mantine-spacing-md));\n}\n\n.m_cbb4ea7e {\n  --stepper-icon-size-xs: calc(2.125rem * var(--mantine-scale));\n  --stepper-icon-size-sm: calc(2.25rem * var(--mantine-scale));\n  --stepper-icon-size-md: calc(2.625rem * var(--mantine-scale));\n  --stepper-icon-size-lg: calc(3rem * var(--mantine-scale));\n  --stepper-icon-size-xl: calc(3.25rem * var(--mantine-scale));\n\n  --stepper-icon-size: var(--stepper-icon-size-md);\n  --stepper-color: var(--mantine-primary-color-filled);\n  --stepper-content-padding: var(--mantine-spacing-md);\n  --stepper-spacing: var(--mantine-spacing-md);\n  --stepper-radius: calc(62.5rem * var(--mantine-scale));\n  --stepper-fz: var(--mantine-font-size-md);\n}\n\n.m_aaf89d0b {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n}\n\n.m_aaf89d0b:where([data-wrap]) {\n    flex-wrap: wrap;\n    gap: var(--mantine-spacing-md) 0;\n  }\n\n.m_aaf89d0b:where([data-orientation='vertical']) {\n    flex-direction: column;\n  }\n\n.m_aaf89d0b:where([data-orientation='vertical']):where([data-icon-position='left']) {\n      align-items: flex-start;\n    }\n\n.m_aaf89d0b:where([data-orientation='vertical']):where([data-icon-position='right']) {\n      align-items: flex-end;\n    }\n\n.m_aaf89d0b:where([data-orientation='horizontal']) {\n    flex-direction: row;\n  }\n\n.m_2a371ac9 {\n  --separator-offset: calc(var(--stepper-icon-size) / 2 - calc(0.0625rem * var(--mantine-scale)));\n\n  transition: background-color 150ms ease;\n  flex: 1;\n}\n\n:where([data-mantine-color-scheme='light']) .m_2a371ac9 {\n    background-color: var(--mantine-color-gray-2);\n}\n\n:where([data-mantine-color-scheme='dark']) .m_2a371ac9 {\n    background-color: var(--mantine-color-dark-2);\n}\n\n.m_2a371ac9:where([data-active]) {\n    background-color: var(--stepper-color);\n  }\n\n.m_2a371ac9:where([data-orientation='horizontal']) {\n    height: calc(0.125rem * var(--mantine-scale));\n    margin-inline: var(--mantine-spacing-md);\n  }\n\n.m_2a371ac9:where([data-orientation='vertical']) {\n    width: calc(0.125rem * var(--mantine-scale));\n    margin-top: calc(var(--mantine-spacing-xs) / 2);\n    margin-bottom: calc(var(--mantine-spacing-xs) - calc(0.125rem * var(--mantine-scale)));\n  }\n\n.m_2a371ac9:where([data-orientation='vertical']):where([data-icon-position='left']) {\n      margin-inline-start: var(--separator-offset);\n    }\n\n.m_2a371ac9:where([data-orientation='vertical']):where([data-icon-position='right']) {\n      margin-inline-end: var(--separator-offset);\n    }\n\n.m_78da155d {\n  padding-top: var(--stepper-content-padding);\n}\n\n.m_cbb57068 {\n  --step-color: var(--stepper-color);\n\n  display: flex;\n  cursor: default;\n}\n\n.m_cbb57068:where([data-allow-click]) {\n    cursor: pointer;\n  }\n\n.m_cbb57068:where([data-icon-position='left']) {\n    flex-direction: row;\n  }\n\n.m_cbb57068:where([data-icon-position='right']) {\n    flex-direction: row-reverse;\n  }\n\n.m_f56b1e2c {\n  align-items: center;\n}\n\n.m_833edb7e {\n  --separator-spacing: calc(var(--mantine-spacing-xs) / 2);\n\n  justify-content: flex-start;\n  min-height: calc(var(--stepper-icon-size) + var(--mantine-spacing-xl) + var(--separator-spacing));\n  margin-top: var(--separator-spacing);\n  overflow: hidden;\n}\n\n.m_833edb7e:where(:first-of-type) {\n    margin-top: 0;\n  }\n\n.m_833edb7e:where(:last-of-type) .m_6496b3f3 {\n    display: none;\n  }\n\n.m_818e70b {\n  position: relative;\n}\n\n.m_6496b3f3 {\n  top: calc(var(--stepper-icon-size) + var(--separator-spacing));\n  inset-inline-start: calc(var(--stepper-icon-size) / 2);\n  height: 100vh;\n  position: absolute;\n  border-inline-start: calc(0.125rem * var(--mantine-scale)) solid;\n}\n\n:where([data-mantine-color-scheme='light']) .m_6496b3f3 {\n    border-color: var(--mantine-color-gray-1);\n}\n\n:where([data-mantine-color-scheme='dark']) .m_6496b3f3 {\n    border-color: var(--mantine-color-dark-5);\n}\n\n.m_6496b3f3:where([data-active]) {\n    border-color: var(--stepper-color);\n  }\n\n.m_1959ad01 {\n  height: var(--stepper-icon-size);\n  width: var(--stepper-icon-size);\n  min-height: var(--stepper-icon-size);\n  min-width: var(--stepper-icon-size);\n  border-radius: var(--stepper-radius);\n  font-size: var(--stepper-fz);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  font-weight: bold;\n  transition:\n    background-color 150ms ease,\n    border-color 150ms ease;\n  border: calc(0.125rem * var(--mantine-scale)) solid;\n}\n\n:where([data-mantine-color-scheme='light']) .m_1959ad01 {\n    background-color: var(--mantine-color-gray-1);\n    border-color: var(--mantine-color-gray-1);\n    color: var(--mantine-color-gray-7);\n}\n\n:where([data-mantine-color-scheme='dark']) .m_1959ad01 {\n    background-color: var(--mantine-color-dark-5);\n    border-color: var(--mantine-color-dark-5);\n    color: var(--mantine-color-dark-1);\n}\n\n.m_1959ad01:where([data-progress]) {\n    border-color: var(--step-color);\n  }\n\n.m_1959ad01:where([data-completed]) {\n    color: var(--stepper-icon-color, var(--mantine-color-white));\n    background-color: var(--step-color);\n    border-color: var(--step-color);\n  }\n\n.m_a79331dc {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--stepper-icon-color, var(--mantine-color-white));\n}\n\n.m_1956aa2a {\n  display: flex;\n  flex-direction: column;\n}\n\n.m_1956aa2a:where([data-icon-position='left']) {\n    margin-inline-start: var(--mantine-spacing-sm);\n  }\n\n.m_1956aa2a:where([data-icon-position='right']) {\n    text-align: right;\n    margin-inline-end: var(--mantine-spacing-sm);\n  }\n\n:where([dir=\"rtl\"]) .m_1956aa2a:where([data-icon-position='right']) {\n      text-align: left;\n}\n\n.m_12051f6c {\n  font-weight: 500;\n  font-size: var(--stepper-fz);\n  line-height: 1;\n}\n\n.m_164eea74 {\n  margin-top: calc(var(--stepper-spacing) / 3);\n  margin-bottom: calc(var(--stepper-spacing) / 3);\n  font-size: calc(var(--stepper-fz) - calc(0.125rem * var(--mantine-scale)));\n  line-height: 1;\n  color: var(--mantine-color-dimmed);\n}\n\n.m_5f93f3bb {\n  --switch-height-xs: calc(1rem * var(--mantine-scale));\n  --switch-height-sm: calc(1.25rem * var(--mantine-scale));\n  --switch-height-md: calc(1.5rem * var(--mantine-scale));\n  --switch-height-lg: calc(1.875rem * var(--mantine-scale));\n  --switch-height-xl: calc(2.25rem * var(--mantine-scale));\n\n  --switch-width-xs: calc(2rem * var(--mantine-scale));\n  --switch-width-sm: calc(2.375rem * var(--mantine-scale));\n  --switch-width-md: calc(2.875rem * var(--mantine-scale));\n  --switch-width-lg: calc(3.5rem * var(--mantine-scale));\n  --switch-width-xl: calc(4.5rem * var(--mantine-scale));\n\n  --switch-thumb-size-xs: calc(0.75rem * var(--mantine-scale));\n  --switch-thumb-size-sm: calc(0.875rem * var(--mantine-scale));\n  --switch-thumb-size-md: calc(1.125rem * var(--mantine-scale));\n  --switch-thumb-size-lg: calc(1.375rem * var(--mantine-scale));\n  --switch-thumb-size-xl: calc(1.75rem * var(--mantine-scale));\n\n  --switch-label-font-size-xs: calc(0.3125rem * var(--mantine-scale));\n  --switch-label-font-size-sm: calc(0.375rem * var(--mantine-scale));\n  --switch-label-font-size-md: calc(0.4375rem * var(--mantine-scale));\n  --switch-label-font-size-lg: calc(0.5625rem * var(--mantine-scale));\n  --switch-label-font-size-xl: calc(0.6875rem * var(--mantine-scale));\n\n  --switch-track-label-padding-xs: calc(0.0625rem * var(--mantine-scale));\n  --switch-track-label-padding-sm: calc(0.125rem * var(--mantine-scale));\n  --switch-track-label-padding-md: calc(0.125rem * var(--mantine-scale));\n  --switch-track-label-padding-lg: calc(0.1875rem * var(--mantine-scale));\n  --switch-track-label-padding-xl: calc(0.1875rem * var(--mantine-scale));\n\n  --switch-height: var(--switch-height-sm);\n  --switch-width: var(--switch-width-sm);\n  --switch-thumb-size: var(--switch-thumb-size-sm);\n  --switch-label-font-size: var(--switch-label-font-size-sm);\n  --switch-track-label-padding: var(--switch-track-label-padding-sm);\n  --switch-radius: calc(62.5rem * var(--mantine-scale));\n  --switch-color: var(--mantine-primary-color-filled);\n\n  position: relative;\n}\n\n.m_926b4011 {\n  height: 0;\n  width: 0;\n  opacity: 0;\n  margin: 0;\n  padding: 0;\n  position: absolute;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.m_9307d992 {\n  -webkit-tap-highlight-color: transparent;\n  cursor: var(--switch-cursor, var(--mantine-cursor-type));\n  overflow: hidden;\n  position: relative;\n  border-radius: var(--switch-radius);\n  background-color: var(--switch-bg);\n  border: 1px solid var(--switch-bd);\n  height: var(--switch-height);\n  min-width: var(--switch-width);\n  margin: 0;\n  transition:\n    background-color 150ms ease,\n    border-color 150ms ease;\n  appearance: none;\n  display: flex;\n  align-items: center;\n  font-size: var(--switch-label-font-size);\n  font-weight: 600;\n  order: var(--switch-order, 1);\n  user-select: none;\n  z-index: 0;\n  line-height: 0;\n  color: var(--switch-text-color);\n}\n\n.m_926b4011:focus-visible + .m_9307d992 {\n    outline: 2px solid var(--mantine-primary-color-filled);\n    outline-offset: calc(0.125rem * var(--mantine-scale));\n  }\n\n.m_926b4011:checked + .m_9307d992 {\n    --switch-bg: var(--switch-color);\n    --switch-bd: var(--switch-color);\n    --switch-text-color: var(--mantine-color-white);\n  }\n\n.m_926b4011:disabled + .m_9307d992,\n  .m_926b4011[data-disabled] + .m_9307d992 {\n    --switch-bg: var(--switch-disabled-color);\n    --switch-bd: var(--switch-disabled-color);\n    --switch-cursor: not-allowed;\n  }\n\n[data-mantine-color-scheme='light'] .m_9307d992 {\n    --switch-bg: var(--mantine-color-gray-2);\n    --switch-bd: var(--mantine-color-gray-3);\n    --switch-text-color: var(--mantine-color-gray-6);\n    --switch-disabled-color: var(--mantine-color-gray-2);\n}\n\n[data-mantine-color-scheme='dark'] .m_9307d992 {\n    --switch-bg: var(--mantine-color-dark-6);\n    --switch-bd: var(--mantine-color-dark-4);\n    --switch-text-color: var(--mantine-color-dark-1);\n    --switch-disabled-color: var(--mantine-color-dark-4);\n}\n\n.m_9307d992[data-error] {\n    --switch-bd: var(--mantine-color-error);\n  }\n\n.m_9307d992[data-label-position='left'] {\n    --switch-order: 2;\n  }\n\n.m_93039a1d {\n  position: absolute;\n  z-index: 1;\n  border-radius: var(--switch-radius);\n  display: flex;\n  background-color: var(--switch-thumb-bg, var(--mantine-color-white));\n  height: var(--switch-thumb-size);\n  width: var(--switch-thumb-size);\n  border: 1px solid var(--switch-thumb-bd);\n  inset-inline-start: var(--switch-thumb-start, var(--switch-track-label-padding));\n  transition: inset-inline-start 150ms ease;\n}\n\n.m_93039a1d > * {\n    margin: auto;\n  }\n\n.m_926b4011:checked + * > .m_93039a1d {\n    --switch-thumb-start: calc(100% - var(--switch-thumb-size) - var(--switch-track-label-padding));\n    --switch-thumb-bd: var(--mantine-color-white);\n  }\n\n.m_926b4011:disabled + * > .m_93039a1d,\n  .m_926b4011[data-disabled] + * > .m_93039a1d {\n    --switch-thumb-bd: var(--switch-thumb-bg-disabled);\n    --switch-thumb-bg: var(--switch-thumb-bg-disabled);\n  }\n\n[data-mantine-color-scheme='light'] .m_93039a1d {\n    --switch-thumb-bd: var(--mantine-color-gray-3);\n    --switch-thumb-bg-disabled: var(--mantine-color-gray-0);\n}\n\n[data-mantine-color-scheme='dark'] .m_93039a1d {\n    --switch-thumb-bd: var(--mantine-color-white);\n    --switch-thumb-bg-disabled: var(--mantine-color-dark-3);\n}\n\n.m_8277e082 {\n  height: 100%;\n  display: grid;\n  place-content: center;\n  min-width: calc(var(--switch-width) - var(--switch-thumb-size));\n  padding-inline: var(--switch-track-label-padding);\n  margin-inline-start: calc(var(--switch-thumb-size) + var(--switch-track-label-padding));\n  transition: margin 150ms ease;\n}\n\n.m_926b4011:checked + * > .m_8277e082 {\n    margin-inline-end: calc(var(--switch-thumb-size) + var(--switch-track-label-padding));\n    margin-inline-start: 0;\n  }\n\n.m_b23fa0ef {\n  width: 100%;\n  border-collapse: collapse;\n  line-height: var(--mantine-line-height);\n  font-size: var(--mantine-font-size-sm);\n  table-layout: var(--table-layout, auto);\n  caption-side: var(--table-caption-side, bottom);\n  border: none;\n}\n\n  :where([data-mantine-color-scheme='light']) .m_b23fa0ef {\n    --table-hover-color: var(--mantine-color-gray-1);\n    --table-striped-color: var(--mantine-color-gray-0);\n    --table-border-color: var(--mantine-color-gray-3);\n}\n\n  :where([data-mantine-color-scheme='dark']) .m_b23fa0ef {\n    --table-hover-color: var(--mantine-color-dark-5);\n    --table-striped-color: var(--mantine-color-dark-6);\n    --table-border-color: var(--mantine-color-dark-4);\n}\n\n  .m_b23fa0ef:where([data-with-table-border]) {\n    border: calc(0.0625rem * var(--mantine-scale)) solid var(--table-border-color);\n  }\n\n.m_4e7aa4f3 {\n  text-align: left;\n}\n\n:where([dir=\"rtl\"]) .m_4e7aa4f3 {\n    text-align: right;\n}\n\n.m_4e7aa4fd {\n  border-bottom: none;\n  background-color: transparent;\n}\n\n@media (hover: hover) {\n    .m_4e7aa4fd:hover:where([data-hover]) {\n      background-color: var(--tr-hover-bg);\n    }\n}\n\n@media (hover: none) {\n    .m_4e7aa4fd:active:where([data-hover]) {\n      background-color: var(--tr-hover-bg);\n    }\n}\n\n.m_4e7aa4fd:where([data-with-row-border]) {\n    border-bottom: calc(0.0625rem * var(--mantine-scale)) solid var(--table-border-color);\n  }\n\n.m_4e7aa4ef,\n.m_4e7aa4f3 {\n  padding: var(--table-vertical-spacing) var(--table-horizontal-spacing, var(--mantine-spacing-xs));\n}\n\n.m_4e7aa4ef:where([data-with-column-border]:not(:last-child)), .m_4e7aa4f3:where([data-with-column-border]:not(:last-child)) {\n    border-inline-end: calc(0.0625rem * var(--mantine-scale)) solid var(--table-border-color);\n  }\n\n.m_b2404537 :where(tr):where([data-with-row-border]:last-of-type) {\n      border-bottom: none;\n    }\n\n.m_b2404537 :where(tr):where([data-striped='odd']:nth-of-type(odd)) {\n      background-color: var(--table-striped-color);\n    }\n\n.m_b2404537 :where(tr):where([data-striped='even']:nth-of-type(even)) {\n      background-color: var(--table-striped-color);\n    }\n\n.m_b2404537 :where(tr)[data-hover] {\n      --tr-hover-bg: var(--table-highlight-on-hover-color, var(--table-hover-color));\n    }\n\n.m_b242d975 {\n  top: var(--table-sticky-header-offset, 0);\n  z-index: 1;\n}\n\n.m_b242d975:where([data-sticky]) {\n    position: sticky;\n    background-color: var(--mantine-color-body);\n  }\n\n.m_9e5a3ac7 {\n  color: var(--mantine-color-dimmed);\n}\n\n.m_9e5a3ac7:where([data-side='top']) {\n    margin-bottom: var(--mantine-spacing-xs);\n  }\n\n.m_9e5a3ac7:where([data-side='bottom']) {\n    margin-top: var(--mantine-spacing-xs);\n  }\n\n.m_a100c15 {\n  overflow-x: var(--table-overflow);\n}\n\n.m_62259741 {\n  min-width: var(--table-min-width);\n}\n\n.m_89d60db1 {\n  display: var(--tabs-display);\n  flex-direction: var(--tabs-flex-direction);\n\n  --tab-justify: flex-start;\n  --tabs-list-direction: row;\n  --tabs-panel-grow: unset;\n  --tabs-display: block;\n  --tabs-flex-direction: row;\n  --tabs-list-border-width: 0;\n  --tabs-list-border-size: 0 0 var(--tabs-list-border-width) 0;\n  --tabs-list-gap: unset;\n\n  --tabs-list-line-bottom: 0;\n  --tabs-list-line-top: unset;\n  --tabs-list-line-start: 0;\n  --tabs-list-line-end: 0;\n\n  --tab-radius: var(--tabs-radius) var(--tabs-radius) 0 0;\n  --tab-border-width: 0 0 var(--tabs-list-border-width) 0;\n}\n\n  .m_89d60db1[data-inverted] {\n    --tabs-list-line-bottom: unset;\n    --tabs-list-line-top: 0;\n    --tab-radius: 0 0 var(--tabs-radius) var(--tabs-radius);\n    --tab-border-width: var(--tabs-list-border-width) 0 0 0;\n  }\n\n  .m_89d60db1[data-inverted] .m_576c9d4::before {\n      top: 0;\n      bottom: unset;\n    }\n\n  .m_89d60db1[data-orientation='vertical'] {\n    --tabs-list-line-start: unset;\n    --tabs-list-line-end: 0;\n    --tabs-list-line-top: 0;\n    --tabs-list-line-bottom: 0;\n    --tabs-list-border-size: 0 var(--tabs-list-border-width) 0 0;\n    --tab-border-width: 0 var(--tabs-list-border-width) 0 0;\n    --tab-radius: var(--tabs-radius) 0 0 var(--tabs-radius);\n    --tabs-list-direction: column;\n    --tabs-panel-grow: 1;\n    --tabs-display: flex;\n  }\n\n  [dir=\"rtl\"] .m_89d60db1[data-orientation='vertical'] {\n      --tabs-list-border-size: 0 0 0 var(--tabs-list-border-width);\n      --tab-border-width: 0 0 0 var(--tabs-list-border-width);\n      --tab-radius: 0 var(--tabs-radius) var(--tabs-radius) 0;\n}\n\n  .m_89d60db1[data-orientation='vertical'][data-placement='right'] {\n      --tabs-flex-direction: row-reverse;\n      --tabs-list-line-start: 0;\n      --tabs-list-line-end: unset;\n      --tabs-list-border-size: 0 0 0 var(--tabs-list-border-width);\n      --tab-border-width: 0 0 0 var(--tabs-list-border-width);\n      --tab-radius: 0 var(--tabs-radius) var(--tabs-radius) 0;\n    }\n\n  [dir=\"rtl\"] .m_89d60db1[data-orientation='vertical'][data-placement='right'] {\n        --tabs-list-border-size: 0 var(--tabs-list-border-width) 0 0;\n        --tab-border-width: 0 var(--tabs-list-border-width) 0 0;\n        --tab-radius: var(--tabs-radius) 0 0 var(--tabs-radius);\n}\n\n  [data-mantine-color-scheme='light'] .m_89d60db1 {\n    --tab-border-color: var(--mantine-color-gray-3);\n}\n\n  [data-mantine-color-scheme='dark'] .m_89d60db1 {\n    --tab-border-color: var(--mantine-color-dark-4);\n}\n\n  .m_89d60db1[data-orientation='horizontal'] {\n    --tab-justify: center;\n  }\n\n  .m_89d60db1[data-variant='default'] {\n    --tabs-list-border-width: calc(0.125rem * var(--mantine-scale));\n  }\n\n  [data-mantine-color-scheme='light'] .m_89d60db1[data-variant='default'] {\n      --tab-hover-color: var(--mantine-color-gray-0);\n}\n\n  [data-mantine-color-scheme='dark'] .m_89d60db1[data-variant='default'] {\n      --tab-hover-color: var(--mantine-color-dark-6);\n}\n\n  .m_89d60db1[data-variant='outline'] {\n    --tabs-list-border-width: calc(0.0625rem * var(--mantine-scale));\n  }\n\n  .m_89d60db1[data-variant='pills'] {\n    --tabs-list-gap: calc(var(--mantine-spacing-sm) / 2);\n  }\n\n  [data-mantine-color-scheme='light'] .m_89d60db1[data-variant='pills'] {\n      --tab-hover-color: var(--mantine-color-gray-0);\n}\n\n  [data-mantine-color-scheme='dark'] .m_89d60db1[data-variant='pills'] {\n      --tab-hover-color: var(--mantine-color-dark-6);\n}\n\n.m_89d33d6d {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: var(--tabs-justify, flex-start);\n  flex-direction: var(--tabs-list-direction);\n  gap: var(--tabs-list-gap);\n\n  --tab-grow: unset;\n}\n\n.m_89d33d6d[data-grow] {\n    --tab-grow: 1;\n  }\n\n.m_b0c91715 {\n  flex-grow: var(--tabs-panel-grow);\n}\n\n.m_4ec4dce6 {\n  position: relative;\n  padding: var(--mantine-spacing-xs) var(--mantine-spacing-md);\n  font-size: var(--mantine-font-size-sm);\n  white-space: nowrap;\n  z-index: 0;\n  display: flex;\n  align-items: center;\n  line-height: 1;\n  user-select: none;\n  flex-grow: var(--tab-grow);\n  justify-content: var(--tab-justify);\n}\n\n.m_4ec4dce6:disabled,\n  .m_4ec4dce6[data-disabled] {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n\n.m_4ec4dce6:focus {\n    z-index: 1;\n  }\n\n.m_fc420b1f {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-left: var(--tab-section-margin-left, 0);\n  margin-right: var(--tab-section-margin-right, 0);\n}\n\n.m_fc420b1f[data-position='left']:not(:only-child) {\n      --tab-section-margin-right: var(--mantine-spacing-xs);\n    }\n\n[dir=\"rtl\"] .m_fc420b1f[data-position='left']:not(:only-child) {\n        --tab-section-margin-right: 0rem;\n        --tab-section-margin-left: var(--mantine-spacing-xs);\n}\n\n.m_fc420b1f[data-position='right']:not(:only-child) {\n      --tab-section-margin-left: var(--mantine-spacing-xs);\n    }\n\n[dir=\"rtl\"] .m_fc420b1f[data-position='right']:not(:only-child) {\n        --tab-section-margin-left: 0rem;\n        --tab-section-margin-right: var(--mantine-spacing-xs);\n}\n\n/*************************************** default variant ***************************************/\n.m_576c9d4 {\n  position: relative;\n}\n.m_576c9d4::before {\n    content: '';\n    position: absolute;\n    border-color: var(--tab-border-color);\n    border-width: var(--tabs-list-border-size);\n    border-style: solid;\n    bottom: var(--tabs-list-line-bottom);\n    inset-inline-start: var(--tabs-list-line-start);\n    inset-inline-end: var(--tabs-list-line-end);\n    top: var(--tabs-list-line-top);\n  }\n\n.m_539e827b {\n  border-radius: var(--tab-radius);\n  border-width: var(--tab-border-width);\n  border-style: solid;\n  border-color: transparent;\n  background-color: var(--tab-bg);\n\n  --tab-bg: transparent;\n}\n\n.m_539e827b:where([data-active]) {\n    border-color: var(--tabs-color);\n  }\n\n@media (hover: hover) {\n\n  .m_539e827b:hover {\n    --tab-bg: var(--tab-hover-color);\n  }\n\n    .m_539e827b:hover:where(:not([data-active])) {\n      border-color: var(--tab-border-color);\n    }\n}\n\n@media (hover: none) {\n\n  .m_539e827b:active {\n    --tab-bg: var(--tab-hover-color);\n  }\n\n    .m_539e827b:active:where(:not([data-active])) {\n      border-color: var(--tab-border-color);\n    }\n}\n\n@media (hover: hover) {\n\n  .m_539e827b:disabled:hover, .m_539e827b[data-disabled]:hover {\n      --tab-bg: transparent;\n  }\n}\n\n@media (hover: none) {\n\n  .m_539e827b:disabled:active, .m_539e827b[data-disabled]:active {\n      --tab-bg: transparent;\n  }\n}\n\n/*************************************** outline variant ***************************************/\n.m_6772fbd5 {\n  position: relative;\n}\n.m_6772fbd5::before {\n    content: '';\n    position: absolute;\n    border-color: var(--tab-border-color);\n    border-width: var(--tabs-list-border-size);\n    border-style: solid;\n    bottom: var(--tabs-list-line-bottom);\n    inset-inline-start: var(--tabs-list-line-start);\n    inset-inline-end: var(--tabs-list-line-end);\n    top: var(--tabs-list-line-top);\n  }\n\n.m_b59ab47c {\n  border-top: calc(0.0625rem * var(--mantine-scale)) solid transparent;\n  border-bottom: calc(0.0625rem * var(--mantine-scale)) solid transparent;\n  border-right: calc(0.0625rem * var(--mantine-scale)) solid transparent;\n  border-left: calc(0.0625rem * var(--mantine-scale)) solid transparent;\n  border-top-color: var(--tab-border-top-color);\n  border-bottom-color: var(--tab-border-bottom-color);\n  border-radius: var(--tab-radius);\n  position: relative;\n\n  --tab-border-bottom-color: transparent;\n  --tab-border-top-color: transparent;\n  --tab-border-inline-end-color: transparent;\n  --tab-border-inline-start-color: transparent;\n}\n\n.m_b59ab47c:where([data-active])::before {\n      content: '';\n      position: absolute;\n      background-color: var(--tab-border-color);\n      bottom: var(--tab-before-bottom, calc(-0.0625rem * var(--mantine-scale)));\n      left: var(--tab-before-left, calc(-0.0625rem * var(--mantine-scale)));\n      right: var(--tab-before-right, auto);\n      top: var(--tab-before-top, auto);\n      width: calc(0.0625rem * var(--mantine-scale));\n      height: calc(0.0625rem * var(--mantine-scale));\n    }\n\n.m_b59ab47c:where([data-active])::after {\n      content: '';\n      position: absolute;\n      background-color: var(--tab-border-color);\n      bottom: var(--tab-after-bottom, calc(-0.0625rem * var(--mantine-scale)));\n      right: var(--tab-after-right, calc(-0.0625rem * var(--mantine-scale)));\n      left: var(--tab-after-left, auto);\n      top: var(--tab-after-top, auto);\n      width: calc(0.0625rem * var(--mantine-scale));\n      height: calc(0.0625rem * var(--mantine-scale));\n    }\n\n.m_b59ab47c:where([data-active]) {\n\n    border-top-color: var(--tab-border-top-color);\n    border-bottom-color: var(--tab-border-bottom-color);\n    border-inline-start-color: var(--tab-border-inline-start-color);\n    border-inline-end-color: var(--tab-border-inline-end-color);\n\n    --tab-border-top-color: var(--tab-border-color);\n    --tab-border-inline-start-color: var(--tab-border-color);\n    --tab-border-inline-end-color: var(--tab-border-color);\n    --tab-border-bottom-color: var(--mantine-color-body);\n}\n\n.m_b59ab47c:where([data-active])[data-inverted] {\n      --tab-border-bottom-color: var(--tab-border-color);\n      --tab-border-top-color: var(--mantine-color-body);\n\n      --tab-before-bottom: auto;\n      --tab-before-top: calc(-0.0625rem * var(--mantine-scale));\n      --tab-after-bottom: auto;\n      --tab-after-top: calc(-0.0625rem * var(--mantine-scale));\n    }\n\n.m_b59ab47c:where([data-active])[data-orientation='vertical'][data-placement='left'] {\n        --tab-border-inline-end-color: var(--mantine-color-body);\n        --tab-border-inline-start-color: var(--tab-border-color);\n        --tab-border-bottom-color: var(--tab-border-color);\n\n        --tab-before-right: calc(-0.0625rem * var(--mantine-scale));\n        --tab-before-left: auto;\n        --tab-before-bottom: auto;\n        --tab-before-top: calc(-0.0625rem * var(--mantine-scale));\n        --tab-after-left: auto;\n        --tab-after-right: calc(-0.0625rem * var(--mantine-scale));\n      }\n\n[dir=\"rtl\"] .m_b59ab47c:where([data-active])[data-orientation='vertical'][data-placement='left'] {\n          --tab-before-right: auto;\n          --tab-before-left: calc(-0.0625rem * var(--mantine-scale));\n          --tab-after-left: calc(-0.0625rem * var(--mantine-scale));\n          --tab-after-right: auto;\n}\n\n.m_b59ab47c:where([data-active])[data-orientation='vertical'][data-placement='right'] {\n        --tab-border-inline-start-color: var(--mantine-color-body);\n        --tab-border-inline-end-color: var(--tab-border-color);\n        --tab-border-bottom-color: var(--tab-border-color);\n\n        --tab-before-left: calc(-0.0625rem * var(--mantine-scale));\n        --tab-before-right: auto;\n        --tab-before-bottom: auto;\n        --tab-before-top: calc(-0.0625rem * var(--mantine-scale));\n        --tab-after-right: auto;\n        --tab-after-left: calc(-0.0625rem * var(--mantine-scale));\n      }\n\n[dir=\"rtl\"] .m_b59ab47c:where([data-active])[data-orientation='vertical'][data-placement='right'] {\n          --tab-before-left: auto;\n          --tab-before-right: calc(-0.0625rem * var(--mantine-scale));\n          --tab-after-right: calc(-0.0625rem * var(--mantine-scale));\n          --tab-after-left: auto;\n}\n\n/*************************************** pills variant ***************************************/\n.m_c3381914 {\n  border-radius: var(--tabs-radius);\n  background-color: var(--tab-bg);\n  color: var(--tab-color);\n\n  --tab-bg: transparent;\n  --tab-color: inherit;\n}\n@media (hover: hover) {\n\n  .m_c3381914:not([data-disabled]):hover {\n      --tab-bg: var(--tab-hover-color);\n  }\n}\n@media (hover: none) {\n\n  .m_c3381914:not([data-disabled]):active {\n      --tab-bg: var(--tab-hover-color);\n  }\n}\n.m_c3381914[data-active][data-active] {\n    --tab-bg: var(--tabs-color);\n    --tab-color: var(--tabs-text-color, var(--mantine-color-white));\n  }\n@media (hover: hover) {\n\n  .m_c3381914[data-active][data-active]:hover {\n      --tab-bg: var(--tabs-color);\n  }\n}\n@media (hover: none) {\n\n  .m_c3381914[data-active][data-active]:active {\n      --tab-bg: var(--tabs-color);\n  }\n}\n\n.m_7341320d {\n  --ti-size-xs: calc(1.125rem * var(--mantine-scale));\n  --ti-size-sm: calc(1.375rem * var(--mantine-scale));\n  --ti-size-md: calc(1.75rem * var(--mantine-scale));\n  --ti-size-lg: calc(2.125rem * var(--mantine-scale));\n  --ti-size-xl: calc(2.75rem * var(--mantine-scale));\n  --ti-size: var(--ti-size-md);\n\n  line-height: 1;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  user-select: none;\n\n  width: var(--ti-size);\n  height: var(--ti-size);\n  min-width: var(--ti-size);\n  min-height: var(--ti-size);\n  border-radius: var(--ti-radius, var(--mantine-radius-default));\n  background: var(--ti-bg, var(--mantine-primary-color-filled));\n  color: var(--ti-color, var(--mantine-color-white));\n  border: var(--ti-bd, 1px solid transparent);\n}\n\n.m_43657ece {\n  --offset: calc(var(--tl-bullet-size) / 2 + var(--tl-line-width) / 2);\n  --tl-bullet-size: calc(1.25rem * var(--mantine-scale));\n  --tl-line-width: calc(0.25rem * var(--mantine-scale));\n  --tl-radius: calc(62.5rem * var(--mantine-scale));\n  --tl-color: var(--mantine-primary-color-filled);\n}\n\n  .m_43657ece:where([data-align='left']) {\n    padding-inline-start: var(--offset);\n  }\n\n  .m_43657ece:where([data-align='right']) {\n    padding-inline-end: var(--offset);\n  }\n\n.m_2ebe8099 {\n  font-weight: 500;\n  line-height: 1;\n  margin-bottom: calc(var(--mantine-spacing-xs) / 2);\n}\n\n.m_436178ff {\n  --item-border: var(--tl-line-width) var(--tli-border-style, solid) var(--item-border-color);\n\n  position: relative;\n  color: var(--mantine-color-text);\n}\n\n.m_436178ff::before {\n    content: '';\n    pointer-events: none;\n    position: absolute;\n    top: 0;\n    left: var(--timeline-line-left, 0);\n    right: var(--timeline-line-right, 0);\n    bottom: calc(var(--mantine-spacing-xl) * -1);\n    border-inline-start: var(--item-border);\n    display: var(--timeline-line-display, none);\n  }\n\n.m_43657ece[data-align='left'] .m_436178ff::before {\n      --timeline-line-left: calc(var(--tl-line-width) * -1);\n      --timeline-line-right: auto;\n    }\n\n[dir=\"rtl\"] .m_43657ece[data-align='left'] .m_436178ff::before {\n        --timeline-line-left: auto;\n        --timeline-line-right: calc(var(--tl-line-width) * -1);\n}\n\n.m_43657ece[data-align='right'] .m_436178ff::before {\n      --timeline-line-left: auto;\n      --timeline-line-right: calc(var(--tl-line-width) * -1);\n    }\n\n[dir=\"rtl\"] .m_43657ece[data-align='right'] .m_436178ff::before {\n        --timeline-line-left: calc(var(--tl-line-width) * -1);\n        --timeline-line-right: auto;\n}\n\n.m_43657ece:where([data-align='left']) .m_436178ff {\n    padding-inline-start: var(--offset);\n    text-align: left;\n  }\n\n.m_43657ece:where([data-align='right']) .m_436178ff {\n    padding-inline-end: var(--offset);\n    text-align: right;\n  }\n\n:where([data-mantine-color-scheme='light']) .m_436178ff {\n    --item-border-color: var(--mantine-color-gray-3);\n}\n\n:where([data-mantine-color-scheme='dark']) .m_436178ff {\n    --item-border-color: var(--mantine-color-dark-4);\n}\n\n.m_436178ff:where([data-line-active])::before {\n      border-color: var(--tli-color, var(--tl-color));\n    }\n\n.m_436178ff:where(:not(:last-of-type)) {\n    --timeline-line-display: block;\n  }\n\n.m_436178ff:where(:not(:first-of-type)) {\n    margin-top: var(--mantine-spacing-xl);\n  }\n\n.m_8affcee1 {\n  width: var(--tl-bullet-size);\n  height: var(--tl-bullet-size);\n  border-radius: var(--tli-radius, var(--tl-radius));\n  border: var(--tl-line-width) solid;\n  background-color: var(--mantine-color-body);\n  position: absolute;\n  top: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--mantine-color-text);\n}\n\n:where([data-mantine-color-scheme='light']) .m_8affcee1 {\n    border-color: var(--mantine-color-gray-3);\n}\n\n:where([data-mantine-color-scheme='dark']) .m_8affcee1 {\n    border-color: var(--mantine-color-dark-4);\n}\n\n.m_43657ece:where([data-align='left']) .m_8affcee1 {\n    left: calc((var(--tl-bullet-size) / 2 + var(--tl-line-width) / 2) * -1);\n    right: auto;\n  }\n\n:where([dir=\"rtl\"]) .m_43657ece:where([data-align='left']) .m_8affcee1 {\n      left: auto;\n      right: calc((var(--tl-bullet-size) / 2 + var(--tl-line-width) / 2) * -1);\n}\n\n.m_43657ece:where([data-align='right']) .m_8affcee1 {\n    left: auto;\n    right: calc((var(--tl-bullet-size) / 2 + var(--tl-line-width) / 2) * -1);\n  }\n\n:where([dir=\"rtl\"]) .m_43657ece:where([data-align='right']) .m_8affcee1 {\n      left: calc((var(--tl-bullet-size) / 2 + var(--tl-line-width) / 2) * -1);\n      right: auto;\n}\n\n.m_8affcee1:where([data-with-child]) {\n    border-width: var(--tl-line-width);\n  }\n\n:where([data-mantine-color-scheme='light']) .m_8affcee1:where([data-with-child]) {\n      background-color: var(--mantine-color-gray-3);\n}\n\n:where([data-mantine-color-scheme='dark']) .m_8affcee1:where([data-with-child]) {\n      background-color: var(--mantine-color-dark-4);\n}\n\n.m_8affcee1:where([data-active]) {\n    border-color: var(--tli-color, var(--tl-color));\n    background-color: var(--mantine-color-white);\n    color: var(--tl-icon-color, var(--mantine-color-white));\n  }\n\n.m_8affcee1:where([data-active]):where([data-with-child]) {\n      background-color: var(--tli-color, var(--tl-color));\n      color: var(--tl-icon-color, var(--mantine-color-white));\n    }\n\n.m_43657ece:where([data-align='left']) .m_540e8f41 {\n    padding-inline-start: var(--offset);\n    text-align: left;\n  }\n\n:where([dir=\"rtl\"]) .m_43657ece:where([data-align='left']) .m_540e8f41 {\n      text-align: right;\n}\n\n.m_43657ece:where([data-align='right']) .m_540e8f41 {\n    padding-inline-end: var(--offset);\n    text-align: right;\n  }\n\n:where([dir=\"rtl\"]) .m_43657ece:where([data-align='right']) .m_540e8f41 {\n      text-align: left;\n}\n\n.m_8a5d1357 {\n  margin: 0;\n  font-weight: var(--title-fw);\n  font-size: var(--title-fz);\n  line-height: var(--title-lh);\n  font-family: var(--mantine-font-family-headings);\n  text-wrap: var(--title-text-wrap, var(--mantine-heading-text-wrap));\n}\n\n  .m_8a5d1357:where([data-line-clamp]) {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-line-clamp: var(--title-line-clamp);\n    -webkit-box-orient: vertical;\n  }\n\n.m_f698e191 {\n  --level-offset: var(--mantine-spacing-lg);\n  margin: 0;\n  padding: 0;\n  user-select: none;\n}\n\n.m_75f3ecf {\n  margin: 0;\n  padding: 0;\n}\n\n.m_f6970eb1 {\n  cursor: pointer;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  outline: 0;\n}\n\n.m_f6970eb1:focus-visible > .m_dc283425 {\n      outline: 2px solid var(--mantine-primary-color-filled);\n      outline-offset: calc(0.125rem * var(--mantine-scale));\n    }\n\n.m_dc283425 {\n  padding-inline-start: var(--label-offset);\n}\n\n:where([data-mantine-color-scheme='light']) .m_dc283425:where([data-selected]) {\n      background-color: var(--mantine-color-gray-1);\n}\n\n:where([data-mantine-color-scheme='dark']) .m_dc283425:where([data-selected]) {\n      background-color: var(--mantine-color-dark-5);\n}\n\n.m_d6493fad :first-child {\n    margin-top: 0;\n  }\n  .m_d6493fad :last-child {\n    margin-bottom: 0;\n  }\n  .m_d6493fad :where(h1, h2, h3, h4, h5, h6) {\n    margin-bottom: var(--mantine-spacing-xs);\n    text-wrap: var(--mantine-heading-text-wrap);\n  }\n  .m_d6493fad :where(h1) {\n    margin-top: calc(1.5 * var(--mantine-spacing-xl));\n    font-size: var(--mantine-h1-font-size);\n    line-height: var(--mantine-h1-line-height);\n    font-weight: var(--mantine-h1-font-weight);\n  }\n  .m_d6493fad :where(h2) {\n    margin-top: var(--mantine-spacing-xl);\n    font-size: var(--mantine-h2-font-size);\n    line-height: var(--mantine-h2-line-height);\n    font-weight: var(--mantine-h2-font-weight);\n  }\n  .m_d6493fad :where(h3) {\n    margin-top: calc(0.8 * var(--mantine-spacing-xl));\n    font-size: var(--mantine-h3-font-size);\n    line-height: var(--mantine-h3-line-height);\n    font-weight: var(--mantine-h3-font-weight);\n  }\n  .m_d6493fad :where(h4) {\n    margin-top: calc(0.8 * var(--mantine-spacing-xl));\n    font-size: var(--mantine-h4-font-size);\n    line-height: var(--mantine-h4-line-height);\n    font-weight: var(--mantine-h4-font-weight);\n  }\n  .m_d6493fad :where(h5) {\n    margin-top: calc(0.5 * var(--mantine-spacing-xl));\n    font-size: var(--mantine-h5-font-size);\n    line-height: var(--mantine-h5-line-height);\n    font-weight: var(--mantine-h5-font-weight);\n  }\n  .m_d6493fad :where(h6) {\n    margin-top: calc(0.5 * var(--mantine-spacing-xl));\n    font-size: var(--mantine-h6-font-size);\n    line-height: var(--mantine-h6-line-height);\n    font-weight: var(--mantine-h6-font-weight);\n  }\n  .m_d6493fad :where(img) {\n    max-width: 100%;\n    margin-bottom: var(--mantine-spacing-xs);\n  }\n  .m_d6493fad :where(p) {\n    margin-top: 0;\n    margin-bottom: var(--mantine-spacing-lg);\n  }\n  :where([data-mantine-color-scheme='light']) .m_d6493fad :where(mark) {\n      background-color: var(--mantine-color-yellow-2);\n      color: inherit;\n}\n  :where([data-mantine-color-scheme='dark']) .m_d6493fad :where(mark) {\n      background-color: var(--mantine-color-yellow-5);\n      color: var(--mantine-color-black);\n}\n  .m_d6493fad :where(a) {\n    color: var(--mantine-color-anchor);\n    text-decoration: none;\n  }\n  @media (hover: hover) {\n    .m_d6493fad :where(a):hover {\n      text-decoration: underline;\n    }\n}\n  @media (hover: none) {\n    .m_d6493fad :where(a):active {\n      text-decoration: underline;\n    }\n}\n  .m_d6493fad :where(hr) {\n    margin-top: var(--mantine-spacing-md);\n    margin-bottom: var(--mantine-spacing-md);\n    border: 0;\n    border-top: calc(0.0625rem * var(--mantine-scale)) solid;\n  }\n  :where([data-mantine-color-scheme='light']) .m_d6493fad :where(hr) {\n      border-color: var(--mantine-color-gray-3);\n}\n  :where([data-mantine-color-scheme='dark']) .m_d6493fad :where(hr) {\n      border-color: var(--mantine-color-dark-3);\n}\n  .m_d6493fad :where(pre) {\n    padding: var(--mantine-spacing-xs);\n    line-height: var(--mantine-line-height);\n    margin: 0;\n    margin-top: var(--mantine-spacing-md);\n    margin-bottom: var(--mantine-spacing-md);\n    overflow-x: auto;\n    font-family: var(--mantine-font-family-monospace);\n    font-size: var(--mantine-font-size-xs);\n    border-radius: var(--mantine-radius-sm);\n  }\n  :where([data-mantine-color-scheme='light']) .m_d6493fad :where(pre) {\n      background-color: var(--mantine-color-gray-0);\n}\n  :where([data-mantine-color-scheme='dark']) .m_d6493fad :where(pre) {\n      background-color: var(--mantine-color-dark-8);\n}\n  .m_d6493fad :where(pre) :where(code) {\n      background-color: transparent;\n      padding: 0;\n      border-radius: 0;\n      color: inherit;\n      border: 0;\n    }\n  .m_d6493fad :where(kbd) {\n    --kbd-fz: calc(0.75rem * var(--mantine-scale));\n    --kbd-padding: calc(0.1875rem * var(--mantine-scale)) calc(0.3125rem * var(--mantine-scale));\n\n    font-family: var(--mantine-font-family-monospace);\n    line-height: var(--mantine-line-height);\n    font-weight: 700;\n    padding: var(--kbd-padding);\n    font-size: var(--kbd-fz);\n    border-radius: var(--mantine-radius-sm);\n    border: calc(0.0625rem * var(--mantine-scale)) solid;\n    border-bottom-width: calc(0.1875rem * var(--mantine-scale));\n  }\n  :where([data-mantine-color-scheme='light']) .m_d6493fad :where(kbd) {\n      border-color: var(--mantine-color-gray-3);\n      color: var(--mantine-color-gray-7);\n      background-color: var(--mantine-color-gray-0);\n}\n  :where([data-mantine-color-scheme='dark']) .m_d6493fad :where(kbd) {\n      border-color: var(--mantine-color-dark-3);\n      color: var(--mantine-color-dark-0);\n      background-color: var(--mantine-color-dark-5);\n}\n  .m_d6493fad :where(code) {\n    line-height: var(--mantine-line-height);\n    padding: calc(0.0625rem * var(--mantine-scale)) calc(0.3125rem * var(--mantine-scale));\n    border-radius: var(--mantine-radius-sm);\n    font-family: var(--mantine-font-family-monospace);\n    font-size: var(--mantine-font-size-xs);\n  }\n  :where([data-mantine-color-scheme='light']) .m_d6493fad :where(code) {\n      background-color: var(--mantine-color-gray-0);\n      color: var(--mantine-color-black);\n}\n  :where([data-mantine-color-scheme='dark']) .m_d6493fad :where(code) {\n      background-color: var(--mantine-color-dark-5);\n      color: var(--mantine-color-white);\n}\n  .m_d6493fad :where(ul, ol):not([data-type='taskList']) {\n    margin-bottom: var(--mantine-spacing-md);\n    padding-inline-start: calc(2.375rem * var(--mantine-scale));\n  }\n  .m_d6493fad :where(ul, ol):not([data-type='taskList']) :where(li) {\n      margin-bottom: var(--mantine-spacing-xs);\n    }\n  .m_d6493fad :where(table) {\n    width: 100%;\n    border-collapse: collapse;\n    caption-side: bottom;\n    margin-bottom: var(--mantine-spacing-md);\n  }\n  .m_d6493fad :where(table) :where(caption) {\n      margin-top: var(--mantine-spacing-xs);\n      font-size: var(--mantine-font-size-sm);\n      color: var(--mantine-color-gray-6);\n    }\n  .m_d6493fad :where(table) :where(th) {\n      text-align: left;\n      font-weight: bold;\n      color: var(--mantine-color-gray-7);\n      font-size: var(--mantine-font-size-sm);\n      padding: var(--mantine-spacing-xs) var(--mantine-spacing-sm);\n    }\n  .m_d6493fad :where(table) :where(thead th) {\n      border-bottom: calc(0.0625rem * var(--mantine-scale)) solid;\n      border-color: var(--mantine-color-gray-3);\n    }\n  .m_d6493fad :where(table) :where(tfoot th) {\n      border-top: calc(0.0625rem * var(--mantine-scale)) solid;\n      border-color: var(--mantine-color-gray-3);\n    }\n  .m_d6493fad :where(table) :where(td) {\n      padding: var(--mantine-spacing-xs) var(--mantine-spacing-sm);\n      border-bottom: calc(0.0625rem * var(--mantine-scale)) solid;\n      border-color: var(--mantine-color-gray-3);\n      font-size: var(--mantine-font-size-sm);\n    }\n  .m_d6493fad :where(table) :where(tr:last-of-type td) {\n      border-bottom: 0;\n    }\n  .m_d6493fad :where(blockquote) {\n    font-size: var(--mantine-font-size-lg);\n    line-height: var(--mantine-line-height);\n    margin: var(--mantine-spacing-md) 0;\n    border-radius: var(--mantine-radius-sm);\n    padding: var(--mantine-spacing-md) var(--mantine-spacing-lg);\n  }\n  :where([data-mantine-color-scheme='light']) .m_d6493fad :where(blockquote) {\n      background-color: var(--mantine-color-gray-0);\n}\n  :where([data-mantine-color-scheme='dark']) .m_d6493fad :where(blockquote) {\n      background-color: var(--mantine-color-dark-8);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
